import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import * as React from 'react';
import React__default, { useRef, useMemo, useState, useEffect, forwardRef, isValidElement, useCallback, createContext, useContext, cloneElement, useLayoutEffect, createElement } from 'react';
import { useBreadcrumbItem, useBreadcrumbs, useButton, useFocus, useHover, mergeProps, useSeparator, useTextField, usePress, useCheckbox, useFocusRing, VisuallyHidden, useSearchField, useKeyboard, useProgressBar, useModalOverlay, FocusScope, useOverlayTrigger, useDialog, useListBox, useOption, usePopover, Overlay, DismissButton, useSelect, HiddenSelect, useFilter, useComboBox } from 'react-aria';
import { styled, createGlobalStyle } from 'styled-components';
import { useSearchFieldState, useOverlayTriggerState, Item, useSelectState, useComboBoxState } from 'react-stately';
import { useSpring, animated, easings } from '@react-spring/web';
import Drawer from '@mui/material/Drawer';
import $4AOtR$reactdom from 'react-dom';
import { LicenseInfo, DateRangePicker, DateRangeCalendar, LocalizationProvider, DateField, DateCalendar } from '@mui/x-date-pickers-pro';
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFns';
import { Autocomplete, Chip, TextField as TextField$2, Popper } from '@mui/material';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function BreadcrumbItem(_a) {
    var { style = {}, id = "", className = "", href = "" } = _a, props = __rest(_a, ["style", "id", "className", "href"]);
    const ref = useRef(null);
    const { itemProps } = useBreadcrumbItem(props, ref);
    const { isCurrent, isDisabled, children } = props;
    return (jsxs("li", { id: id, style: Object.assign({ display: "flex", alignItems: "center", cursor: isCurrent || isDisabled ? "default" : "pointer", textDecoration: isCurrent || isDisabled ? "none" : "underline" }, style), className: `${className} breadcrumbsCompLibrary_listItem`, children: [jsx("a", Object.assign({}, itemProps, { ref: ref, className: `breadcrumbsCompLibrary_listItem_link breadcrumbsCompLibrary_listItem_link_currnet_${isCurrent}`, href: href, style: {
                    cursor: isCurrent || isDisabled ? "default" : "pointer",
                    textDecoration: isCurrent || isDisabled ? "none" : "underline",
                }, children: children })), !isCurrent && (jsx("span", { "aria-hidden": "true", style: { padding: "0 5px" }, className: "breadcrumbsCompLibrary_right_svg_span", children: jsx("svg", { className: "breadcrumbsCompLibrary_right_svg", width: "16", height: "17", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: jsx("g", { id: `${id}chevron-right`, children: jsx("path", { id: `${id}vector`, d: "M6 12.3335L10 8.3335L6 4.3335", stroke: "#522367", strokeLinecap: "round", strokeLinejoin: "round" }) }) }) }))] }));
}

function Breadcrumbs(_a) {
    var { semanticColor = "Light Background", style = {}, id = "", className = "", spacing = "comfortable" } = _a, props = __rest(_a, ["semanticColor", "style", "id", "className", "spacing"]);
    const { navProps } = useBreadcrumbs(props);
    const { children } = props;
    const allowedChildren = React__default.Children.toArray(children)
        .map((child) => {
        if (React__default.isValidElement(child) && child.type === BreadcrumbItem) {
            return {
                item: child,
            };
        }
        return null;
    })
        .filter(Boolean);
    return (jsx("nav", Object.assign({}, navProps, { style: Object.assign({}, style), className: `${className} breadcrumbsCompLibrary breadcrumbsCompLibrary_spacing_${spacing} breadcrumbsCompLibrary_${semanticColor === "Light Background"
            ? "semantic_light"
            : "semantic_dark"}`, id: id, children: jsx("ol", { className: "breadcrumbsCompLibrary_ordered_list", style: { display: "flex", listStyle: "none", margin: 0, padding: 0 }, children: allowedChildren === null || allowedChildren === void 0 ? void 0 : allowedChildren.map((item) => {
                return item === null || item === void 0 ? void 0 : item.item;
            }) }) })));
}

function Loader() {
    return (jsx("div", { className: "loader", "data-testid": "btn-loading-svg-test", children: jsx("svg", { width: "24", height: "24", viewBox: "0 0 23 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: jsx("path", { id: "Vector", fillRule: "evenodd", clipRule: "evenodd", d: "M12.25 1C12.25 0.585786 11.9142 0.25 11.5 0.25C11.0858 0.25 10.75 0.585786 10.75 1V5C10.75 5.41421 11.0858 5.75 11.5 5.75C11.9142 5.75 12.25 5.41421 12.25 5V1ZM12.25 17C12.25 16.5858 11.9142 16.25 11.5 16.25C11.0858 16.25 10.75 16.5858 10.75 17V21C10.75 21.4142 11.0858 21.75 11.5 21.75C11.9142 21.75 12.25 21.4142 12.25 21V17ZM3.8996 3.39985C4.19249 3.10695 4.66737 3.10695 4.96026 3.39985L7.79026 6.22985C8.08316 6.52274 8.08316 6.99761 7.79026 7.29051C7.49737 7.5834 7.0225 7.5834 6.7296 7.29051L3.8996 4.46051C3.60671 4.16761 3.60671 3.69274 3.8996 3.39985ZM16.2703 14.7099C15.9774 14.417 15.5026 14.417 15.2097 14.7099C14.9168 15.0028 14.9168 15.4777 15.2097 15.7706L18.0397 18.6006C18.3326 18.8935 18.8074 18.8935 19.1003 18.6006C19.3932 18.3077 19.3932 17.8328 19.1003 17.5399L16.2703 14.7099ZM0.75 11C0.75 10.5858 1.08579 10.25 1.5 10.25H5.5C5.91421 10.25 6.25 10.5858 6.25 11C6.25 11.4142 5.91421 11.75 5.5 11.75H1.5C1.08579 11.75 0.75 11.4142 0.75 11ZM17.5 10.25C17.0858 10.25 16.75 10.5858 16.75 11C16.75 11.4142 17.0858 11.75 17.5 11.75H21.5C21.9142 11.75 22.25 11.4142 22.25 11C22.25 10.5858 21.9142 10.25 21.5 10.25H17.5ZM7.79026 14.7099C8.08316 15.0028 8.08316 15.4777 7.79026 15.7706L4.96026 18.6006C4.66737 18.8935 4.19249 18.8935 3.8996 18.6006C3.60671 18.3077 3.60671 17.8328 3.8996 17.5399L6.7296 14.7099C7.0225 14.417 7.49737 14.417 7.79026 14.7099ZM19.1003 4.46051C19.3932 4.16761 19.3932 3.69274 19.1003 3.39985C18.8074 3.10695 18.3326 3.10695 18.0397 3.39985L15.2097 6.22985C14.9168 6.52274 14.9168 6.99761 15.2097 7.29051C15.5026 7.5834 15.9774 7.5834 16.2703 7.29051L19.1003 4.46051Z", fill: "#306582" }) }) }));
}

function Button$1(_a) {
    var { isDisabled = false, isRippleActive = false, hierarchy = "primary", spacing = "comfortable", semanticColor = "Light Background", style = {}, id = "", isLoading = false, className = "", onClick = () => undefined, loadingIcon = undefined, btnRef = undefined, isOnlyActiveOnPress = false } = _a, props = __rest(_a, ["isDisabled", "isRippleActive", "hierarchy", "spacing", "semanticColor", "style", "id", "isLoading", "className", "onClick", "loadingIcon", "btnRef", "isOnlyActiveOnPress"]);
    const ref = useRef(null);
    const { btnType, type } = props;
    const { icon, label, leftIcon, rightIcon, isLeftIcon, isRightIcon } = useMemo(() => {
        const propValues = {
            icon: "icon" in props ? props === null || props === void 0 ? void 0 : props.icon : undefined,
            label: "label" in props ? props === null || props === void 0 ? void 0 : props.label : undefined,
            leftIcon: "leftIcon" in props ? props === null || props === void 0 ? void 0 : props.leftIcon : undefined,
            rightIcon: "rightIcon" in props ? props === null || props === void 0 ? void 0 : props.rightIcon : undefined,
            isLeftIcon: "isLeftIcon" in props ? props === null || props === void 0 ? void 0 : props.isLeftIcon : false,
            isRightIcon: "isRightIcon" in props ? props === null || props === void 0 ? void 0 : props.isRightIcon : false,
        };
        return propValues;
    }, [props]);
    const [isHovered, setIsHovered] = useState(false);
    const [accesibilityClassName, setAccesibilityClassName] = useState("");
    function createRipple(event) {
        const button = event.currentTarget;
        const circle = document.createElement("span");
        const diameter = Math.max(button.clientWidth, button.clientHeight);
        const radius = diameter / 2;
        circle.style.width = `${diameter}px`;
        circle.style.height = `${diameter}px`;
        circle.style.left = `${event.pageX - button.offsetLeft - radius}px`;
        circle.style.top = `${event.pageY - button.offsetTop - radius}px`;
        circle.classList.add("ripple");
        const ripple = button.getElementsByClassName("ripple")[0];
        if (ripple) {
            ripple.remove();
        }
        button.appendChild(circle);
        setAccesibilityClassName(isHovered ? "hovered" : "");
    }
    const handleOnClick = (event) => {
        if (isRippleActive) {
            createRipple(event);
        }
    };
    const { buttonProps } = useButton(Object.assign(Object.assign({}, props), { isDisabled,
        onPress() {
            onClick();
        },
        onPressChange(isPressed) {
            if (isPressed) {
                setAccesibilityClassName("pressed");
            }
            else {
                setAccesibilityClassName("");
            }
        } }), ref);
    const { focusProps } = useFocus({
        isDisabled,
        onFocusChange: (focused) => {
            if (!isDisabled) {
                setAccesibilityClassName(focused ? "focused" : "");
            }
        },
    });
    const { hoverProps } = useHover({
        isDisabled,
        onHoverChange: (hovered) => {
            setIsHovered(hovered);
            setAccesibilityClassName(hovered ? "hovered" : "");
        },
    });
    const btnBody = useMemo(() => {
        if (isLoading) {
            return loadingIcon !== null && loadingIcon !== void 0 ? loadingIcon : jsx(Loader, {});
        }
        if (btnType === "label") {
            return (jsxs("div", { className: `${hierarchy} ${semanticColor} btnLabel`, children: [label, " "] }));
        }
        return jsxs("div", { children: [icon, " "] });
    }, [btnType, icon, label, isLoading, loadingIcon, hierarchy, semanticColor]);
    const btnDisabled = useMemo(() => {
        return isDisabled;
    }, [isDisabled]);
    return (jsx("button", Object.assign({ type: type === "submit" ? "submit" : "button" }, (isOnlyActiveOnPress === true
        ? {}
        : { onClick: (e) => handleOnClick(e) }), mergeProps(buttonProps, focusProps, hoverProps), { ref: !btnRef ? ref : btnRef, id: id }, (props.form ? { form: props.form } : {}), { disabled: btnDisabled, style: Object.assign({}, style), className: `${className} btnCompLibrary btnCompLibrary_btnType_${btnType} btnCompLibrary_hierarchy_${hierarchy
            .split("-")
            .join("_")} btnCompLibrary_spacing_${spacing} btnCompLibrary_${semanticColor === "Light Background"
            ? "semantic_light"
            : "semantic_dark"} ${isDisabled && "btnCompLibrary_disabled"} ${accesibilityClassName}`, children: jsxs("div", { className: "btnCompLibrary_wrapper", style: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }, children: [
                /* left icon */
                jsx("div", { className: "btnCompLibrary_leftIcon", style: { display: "flex", alignItems: "center" }, children: btnType === "label" &&
                        isLeftIcon &&
                        isLoading === false &&
                        leftIcon }), 
                /* body */
                jsx("div", { className: "btnCompLibrary_body", style: { display: "flex", alignItems: "center" }, children: btnBody }), 
                /* right icon */
                jsx("div", { className: "btnCompLibrary_rightIcon", style: { display: "flex", alignItems: "center" }, children: btnType === "label" &&
                        isRightIcon &&
                        isLoading === false &&
                        rightIcon })] }) })));
}

function Divider(_a) {
    var { style = {}, id = "", className = "", color = "", thickness = 0, margin = 5, brand = "staysure" } = _a, props = __rest(_a, ["style", "id", "className", "color", "thickness", "margin", "brand"]);
    const { separatorProps } = useSeparator(props);
    const { orientation } = props;
    const dividerColor = useMemo(() => {
        if (color)
            return color;
        if (brand === "avanti")
            return "#DCD8D3";
        if (brand === "staysure")
            return "#DCDCDC";
        return "rgba(220, 220, 220, 1)";
    }, [color, brand]);
    const dividerWidth = useMemo(() => {
        if (thickness) {
            return orientation === "vertical" ? `${thickness}px` : "100%";
        }
        return orientation === "vertical" ? "1px" : "100%";
    }, [orientation, thickness]);
    const dividerHeight = useMemo(() => {
        if (thickness) {
            return orientation === "vertical" ? "100%" : `${thickness}px`;
        }
        return orientation === "vertical" ? "100%" : "1px";
    }, [orientation, thickness]);
    return (jsx("div", Object.assign({}, separatorProps, { className: `dividerCompLibrary ${className}`, id: id, style: Object.assign({ background: dividerColor, width: dividerWidth, height: dividerHeight, margin: orientation === "vertical" ? `0 ${margin}px` : `${margin}px 0` }, style) })));
}

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var classnames = {exports: {}};

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/

(function (module) {
	/* global define */

	(function () {

	  var hasOwn = {}.hasOwnProperty;
	  function classNames() {
	    var classes = '';
	    for (var i = 0; i < arguments.length; i++) {
	      var arg = arguments[i];
	      if (arg) {
	        classes = appendClass(classes, parseValue(arg));
	      }
	    }
	    return classes;
	  }
	  function parseValue(arg) {
	    if (typeof arg === 'string' || typeof arg === 'number') {
	      return arg;
	    }
	    if (typeof arg !== 'object') {
	      return '';
	    }
	    if (Array.isArray(arg)) {
	      return classNames.apply(null, arg);
	    }
	    if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
	      return arg.toString();
	    }
	    var classes = '';
	    for (var key in arg) {
	      if (hasOwn.call(arg, key) && arg[key]) {
	        classes = appendClass(classes, key);
	      }
	    }
	    return classes;
	  }
	  function appendClass(value, newClass) {
	    if (!newClass) {
	      return value;
	    }
	    if (value) {
	      return value + ' ' + newClass;
	    }
	    return value + newClass;
	  }
	  if (module.exports) {
	    classNames.default = classNames;
	    module.exports = classNames;
	  } else {
	    window.classNames = classNames;
	  }
	})(); 
} (classnames));

var classnamesExports = classnames.exports;
var classNames = /*@__PURE__*/getDefaultExportFromCjs(classnamesExports);

const useToggleState$1 = (defaultValue, onClick) => {
    const [isSelected, setIsSelected] = useState(defaultValue);
    const toggle = () => {
        onClick(!isSelected);
        setIsSelected(!isSelected);
    };
    const setSelected = (value) => {
        setIsSelected(value);
        onClick(value);
    };
    return {
        isSelected,
        setSelected,
        toggle,
    };
};

function OptionSelection({ style, id, isDisabled = false, title, content, tabIndex = 0, hasCheckBox = false, card = "", classCheckboxOuterWrap = "", classCheckBoxWrap = "", checkboxInput = "", checkboxOuter = "", checkboxInner = "", classTitle = "", classDescription = "", defaultValue = false, onClick = () => { }, }) {
    const ref = useRef(null);
    const state = useToggleState$1(defaultValue, onClick);
    const [isHovered, setIsHovered] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const { buttonProps } = useButton({
        isDisabled,
        onPress: () => {
            state.setSelected(!defaultValue);
        },
    }, ref);
    const { focusProps } = useFocus({
        isDisabled,
        onFocusChange: (focused) => {
            setIsFocused(focused);
        },
    });
    const { hoverProps } = useHover({
        onHoverChange: (hovered) => {
            setIsHovered(hovered);
        },
    });
    const strokeColor = isDisabled ? "#272427" : "white";
    const dynamicClass = classNames({
        disabled: isDisabled,
        checkbox: hasCheckBox,
        default: !hasCheckBox,
        hovered: isHovered,
        focused: isFocused,
        clicked: defaultValue,
    });
    return (jsxs("div", Object.assign({}, mergeProps(buttonProps, focusProps, hoverProps), { className: `card ${card} ${dynamicClass} `, id: id, tabIndex: tabIndex, style: Object.assign({}, style), "data-testid": "card", children: [jsxs("div", { className: `classCheckboxOuterWrap ${classCheckboxOuterWrap} ${dynamicClass}`, "data-testid": "checkbox-outer-wrap", children: [hasCheckBox && (jsxs("div", { className: `classCheckBoxWrap ${classCheckBoxWrap} ${dynamicClass}`, "data-testid": "Checkbox-wrap", children: [jsx("input", { type: "checkbox", className: `checkboxInput ${checkboxInput} ${dynamicClass}`, "data-testid": "checkbox-input", hidden: true }), jsx("div", { className: `checkboxOuter ${checkboxOuter} ${dynamicClass}`, "data-testid": "checkbox-outer", children: jsx("div", { className: `checkboxInner ${checkboxInner} ${dynamicClass}`, "data-testid": "checkbox-inner", children: jsx("svg", { width: "16", height: "16", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: jsx("g", { id: "Check", children: jsx("path", { id: "Vector", d: "M13.3333 6.00031L5.99996 13.3336L2.66663 10.0003", stroke: strokeColor, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }) }) }) }) })] })), title && (jsx("div", { className: `classTitle ${classTitle} ${dynamicClass}`, "data-testid": "title", children: title }))] }), content && (jsx("div", { className: `classDescription ${classDescription} ${dynamicClass}`, "data-testid": "description", children: content }))] })));
}

const getSizeMap = (size) => {
    switch (size) {
        case "S":
            return 16;
        case "L":
            return 32;
        case "XL":
            return 48;
        case "XXL":
            return 56;
        default:
            return 24;
    }
};

function FacebookIcon({ testId, size = "M", width, height, fill = "none", stroke = "white", strokeWidth = 1.5, }) {
    const sizeMap = useMemo(() => getSizeMap(size), [size]);
    return (jsx("svg", { width: width !== null && width !== void 0 ? width : sizeMap, height: height !== null && height !== void 0 ? height : sizeMap, viewBox: "0 0 24 24", fill: fill, "data-testid": testId, className: "iconCompLibrary_facebookIcon_svg", id: "iconCompLibrary_facebookIcon_svg_id", xmlns: "http://www.w3.org/2000/svg", children: jsx("path", { className: "iconCompLibrary_facebookIcon_path", id: "iconCompLibrary_facebookIcon_path_id", d: "M18 2H15C13.6739 2 12.4021 2.52678 11.4645 3.46447C10.5268 4.40215 10 5.67392 10 7V10H7V14H10V22H14V14H17L18 10H14V7C14 6.73478 14.1054 6.48043 14.2929 6.29289C14.4804 6.10536 14.7348 6 15 6H18V2Z", stroke: stroke, strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }) }));
}

function HomeIcon({ testId, size = "M", width, height, fill = "none", stroke = "white", strokeWidth = 1.5, }) {
    const sizeMap = useMemo(() => getSizeMap(size), [size]);
    return (jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: width !== null && width !== void 0 ? width : sizeMap, height: height !== null && height !== void 0 ? height : sizeMap, fill: fill, viewBox: "0 0 24 24", "data-testid": testId, className: "iconCompLibrary_homeIcon_svg", id: "iconCompLibrary_homeIcon_svg_id", children: jsx("path", { className: "iconCompLibrary_homeIcon_path", id: "iconCompLibrary_homeIcon_path_id", stroke: stroke, strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: strokeWidth, d: "M9 22V12h6v10M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9Z" }) }));
}

function MessageIcon({ testId, size = "M", width, height, fill = "none", stroke = "#272427", strokeWidth = 1.5, }) {
    const sizeMap = useMemo(() => getSizeMap(size), [size]);
    return (jsx("svg", { width: width !== null && width !== void 0 ? width : sizeMap, height: height !== null && height !== void 0 ? height : sizeMap, fill: fill, viewBox: "0 0 24 24", "data-testid": testId, className: "iconCompLibrary_messageIcon_svg", id: "iconCompLibrary_messageIcon_svg_id", children: jsx("path", { className: "iconCompLibrary_messageIcon_path", id: "iconCompLibrary_messageIcon_path_id", d: "M21 11.5C21.0162 17.6977 13.9224 21.7389 8.5 19L3.97242 20.6464C3.57933 20.7893 3.19494 20.4152 3.32721 20.0184L4.9 15.3C4.30493 14.1219 3.99656 12.8199 4 11.5C4.00423 0.563507 21 0.572552 21 11.5Z", stroke: stroke, strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }) }));
}

function PhoneIcon({ testId, size = "M", width, height, fill = "none", stroke = "#272427", strokeWidth = 1.5, }) {
    const sizeMap = useMemo(() => getSizeMap(size), [size]);
    return (jsx("svg", { width: width !== null && width !== void 0 ? width : sizeMap, height: height !== null && height !== void 0 ? height : sizeMap, fill: fill, viewBox: "0 0 24 24", "data-testid": testId, className: "iconCompLibrary_phoneIcon_svg", id: "iconCompLibrary_phoneIcon_svg_id", children: jsx("path", { className: "iconCompLibrary_phoneIcon_path", id: "iconCompLibrary_phoneIcon_path_id", d: "M22.0004 16.9201C22.0004 23.8823 16.2139 22.1078 11.1904 18.8501C8.77425 17.3148 6.72576 15.2663 5.19042 12.8501C1.78683 7.59616 -0.261732 2.0001 7.11042 2.0001C7.59573 1.99532 8.06622 2.16718 8.43419 2.48363C9.48034 3.38332 10.1532 6.43703 9.89433 7.65098C9.6922 8.59875 8.73869 9.26183 8.09042 9.9101C9.51398 12.4136 11.5869 14.4865 14.0904 15.9101C14.7387 15.2618 15.4018 14.3083 16.3495 14.1062C17.9695 13.7607 22.0533 14.7897 22.0004 16.9201Z", stroke: stroke, strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }) }));
}

function TextField$1(_a) {
    var { id, label, hint, inputTestId, componentTestId, errorTestId, leftIcon, rightIcon, errorMessage, customClassNames, errorTextColor = "#ca302b", isDisabled = false, isRequired = true } = _a, rest = __rest(_a, ["id", "label", "hint", "inputTestId", "componentTestId", "errorTestId", "leftIcon", "rightIcon", "errorMessage", "customClassNames", "errorTextColor", "isDisabled", "isRequired"]);
    const inputRef = useRef(null);
    const parentRef = useRef(null);
    const { textFieldClass, activeClass, errorClass, disabledClass, focusClass, labelClass, altTextClass, labelWrapperClass, hintClass, iconClass, } = customClassNames !== null && customClassNames !== void 0 ? customClassNames : {};
    const [inputError, setInputError] = useState(false);
    const { labelProps, inputProps, errorMessageProps } = useTextField(Object.assign(Object.assign({}, rest), { "aria-label": label, isDisabled }), inputRef);
    const textboxfieldClasses = classNames(`${textFieldClass !== null && textFieldClass !== void 0 ? textFieldClass : "textfield"}`, {
        [`${disabledClass}`]: isDisabled,
        [`${errorClass}`]: inputError,
    });
    const labelClasses = classNames(`${labelClass !== null && labelClass !== void 0 ? labelClass : "label"}`);
    const altTextClasses = classNames(`${altTextClass !== null && altTextClass !== void 0 ? altTextClass : "altText"}`);
    const labelWrapperClasses = classNames(`${labelWrapperClass !== null && labelWrapperClass !== void 0 ? labelWrapperClass : "labelWrapper"}`);
    const hintClasses = classNames(`${hintClass !== null && hintClass !== void 0 ? hintClass : "hint"}`);
    const iconClasses = classNames(`${iconClass !== null && iconClass !== void 0 ? iconClass : "icon"}`, {
        [`${disabledClass}`]: isDisabled,
        [`${errorClass}`]: inputError,
    });
    // eslint-disable-next-line consistent-return
    useEffect(() => {
        const inputElement = inputRef.current;
        const parentElement = parentRef.current;
        if (inputElement && parentElement) {
            const handleFocus = () => {
                parentElement.classList.add(focusClass !== null && focusClass !== void 0 ? focusClass : "focus");
            };
            const handleBlur = () => {
                parentElement.classList.remove(focusClass !== null && focusClass !== void 0 ? focusClass : "focus");
                parentElement.classList.remove(activeClass !== null && activeClass !== void 0 ? activeClass : "active");
            };
            const handleInput = () => {
                parentElement.classList.add(activeClass !== null && activeClass !== void 0 ? activeClass : "active");
            };
            const handleInvalid = () => {
                parentElement.classList.add(errorClass !== null && errorClass !== void 0 ? errorClass : "error");
                setInputError(true);
            };
            inputElement.addEventListener("focus", handleFocus);
            inputElement.addEventListener("blur", handleBlur);
            inputElement.addEventListener("input", handleInput);
            inputElement.addEventListener("invalid", handleInvalid);
            return () => {
                inputElement.removeEventListener("focus", handleFocus);
                inputElement.removeEventListener("blur", handleBlur);
                inputElement.removeEventListener("input", handleInput);
                inputElement.removeEventListener("invalid", handleInvalid);
            };
        }
    }, [activeClass, errorClass, focusClass]);
    useEffect(() => {
        setInputError(false);
    }, [inputProps.value]);
    return (jsxs("div", { "data-testid": componentTestId, style: { width: "100%" }, children: [jsxs("div", { className: labelWrapperClasses, children: [jsx("label", Object.assign({ htmlFor: id, className: labelClasses }, labelProps, { children: label })), !isRequired && jsx("p", { className: altTextClasses, children: "Optional" })] }), jsxs("div", { ref: parentRef, className: textboxfieldClasses, children: [leftIcon && jsx("div", { className: iconClasses, children: leftIcon }), jsx("input", Object.assign({}, inputProps, { "data-testid": inputTestId, ref: inputRef, id: id, disabled: isDisabled })), rightIcon && jsx("div", { className: iconClasses, children: rightIcon })] }), inputError ? (jsx("div", Object.assign({}, errorMessageProps, { className: hintClasses, style: { color: errorTextColor }, "data-testid": errorTestId, children: errorMessage }))) : (jsx("div", { className: hintClasses, children: hint }))] }));
}

const ButtonWrapper = styled.button `
  cursor: pointer;
  width: fit-content;
  border: none;
  margin: 0px;
  padding: 2px;
  outline: none;
  background: transparent;
  display: flex;
  margin-right: 5px;
  outline: none;
  border: none;
  z-index: 10;
`;
const TooltipTrigger = forwardRef(function TooltipTrigger({ elementID = "tooltip", className = "", width = 24, height = 24, triggerIcon = null, triggerIconClassName = "", triggerIconHoveredClassName = "hovered", hideIcon = null, hideIconClassName = "", hideIconHoveredClassName = "hovered", isShowTooltip = false, inlineStyle = {}, isDisabled = false, onPress = () => { }, }, ref) {
    const { pressProps } = usePress({
        isDisabled,
        onPress: (event) => onPress(event),
    });
    const { hoverProps, isHovered } = useHover({ isDisabled });
    if (isShowTooltip && isValidElement(hideIcon))
        return (jsx(ButtonWrapper
        // eslint-disable-next-line react/jsx-props-no-spreading
        , Object.assign({}, mergeProps(pressProps, hoverProps), { type: "button", id: `${elementID}-btn`, "data-testid": `${elementID}-btn-wrapper`, style: inlineStyle, className: `svg-icon ${className} ${hideIconClassName} ${isHovered ? hideIconHoveredClassName : ""}`, "data-hovered": isHovered || undefined, ref: ref, children: hideIcon })));
    if (isShowTooltip === false && isValidElement(triggerIcon))
        return (jsx(ButtonWrapper
        // eslint-disable-next-line react/jsx-props-no-spreading
        , Object.assign({}, mergeProps(pressProps, hoverProps), { type: "button", id: `${elementID}-btn`, "data-testid": `${elementID}-btn-wrapper`, style: inlineStyle, className: `svg-icon ${className} ${triggerIconClassName} ${isHovered ? triggerIconHoveredClassName : ""}`, "data-hovered": isHovered || undefined, ref: ref, children: triggerIcon })));
    if (isShowTooltip && hideIcon === null)
        return (jsx(ButtonWrapper
        // eslint-disable-next-line react/jsx-props-no-spreading
        , Object.assign({}, mergeProps(pressProps, hoverProps), { id: `${elementID}-btn`, "data-testid": `${elementID}-btn-wrapper`, "data-hovered": isHovered || undefined, type: "button", ref: ref, children: jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: width, height: height, style: inlineStyle, id: `${elementID}-icon-hide`, "data-testid": `${elementID}-icon-hide`, "data-hovered": isHovered || undefined, className: `svg-icon ${className} ${hideIconClassName} ${isHovered ? hideIconHoveredClassName : ""}`, children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 22.3335C17.5228 22.3335 22 17.8563 22 12.3335C22 6.81065 17.5228 2.3335 12 2.3335C6.47715 2.3335 2 6.81065 2 12.3335C2 17.8563 6.47715 22.3335 12 22.3335ZM8.22922 16.1045C7.96887 15.8441 7.96887 15.422 8.22922 15.1617L11.0568 12.334L8.22782 9.50503C7.96747 9.24469 7.96747 8.82257 8.22781 8.56222C8.48816 8.30188 8.91027 8.30188 9.17062 8.56222L11.9996 11.3912L14.8289 8.56199C15.0892 8.30164 15.5113 8.30164 15.7717 8.56199C16.032 8.82234 16.032 9.24445 15.7717 9.5048L12.9424 12.334L15.7703 15.1619C16.0306 15.4222 16.0306 15.8443 15.7703 16.1047C15.5099 16.365 15.0878 16.365 14.8275 16.1047L11.9996 13.2769L9.17203 16.1045C8.91168 16.3648 8.48957 16.3648 8.22922 16.1045Z", fill: "#040C53" }) }) })));
    return (jsx(ButtonWrapper
    // eslint-disable-next-line react/jsx-props-no-spreading
    , Object.assign({}, mergeProps(pressProps, hoverProps), { id: `${elementID}-btn`, "data-testid": `${elementID}-btn-wrapper`, "data-hovered": isHovered || undefined, type: "button", ref: ref, children: jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: width, height: height, style: inlineStyle, id: `${elementID}-icon-show`, "data-testid": `${elementID}-icon-show`, "data-hovered": isHovered || undefined, className: `svg-icon ${className} ${triggerIconClassName} ${isHovered ? triggerIconHoveredClassName : ""}`, children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 22.3335C17.5228 22.3335 22 17.8563 22 12.3335C22 6.81065 17.5228 2.3335 12 2.3335C6.47715 2.3335 2 6.81065 2 12.3335C2 17.8563 6.47715 22.3335 12 22.3335ZM12 21.0002C16.7865 21.0002 20.6667 17.12 20.6667 12.3335C20.6667 7.54703 16.7865 3.66683 12 3.66683C7.21353 3.66683 3.33333 7.54703 3.33333 12.3335C3.33333 17.12 7.21353 21.0002 12 21.0002Z", fill: "#040C53" }), jsx("path", { d: "M12 11.6668C11.6318 11.6668 11.3333 11.9653 11.3333 12.3335V17.0002C11.3333 17.3684 11.6318 17.6668 12 17.6668C12.3682 17.6668 12.6667 17.3684 12.6667 17.0002V12.3335C12.6667 11.9653 12.3682 11.6668 12 11.6668Z", fill: "#040C53" }), jsx("path", { d: "M12 7.66683C11.6318 7.66683 11.3333 7.96531 11.3333 8.3335V8.80016C11.3333 9.16835 11.6318 9.46683 12 9.46683C12.3682 9.46683 12.6667 9.16835 12.6667 8.80016V8.3335C12.6667 7.96531 12.3682 7.66683 12 7.66683Z", fill: "#040C53" })] }) })));
});

/**
 * Check value is empty or not
 * @param obj any
 * @returns boolean
 */
const isEmpty = (obj) => {
    if (obj === null)
        return true;
    if (obj === undefined)
        return true;
    if (typeof obj === "string" && obj.trim() === "")
        return true;
    if (typeof obj === "object" && Object.keys(obj).length === 0)
        return true;
    if (Array.isArray(obj) && obj.length === 0)
        return true;
    return false;
};

const TooltipWrapper = styled.div `
  position: absolute;
  background-color: ${({ $tooltipBackgroundColor }) => $tooltipBackgroundColor};
  ${({ $screenType, $parentWidth }) => $screenType !== "sm" && `width: ${$parentWidth};`}
  ${({ $screenType }) => $screenType === "sm" && `left:0;right:0;`}
  margin-top: ${({ $spaseBetweenTriggerAndTooltip }) => $spaseBetweenTriggerAndTooltip};

  &:after {
    content: " ";
    position: absolute;
    border-width: 12px;
    border-style: solid;
    border-color: ${({ $tooltipBackgroundColor }) => $tooltipBackgroundColor}
      transparent transparent transparent;
    bottom: 100%;
    left: ${({ $toLeft }) => $toLeft};
    rotate: 180deg;
  }
`;
const TooltipSpanWrapper = styled.span `
  width: 100%;
  ${({ $screenType, $tooltipHeight }) => ["sm", "md"].includes(`${$screenType}`) && `height: ${$tooltipHeight}`}
`;
const TooltipElement = forwardRef(function TooltipElement({ tooltipID = "tooltip", screenType = "2xl", parentWidth = "auto", tooltipHeight = "auto", toLeft = "0px", title = "", titleClassName = "", body = "", bodyClassName = "", tooltipClassName = "", tooltipClassNameSM = "", tooltipClassNameMD = "", tooltipClassNameLG = "", tooltipClassNameXL = "", tooltipClassName2XL = "", tooltipBackgroundColor = "#D3D3D3", spaseBetweenTriggerAndTooltip = "10px", footer = "", footerClassName = "", btnHierarchy = "tertiary", btnSemanticColor = "Light Background", btnlabel = "", btnClassName = "", btnID = "tooltip-btn", onPressBtn = () => undefined, }, ref) {
    const getStyleClassName = () => {
        if (screenType === "sm")
            return tooltipClassNameSM;
        if (screenType === "md")
            return tooltipClassNameMD;
        if (screenType === "lg")
            return tooltipClassNameLG;
        if (screenType === "xl")
            return tooltipClassNameXL;
        return tooltipClassName2XL;
    };
    return (jsx(TooltipSpanWrapper, { "$screenType": screenType, "$tooltipHeight": tooltipHeight, "data-testid": `${tooltipID}-span-wrapper`, children: jsxs(TooltipWrapper, { "$screenType": screenType, "$tooltipBackgroundColor": tooltipBackgroundColor, "$parentWidth": parentWidth, "$spaseBetweenTriggerAndTooltip": spaseBetweenTriggerAndTooltip, className: `${tooltipClassName} ${getStyleClassName()}`, "$toLeft": toLeft, "data-testid": `${tooltipID}-element-wrapper`, ref: ref, children: [!isEmpty(title) ? (jsx("div", { "data-testid": `${tooltipID}-title-wrapper`, className: `${titleClassName}`, children: title })) : null, !isEmpty(body) ? (jsx("div", { "data-testid": `${tooltipID}-body-wrapper`, className: `${bodyClassName}`, children: body })) : null, !isEmpty(footer) ? (jsx("div", { "data-testid": `${tooltipID}-footer-wrapper`, className: `${footerClassName}`, children: footer })) : (btnlabel !== "" && (jsx("div", { "data-testid": `${tooltipID}-footer-btn-wrapper`, className: `${footerClassName}`, children: jsx(Button$1, { id: btnID, "data-testid": btnID, className: btnClassName.toString(), hierarchy: btnHierarchy, btnType: "label", semanticColor: btnSemanticColor, label: btnlabel, onClick: () => onPressBtn() }) })))] }) }));
});

const styles$1 = {
    PTM: {
        screenSize: {
            "screenSize-s": 600,
            "screenSize-m": 904,
            "screenSize-l": 1440,
            "screenSize-xl": 1640,
            "screenSize-xxl": 1840,
        },
    },
};

/**
 * Hook to get the current screen size
 * @param smallSize number
 * @param mediumSize number
 * @param largeSize number
 * @param xlargeSize number
 * @returns {string}
 */
const useScreenSize = (smallSize = styles$1.PTM.screenSize["screenSize-s"], mediumSize = styles$1.PTM.screenSize["screenSize-m"], largeSize = styles$1.PTM.screenSize["screenSize-l"], xlargeSize = styles$1.PTM.screenSize["screenSize-xl"]) => {
    const [screenSize, setScreenSize] = useState("");
    const handleResize = useCallback(() => {
        if (window.innerWidth <= smallSize)
            setScreenSize("sm");
        else if (window.innerWidth <= mediumSize)
            setScreenSize("md");
        else if (window.innerWidth <= largeSize)
            setScreenSize("lg");
        else if (window.innerWidth <= xlargeSize)
            setScreenSize("xl");
        else
            setScreenSize("2xl");
    }, [smallSize, mediumSize, largeSize, xlargeSize]);
    useEffect(() => {
        // Call handler right away so state gets updated with initial window size
        handleResize();
        // Add event listener
        window.addEventListener("resize", handleResize);
        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [handleResize]);
    return screenSize;
};

function Tooltip({ tooltipID = "tooltip", mainWrapperClassName = "mainWrapperClassName", subWrapperClassName = "subWrapperClassName", leftChildClassName = "leftChildElement", rightChildClassName = "rightChildElement", triggerIconWrapperClassName = "triggerIconWrapperClassName", leftChildElement = null, rightChildElement = null, tooltipTitle = "", tooltipTitleClassName = "", tooltipBody = "", tooltipBodyClassName = "", tooltipFooter = null, tooltipFooterClassName = "", tooltipClassName = "", tooltipClassNameSM = "", tooltipClassNameMD = "", tooltipClassNameLG = "", tooltipClassNameXL = "", tooltipClassName2XL = "", tooltipBackgroundColor = "#D3D3D3", spaseBetweenTriggerAndTooltip = "10px", tooltipTriggerClassName = "", tooltipTriggerIcon = null, tooltipTriggerIconClassName = "", tooltipTriggerIconHoveredClassName = "", tooltipHideIconClassName = "", tooltipHideIcon = null, tooltipHideIconHoveredClassName = "", tooltipTriggerInlineStyle = {}, isDisabled = false, relativePadding = 15, btnID = "tooltip-btn", btnlabel = "", btnHierarchy = "tertiary", btnSemanticColor = "Light Background", btnClassName = "", onPressBtn = () => { }, }) {
    const screenSize = useScreenSize();
    const [{ showTooltip }, setState] = useState({
        showTooltip: false,
    });
    const [{ parentWidth, tooltipHeight, toLeft }, setdimension] = useState({
        parentWidth: "auto",
        tooltipHeight: "auto",
        toLeft: `0px`,
    });
    const parentElementRef = useRef(null);
    const tooltipElementRef = useRef(null);
    const tooltipTriggerRef = useRef(null);
    const setParentWidth = useCallback(() => {
        let width = "auto";
        let height = "auto";
        let left = `0px`;
        if (parentElementRef.current) {
            const { offsetWidth } = parentElementRef.current;
            width = `${offsetWidth + 5}px`;
        }
        if (tooltipElementRef.current) {
            const { clientHeight } = tooltipElementRef.current;
            height = `${clientHeight + relativePadding}px`;
        }
        if (tooltipTriggerRef.current && tooltipElementRef.current) {
            const rect = tooltipTriggerRef.current.getBoundingClientRect();
            const parentElementrect = tooltipElementRef.current.getBoundingClientRect();
            left =
                window.innerWidth > styles$1.PTM.screenSize["screenSize-s"]
                    ? `${rect.left - parentElementrect.left}px`
                    : `${rect.left}px`;
        }
        setdimension({
            parentWidth: width,
            tooltipHeight: height,
            toLeft: left,
        });
    }, [parentElementRef, tooltipElementRef, tooltipTriggerRef, relativePadding]);
    const triggerTooltip = () => {
        setParentWidth();
        setState({
            showTooltip: !showTooltip,
        });
    };
    useEffect(() => {
        window.addEventListener("resize", setParentWidth);
        return () => {
            window.removeEventListener("resize", setParentWidth);
        };
    }, [setParentWidth]);
    useEffect(() => {
        setParentWidth();
    }, [showTooltip, setParentWidth]);
    return (jsxs("div", { ref: parentElementRef, className: mainWrapperClassName, "data-testid": `${tooltipID}-main-wrapper`, children: [jsxs("div", { className: subWrapperClassName, "data-testid": `${tooltipID}-sub-wrapper`, children: [isValidElement(leftChildElement) && (jsx("div", { className: leftChildClassName, "data-testid": `${tooltipID}-left-child-wrapper`, children: leftChildElement })), jsx("div", { className: triggerIconWrapperClassName, "data-testid": `${tooltipID}-trigger-wrapper`, children: jsx(TooltipTrigger, { ref: tooltipTriggerRef, elementID: tooltipID, className: tooltipTriggerClassName, triggerIcon: tooltipTriggerIcon, triggerIconClassName: tooltipTriggerIconClassName, triggerIconHoveredClassName: tooltipTriggerIconHoveredClassName, hideIcon: tooltipHideIcon, hideIconClassName: tooltipHideIconClassName, hideIconHoveredClassName: tooltipHideIconHoveredClassName, inlineStyle: tooltipTriggerInlineStyle, isDisabled: isDisabled, isShowTooltip: showTooltip, onPress: () => triggerTooltip() }) }), isValidElement(rightChildElement) && (jsx("div", { className: rightChildClassName, "data-testid": `${tooltipID}-right-child-wrapper`, children: rightChildElement }))] }), showTooltip === true && (jsx(TooltipElement, { ref: tooltipElementRef, tooltipID: tooltipID, title: tooltipTitle, titleClassName: tooltipTitleClassName, body: tooltipBody, bodyClassName: tooltipBodyClassName, footer: tooltipFooter, footerClassName: tooltipFooterClassName, tooltipClassName: tooltipClassName, tooltipClassNameSM: tooltipClassNameSM, tooltipClassNameMD: tooltipClassNameMD, tooltipClassNameLG: tooltipClassNameLG, tooltipClassNameXL: tooltipClassNameXL, tooltipClassName2XL: tooltipClassName2XL, parentWidth: parentWidth, toLeft: toLeft, screenType: screenSize, tooltipHeight: tooltipHeight, tooltipBackgroundColor: tooltipBackgroundColor, spaseBetweenTriggerAndTooltip: spaseBetweenTriggerAndTooltip, btnID: btnID, btnlabel: btnlabel, btnClassName: btnClassName, btnHierarchy: btnHierarchy, btnSemanticColor: btnSemanticColor, onPressBtn: () => onPressBtn() }))] }));
}

function CheckIcon$1({ elementID = "check-icon", width = 16, height = 16, style = {}, stroke = "none", className = "", }) {
    return (jsx("svg", { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", width: width, height: height, style: style, id: elementID, "data-testid": `${elementID}`, fill: "none", stroke: stroke, className: `checked-icon ${className}`, children: jsx("path", { d: "M13.3333 5.3335L5.99999 12.6668L2.66666 9.3335", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }) }));
}
function IndeterminateIcon({ elementID = "indeterminate-icon", width = 16, height = 16, style = {}, stroke = "none", className = "", }) {
    return (jsx("svg", { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", width: width, height: height, style: style, id: elementID, "data-testid": `${elementID}`, stroke: stroke, className: `indeterminate-icon ${className}`, fill: "none", children: jsx("path", { d: "M3.33334 8H12.6667", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }) }));
}
function RenderIcon({ indeterminate = false, isChecked = false, checkIconClassName = "", indeterminateIconClassName = "", defaultElementClassName = "", customCheckIcon = null, customIndeterminateIcon = null, checkIconColor = "", indeterminateIconColor = "", }) {
    if (indeterminate && isChecked && customIndeterminateIcon === null)
        return (jsx(IndeterminateIcon, { className: `indeterminateIcon  ${indeterminateIconClassName}`, "data-testid": "indeterminate-icon", stroke: indeterminateIconColor }));
    if (!indeterminate && isChecked && customCheckIcon === null)
        return (jsx(CheckIcon$1, { className: `checkIcon ${checkIconClassName}`, "data-testid": "checked-icon", stroke: checkIconColor }));
    if (indeterminate && isChecked && customCheckIcon !== null)
        return customIndeterminateIcon;
    if (!indeterminate && isChecked && customIndeterminateIcon !== null)
        return customCheckIcon;
    return (jsx("span", { id: "", "data-testid": "default-element", style: { width: "16px", height: "16px" }, className: defaultElementClassName }));
}

const useToggleState = (defaultValue, onChange) => {
    const [isSelected, setSelectedFn] = useState(defaultValue);
    const toggle = () => {
        onChange(!isSelected);
        setSelectedFn(!isSelected);
    };
    const setSelected = (value) => {
        setSelectedFn(value);
        onChange(value);
    };
    return {
        isSelected,
        setSelected,
        toggle,
    };
};

const CheckBoxWrapper = styled.label `
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: fit-content;
  border: 1.5px solid ${({ $borderColor }) => $borderColor};
`;
function CheckBox(props) {
    const { elementID = "checkbox", isDisabled = false, isIndeterminate = false, style = {}, defaultValue = false, checkBoxWrapperClassName = "", checkIconClassName = "", indeterminateIconClassName = "", defaultElementClassName = "", customCheckIcon = null, customIndeterminateIcon = null, borderColor = "#DC09A0", indeterminateIconColor = "#DC09A0", checkIconColor = "#DC09A0", 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onChange = (value) => { }, } = props;
    const ref = useRef(null);
    const state = useToggleState(defaultValue, onChange);
    const { inputProps } = useCheckbox(props, state, ref);
    const { hoverProps, isHovered } = useHover({ isDisabled });
    const { isFocusVisible, focusProps } = useFocusRing();
    return (jsxs(CheckBoxWrapper, Object.assign({ "$borderColor": borderColor }, mergeProps(hoverProps, focusProps), { className: `${checkBoxWrapperClassName} ${isDisabled ? "disabled" : ""}`, "data-testid": elementID, id: elementID, style: style, "data-hovered": (isHovered && !state.isSelected) || undefined, "data-is-selected": state.isSelected, "data-hovered-with-selected": (isHovered && state.isSelected) || undefined, "data-disabled": isDisabled, "data-focused": isFocusVisible || undefined, "aria-label": "checkbox", htmlFor: `native-checkbox-${elementID}`, tabIndex: 0, children: [jsx(VisuallyHidden, { children: jsx("input", Object.assign({}, mergeProps(inputProps), { ref: ref, id: `native-checkbox-${elementID}` })) }), jsx(RenderIcon, { indeterminate: isIndeterminate, isChecked: state.isSelected, checkIconClassName: checkIconClassName, indeterminateIconClassName: indeterminateIconClassName, defaultElementClassName: defaultElementClassName, customCheckIcon: customCheckIcon, customIndeterminateIcon: customIndeterminateIcon, checkIconColor: checkIconColor, indeterminateIconColor: indeterminateIconColor })] })));
}

function Searchbox(props) {
    const { style = {}, options = [], id, isDisabled = false, componentTestId, inputTestId, buttonTestId, itemWrapTestId, listTestId, wrapperTestId, searchboxClass, inputClass, leftIcon, iconClass, itemClass, buttonClass, wrapperClass, itemWrapClass, listClass, labelWrapperClasses, labelClasses, label = "Search" } = props, rest = __rest(props, ["style", "options", "id", "isDisabled", "componentTestId", "inputTestId", "buttonTestId", "itemWrapTestId", "listTestId", "wrapperTestId", "searchboxClass", "inputClass", "leftIcon", "iconClass", "itemClass", "buttonClass", "wrapperClass", "itemWrapClass", "listClass", "labelWrapperClasses", "labelClasses", "label"]);
    const inputRef = useRef(null);
    const parentRef = useRef(null);
    const ref = useRef(null);
    const state = useSearchFieldState(props);
    const [isTyping, setIsTyping] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [isComponentVisible, setIsComponentVisible] = useState(false);
    const [filteredSuggestions, setFilteredSuggestions] = useState([]);
    const { buttonProps } = useButton(props, ref);
    const { inputProps, labelProps } = useSearchField(Object.assign(Object.assign({}, rest), { "aria-label": label, isDisabled }), state, ref);
    const { focusProps, isFocused } = useFocusRing();
    const { hoverProps, isHovered } = useHover({ isDisabled });
    const { keyboardProps } = useKeyboard({
        onKeyDown: () => setIsTyping(true),
    });
    const dynamicClass = classNames(`searchboxClass`, {
        hovered: isHovered,
        focused: isFocused,
        typing: isFocused && isTyping,
    });
    const handleInputChange = (e) => {
        const query = e.target.value;
        setSearchQuery(query);
        setIsComponentVisible(true);
        const selectedSuggestions = options.filter((option) => option.toLowerCase().includes(query.toLowerCase()));
        setFilteredSuggestions(selectedSuggestions);
    };
    const handleSuggestionsClick = (clickedSuggestion) => {
        setSearchQuery(clickedSuggestion);
        setIsComponentVisible(false);
    };
    return (jsxs("div", { className: `${wrapperClass} ${dynamicClass}`, "data-testid": wrapperTestId, children: [jsx("div", { className: labelWrapperClasses, children: jsx("label", Object.assign({ htmlFor: id, className: labelClasses }, labelProps, { "aria-label": "label", children: label })) }), jsxs("div", Object.assign({}, mergeProps(focusProps, hoverProps), { "aria-label": "search", "data-testid": componentTestId, "data-focused": isFocused, "data-hovered": isHovered, ref: parentRef, className: `${searchboxClass} ${dynamicClass}`, style: style, children: [leftIcon && (jsx("div", { className: `${iconClass} ${dynamicClass}`, children: leftIcon })), jsx("input", Object.assign({ "data-testid": inputTestId, ref: inputRef }, mergeProps(inputProps, hoverProps, focusProps, keyboardProps), { id: id, disabled: isDisabled, className: `${inputClass} ${dynamicClass}`, value: searchQuery, onChange: handleInputChange, "aria-label": "input" }))] })), isComponentVisible && filteredSuggestions.length > 0 && (jsx("ul", { className: `${listClass} ${dynamicClass}`, children: filteredSuggestions.map((suggestion) => (jsx("div", { className: `${itemWrapClass} ${dynamicClass}`, "data-testid": itemWrapTestId, children: jsx("li", { className: `${itemClass} ${dynamicClass}`, "data-testid": listTestId, children: jsx("button", Object.assign({ className: `${buttonClass} ${dynamicClass}`, type: "button", "data-testid": buttonTestId, "aria-label": "button" }, buttonProps, { ref: ref, onClick: () => handleSuggestionsClick(suggestion), children: suggestion }), suggestion) }, suggestion) }, suggestion))) }))] }));
}

function InstagramIcon({ testId, size = "M", width, height, fill = "none", stroke = "white", strokeWidth = 1.5, }) {
    const sizeMap = useMemo(() => getSizeMap(size), [size]);
    return (jsx("svg", { width: width !== null && width !== void 0 ? width : sizeMap, height: height !== null && height !== void 0 ? height : sizeMap, viewBox: "0 0 24 24", fill: fill, "data-testid": testId, className: "iconCompLibrary_instagramIcon_svg", id: "iconCompLibrary_instagramIcon_svg_id", xmlns: "http://www.w3.org/2000/svg", children: jsx("path", { className: "iconCompLibrary_instagramIcon_path", id: "iconCompLibrary_instagramIcon_path_id", d: "M17.5 6.5H17.51M7 2H17C19.7614 2 22 4.23858 22 7V17C22 19.7614 19.7614 22 17 22H7C4.23858 22 2 19.7614 2 17V7C2 4.23858 4.23858 2 7 2ZM15.9997 11.3698C16.1231 12.2021 15.981 13.052 15.5935 13.7988C15.206 14.5456 14.5929 15.1512 13.8413 15.5295C13.0898 15.9077 12.2382 16.0394 11.4075 15.9057C10.5768 15.7721 9.80947 15.3799 9.21455 14.785C8.61962 14.1901 8.22744 13.4227 8.09377 12.592C7.96011 11.7614 8.09177 10.9097 8.47003 10.1582C8.84829 9.40667 9.45389 8.79355 10.2007 8.40605C10.9475 8.01856 11.7975 7.8764 12.6297 7.99981C13.4786 8.1257 14.2646 8.52128 14.8714 9.12812C15.4782 9.73496 15.8738 10.5209 15.9997 11.3698Z", stroke: stroke, strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }) }));
}

function TwitterIcon({ testId, size = "M", width, height, fill = "none", stroke = "white", strokeWidth = 1.5, }) {
    const sizeMap = useMemo(() => getSizeMap(size), [size]);
    return (jsx("svg", { width: width !== null && width !== void 0 ? width : sizeMap, height: height !== null && height !== void 0 ? height : sizeMap, viewBox: "0 0 24 24", fill: fill, "data-testid": testId, className: "iconCompLibrary_twitterIcon_svg", id: "iconCompLibrary_twitterIcon_svg_id", xmlns: "http://www.w3.org/2000/svg", children: jsx("path", { className: "iconCompLibrary_twitterIcon_path", id: "iconCompLibrary_twitterIcon_path_id", d: "M11.8616 8.46864L19.147 0H17.4206L11.0947 7.3532L6.04225 0H0.214844L7.85515 11.1193L0.214844 20H1.94134L8.62162 12.2348L13.9574 20H19.7848L11.8612 8.46864H11.8616ZM9.49695 11.2173L8.72283 10.1101L2.56342 1.29968H5.21521L10.1859 8.40994L10.9601 9.51718L17.4214 18.7594H14.7696L9.49695 11.2177V11.2173Z", stroke: stroke, strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }) }));
}

function LinkedinIcon({ testId, size = "M", width, height, fill = "none", stroke = "white", strokeWidth = 1.5, }) {
    const sizeMap = useMemo(() => getSizeMap(size), [size]);
    return (jsx("svg", { width: width !== null && width !== void 0 ? width : sizeMap, height: height !== null && height !== void 0 ? height : sizeMap, viewBox: "0 0 24 24", fill: fill, "data-testid": testId, className: "iconCompLibrary_linkedinIcon_svg", id: "iconCompLibrary_linkedinIcon_svg_id", xmlns: "http://www.w3.org/2000/svg", children: jsx("path", { className: "iconCompLibrary_linkedinIcon_path", id: "iconCompLibrary_linkedinIcon_path_id", d: "M16 8C17.5913 8 19.1174 8.63214 20.2426 9.75736C21.3679 10.8826 22 12.4087 22 14V21H18V14C18 13.4696 17.7893 12.9609 17.4142 12.5858C17.0391 12.2107 16.5304 12 16 12C15.4696 12 14.9609 12.2107 14.5858 12.5858C14.2107 12.9609 14 13.4696 14 14V21H10V14C10 12.4087 10.6321 10.8826 11.7574 9.75736C12.8826 8.63214 14.4087 8 16 8Z M6 9H2V21H6V9Z M4 6C5.10457 6 6 5.10457 6 4C6 2.89543 5.10457 2 4 2C2.89543 2 2 2.89543 2 4C2 5.10457 2.89543 6 4 6Z", stroke: stroke, strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }) }));
}

const colorMapCommon = {
    staysure: {
        light: "#306582",
        dark: "#FFFFFF",
    },
    avanti: {
        light: "#005A5E",
        dark: "#FFFFFF",
    },
    default: {
        light: "#272427",
        dark: "#FFFFFF",
    },
};
const colorMapChevronIcon = {
    staysure: {
        light: "#522367",
        dark: "#FFFFFF",
    },
    avanti: {
        light: "#005A5E",
        dark: "#FFFFFF",
    },
    default: {
        light: "#272427",
        dark: "#FFFFFF",
    },
};
const colorMapCheckCircleIcon = {
    staysure: {
        light: {
            check: {
                fill: "#306582",
                stroke: "#FFFFFF",
            },
            uncheck: {
                fill: "#FFFFFF",
                stroke: "#306582",
            },
        },
        dark: {
            check: {
                fill: "#FFFFFF",
                stroke: "#306582",
            },
            uncheck: {
                fill: "#306582",
                stroke: "#FFFFFF",
            },
        },
    },
    avanti: {
        light: {
            check: {
                fill: "#005A5E",
                stroke: "#FFFFFF",
            },
            uncheck: {
                fill: "#FFFFFF",
                stroke: "#005A5E",
            },
        },
        dark: {
            check: {
                fill: "#FFFFFF",
                stroke: "#005A5E",
            },
            uncheck: {
                fill: "#FFFFFF",
                stroke: "#005A5E",
            },
        },
    },
    default: {
        light: {
            check: {
                fill: "none",
                stroke: "#272427",
            },
            uncheck: {
                fill: "none",
                stroke: "#272427",
            },
        },
        dark: {
            check: {
                fill: "none",
                stroke: "#272427",
            },
            uncheck: {
                fill: "none",
                stroke: "#272427",
            },
        },
    },
};
const colorMapCalendarIcon = {
    staysure: {
        light: {
            fill: "#FFFFFF",
            stroke: "#306582",
        },
        dark: {
            fill: "#306582",
            stroke: "#FFFFFF",
        },
    },
    avanti: {
        light: {
            fill: "#FFFFFF",
            stroke: "#005A5E",
        },
        dark: {
            fill: "#005A5E",
            stroke: "#FFFFFF",
        },
    },
    default: {
        light: {
            fill: "none",
            stroke: "#272427",
        },
        dark: {
            fill: "none",
            stroke: "#272427",
        },
    },
};

function CheckCircleIcon({ testId, size = "M", width, height, id = "", className = "", fill, stroke, strokeWidth = 1.5, brand = "staysure", semanticColor = "light", state = "check", }) {
    const sizeMap = useMemo(() => {
        switch (size) {
            case "S":
                return 16;
            case "L":
                return 32;
            case "XL":
                return 48;
            case "XXL":
                return 56;
            default:
                return 24;
        }
    }, [size]);
    const fillValue = useMemo(() => {
        // Check if the brand and semanticColor are not undefined
        if (state && brand && semanticColor) {
            // Check if the brand is available in the colorMap
            const validBrand = colorMapCheckCircleIcon[brand] ? brand : "default";
            // Check if the semanticColor is available in the colorMap
            const validSemanticColor = colorMapCheckCircleIcon[validBrand][semanticColor]
                ? semanticColor
                : "light";
            // Check if the state is available in the colorMap
            const validState = colorMapCheckCircleIcon[validBrand][validSemanticColor][state]
                ? state
                : "check";
            // Return the fill and stroke values based on the brand, semanticColor and state
            return {
                fill: fill !== null && fill !== void 0 ? fill : colorMapCheckCircleIcon[validBrand][validSemanticColor][validState]
                    .fill,
                stroke: stroke !== null && stroke !== void 0 ? stroke : colorMapCheckCircleIcon[validBrand][validSemanticColor][validState]
                    .stroke,
            };
        }
        // default values
        return {
            fill: fill !== null && fill !== void 0 ? fill : colorMapCheckCircleIcon.default.light.check.fill,
            stroke: stroke !== null && stroke !== void 0 ? stroke : colorMapCheckCircleIcon.default.light.check.stroke,
        };
    }, [semanticColor, stroke, brand, fill, state]);
    return (jsx("svg", { width: width !== null && width !== void 0 ? width : sizeMap, height: height !== null && height !== void 0 ? height : sizeMap, fill: fillValue.fill, viewBox: "0 0 24 24", "data-testid": testId, className: `iconCompLibrary_checkCircleIcon_svg_${className}`, id: `iconCompLibrary_checkCircleIcon_svg_id_${id}`, children: jsx("path", { className: `iconCompLibrary_checkCircleIcon_path_${className}`, id: `iconCompLibrary_checkCircleIcon_path_id_${id}`, d: "M9 12L11 14L15 10M12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22Z", stroke: fillValue.stroke, strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }) }));
}

function CheckCircleFilledIcon({ testId, size = "M", width, height, id = "", className = "", fill, stroke, strokeWidth = 0, brand = "staysure", semanticColor = "light", state = "check", }) {
    const sizeMap = useMemo(() => {
        switch (size) {
            case "S":
                return 16;
            case "L":
                return 32;
            case "XL":
                return 48;
            case "XXL":
                return 56;
            default:
                return 24;
        }
    }, [size]);
    const fillValue = useMemo(() => {
        // Check if the brand and semanticColor are not undefined
        if (state && brand && semanticColor) {
            // Check if the brand is available in the colorMap
            const validBrand = colorMapCheckCircleIcon[brand] ? brand : "default";
            // Check if the semanticColor is available in the colorMap
            const validSemanticColor = colorMapCheckCircleIcon[validBrand][semanticColor]
                ? semanticColor
                : "light";
            // Check if the state is available in the colorMap
            const validState = colorMapCheckCircleIcon[validBrand][validSemanticColor][state]
                ? state
                : "check";
            // Return the fill and stroke values based on the brand, semanticColor and state
            return {
                fill: fill !== null && fill !== void 0 ? fill : colorMapCheckCircleIcon[validBrand][validSemanticColor][validState]
                    .fill,
                stroke: stroke !== null && stroke !== void 0 ? stroke : colorMapCheckCircleIcon[validBrand][validSemanticColor][validState]
                    .stroke,
            };
        }
        // default values
        return {
            fill: fill !== null && fill !== void 0 ? fill : colorMapCheckCircleIcon.default.light.check.fill,
            stroke: stroke !== null && stroke !== void 0 ? stroke : colorMapCheckCircleIcon.default.light.check.stroke,
        };
    }, [semanticColor, stroke, brand, fill, state]);
    return (jsx("svg", { width: width !== null && width !== void 0 ? width : sizeMap, height: height !== null && height !== void 0 ? height : sizeMap, fill: fillValue.fill, viewBox: "0 0 24 24", "data-testid": testId, className: `iconCompLibrary_checkCircleIcon_svg_${className}`, id: `iconCompLibrary_checkCircleIcon_svg_id_${id}`, children: jsx("path", { className: `iconCompLibrary_checkCircleIcon_path_${className}`, id: `iconCompLibrary_checkCircleIcon_path_id_${id}`, fillRule: "evenodd", clipRule: "evenodd", d: "M22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12ZM15.5303 10.5303C15.8232 10.2374 15.8232 9.76256 15.5303 9.46967C15.2374 9.17678 14.7626 9.17678 14.4697 9.46967L11 12.9393L9.53033 11.4697C9.23744 11.1768 8.76256 11.1768 8.46967 11.4697C8.17678 11.7626 8.17678 12.2374 8.46967 12.5303L10.4697 14.5303C10.7626 14.8232 11.2374 14.8232 11.5303 14.5303L15.5303 10.5303Z", stroke: fillValue.stroke, strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }) }));
}

function HeartIcon({ testId, size = "M", width, height, id = "", className = "", fill = "none", stroke = "#272427", strokeWidth = 1.5, }) {
    const sizeMap = useMemo(() => {
        switch (size) {
            case "S":
                return 16;
            case "L":
                return 32;
            case "XL":
                return 48;
            case "XXL":
                return 56;
            default:
                return 24;
        }
    }, [size]);
    return (jsx("svg", { width: width !== null && width !== void 0 ? width : sizeMap, height: height !== null && height !== void 0 ? height : sizeMap, fill: fill, viewBox: "0 0 24 24", "data-testid": testId, className: `iconCompLibrary_heartIcon_svg_${className}`, id: `iconCompLibrary_heartIcon_svg_id_${id}`, children: jsx("path", { className: `iconCompLibrary_heartIcon_path_${className}`, id: `iconCompLibrary_heartIcon_path_id_${id}`, d: "M20.4201 4.57996C19.9184 4.07653 19.3223 3.67709 18.6659 3.40455C18.0095 3.132 17.3058 2.9917 16.5951 2.9917C15.8844 2.9917 15.1806 3.132 14.5243 3.40455C13.8679 3.67709 13.2718 4.07653 12.7701 4.57996L12.0001 5.35996L11.2301 4.57996C10.7284 4.07653 10.1323 3.67709 9.47591 3.40455C8.81953 3.132 8.1158 2.9917 7.40509 2.9917C6.69437 2.9917 5.99065 3.132 5.33427 3.40455C4.67789 3.67709 4.08176 4.07653 3.58009 4.57996C1.46009 6.69996 1.33009 10.28 4.00009 13L12.0001 21L20.0001 13C22.6701 10.28 22.5401 6.69996 20.4201 4.57996Z", stroke: stroke, strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }) }));
}

function ProgressBar({ id = "progress-bar", testId = "progress-bar", label = "", value, minValue = 0, maxValue = 100, height = 12, duration = 500, brand = "staysure", }) {
    const { progressBarProps, labelProps } = useProgressBar({
        label,
        value,
        minValue,
        maxValue,
        "aria-label": "Quote Progress",
    });
    let barColor = "rgba(118, 44, 125, 1)";
    let barBackgroundColor = "#D1C0D6";
    if (brand === "avanti") {
        barColor = "rgba(0, 90, 94, 1)";
        barBackgroundColor = "#FFFFFF";
    }
    // Calculate the width of the progress bar as a percentage
    const percentage = (value - minValue) / (maxValue - minValue);
    const progressWidth = useSpring({
        width: `${Math.round(percentage * 100)}%`,
        config: { duration },
    });
    const { x } = useSpring({
        loop: true,
        from: { x: 0 },
        to: [{ x: 30 }, { x: 60 }, { x: 90 }, { x: 50 }, { x: 10 }],
        config: { mass: 1, damping: 2, tension: 5, friction: 3 }, // Adjust duration for speed of the floating effect
    });
    return (jsxs("div", { id: id, "data-testid": testId, role: progressBarProps.role, "aria-valuenow": progressBarProps["aria-valuenow"], "aria-valuemin": progressBarProps["aria-valuemin"], "aria-valuemax": progressBarProps["aria-valuemax"], "aria-valuetext": progressBarProps["aria-valuetext"], "aria-label": progressBarProps["aria-label"], style: { width: "auto" }, children: [jsx("div", { style: { display: "flex", justifyContent: "space-between" }, "data-testid": `${testId}-label`, children: label && jsx("span", { id: labelProps.id, children: label }) }), jsx("div", { style: { height, background: barBackgroundColor }, "data-testid": `${testId}-track`, children: jsx(animated.div, { "data-testid": `${testId}-fill`, style: {
                        width: progressWidth.width,
                        height,
                        background: brand === "staysure"
                            ? x.to((y) => `linear-gradient(to right, 
                ${barColor.replace("1)", `${y / 100})`)}, 
                ${barColor.replace("1)", "0.50)")}, 
                ${barColor.replace("1)", `${(100 - y) / 100})`)}
                )`)
                            : barColor,
                    } }) })] }));
}

function XIcon({ testId, size = "M", width, height, stroke = "#3a1dcc", strokeWidth = 1.5, }) {
    const sizeMap = useMemo(() => getSizeMap(size), [size]);
    return (jsx("svg", { width: width !== null && width !== void 0 ? width : sizeMap, height: height !== null && height !== void 0 ? height : sizeMap, viewBox: "0 0 24 24", "data-testid": testId, className: "iconCompLibrary_xIcon_svg", id: "iconCompLibrary_xIcon_svg_id", xmlns: "http://www.w3.org/2000/svg", children: jsx("path", { className: "iconCompLibrary_xIcon_path", id: "iconCompLibrary_xIcon_path_id", d: "M18 6L6 18M6 6L18 18", stroke: stroke, strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }) }));
}

function XCircleIcon({ testId, size = "M", width, height, stroke = "white", strokeWidth = 1.5, }) {
    const sizeMap = useMemo(() => getSizeMap(size), [size]);
    return (jsx("svg", { width: width !== null && width !== void 0 ? width : sizeMap, height: height !== null && height !== void 0 ? height : sizeMap, viewBox: "0 0 24 24", "data-testid": testId, className: "iconCompLibrary_xCircleIcon_svg", id: "iconCompLibrary_xCircleIcon_svg_id", xmlns: "http://www.w3.org/2000/svg", children: jsx("path", { className: "iconCompLibrary_xCircleIcon_path", id: "iconCompLibrary_xCircleIcon_path_id", d: "M12 3.27002C6.89137 3.27002 2.75 7.41139 2.75 12.52C2.75 17.6287 6.89137 21.77 12 21.77C17.1086 21.77 21.25 17.6287 21.25 12.52C21.25 7.41139 17.1086 3.27002 12 3.27002ZM1.25 12.52C1.25 6.58296 6.06294 1.77002 12 1.77002C17.9371 1.77002 22.75 6.58296 22.75 12.52C22.75 18.4571 17.9371 23.27 12 23.27C6.06294 23.27 1.25 18.4571 1.25 12.52ZM15.5303 8.98969C15.8232 9.28258 15.8232 9.75746 15.5303 10.0503L13.0607 12.52L15.5303 14.9897C15.8232 15.2826 15.8232 15.7575 15.5303 16.0504C15.2374 16.3432 14.7626 16.3432 14.4697 16.0504L12 13.5807L9.53033 16.0504C9.23744 16.3432 8.76256 16.3432 8.46967 16.0504C8.17678 15.7575 8.17678 15.2826 8.46967 14.9897L10.9393 12.52L8.46967 10.0503C8.17678 9.75746 8.17678 9.28258 8.46967 8.98969C8.76256 8.6968 9.23744 8.6968 9.53033 8.98969L12 11.4594L14.4697 8.98969C14.7626 8.6968 15.2374 8.6968 15.5303 8.98969Z", stroke: stroke, strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }) }));
}

function XCircleFilledIcon({ testId, size = "M", width, height, id = "", className = "", fill, stroke, strokeWidth = 0, brand = "staysure", semanticColor = "light", }) {
    const sizeMap = useMemo(() => {
        switch (size) {
            case "S":
                return 16;
            case "L":
                return 32;
            case "XL":
                return 48;
            case "XXL":
                return 56;
            default:
                return 24;
        }
    }, [size]);
    const fillValue = useMemo(() => {
        const validBrand = colorMapCheckCircleIcon[brand] ? brand : "default";
        const validSemanticColor = colorMapCheckCircleIcon[validBrand][semanticColor]
            ? semanticColor
            : "light";
        return {
            fill: fill !== null && fill !== void 0 ? fill : colorMapCheckCircleIcon[validBrand][validSemanticColor].check.fill,
            stroke: stroke !== null && stroke !== void 0 ? stroke : colorMapCheckCircleIcon[validBrand][validSemanticColor].check.stroke,
        };
    }, [semanticColor, stroke, brand, fill]);
    return (jsx("svg", { width: width !== null && width !== void 0 ? width : sizeMap, height: height !== null && height !== void 0 ? height : sizeMap, fill: fillValue.fill, viewBox: "0 0 24 24", "data-testid": testId, className: `iconCompLibrary_checkCircleIcon_svg_${className}`, id: `iconCompLibrary_checkCircleIcon_svg_id_${id}`, children: jsx("path", { className: `iconCompLibrary_checkCircleIcon_path_${className}`, id: `iconCompLibrary_checkCircleIcon_path_id_${id}`, fillRule: "evenodd", clipRule: "evenodd", d: "M10 20C15.523 20 20 15.523 20 10C20 4.477 15.523 0 10 0C4.477 0 0 4.477 0 10C0 15.523 4.477 20 10 20ZM7.53033 6.21967C7.23744 5.92678 6.76256 5.92678 6.46967 6.21967C6.17678 6.51256 6.17678 6.98744 6.46967 7.28033L8.93934 9.75L6.46967 12.2197C6.17678 12.5126 6.17678 12.9874 6.46967 13.2803C6.76256 13.5732 7.23744 13.5732 7.53033 13.2803L10 10.8107L12.4697 13.2803C12.7626 13.5732 13.2374 13.5732 13.5303 13.2803C13.8232 12.9874 13.8232 12.5126 13.5303 12.2197L11.0607 9.75L13.5303 7.28033C13.8232 6.98744 13.8232 6.51256 13.5303 6.21967C13.2374 5.92678 12.7626 5.92678 12.4697 6.21967L10 8.68934L7.53033 6.21967Z", stroke: fillValue.stroke, strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }) }));
}

function AlertTriangleFilledIcon({ testId, size = "M", width, height, id = "", className = "", fill, stroke, strokeWidth = 0, brand = "staysure", semanticColor = "light", }) {
    const sizeMap = useMemo(() => {
        switch (size) {
            case "S":
                return 16;
            case "L":
                return 32;
            case "XL":
                return 48;
            case "XXL":
                return 56;
            default:
                return 24;
        }
    }, [size]);
    const fillValue = useMemo(() => {
        const validBrand = colorMapCheckCircleIcon[brand] ? brand : "default";
        const validSemanticColor = colorMapCheckCircleIcon[validBrand][semanticColor]
            ? semanticColor
            : "light";
        return {
            fill: fill !== null && fill !== void 0 ? fill : colorMapCheckCircleIcon[validBrand][validSemanticColor].check.fill,
            stroke: stroke !== null && stroke !== void 0 ? stroke : colorMapCheckCircleIcon[validBrand][validSemanticColor].check.stroke,
        };
    }, [semanticColor, stroke, brand, fill]);
    return (jsx("svg", { width: width !== null && width !== void 0 ? width : sizeMap, height: height !== null && height !== void 0 ? height : sizeMap, fill: fillValue.fill, viewBox: "0 0 24 24", "data-testid": testId, className: `iconCompLibrary_checkCircleIcon_svg_${className}`, id: `iconCompLibrary_checkCircleIcon_svg_id_${id}`, children: jsx("path", { className: `iconCompLibrary_checkCircleIcon_path_${className}`, id: `iconCompLibrary_checkCircleIcon_path_id_${id}`, fillRule: "evenodd", clipRule: "evenodd", d: "M13.7304 3.99998L21.7304 18C21.9059 18.3039 21.9983 18.6486 21.9984 18.9995C21.9985 19.3504 21.9062 19.6951 21.7309 19.9991C21.5556 20.3031 21.3035 20.5556 20.9997 20.7313C20.6959 20.9069 20.3513 20.9996 20.0004 21H4.00042C3.64783 21.0032 3.30066 20.9131 2.99411 20.7388C2.68757 20.5646 2.43253 20.3124 2.25486 20.0078C2.0772 19.7032 1.98321 19.3571 1.98243 19.0045C1.98165 18.6519 2.0741 18.3053 2.25042 18L10.2504 3.99998C10.4249 3.69218 10.6778 3.43617 10.9835 3.25805C11.2892 3.07993 11.6366 2.98608 11.9904 2.98608C12.3442 2.98608 12.6917 3.07993 12.9973 3.25805C13.303 3.43617 13.556 3.69218 13.7304 3.99998ZM12.75 9C12.75 8.58579 12.4142 8.25 12 8.25C11.5858 8.25 11.25 8.58579 11.25 9V13C11.25 13.4142 11.5858 13.75 12 13.75C12.4142 13.75 12.75 13.4142 12.75 13V9ZM12 16.25C11.5858 16.25 11.25 16.5858 11.25 17C11.25 17.4142 11.5858 17.75 12 17.75H12.01C12.4242 17.75 12.76 17.4142 12.76 17C12.76 16.5858 12.4242 16.25 12.01 16.25H12Z", stroke: fillValue.stroke, strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }) }));
}

function ToggleButton(_a) {
    var { isDisabled = false, isDefaultActive = false, spacing = "comfortable", semanticColor = "Light Background", style = {}, id = "", className = "", onClick = () => undefined, isToggleEnable = true, brand } = _a, props = __rest(_a, ["isDisabled", "isDefaultActive", "spacing", "semanticColor", "style", "id", "className", "onClick", "isToggleEnable", "brand"]);
    const ref = useRef(null);
    const { btnType } = props;
    const { icon, label, description, isWidthChange, isLeftIcon, isActiveRightIcon, activeRightIcon, isActiveLeftIcon, leftIcon, activeIcon, activeLeftIcon, isAcoToggleButton = false, extraRightIcon, isEnableExtraIcon, } = useMemo(() => {
        const propValues = {
            icon: "icon" in props ? props === null || props === void 0 ? void 0 : props.icon : undefined,
            label: "label" in props ? props === null || props === void 0 ? void 0 : props.label : undefined,
            description: "description" in props ? props === null || props === void 0 ? void 0 : props.description : undefined,
            isWidthChange: "isWidthChange" in props ? props === null || props === void 0 ? void 0 : props.isWidthChange : true,
            isLeftIcon: "isLeftIcon" in props ? props === null || props === void 0 ? void 0 : props.isLeftIcon : true,
            isActiveRightIcon: "isActiveRightIcon" in props ? props === null || props === void 0 ? void 0 : props.isActiveRightIcon : true,
            leftIcon: "leftIcon" in props ? props === null || props === void 0 ? void 0 : props.leftIcon : undefined,
            activeLeftIcon: "activeLeftIcon" in props ? props === null || props === void 0 ? void 0 : props.activeLeftIcon : undefined,
            activeRightIcon: "activeRightIcon" in props ? props === null || props === void 0 ? void 0 : props.activeRightIcon : undefined,
            activeIcon: "activeIcon" in props ? props === null || props === void 0 ? void 0 : props.activeIcon : undefined,
            isAcoToggleButton: "isAcoToggleButton" in props ? props === null || props === void 0 ? void 0 : props.isAcoToggleButton : false,
            isActiveLeftIcon: "isActiveLeftIcon" in props ? props === null || props === void 0 ? void 0 : props.isActiveLeftIcon : true,
            extraRightIcon: "extraRightIcon" in props ? props === null || props === void 0 ? void 0 : props.extraRightIcon : undefined,
            isEnableExtraIcon: "isEnableExtraIcon" in props ? props === null || props === void 0 ? void 0 : props.isEnableExtraIcon : false,
        };
        return propValues;
    }, [props]);
    const [accesibilityClassName, setAccesibilityClassName] = useState("");
    const [isActive, setIsActive] = useState(false);
    useEffect(() => {
        setIsActive(isDefaultActive);
    }, [isDefaultActive]);
    const { buttonProps } = useButton(Object.assign(Object.assign({}, props), { isDisabled,
        onPress() {
            if (isToggleEnable) {
                setIsActive((val) => !val);
                onClick(!isActive);
            }
            else {
                setIsActive(true);
                onClick(true);
            }
        },
        onPressChange(isPressed) {
            if (isPressed) {
                setAccesibilityClassName("pressed");
            }
            else {
                setAccesibilityClassName("");
            }
        } }), ref);
    const { focusProps } = useFocus({
        isDisabled,
        onFocusChange: (focused) => {
            if (!isDisabled) {
                setAccesibilityClassName(focused ? "focused" : "");
            }
        },
    });
    const { hoverProps } = useHover({
        isDisabled,
        onHoverChange: (hovered) => {
            setAccesibilityClassName(hovered ? "hovered" : "");
        },
    });
    const splitsLabelPrefix = useCallback(() => {
        if (isActive && isAcoToggleButton) {
            const temp = label;
            const labelWithoutPrefix = temp === null || temp === void 0 ? void 0 : temp.split(" ");
            return labelWithoutPrefix === null || labelWithoutPrefix === void 0 ? void 0 : labelWithoutPrefix[1];
        }
        return label;
    }, [label, isActive, isAcoToggleButton]);
    const btnBody = useMemo(() => {
        if (btnType === "button") {
            return (jsxs(Fragment, { children: [jsx("div", { id: `componnt_lib_toggle_btn_label_${id}`, className: "componnt_lib_toggle_btn_label", children: splitsLabelPrefix() }), description && (jsx("div", { id: `componnt_lib_toggle_btn_description_${id}`, className: "componnt_lib_toggle_btn_description", children: description }))] }));
        }
        return isActive
            ? activeIcon !== null && activeIcon !== void 0 ? activeIcon : (jsx(HeartIcon, { stroke: "rgba(48, 101, 130, 1)", fill: "rgba(48, 101, 130, 1)" }))
            : icon !== null && icon !== void 0 ? icon : jsx(HeartIcon, { stroke: "rgba(48, 101, 130, 1)" });
    }, [activeIcon, btnType, description, icon, id, isActive, splitsLabelPrefix]);
    const btnDisabled = useMemo(() => {
        return isDisabled;
    }, [isDisabled]);
    return (jsxs("button", Object.assign({ type: "button" }, mergeProps(buttonProps, focusProps, hoverProps), { ref: ref, id: id, className: `${accesibilityClassName ? `${accesibilityClassName}` : ""} componnt_lib_toggle_btn componnt_lib_toggle_btn_${btnType} ${className}  componnt_lib_toggle_btn_${spacing} 
      componnt_lib_toggle_btn_${semanticColor === "Light Background" ? "light" : "dark"} ${isActive
            ? "componnt_lib_toggle_btn_active"
            : "componnt_lib_toggle_btn_inactive"} ${isDisabled ? "componnt_lib_toggle_btn_disabled" : ""} ${brand === "avanti" ? "avn_btn" : "sts_btn"}`, disabled: btnDisabled, style: Object.assign({}, style), children: [btnType === "button" && (jsxs("div", { id: `componnt_lib_toggle_btn_wraper_${id}`, className: "componnt_lib_toggle_btn_wraper", style: {
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                }, children: [jsxs("div", { id: `componnt_lib_toggle_btn_body_wrapper_${id}`, className: "componnt_lib_toggle_btn_body_wrapper", style: {
                            display: "inline-flex",
                            alignItems: "center",
                        }, children: [isLeftIcon && leftIcon && (jsx("div", { id: `componnt_lib_toggle_btn_leftIcon_${id}`, className: "componnt_lib_toggle_btn_leftIcon", children: isActive ? activeLeftIcon : leftIcon })), isActive &&
                                isAcoToggleButton &&
                                isWidthChange &&
                                isActiveLeftIcon &&
                                !btnDisabled &&
                                btnType === "button" && (jsx("div", { id: `componnt_lib_toggle_btn_activeIcon_${id}`, className: "componnt_lib_toggle_btn_activeLeftIcon", children: activeLeftIcon !== null && activeLeftIcon !== void 0 ? activeLeftIcon : (jsx(CheckCircleIcon, { stroke: "rgba(48, 101, 130, 1)", fill: "rgba(255, 255, 255, 1)" })) })), jsx("div", { id: `componnt_lib_toggle_btn_body_${id}`, className: "componnt_lib_toggle_btn_body", children: btnBody })] }), isEnableExtraIcon && extraRightIcon && (jsx("div", { id: "componnt_lib_toggle_btn_extra_icon", className: "component_lib_toggle_btn_extra_icon", children: extraRightIcon })), !isWidthChange &&
                        isActiveRightIcon &&
                        !btnDisabled &&
                        btnType === "button" && (jsx("div", { id: `componnt_lib_toggle_btn_activeIcon_${id}`, className: "componnt_lib_toggle_btn_activeIcon", style: {
                            visibility: `${isActive ? "visible" : "hidden"}`,
                        }, children: activeRightIcon !== null && activeRightIcon !== void 0 ? activeRightIcon : jsx(CheckCircleIcon, {}) })), isActive &&
                        isWidthChange &&
                        isActiveRightIcon &&
                        !btnDisabled &&
                        btnType === "button" && (jsx("div", { id: `componnt_lib_toggle_btn_activeIcon_${id}`, className: "componnt_lib_toggle_btn_activeIcon", children: activeRightIcon !== null && activeRightIcon !== void 0 ? activeRightIcon : jsx(CheckCircleIcon, {}) }))] })), btnType === "icon" && (jsx("div", { id: `componnt_lib_toggle_btn_body_${id}`, className: "componnt_lib_toggle_btn_body", children: btnBody }))] })));
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$7 = ".helpButton-module_helpBtnCalss__iiCk8 {\n  font-family: \"proxima-nova\", sans-serif;\n  width: 156px;\n  height: 40px;\n  border-radius: 80px;\n  overflow: hidden;\n  justify-content: flex-start;\n  align-items: center;\n  display: inline-flex;\n  background-size: 100% !important;\n}\n";
var style = {"helpBtnCalss":"helpButton-module_helpBtnCalss__iiCk8"};
styleInject(css_248z$7);

function HelpButton(_a) {
    var { buttonRef, isOpen, onClick, backgroundAnimationSpeed = 3, gradient, avatarSrc, brand } = _a, props = __rest(_a, ["buttonRef", "isOpen", "onClick", "backgroundAnimationSpeed", "gradient", "avatarSrc", "brand"]);
    const [btnOpenState, setBtnOpenState] = useState(false);
    const [accesibilityClassName, setAccesibilityClassName] = useState("");
    const helpBtnRef = useRef(null);
    const { x } = useSpring({
        loop: true,
        from: { x: 0 },
        to: [{ x: 20 }, { x: 40 }, { x: 60 }, { x: 80 }, { x: 100 }],
        config: { frequency: backgroundAnimationSpeed }, // Adjust duration for speed of the floating effect
    });
    useEffect(() => {
        if (isOpen !== undefined)
            setBtnOpenState(isOpen);
    }, [isOpen]);
    const { x: valueSpring } = useSpring({
        from: { x: 0 },
        x: btnOpenState ? 1 : 0,
        config: {
            friction: 15,
            tension: 100,
            mass: 1,
            bounce: 0.2,
            easing: easings.easeInOutBack,
            onRest: () => {
                setBtnOpenState(!btnOpenState);
                onClick === null || onClick === void 0 ? void 0 : onClick();
            },
        },
    });
    const ref = buttonRef !== null && buttonRef !== void 0 ? buttonRef : helpBtnRef;
    const gradientColors = useMemo(() => {
        if (gradient) {
            return gradient;
        }
        if (brand === "avanti") {
            return {
                color1: "#289292",
                color2: "#164648",
                color3: "#289292",
                color4: "#164648",
                color5: "#289292",
            };
        }
        return {
            color1: "rgb(215, 148, 224)",
            color2: "rgba(118, 44, 125, 1)",
            color3: "rgba(0, 107, 214, 1)",
            color4: "rgba(131, 175, 195, 1)",
            color5: "rgba(223, 65, 60, 1)",
        };
    }, [gradient, brand]);
    const { color1, color2, color3, color4, color5 } = gradientColors;
    const calcGradientPosition = (y, boundary) => {
        return -5 * (boundary - y) + 100;
    };
    const getGradient = (y) => {
        if (y < 20) {
            return `${color1} ${-100}%, ${color2} ${100}%, ${color3} ${300}% `;
        }
        if (y < 40) {
            return `${color1} ${-100 - calcGradientPosition(y, 40)}%, ${color2} ${100 - calcGradientPosition(y, 40)}%, ${color3} ${300 - calcGradientPosition(y, 40)}%`;
        }
        if (y < 60) {
            return `${color4} ${-200 + calcGradientPosition(y, 60)}%, ${color2} ${0 + calcGradientPosition(y, 60)}%, ${color3} ${200 + calcGradientPosition(y, 60)}%`;
        }
        if (y < 80) {
            return `${color4} ${-100 - calcGradientPosition(y, 80)}%, ${color2} ${100 - calcGradientPosition(y, 80)}%, ${color5} ${300 - calcGradientPosition(y, 80)}%`;
        }
        return `${color1} ${-200 + calcGradientPosition(y, 100)}%, ${color2} ${0 + calcGradientPosition(y, 100)}%, ${color5} ${200 + calcGradientPosition(y, 100)}%`;
    };
    const { buttonProps } = useButton(Object.assign(Object.assign({}, props), { onPress(e) {
            if (onClick !== undefined) {
                onClick(e);
            }
            if (isOpen === undefined)
                setBtnOpenState((val) => !val);
        },
        onPressChange(isPressed) {
            if (isPressed) {
                setAccesibilityClassName("pressed");
            }
            else {
                setAccesibilityClassName("");
            }
        } }), ref);
    const { focusProps } = useFocus({
        onFocusChange: (focused) => {
            setAccesibilityClassName(focused ? "focused" : "");
        },
    });
    const { hoverProps } = useHover({
        onHoverChange: (hovered) => {
            setAccesibilityClassName(hovered ? "hovered" : "");
        },
    });
    // const handleClose = useCallback(
    //   (e: TouchEvent) => {
    //     e.preventDefault();
    //     if (onClick !== undefined) {
    //       onClick(e);
    //     }
    //     if (isOpen === undefined) setBtnOpenState((val) => !val);
    //   },
    //   [isOpen, onClick]
    // );
    return (jsx(animated.button, Object.assign({ type: "button" }, mergeProps(buttonProps, focusProps, hoverProps), { "data-testid": "helpButton-test-id", className: `${style.helpBtnCalss} ${accesibilityClassName}`, style: {
            background: x.to((y) => `linear-gradient(270deg, 
             ${getGradient(y)}
              )`),
            border: brand === "staysure"
                ? "1px solid rgba(165, 102, 173, 1)"
                : " 1px solid #005a5e ",
            padding: "1px",
            margin: 0,
            cursor: "pointer",
            outline: accesibilityClassName === "focused" ||
                accesibilityClassName === "hovered"
                ? "2px solid #368fe9"
                : "none",
            outlineOffset: "2px",
        }, ref: ref, children: jsxs(animated.div, { style: {
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginLeft: valueSpring.to({
                    range: [0, 1],
                    output: [0, -116],
                }),
            }, "data-testid": "helpButton-body-wrapper-test-id", className: "helpButton-body-wrapper", children: [jsx("div", { style: {
                        minWidth: "calc(100% - 40px)",
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        textAlign: "center",
                        fontSize: "18px",
                        lineHeight: "18px",
                        fontWeight: "600",
                        color: "white",
                        paddingRight: "12px",
                        fontFamily: brand === "staysure"
                            ? "proxima-nova, sans-serif"
                            : "faktum, sans-serif",
                    }, className: "helpButton-body-section-1", children: "Get help" }), jsx(animated.div, { style: {
                        minWidth: "40px",
                        width: "40px",
                        display: "flex",
                        justifyContent: "flex-end",
                        opacity: valueSpring.to({
                            range: [0, 1],
                            output: [1, 0.3],
                        }),
                    }, className: "helpButton-body-section-2", children: jsx("img", { alt: "AvatarImage", src: avatarSrc, width: "36px", height: "36px", style: {
                            borderRadius: "80px",
                        }, className: "helpButton-avatar" }) }), jsxs("div", { style: {
                        minWidth: "calc(100% - 36px)",
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        textAlign: "center",
                        fontSize: "16px",
                        fontWeight: "500",
                        color: "white",
                    }, className: "helpButton-body-section-3", children: [jsx("div", { style: {
                                display: "flex",
                                minWidth: "calc(100% - 40px)",
                                justifyContent: "center",
                                alignItems: "center",
                                textAlign: "center",
                                fontSize: "18px",
                                lineHeight: "18px",
                                fontWeight: "600",
                                color: "white",
                                fontFamily: brand === "staysure"
                                    ? "proxima-nova, sans-serif"
                                    : "faktum, sans-serif",
                            }, className: "helpButton-body-section-3-1", children: "Close" }), jsx("div", { style: {
                                width: "40px",
                                display: "flex",
                                justifyContent: "flex-end",
                            }, className: "helpButton-body-section-3-2", children: jsxs("svg", { width: "36", height: "36", viewBox: "0 0 36 36", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [jsx("g", { clipPath: "url(#clip0_4788_80719)", children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 3.875C10.199 3.875 3.875 10.199 3.875 18C3.875 25.801 10.199 32.125 18 32.125C25.801 32.125 32.125 25.801 32.125 18C32.125 10.199 25.801 3.875 18 3.875ZM2.125 18C2.125 9.23248 9.23248 2.125 18 2.125C26.7675 2.125 33.875 9.23248 33.875 18C33.875 26.7675 26.7675 33.875 18 33.875C9.23248 33.875 2.125 26.7675 2.125 18ZM23.1187 12.8813C23.4604 13.223 23.4604 13.777 23.1187 14.1187L19.2374 18L23.1187 21.8813C23.4604 22.223 23.4604 22.777 23.1187 23.1187C22.777 23.4604 22.223 23.4604 21.8813 23.1187L18 19.2374L14.1187 23.1187C13.777 23.4604 13.223 23.4604 12.8813 23.1187C12.5396 22.777 12.5396 22.223 12.8813 21.8813L16.7626 18L12.8813 14.1187C12.5396 13.777 12.5396 13.223 12.8813 12.8813C13.223 12.5396 13.777 12.5396 14.1187 12.8813L18 16.7626L21.8813 12.8813C22.223 12.5396 22.777 12.5396 23.1187 12.8813Z", fill: "white" }) }), jsx("defs", { children: jsx("clipPath", { id: "clip0_4788_80719", children: jsx("rect", { width: "36", height: "36", fill: "white" }) }) })] }) })] })] }) })));
}

const ModalContext = createContext({
    underlayStyles: {},
    modalStyles: {},
    className: "",
    uderlayClassName: "",
});

function ModalView(_a) {
    var { state, children } = _a, props = __rest(_a, ["state", "children"]);
    const ref = useRef(null);
    const { modalProps, underlayProps } = useModalOverlay(props, state, ref);
    const { modalStyles, underlayStyles, className, uderlayClassName } = useContext(ModalContext);
    return (jsx(FocusScope, { restoreFocus: false, children: jsx("div", Object.assign({ style: Object.assign({}, underlayStyles), "data-testid": "modalView-underLayer-test-id", className: uderlayClassName }, underlayProps, { children: jsx("div", Object.assign({}, modalProps, { ref: ref, className: className, style: modalStyles, "data-testid": "modalView-overlayer-test-id", children: children })) })) }));
}

function ModalTrigger(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    const state = useOverlayTriggerState(props);
    const { overlayProps } = useOverlayTrigger({ type: "dialog" }, state);
    return state.isOpen ? (jsx(ModalView, Object.assign({}, props, { state: state, children: cloneElement(children, overlayProps) }))) : null;
}

function FocusLock({ children, disabled }) {
    const containerRef = useRef(null);
    const focusedElementBeforeLockRef = useRef(null);
    useEffect(() => {
        const container = containerRef.current;
        const handleKeyDown = (event) => {
            const TAB_KEYCODE = 9;
            if (!container)
                return;
            const focusableElements = container.querySelectorAll('a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select');
            const firstFocusableElement = focusableElements[0];
            const lastFocusableElement = focusableElements[focusableElements.length - 1]; // Type it as HTMLElement
            if (event.keyCode === TAB_KEYCODE) {
                if (event.shiftKey) {
                    // Shift + Tab
                    if (document.activeElement === firstFocusableElement) {
                        lastFocusableElement === null || lastFocusableElement === void 0 ? void 0 : lastFocusableElement.focus();
                        event.preventDefault();
                    }
                }
                else if (document.activeElement === lastFocusableElement) {
                    // Tab
                    firstFocusableElement === null || firstFocusableElement === void 0 ? void 0 : firstFocusableElement.focus();
                    event.preventDefault();
                }
            }
        };
        const lock = () => {
            // Store the currently focused element before locking
            focusedElementBeforeLockRef.current =
                document.activeElement;
            container === null || container === void 0 ? void 0 : container.addEventListener("keydown", handleKeyDown);
            container === null || container === void 0 ? void 0 : container.focus(); // Optionally, focus the container to start the tabbing cycle inside it
        };
        const unlock = () => {
            // When unlocking, focus the previously focused element
            if (focusedElementBeforeLockRef.current) {
                focusedElementBeforeLockRef.current.focus();
            }
            // Reset the stored focused element and remove event listener
            focusedElementBeforeLockRef.current = null;
            container === null || container === void 0 ? void 0 : container.removeEventListener("keydown", handleKeyDown);
        };
        if (!disabled) {
            lock();
        }
        else {
            unlock();
        }
        return () => unlock();
    }, [disabled]);
    return (jsx("div", { ref: containerRef, tabIndex: disabled ? undefined : -1, children: children }));
}

const defaultUnderlayStyles = {
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    position: "fixed",
};
function Modal({ underlayStyles, modalStyles, isOpen, onOpenChange, children, className, uderlayClassName, isDismissable = true, }) {
    const contexValue = useMemo(() => {
        return {
            underlayStyles: Object.assign(Object.assign({}, defaultUnderlayStyles), underlayStyles),
            modalStyles: Object.assign({}, modalStyles),
            className,
            uderlayClassName,
        };
    }, [underlayStyles, modalStyles, className, uderlayClassName]);
    const modalTriggerProps = useMemo(() => {
        if (isOpen !== undefined)
            return { isOpen };
        return {};
    }, [isOpen]);
    const handleOnOpenChange = (isOpenState) => {
        if (onOpenChange !== undefined)
            onOpenChange(isOpenState);
    };
    return (jsx(ModalContext.Provider, { value: contexValue, children: jsx(FocusLock, { disabled: !isOpen, children: jsx(ModalTrigger, Object.assign({ isDismissable: isDismissable }, modalTriggerProps, { onOpenChange: (e) => handleOnOpenChange(e), children: jsx("div", { children: children }) })) }) }));
}

function Dialog(_a) {
    var { title, children, style, className } = _a, props = __rest(_a, ["title", "children", "style", "className"]);
    const ref = useRef(null);
    const { dialogProps, titleProps } = useDialog(props, ref);
    return (jsxs("div", Object.assign({}, dialogProps, { ref: ref, style: Object.assign({ outline: "none" }, style), className: className, children: [title &&
                (typeof title === "string" ? (jsx("h2", Object.assign({}, titleProps, { className: "dialog-title", children: title }))) : (jsx("div", Object.assign({}, titleProps, { className: "dialog-title", children: title })))), children] })));
}

function Option$2({ item, state, listClassName = "", availableListOptionsStyles = {}, focusedListTextColor, focusedListBackgroundColor, }) {
    const ref = useRef(null);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { optionProps, isFocused, isDisabled } = useOption({ key: item.key }, state, ref);
    return (jsx("li", Object.assign({}, optionProps, { ref: ref, style: Object.assign({ outline: "none", cursor: "pointer", display: "flex", justifyContent: "space-between", background: isFocused ? focusedListBackgroundColor : "transparent", color: isFocused ? focusedListTextColor : "#272427" }, availableListOptionsStyles), className: listClassName, children: item.rendered })));
}
function ListBox$2(props) {
    const ref = useRef(null);
    const { listBoxRef = ref, state, listBoxStyle = {}, unorderedListClassName, listClassName, focusedListTextColor, focusedListBackgroundColor, availableListOptionsStyles = {}, } = props;
    const { listBoxProps } = useListBox(props, state, listBoxRef);
    return (jsx("ul", Object.assign({}, listBoxProps, { ref: listBoxRef, className: unorderedListClassName, style: Object.assign({ margin: 0, padding: 0, listStyle: "none", maxHeight: 509, overflow: "auto", minWidth: 320, background: "white", marginTop: "3px", border: "1px solid gray", borderRadius: "5px" }, listBoxStyle), children: [...state.collection].map((item) => (jsx(Option$2, { item: item, state: state, listClassName: listClassName, focusedListTextColor: focusedListTextColor, focusedListBackgroundColor: focusedListBackgroundColor, availableListOptionsStyles: availableListOptionsStyles }, item.key))) })));
}

function Popover$2(_a) {
    var { children, state } = _a, props = __rest(_a, ["children", "state"]);
    const popoverRef = useRef(null);
    const { popoverProps, underlayProps } = usePopover(Object.assign(Object.assign({}, props), { popoverRef }), state);
    return (jsxs(Overlay, { children: [jsx("div", Object.assign({}, underlayProps, { style: { position: "relative", inset: 0 } })), jsxs("div", Object.assign({}, popoverProps, { ref: popoverRef, style: Object.assign(Object.assign({}, popoverProps.style), { 
                    // background: 'var(--page-background)',
                    backgroundColor: "white", borderRadius: "8px", marginTop: "10px" }), className: `list-overlay ${props.className}`, children: [jsx(DismissButton, { onDismiss: state.close }), children, jsx(DismissButton, { onDismiss: state.close })] }))] }));
}

function ChevronDownIcon({ testId, width, height, id = "", className = "", stroke, strokeWidth = 1.5, size = "M", brand = "staysure", semanticColor = "light", }) {
    const sizeMap = useMemo(() => {
        switch (size) {
            case "S":
                return 16;
            case "L":
                return 32;
            case "XL":
                return 48;
            case "XXL":
                return 56;
            default:
                return 24;
        }
    }, [size]);
    const strokeColor = useMemo(() => {
        if (brand && semanticColor) {
            const validBrand = colorMapChevronIcon[brand] ? brand : "default";
            const validSemanticColor = colorMapChevronIcon[validBrand][semanticColor]
                ? semanticColor
                : "light";
            return stroke !== null && stroke !== void 0 ? stroke : colorMapChevronIcon[validBrand][validSemanticColor];
        }
        return stroke !== null && stroke !== void 0 ? stroke : colorMapChevronIcon.default.light;
    }, [semanticColor, stroke, brand]);
    return (jsx("svg", { width: width !== null && width !== void 0 ? width : sizeMap, height: height !== null && height !== void 0 ? height : sizeMap, fill: "none", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", "data-testid": testId, className: `iconCompLibrary_chevronDownIcon_svg_${className}`, id: `iconCompLibrary_chevronDownIcon_svg_id_${id}`, children: jsx("path", { className: `iconCompLibrary_chevronDownIcon_path_${className}`, id: `iconCompLibrary_chevronDownIcon_path_id_${id}`, d: "M6 9.75977L12 15.7598L18 9.75977", stroke: strokeColor, strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }) }));
}

const Container$2 = styled.div `
  display: inline-block;
`;
const LabelDropdownWrapper = styled.div `
  display: flex;
  align-items: end;
  flex-direction: column;
`;
const Label = styled.div `
  padding-bottom: 8px;
`;
const DropdownButton$1 = styled.button `
  display: flex;
  align-items: center;
  justify-content: space-between;
  outline: none;
`;
const AlertMessage$1 = styled.div `
  position: absolute;
  color: ${({ $alerttextcolor }) => $alerttextcolor};
`;
function Select$1(_a) {
    var { isDisabled = false, label = "", alertState = null, alertMessage = "", placeholderText = "", placeholderTextAndLabel = "", spacing = "comfortable", semanticColor = "Light Background", dropdownBtnStyle = {}, dropdownArrowStyle = {}, placeholderTextStyle = {}, id = "", children, className = "", unorderedListClassName, popOverClassName = "", listClassName, $alerttextcolor = "#008205", optionalIcon, listBoxStyle, availableListOptionsStyles, focusedListTextColor = "#272427", focusedListBackgroundColor = "#7d7d7d14", isDispTextValueAfterSelect = false, defaultValue, strokeColor, brand, onDropdownBlur, placeholderLeftBeforeSelect, placeholderLeftAfterSelect, placeholderTopBeforeSelect, placeholderTopAfterSelect, dropdownRef, shouldCalculateWidth = false } = _a, props = __rest(_a, ["isDisabled", "label", "alertState", "alertMessage", "placeholderText", "placeholderTextAndLabel", "spacing", "semanticColor", "dropdownBtnStyle", "dropdownArrowStyle", "placeholderTextStyle", "id", "children", "className", "unorderedListClassName", "popOverClassName", "listClassName", "$alerttextcolor", "optionalIcon", "listBoxStyle", "availableListOptionsStyles", "focusedListTextColor", "focusedListBackgroundColor", "isDispTextValueAfterSelect", "defaultValue", "strokeColor", "brand", "onDropdownBlur", "placeholderLeftBeforeSelect", "placeholderLeftAfterSelect", "placeholderTopBeforeSelect", "placeholderTopAfterSelect", "dropdownRef", "shouldCalculateWidth"]);
    const state = useSelectState(Object.assign(Object.assign({}, props), { isDisabled, children: children, defaultSelectedKey: defaultValue }));
    useEffect(() => {
        state.setSelectedKey(defaultValue);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultValue]);
    const ref = useRef(null);
    const [dropdownWidth, setDropdownWidth] = useState(0);
    const updateWidth = () => {
        if (dropdownRef === null || dropdownRef === void 0 ? void 0 : dropdownRef.current) {
            setDropdownWidth(dropdownRef === null || dropdownRef === void 0 ? void 0 : dropdownRef.current.offsetWidth);
        }
    };
    useLayoutEffect(() => {
        if (shouldCalculateWidth) {
            updateWidth();
            window.addEventListener("resize", updateWidth);
            return () => window.removeEventListener("resize", updateWidth);
        }
        return undefined;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldCalculateWidth]);
    const { triggerProps, valueProps, menuProps } = useSelect(Object.assign(Object.assign({}, props), { isDisabled, "aria-label": label || "dropdown-label" }), state, dropdownRef !== null && dropdownRef !== void 0 ? dropdownRef : ref);
    const [isHovered, setIsHovered] = useState(false);
    const [isKeyBoardFocused, setIsKeyBoardFocused] = useState(false);
    const { isOpen, selectedKey } = state;
    const [containerOnBlur, setContainerOnBlur] = useState(false);
    const btnDisabled = useMemo(() => isDisabled, [isDisabled]);
    const placeholderStyle = useMemo(() => ({
        left: state.selectedItem
            ? placeholderLeftAfterSelect !== null && placeholderLeftAfterSelect !== void 0 ? placeholderLeftAfterSelect : -24
            : placeholderLeftBeforeSelect !== null && placeholderLeftBeforeSelect !== void 0 ? placeholderLeftBeforeSelect : 0,
        top: state.selectedItem
            ? placeholderTopAfterSelect !== null && placeholderTopAfterSelect !== void 0 ? placeholderTopAfterSelect : -5
            : placeholderTopBeforeSelect !== null && placeholderTopBeforeSelect !== void 0 ? placeholderTopBeforeSelect : 13,
    }), [
        state.selectedItem,
        placeholderLeftAfterSelect,
        placeholderLeftBeforeSelect,
        placeholderTopAfterSelect,
        placeholderTopBeforeSelect,
    ]);
    const { hoverProps } = useHover({
        isDisabled,
        onHoverChange: (hovered) => {
            setIsHovered(hovered);
        },
    });
    useEffect(() => {
        if (!isOpen && containerOnBlur) {
            if (onDropdownBlur) {
                onDropdownBlur(true);
            }
        }
    }, [containerOnBlur, isOpen, selectedKey, onDropdownBlur]);
    const { buttonProps } = useButton(Object.assign(Object.assign({}, triggerProps), { isDisabled,
        onFocus(e) {
            if (triggerProps.onFocus)
                triggerProps.onFocus(e);
            if (e.relatedTarget !== null) {
                setIsKeyBoardFocused(true);
            }
        },
        onBlur(e) {
            if (triggerProps.onBlur)
                triggerProps.onBlur(e);
            setIsKeyBoardFocused(false);
        } }), dropdownRef !== null && dropdownRef !== void 0 ? dropdownRef : ref);
    const handleDisplayAfterSelect = () => {
        var _a, _b;
        if (isDispTextValueAfterSelect) {
            return (_a = state.selectedItem) === null || _a === void 0 ? void 0 : _a.textValue;
        }
        return (_b = state.selectedItem) === null || _b === void 0 ? void 0 : _b.rendered;
    };
    return (jsxs(Container$2, { className: isKeyBoardFocused ? "keyBoardFocused" : "", onBlur: () => setContainerOnBlur(true), children: [jsxs(LabelDropdownWrapper, { children: [jsx(Label, { className: "hint_label", children: label }), jsx(HiddenSelect, { isDisabled: btnDisabled, state: state, triggerRef: ref }), jsx(DropdownButton$1
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    , Object.assign({}, mergeProps(buttonProps, hoverProps), { ref: dropdownRef !== null && dropdownRef !== void 0 ? dropdownRef : ref, disabled: isDisabled, style: Object.assign({}, dropdownBtnStyle), id: id, "data-testid": id, className: `${className} dropdown_component_library 
            ${isHovered ? "hovered" : ""} 
            ${state.isFocused ? "focused" : ""}
            ${state.isOpen ? "filled" : ""}
            ${state.selectedItem ? "selected" : ""}
            ${!state.selectedItem && state.isFocused
                            ? "focused_without_selectitem"
                            : ""} 
            ${alertState === "error" ? "error" : ""}
            ${alertState === "warning" ? "warning" : ""}
            ${alertState === "success" ? "success" : ""}
            ${isDisabled ? "disabled" : ""}
            ${brand === "avanti" ? "avn_styles" : "sts_styles"}
            ${isKeyBoardFocused ? "keyBoardFocusedInBtn" : ""}
            dropdown_component_library_${spacing}
            dropdown_component_library_${semanticColor === "Light Background"
                            ? "semantic_light"
                            : "semantic_dark"}
        `, "aria-label": "dropdown", children: jsxs("div", { style: {
                                display: "flex",
                                justifyContent: "space-between",
                                width: "100%",
                                position: "relative",
                            }, children: [jsxs("div", { style: { display: "flex" }, children: [optionalIcon && (jsx("div", { className: "optional_icon_component_library", "data-testid": "optional-icon", children: optionalIcon })), placeholderTextAndLabel && (jsx("label", Object.assign({ 
                                            // eslint-disable-next-line react/jsx-props-no-spreading
                                            id: `${id}-label`, "data-testid": `${id}-label`, htmlFor: `${id}-input`, "aria-label": `${label}-label`, "aria-labelledby": label }, valueProps, { style: Object.assign(Object.assign({}, placeholderTextStyle), { position: "absolute", left: placeholderStyle.left, top: placeholderStyle.top, transform: state.selectedItem
                                                    ? "translateY(-100%) scale(0.75)"
                                                    : "translateY(-50%) scale(1)", transition: "top 0.2s ease, transform 0.2s ease, left 0.2s ease", background: state.selectedItem ? "white" : "transparent", padding: state.selectedItem ? "0 4px 0 4px" : 0, color: state.selectedItem ? "#272427" : "#4F4F4F", fontSize: 16, fontWeight: state.selectedItem ? 500 : 600, borderRadius: 120 }), children: placeholderTextAndLabel }))), jsx("div", Object.assign({}, valueProps, { style: Object.assign({}, placeholderTextStyle), className: `placeholder_text_component_library 
                          ${state.isOpen ? "filled" : ""}
                          ${alertState === "error" ? "error" : ""}
                          ${alertState === "warning" ? "warning" : ""}
                          ${alertState === "success" ? "success" : ""}
                          ${brand === "avanti" ? "avn_styles" : "sts_styles"}
                       `, children: state.selectedItem
                                                ? handleDisplayAfterSelect()
                                                : placeholderText !== null && placeholderText !== void 0 ? placeholderText : placeholderTextAndLabel }))] }), jsx("div", { "aria-hidden": "true", style: dropdownArrowStyle, className: "arrow_head_icon_component_library", children: jsx(ChevronDownIcon, { stroke: strokeColor }) })] }) }))] }), jsx(AlertMessage$1, { "$alerttextcolor": $alerttextcolor, className: `alert_message_dropdown 
                    ${alertState === "error" ? "error" : ""}
                    ${alertState === "warning" ? "warning" : ""}
                    ${alertState === "success" ? "success" : ""}`, children: alertMessage }), state.isOpen && (jsx(Popover$2, { state: state, triggerRef: dropdownRef !== null && dropdownRef !== void 0 ? dropdownRef : ref, placement: "bottom start", className: popOverClassName, children: jsx(ListBox$2
                // eslint-disable-next-line react/jsx-props-no-spreading
                , Object.assign({}, menuProps, { listBoxStyle: shouldCalculateWidth
                        ? Object.assign(Object.assign({}, listBoxStyle), { width: dropdownWidth }) : Object.assign({}, listBoxStyle), availableListOptionsStyles: Object.assign({}, availableListOptionsStyles), state: state, unorderedListClassName: unorderedListClassName, listClassName: listClassName, focusedListTextColor: focusedListTextColor, focusedListBackgroundColor: focusedListBackgroundColor })) }))] }));
}
function DropdownItem$1({ children, }) {
    return children;
}
function mapDropdownItems$1(children) {
    return React__default.Children.toArray(children)
        .map((child) => {
        var _a, _b;
        if (React__default.isValidElement(child) && child.type === DropdownItem$1) {
            return {
                item: child,
                value: (_a = child.props.value) !== null && _a !== void 0 ? _a : "",
                keyValue: (_b = child.props.keyValue) !== null && _b !== void 0 ? _b : "",
            };
        }
        return null;
    })
        .filter(Boolean);
}
function Dropdown$1(_a) {
    var { children, listBoxStyle, defaultValue } = _a, props = __rest(_a, ["children", "listBoxStyle", "defaultValue"]);
    const allowedChildren = mapDropdownItems$1(children);
    const propsList = Object.assign({}, props);
    delete propsList.children;
    return (jsx(Select$1, Object.assign({ defaultValue: defaultValue }, propsList, { listBoxStyle: listBoxStyle, children: allowedChildren === null || allowedChildren === void 0 ? void 0 : allowedChildren.map((item) => (jsx(Item, { textValue: item === null || item === void 0 ? void 0 : item.value, children: item === null || item === void 0 ? void 0 : item.item }, (item === null || item === void 0 ? void 0 : item.keyValue) !== "" ? item === null || item === void 0 ? void 0 : item.keyValue : item === null || item === void 0 ? void 0 : item.value))) })));
}

function TelephoneTextField(_a) {
    var { label, id = "custom-text-field", isDisabled = false, state = "", message = "", value = "", hint = "", width = "100%", maxLength, onChange, onSelect, labelLeftPadding, activeHoverd = true, type, brand = "staysure", inputFieldClassName, dropdownOptions, dropDownValue } = _a, props = __rest(_a, ["label", "id", "isDisabled", "state", "message", "value", "hint", "width", "maxLength", "onChange", "onSelect", "labelLeftPadding", "activeHoverd", "type", "brand", "inputFieldClassName", "dropdownOptions", "dropDownValue"]);
    const [isFocused, setIsFocused] = useState(false);
    const [fieldValue, setFieldValue] = useState(value);
    const [isHover, setIsHover] = useState(false);
    const [isActive, setIsActive] = useState(false);
    const ref = useRef(null);
    const [accesibilityClassName, setAccesibilityClassName] = useState("");
    const [isTabFocused, setIsTabFocused] = useState(false);
    useEffect(() => {
        setFieldValue(value);
    }, [value]);
    useEffect(() => {
        const handleKeyboard = (e) => {
            /* istanbul ignore else */
            if (e.key === "Tab" && !isDisabled) {
                setIsTabFocused(true);
            }
        };
        document.addEventListener("keydown", handleKeyboard);
        return () => {
            document.removeEventListener("keydown", handleKeyboard);
        };
    }, [isDisabled]);
    const { labelProps, inputProps, errorMessageProps } = useTextField(Object.assign(Object.assign({}, props), { "aria-label": label }), ref);
    // Prevent scrolling on number input type
    useEffect(() => {
        const inputElement = ref.current;
        if (inputElement) {
            inputElement.addEventListener("wheel", (e) => e.preventDefault(), {
                passive: false,
            });
        }
        return () => {
            if (inputElement) {
                inputElement.removeEventListener("wheel", (e) => e.preventDefault());
            }
        };
    }, []);
    // check active state
    const { focusProps } = useFocus({
        isDisabled,
        onFocusChange: (focused) => {
            /* istanbul ignore else */
            if (focused) {
                setIsActive(true);
                setAccesibilityClassName("focused");
            }
        },
    });
    const handleFocus = () => {
        if (isTabFocused) {
            setIsFocused((prevIsFocused) => !prevIsFocused);
            setIsActive(true);
        }
        else {
            setIsActive(true);
        }
    };
    const handleBlur = (e) => {
        setIsActive(false);
        setIsFocused(false);
        setAccesibilityClassName("");
        if (inputProps && typeof inputProps.onBlur === "function") {
            inputProps.onBlur(e);
        }
    };
    const handleChange = (e) => {
        setFieldValue(e.target.value);
        /* istanbul ignore else */
        if (onChange && onChange !== undefined) {
            onChange(e.target.value, e);
        }
    };
    const handleMouseDown = () => {
        setIsFocused(true);
        setIsActive(true);
    };
    const handleMouseUp = () => {
        setIsFocused(false);
    };
    const getInputBorder = useCallback(() => {
        if (isDisabled)
            return brand === "staysure"
                ? "2px solid rgba(210, 210, 210, 1)"
                : "2px solid rgba(210, 206, 202, 1)";
        if (state === "error")
            return `2px solid rgba(202, 48, 43, 1)`;
        if (state === "warning")
            return "2px solid rgba(208, 109, 16, 1)";
        if (state === "success")
            return "2px solid rgba(0, 130, 5, 1)";
        if (isFocused)
            return "2px solid rgba(54, 143, 233, 1)";
        if (isHover && activeHoverd)
            return brand === "staysure"
                ? "2px solid rgba(40, 86, 110, 1)"
                : "2px solid rgba(22, 70, 72, 1)";
        if (isActive || fieldValue)
            return brand === "staysure"
                ? "2px solid rgba(48, 101, 130, 1)"
                : "2px solid rgba(22, 70, 72, 1)";
        return brand === "staysure"
            ? "1px solid rgba(48, 101, 130, 1)"
            : "1px solid rgba(0, 90, 94, 1)";
    }, [
        brand,
        isFocused,
        isHover,
        isActive,
        fieldValue,
        state,
        isDisabled,
        activeHoverd,
    ]);
    const getInputBackgroundColor = useCallback(() => {
        if (isDisabled || (isHover && activeHoverd && !isFocused && !isActive))
            return "rgba(240, 240, 240, 1)";
        return "transparent";
    }, [isDisabled, isHover, isFocused, isActive, activeHoverd]);
    const inputStyle = useMemo(() => ({
        border: getInputBorder(),
        backgroundColor: getInputBackgroundColor(),
    }), [getInputBorder, getInputBackgroundColor]);
    const getLabelBorder = useCallback(() => {
        if (isFocused && !fieldValue)
            return "rgba(54, 143, 233, 1)";
        if (brand === "staysure" && (fieldValue || isActive))
            return "rgba(39, 36, 39, 1)";
        if (brand === "avanti" && (fieldValue || isActive))
            return "rgba(46, 45, 44, 1)";
        if (brand === "staysure" && isDisabled)
            return "rgba(125, 125, 125, 1)";
        if (brand === "avanti" && isDisabled)
            return "rgba(125, 123, 120, 1)";
        if (brand === "staysure")
            return "rgba(79, 79, 79, 1)";
        return "rgba(79, 77, 76, 1)";
    }, [isFocused, fieldValue, isActive, brand, isDisabled]);
    const getLabelBackgroundColor = useCallback(() => {
        if (isDisabled && fieldValue)
            return "linear-gradient(to top, rgba(240, 240, 240, 1) 0%, rgba(240, 240, 240, 1) 40%, white 40%, white 100%";
        if (isDisabled && !isFocused && !isActive)
            return "transparent";
        if (isActive || fieldValue) {
            return `linear-gradient(to top, ${isHover && !isFocused && !isActive ? "rgba(240, 240, 240, 1)" : "white"} 0%, ${isHover && !isFocused && !isActive ? "rgba(240, 240, 240, 1)" : "white"} 42%, white 42%, white 100%`;
        }
        return "transparent";
    }, [isDisabled, isFocused, fieldValue, isActive, isHover]);
    const labelStyle = useMemo(() => ({
        color: getLabelBorder(),
        backgroundColor: getLabelBackgroundColor(),
    }), [getLabelBorder, getLabelBackgroundColor]);
    const messageColor = useMemo(() => {
        if (isDisabled && state === "success")
            return "rgb(0, 130, 5)";
        if (isDisabled)
            return "rgb(125, 125, 125)";
        if (state === "error")
            return "rgb(202, 48, 43)";
        if (state === "warning")
            return "rgb(208, 109, 16)";
        if (state === "success")
            return "rgb(0, 130, 5)";
        return "rgb(48, 101, 130)";
    }, [state, isDisabled]);
    const fieldTextColor = useMemo(() => {
        if (brand === "staysure") {
            if (isDisabled)
                return "rgba(125, 125, 125, 1)";
            return "rgba(39, 36, 39, 1)";
        }
        if (brand === "avanti") {
            if (isDisabled)
                return "rgba(79, 77, 76, 1)";
            return "rgba(46, 45, 44, 1)";
        }
        return "rgba(39, 36, 39, 1)";
    }, [brand, isDisabled]);
    const setClassName = useMemo(() => {
        if (isActive)
            return "active-";
        if (state === "error")
            return "error-";
        if (isHover)
            return "hover-";
        return "";
    }, [isActive, state, isHover]);
    const onFocusInput = () => {
        const input = ref.current;
        if (input) {
            input.focus();
        }
    };
    const componentRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [selectedValue, setSelectedValue] = useState(dropdownOptions[0]);
    const handleDropdownToggle = (e) => {
        e.stopPropagation();
        e.preventDefault();
        setIsOpen((prev) => !prev);
    };
    useEffect(() => {
        const selectedOption = dropdownOptions.find((option) => option.code === dropDownValue);
        if (selectedOption) {
            setSelectedValue(selectedOption);
        }
    }, [dropDownValue, dropdownOptions]);
    const handleOptionSelect = (option) => {
        setSelectedValue(option);
        setIsOpen(false);
        // Trigger the onSelect callback when an option is selected
        if (onSelect) {
            onSelect(option);
        }
    };
    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (componentRef.current &&
                !componentRef.current.contains(event.target)) {
                setIsOpen(false); // Close the dropdown
            }
        };
        // Add event listener when dropdown is open
        if (isOpen) {
            document.addEventListener("mousedown", handleOutsideClick);
        }
        return () => {
            // Cleanup event listener
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, [isOpen]);
    return (jsxs("div", { style: { width }, children: [hint && (jsx("div", { style: {
                    textAlign: "right",
                    fontSize: 16,
                    fontWeight: 350,
                    color: "rgba(79, 79, 79, 1)",
                    padding: "none",
                    marginBottom: 8,
                    lineHeight: "24px",
                }, children: hint })), jsx("div", { id: id, "data-testid": id, role: "textbox", tabIndex: -1, onMouseEnter: () => setIsHover(true), onMouseLeave: () => setIsHover(false), "aria-label": label, "aria-labelledby": `${id}-label`, "aria-hidden": "true", className: `${setClassName}text-input ${fieldValue ? "has-value " : ""}text-input-block`, style: {
                    position: "relative",
                    height: "56px",
                    border: inputStyle.border,
                    borderRadius: 8,
                    backgroundColor: inputStyle.backgroundColor,
                    outline: isHover && activeHoverd && !isFocused
                        ? "2px solid rgba(171, 185, 195, 1)"
                        : "none",
                }, onClick: () => {
                    onFocusInput();
                }, children: jsxs("div", { style: {
                        height: "100%",
                        width: "100%",
                        border: "none",
                        borderRadius: 8,
                        boxSizing: "border-box",
                        outline: "none",
                        fontSize: 16,
                        fontWeight: 600,
                        backgroundColor: inputStyle.backgroundColor,
                        color: fieldTextColor,
                        caretColor: "#000",
                        display: "flex",
                    }, className: `${accesibilityClassName} ${inputFieldClassName}`, children: [jsxs("div", { ref: componentRef, style: {
                                position: "relative",
                                minWidth: "120px",
                                maxWidth: "200px",
                                zIndex: 1,
                            }, children: [jsxs("button", { type: "button", onClick: handleDropdownToggle, style: {
                                        display: "flex",
                                        alignItems: "center",
                                        cursor: "pointer",
                                        fontSize: "16px",
                                        width: "auto",
                                        height: "52px",
                                        borderTopLeftRadius: 8,
                                        borderBottomLeftRadius: 8,
                                        backgroundColor: inputStyle.backgroundColor,
                                        border: "none",
                                        borderRight: "2px solid #D2D2D2",
                                        paddingLeft: "12px",
                                        paddingRight: "12px",
                                        whiteSpace: "nowrap", // Prevent line breaks
                                        fontWeight: 600,
                                        justifyContent: "space-between",
                                    }, children: [jsxs("span", { style: { display: "flex", alignItems: "center", gap: 8 }, children: [selectedValue.optDropdownFlag, " ", selectedValue.optDropdownTelCode] }), jsx("div", { "aria-hidden": "true", className: "arrow_head_icon_component_library", children: jsx(ChevronDownIcon, { stroke: "#000" }) })] }), isOpen && (jsx("div", { style: {
                                        position: "absolute",
                                        top: "100%",
                                        left: 0,
                                        right: 0,
                                        border: "1px solid gray",
                                        background: "white",
                                        overflowY: "auto",
                                        borderTop: "none",
                                        margin: 0,
                                        padding: 0,
                                        listStyle: "none",
                                        maxHeight: 509,
                                        overflow: "auto",
                                        minWidth: 317,
                                        marginTop: "3px",
                                        borderRadius: "5px",
                                        outline: "none",
                                        fontWeight: 400,
                                        boxShadow: "0px 0px 12px 0px rgba(15, 23, 42, 0.11)",
                                    }, children: dropdownOptions.map((option) => (jsxs("button", { type: "button", onClick: () => handleOptionSelect(option), style: {
                                            display: "flex",
                                            alignItems: "center",
                                            padding: "8px",
                                            cursor: "pointer",
                                            gap: 8,
                                        }, children: [option.optDropdownFlag, option.optDropdownName, "  ", option.optDropdownTelCode] }, option.code))) }))] }), jsxs("div", { style: {
                                position: "relative",
                                height: "100%",
                                width: "100%",
                                border: "none",
                                borderRadius: 8,
                                boxSizing: "border-box",
                                outline: "none",
                                fontSize: 16,
                                fontWeight: 600,
                                backgroundColor: inputStyle.backgroundColor,
                                color: fieldTextColor,
                                caretColor: "#000",
                            }, children: [jsx("label", Object.assign({}, labelProps, { id: `${id}-label`, "data-testid": `${id}-label`, htmlFor: `${id}-input`, "aria-label": label, style: {
                                        position: "absolute",
                                        left: isActive || fieldValue ? -125 : labelLeftPadding !== null && labelLeftPadding !== void 0 ? labelLeftPadding : 8,
                                        top: isActive || fieldValue ? 10 : "50%",
                                        transform: isActive || fieldValue
                                            ? "translateY(-100%) scale(0.75)"
                                            : "translateY(-50%) scale(1)",
                                        transition: "top 0.2s ease, transform 0.2s ease, left 0.2s ease",
                                        background: labelStyle.backgroundColor,
                                        padding: isActive || fieldValue ? "0 4px 0 4px" : 0,
                                        color: labelStyle.color,
                                        fontSize: 16,
                                        fontWeight: isActive || fieldValue ? 500 : 600,
                                        zIndex: 1,
                                    }, children: label })), jsx("input", Object.assign({}, mergeProps(inputProps, focusProps), { ref: ref, id: `${id}-input`, "data-testid": `${id}-input`, type: type !== null && type !== void 0 ? type : "text", onMouseDown: handleMouseDown, onMouseUp: handleMouseUp, onMouseLeave: handleMouseUp, onBlur: handleBlur, onFocus: handleFocus, onChange: handleChange, disabled: isDisabled, maxLength: maxLength !== null && maxLength !== void 0 ? maxLength : 20, value: fieldValue, className: `${accesibilityClassName} ${inputFieldClassName}`, style: {
                                        height: "100%",
                                        width: "100%",
                                        border: "none",
                                        borderRadius: 8,
                                        padding: `16px ${labelLeftPadding !== null && labelLeftPadding !== void 0 ? labelLeftPadding : "8px"}`,
                                        boxSizing: "border-box",
                                        outline: "none",
                                        fontSize: 16,
                                        fontWeight: 600,
                                        backgroundColor: inputStyle.backgroundColor,
                                        color: fieldTextColor,
                                        caretColor: "#000",
                                    } }))] })] }) }), message && state === "error" ? (jsx("div", Object.assign({}, errorMessageProps, { id: `${id}-message`, "data-testid": `${id}-message`, style: {
                    textAlign: "left",
                    fontSize: 14,
                    fontWeight: 600,
                    color: messageColor,
                    padding: "none",
                    marginTop: 4,
                    lineHeight: "21px",
                    width: 320,
                }, children: message }))) : null, message && state !== "error" ? (jsx("div", { id: `${id}-message`, "data-testid": `${id}-message`, style: {
                    textAlign: "left",
                    fontSize: 14,
                    fontWeight: 600,
                    color: messageColor,
                    padding: "none",
                    marginTop: 4,
                    lineHeight: "21px",
                    width: 320,
                }, children: message })) : null] }));
}

var css_248z$6 = ".SideDrawer-module_header__P2BV9 {\n    min-height: 64px;\n    border-bottom: 1px solid #ddd;\n}\n\n.SideDrawer-module_overlay__iFuwl {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    opacity: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.SideDrawer-module_overlayOpen__EseOY {\n    opacity: 1;\n    z-index: 0;\n    visibility: visible;\n}\n\n.SideDrawer-module_overlayHidden__k1hP4 {\n    opacity: 0;\n    z-index: -1;\n    visibility: hidden;\n    transition: 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n}\n\n.SideDrawer-module_drawer__6CAEX {\n    top: 0;\n    flex: 1 0 auto;\n    height: 100%;\n    display: flex;\n    outline: 0;\n    z-index: 1200;\n    position: fixed;\n    overflow-y: auto;\n    flex-direction: column;\n    background-color: #ffffff;\n    flex-shrink: 0;\n    transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 1000ms,\n        transform 500ms cubic-bezier(0, 0, 0.2, 1) 0ms;\n}\n\n.SideDrawer-module_hidden__RPz3o {\n    visibility: hidden;\n    width: 240px;\n    transform: translateX(300px);\n    flex-shrink: 0;\n    transition: 325ms cubic-bezier(0, 0, 0.2, 1) 0ms;\n}\n\n.SideDrawer-module_animate__kZCME {\n    visibility: visible;\n    transform: none;\n    box-shadow: 0 8px 10px -5px rgba(0, 0, 0, 0.2),\n        0px 16px 24px 2px rgba(0, 0, 0, 0.14), 0px 6px 30px 5px rgba(0, 0, 0, 0.12);\n}\n\n.SideDrawer-module_left__nwOjL {\n    left: 0;\n    right: auto;\n}\n\n.SideDrawer-module_right__-Ruz5 {\n    right: 0;\n    left: auto;\n}\n\n.SideDrawer-module_closeBtn__kBhPa:focus-visible {\n    outline: 2px solid #368fe9;\n    outline-offset: 2px;\n    border-radius: 8px;\n}";
var Styles$4 = {"header":"SideDrawer-module_header__P2BV9","overlay":"SideDrawer-module_overlay__iFuwl","overlayOpen":"SideDrawer-module_overlayOpen__EseOY","overlayHidden":"SideDrawer-module_overlayHidden__k1hP4","drawer":"SideDrawer-module_drawer__6CAEX","hidden":"SideDrawer-module_hidden__RPz3o","animate":"SideDrawer-module_animate__kZCME","left":"SideDrawer-module_left__nwOjL","right":"SideDrawer-module_right__-Ruz5","closeBtn":"SideDrawer-module_closeBtn__kBhPa"};
styleInject(css_248z$6);

function SupportDrawer({ isOpen, onCloseDrawer, children, drawerContentClassName, wrapperStyles = "", closeBtnWrapperStyles = "", drawerContentWrapperClassName = "", width, closeButton, closeBtnWrapperClassName, closeBtnWrapperProps, drawerPaperProps, }) {
    const [open, setOpen] = useState(isOpen);
    const toggleDrawer = (newOpen) => () => {
        setOpen(newOpen);
        onCloseDrawer();
    };
    useEffect(() => {
        setOpen(isOpen);
    }, [isOpen]);
    return (jsx(Drawer, { onClose: toggleDrawer(false), anchor: "right", open: open, "data-testid": "support-drawer", transitionDuration: 500, PaperProps: {
            style: Object.assign({ width, height: "auto", maxHeight: "100vh" }, drawerPaperProps),
            className: `${wrapperStyles} `,
        }, children: jsxs("div", { className: `${drawerContentWrapperClassName}`, children: [jsx("div", { className: `${closeBtnWrapperStyles}`, children: jsx("button", { style: Object.assign({ border: "none", background: "transparent" }, closeBtnWrapperProps), type: "button", onClick: toggleDrawer(false), className: ` ${closeBtnWrapperClassName} ${Styles$4.closeBtn}`, children: closeButton }) }), jsx("div", { className: drawerContentClassName, children: children })] }) }));
}

const TextBox = styled.div `
  min-width: 20px;
  border: 1px solid;
  border-left-width: 6px;
  position: relative;
`;
function InlineInfoBox({ style, id, content, tabIndex = 0, className = "", }) {
    const ref = useRef(null);
    return (jsx(TextBox, { ref: ref, id: id, tabIndex: tabIndex, style: style, "data-testid": "textBox", className: ` ${className}`, children: jsx("div", { "data-testid": "content", className: "component-lib-inlineInfoBox-content", children: content }) }));
}

function LeftArrowIcon({ testId, size = "M", width, height, stroke, strokeWidth = 1.5, brand = "staysure", semanticColor = "light", }) {
    const sizeMap = useMemo(() => getSizeMap(size), [size]);
    const strokeColor = useMemo(() => {
        if (brand && semanticColor) {
            const validBrand = colorMapCommon[brand] ? brand : "default";
            const validSemanticColor = colorMapCommon[validBrand][semanticColor]
                ? semanticColor
                : "light";
            return stroke !== null && stroke !== void 0 ? stroke : colorMapCommon[validBrand][validSemanticColor];
        }
        return stroke !== null && stroke !== void 0 ? stroke : colorMapCommon.default.light;
    }, [brand, semanticColor, stroke]);
    return (jsx("svg", { width: width !== null && width !== void 0 ? width : sizeMap, height: height !== null && height !== void 0 ? height : sizeMap, viewBox: "0 0 24 25", "data-testid": testId, className: "iconCompLibrary_leftArrowIcon_svg", id: "iconCompLibrary_leftArrowIcon_svg_id", xmlns: "http://www.w3.org/2000/svg", fill: "none", children: jsx("path", { className: "iconCompLibrary_leftArrowIcon_path", id: "iconCompLibrary_leftArrowIcon_path_id", d: "M19 12H5.5M12 19L5 12L12 5", stroke: strokeColor, strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }) }));
}

function RightArrowIcon({ testId, size = "M", width, height, stroke = "#306582", strokeWidth = 1.5, }) {
    const sizeMap = useMemo(() => getSizeMap(size), [size]);
    return (jsx("svg", { width: width !== null && width !== void 0 ? width : sizeMap, height: height !== null && height !== void 0 ? height : sizeMap, viewBox: "0 0 24 25", "data-testid": testId, className: "iconCompLibrary_rightArrowIcon_svg", id: "iconCompLibrary_rightArrowIcon_svg_id", xmlns: "http://www.w3.org/2000/svg", fill: "none", children: jsx("path", { className: "iconCompLibrary_rightArrowIcon_path", id: "iconCompLibrary_rightArrowIcon_path_id", d: "M5 12H19M19 12L12 5M19 12L12 19", stroke: stroke, strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }) }));
}

function InfoIcon({ testId, size = "M", width, height, stroke, strokeWidth = 1.5, brand = "staysure", semanticColor = "light", }) {
    const sizeMap = useMemo(() => getSizeMap(size), [size]);
    const strokeColor = useMemo(() => {
        if (brand && semanticColor) {
            const validBrand = colorMapCommon[brand] ? brand : "default";
            const validSemanticColor = colorMapCommon[validBrand][semanticColor]
                ? semanticColor
                : "light";
            return stroke !== null && stroke !== void 0 ? stroke : colorMapCommon[validBrand][validSemanticColor];
        }
        return stroke !== null && stroke !== void 0 ? stroke : colorMapCommon.default.light;
    }, [brand, semanticColor, stroke]);
    return (jsx("svg", { width: width !== null && width !== void 0 ? width : sizeMap, height: height !== null && height !== void 0 ? height : sizeMap, viewBox: "0 0 24 24", "data-testid": testId, className: "iconCompLibrary_infoIcon_svg", id: "iconCompLibrary_infoIcon_svg_id", xmlns: "http://www.w3.org/2000/svg", fill: "none", children: jsx("path", { className: "iconCompLibrary_infoIcon_path", id: "iconCompLibrary_infoIcon_path_id", d: "M11 15V11M11 7H11.01M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z", stroke: strokeColor, strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }) }));
}

function HeartHandshakeIcon({ testId, size = "M", width, height, fill, brand = "staysure", semanticColor = "light", stroke, strokeWidth = 0, }) {
    const sizeMap = useMemo(() => getSizeMap(size), [size]);
    const strokeColor = useMemo(() => {
        if (brand && semanticColor) {
            const validBrand = colorMapCommon[brand] ? brand : "default";
            const validSemanticColor = colorMapCommon[validBrand][semanticColor]
                ? semanticColor
                : "light";
            return stroke !== null && stroke !== void 0 ? stroke : colorMapCommon[validBrand][validSemanticColor];
        }
        return stroke !== null && stroke !== void 0 ? stroke : colorMapCommon.default.light;
    }, [brand, semanticColor, stroke]);
    return (jsx("svg", { width: width !== null && width !== void 0 ? width : sizeMap, height: height !== null && height !== void 0 ? height : sizeMap, viewBox: "0 0 25 24", "data-testid": testId, className: "iconCompLibrary_heartHandshakeIcon_svg", id: "iconCompLibrary_heartHandshakeIcon_svg_id", xmlns: "http://www.w3.org/2000/svg", fill: fill, stroke: strokeColor, strokeWidth: strokeWidth, children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.90512 2.24219C7.09569 2.24219 6.29423 2.40197 5.54668 2.71237C4.79933 3.0227 4.12058 3.47746 3.54931 4.05059C1.11056 6.48986 1.03563 10.5417 3.96489 13.5258L3.96487 13.5259L3.96979 13.5308L11.9698 21.5308C12.1104 21.6714 12.3012 21.7504 12.5001 21.7504C12.699 21.7504 12.8898 21.6714 13.0304 21.5308L21.0304 13.5308L21.0305 13.5308L21.0353 13.5258C23.9646 10.5417 23.8897 6.48985 21.4509 4.05058C20.8796 3.47745 20.2009 3.02269 19.4536 2.71237C18.706 2.40197 17.9045 2.24219 17.0951 2.24219C16.2857 2.24219 15.4842 2.40197 14.7367 2.71237C13.9891 3.02278 13.3102 3.47769 12.7389 4.05104L12.7364 4.05355L12.5001 4.29288L12.2639 4.05355L12.2639 4.05354L12.2614 4.05104C11.69 3.47769 11.0111 3.02278 10.2636 2.71237C9.51601 2.40197 8.71454 2.24219 7.90512 2.24219ZM6.12191 4.09769C6.68713 3.863 7.29311 3.74219 7.90512 3.74219C8.51712 3.74219 9.12311 3.863 9.68832 4.09769C10.253 4.33218 10.7659 4.67573 11.1977 5.10868L11.1989 5.10985L11.4436 5.35776L8.8388 7.97087L8.8375 7.97218C8.30245 8.5116 8.00223 9.24059 8.00223 10.0004C8.00223 10.7601 8.30245 11.4891 8.8375 12.0285L9.36998 11.5004L8.84181 12.0328C9.38123 12.5679 10.1102 12.8681 10.87 12.8681C11.6288 12.8681 12.3569 12.5686 12.8962 12.0348L15.1543 9.82658L15.1544 9.82659L15.1575 9.8235C15.5787 9.40671 16.1474 9.17293 16.74 9.17293C17.332 9.17293 17.9001 9.40623 18.3212 9.82221L18.3225 9.8235L20.4405 11.9415C20.2955 12.1214 20.1379 12.2986 19.9673 12.4726L18.5001 13.9398L17.0304 12.4702C16.7375 12.1773 16.2626 12.1773 15.9697 12.4702C15.6768 12.7631 15.6768 13.2379 15.9697 13.5308L17.4394 15.0005L15.5001 16.9398L14.0304 15.4702C13.7375 15.1773 13.2626 15.1773 12.9697 15.4702C12.6768 15.7631 12.6768 16.2379 12.9697 16.5308L14.4394 18.0005L12.5001 19.9398L5.03297 12.4726C2.62492 10.0173 2.81026 6.91096 4.61045 5.11078L4.61137 5.10985C5.04337 4.67635 5.55669 4.33239 6.12191 4.09769ZM21.258 10.6377C22.196 8.61437 21.7621 6.48306 20.3898 5.11078L20.3889 5.10985C19.9569 4.67635 19.4435 4.33239 18.8783 4.09769C18.3131 3.863 17.7071 3.74219 17.0951 3.74219C16.4831 3.74219 15.8771 3.863 15.3119 4.09769C14.7472 4.33218 14.2343 4.67573 13.8025 5.10868L13.8014 5.10985L13.0339 5.88734L13.02 5.90098L9.90246 9.02852L9.90186 9.02912C9.64586 9.28753 9.50223 9.63658 9.50223 10.0004C9.50223 10.3634 9.64528 10.7118 9.90031 10.97C10.1586 11.225 10.5069 11.3681 10.87 11.3681C11.234 11.3681 11.5833 11.2242 11.8418 10.9679L11.8456 10.9641L11.8456 10.9641L14.1041 8.75561C14.806 8.06196 15.7531 7.67293 16.74 7.67293C17.7276 7.67293 18.6754 8.06256 19.3775 8.75721L19.3803 8.76001L21.258 10.6377Z" }) }));
}

function MailIcon({ testId, size = "M", width, height, stroke, strokeWidth = 1.5, brand = "staysure", semanticColor = "light", }) {
    const sizeMap = useMemo(() => getSizeMap(size), [size]);
    const strokeColor = useMemo(() => {
        if (brand && semanticColor) {
            const validBrand = colorMapCommon[brand] ? brand : "default";
            const validSemanticColor = colorMapCommon[validBrand][semanticColor]
                ? semanticColor
                : "light";
            return stroke !== null && stroke !== void 0 ? stroke : colorMapCommon[validBrand][validSemanticColor];
        }
        return stroke !== null && stroke !== void 0 ? stroke : colorMapCommon.default.light;
    }, [brand, semanticColor, stroke]);
    return (jsx("svg", { width: width !== null && width !== void 0 ? width : sizeMap, height: height !== null && height !== void 0 ? height : sizeMap, viewBox: "0 0 22 18", "data-testid": testId, className: "iconCompLibrary_mailIcon_svg", xmlns: "http://www.w3.org/2000/svg", fill: "none", children: jsx("path", { d: "M21 4L12.03 9.7C11.7213 9.89343 11.3643 9.99601 11 9.99601C10.6357 9.99601 10.2787 9.89343 9.97 9.7L1 4M3 1H19C20.1046 1 21 1.89543 21 3V15C21 16.1046 20.1046 17 19 17H3C1.89543 17 1 16.1046 1 15V3C1 1.89543 1.89543 1 3 1Z", stroke: strokeColor, strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }) }));
}

function CheckIcon({ testId, size = "M", width, height, fill, brand = "staysure", semanticColor = "light", }) {
    const sizeMap = useMemo(() => getSizeMap(size), [size]);
    const fillColor = useMemo(() => {
        if (brand && semanticColor) {
            const validBrand = colorMapCommon[brand] ? brand : "default";
            const validSemanticColor = colorMapCommon[validBrand][semanticColor]
                ? semanticColor
                : "light";
            return fill !== null && fill !== void 0 ? fill : colorMapCommon[validBrand][validSemanticColor];
        }
        return fill !== null && fill !== void 0 ? fill : colorMapCommon.default.light;
    }, [brand, semanticColor, fill]);
    return (jsx("svg", { width: width !== null && width !== void 0 ? width : sizeMap, height: height !== null && height !== void 0 ? height : sizeMap, viewBox: "0 0 22 22", "data-testid": testId, className: "iconCompLibrary_checkIcon_svg", id: "iconCompLibrary_checkIcon_svg_id", xmlns: "http://www.w3.org/2000/svg", fill: "none", children: jsx("path", { className: "iconCompLibrary_checkIcon_path", id: "iconCompLibrary_checkIcon_path_id", d: "M8.96148 2.01161C10.9071 1.57202 12.9427 1.77314 14.7648 2.58498C15.1431 2.75356 15.5865 2.58351 15.7551 2.20515C15.9237 1.8268 15.7536 1.38342 15.3753 1.21483C13.2578 0.271345 10.8921 0.0376107 8.6309 0.54849C6.36974 1.05937 4.3343 2.28749 2.82815 4.04969C1.322 5.81188 0.42583 8.01374 0.273303 10.3269C0.120776 12.64 0.720061 14.9405 1.98178 16.8852C3.2435 18.8299 5.10006 20.3146 7.27456 21.118C9.44905 21.9214 11.825 22.0003 14.048 21.343C16.271 20.6857 18.222 19.3275 19.61 17.4708C20.998 15.6141 21.7487 13.3585 21.75 11.0403V11.0399V10.1199C21.75 9.70569 21.4142 9.3699 21 9.3699C20.5858 9.3699 20.25 9.70569 20.25 10.1199V11.0395C20.2489 13.0342 19.603 14.975 18.4086 16.5727C17.2143 18.1703 15.5355 19.339 13.6227 19.9046C11.7099 20.4701 9.66547 20.4022 7.79439 19.711C5.92331 19.0197 4.32581 17.7421 3.24014 16.0688C2.15447 14.3954 1.63881 12.4159 1.77005 10.4256C1.9013 8.4352 2.67242 6.54058 3.96841 5.02427C5.2644 3.50796 7.01583 2.4512 8.96148 2.01161ZM21.5306 3.56986C21.8233 3.27682 21.8231 2.80195 21.5301 2.5092C21.237 2.21645 20.7622 2.21669 20.4694 2.50973L10.9997 11.9889L8.53033 9.51947C8.23744 9.22657 7.76256 9.22657 7.46967 9.51947C7.17678 9.81236 7.17678 10.2872 7.46967 10.5801L10.4697 13.5801C10.6104 13.7208 10.8012 13.7998 11.0002 13.7998C11.1992 13.7997 11.39 13.7206 11.5306 13.5799L21.5306 3.56986Z", fill: fillColor, strokeLinecap: "round", strokeLinejoin: "round" }) }));
}

function TextField(_a) {
    var { label, id = "custom-text-field", isDisabled = false, state = "", message = "", value = "", hint = "", width = 320, maxLength = 40, onChange, labelLeftPadding, activeHoverd = true, type, brand = "staysure", inputFieldClassName, msgCustomStyles } = _a, props = __rest(_a, ["label", "id", "isDisabled", "state", "message", "value", "hint", "width", "maxLength", "onChange", "labelLeftPadding", "activeHoverd", "type", "brand", "inputFieldClassName", "msgCustomStyles"]);
    const [isFocused, setIsFocused] = useState(false);
    const [fieldValue, setFieldValue] = useState(value);
    const [isHover, setIsHover] = useState(false);
    const [isActive, setIsActive] = useState(false);
    const ref = useRef(null);
    const [accesibilityClassName, setAccesibilityClassName] = useState("");
    const [isTabFocused, setIsTabFocused] = useState(false);
    useEffect(() => {
        setFieldValue(value);
    }, [value]);
    useEffect(() => {
        const handleKeyboard = (e) => {
            /* istanbul ignore else */
            if (e.key === "Tab" && !isDisabled) {
                setIsTabFocused(true);
            }
        };
        document.addEventListener("keydown", handleKeyboard);
        return () => {
            document.removeEventListener("keydown", handleKeyboard);
        };
    }, [isDisabled]);
    const { labelProps, inputProps, errorMessageProps } = useTextField(Object.assign(Object.assign({}, props), { "aria-label": label }), ref);
    // Prevent scrolling on number input type
    useEffect(() => {
        const inputElement = ref.current;
        if (inputElement) {
            inputElement.addEventListener("wheel", (e) => e.preventDefault(), {
                passive: false,
            });
        }
        return () => {
            if (inputElement) {
                inputElement.removeEventListener("wheel", (e) => e.preventDefault());
            }
        };
    }, []);
    // check active state
    const { focusProps } = useFocus({
        isDisabled,
        onFocusChange: (focused) => {
            /* istanbul ignore else */
            if (focused) {
                setIsActive(true);
                setAccesibilityClassName("focused");
            }
        },
    });
    const handleFocus = () => {
        if (isTabFocused) {
            setIsFocused((prevIsFocused) => !prevIsFocused);
            setIsActive(true);
        }
        else {
            setIsActive(true);
        }
    };
    const handleBlur = (e) => {
        setIsActive(false);
        setIsFocused(false);
        setAccesibilityClassName("");
        if (inputProps && typeof inputProps.onBlur === "function") {
            inputProps.onBlur(e);
        }
    };
    const handleChange = (e) => {
        setFieldValue(e.target.value);
        /* istanbul ignore else */
        if (onChange && onChange !== undefined) {
            onChange(e.target.value, e);
        }
    };
    const handleMouseDown = () => {
        setIsFocused(true);
        setIsActive(true);
    };
    const handleMouseUp = () => {
        setIsFocused(false);
    };
    const getInputBorder = useCallback(() => {
        if (isDisabled)
            return brand === "staysure"
                ? "2px solid rgba(210, 210, 210, 1)"
                : "2px solid rgba(210, 206, 202, 1)";
        if (state === "error")
            return `2px solid rgba(202, 48, 43, 1)`;
        if (state === "warning")
            return "2px solid rgba(208, 109, 16, 1)";
        if (state === "success")
            return "2px solid rgba(0, 130, 5, 1)";
        if (isFocused)
            return "2px solid rgba(54, 143, 233, 1)";
        if (isHover && activeHoverd)
            return brand === "staysure"
                ? "2px solid rgba(40, 86, 110, 1)"
                : "2px solid rgba(22, 70, 72, 1)";
        if (isActive || fieldValue)
            return brand === "staysure"
                ? "2px solid rgba(48, 101, 130, 1)"
                : "2px solid rgba(22, 70, 72, 1)";
        return brand === "staysure"
            ? "1px solid rgba(48, 101, 130, 1)"
            : "1px solid rgba(0, 90, 94, 1)";
    }, [
        brand,
        isFocused,
        isHover,
        isActive,
        fieldValue,
        state,
        isDisabled,
        activeHoverd,
    ]);
    const getInputBackgroundColor = useCallback(() => {
        if (isDisabled || (isHover && activeHoverd && !isFocused && !isActive))
            return "rgba(240, 240, 240, 1)";
        return "transparent";
    }, [isDisabled, isHover, isFocused, isActive, activeHoverd]);
    const inputStyle = useMemo(() => ({
        border: getInputBorder(),
        backgroundColor: getInputBackgroundColor(),
    }), [getInputBorder, getInputBackgroundColor]);
    const getLabelBorder = useCallback(() => {
        if (isFocused && !fieldValue)
            return "rgba(54, 143, 233, 1)";
        if (brand === "staysure" && fieldValue && isDisabled)
            return "rgba(125, 125, 125, 1)";
        if (brand === "staysure" && (fieldValue || isActive))
            return "rgba(39, 36, 39, 1)";
        if (brand === "avanti" && (fieldValue || isActive))
            return "rgba(46, 45, 44, 1)";
        if (brand === "staysure" && isDisabled)
            return "rgba(125, 125, 125, 1)";
        if (brand === "avanti" && isDisabled)
            return "rgba(125, 123, 120, 1)";
        if (brand === "staysure")
            return "rgba(79, 79, 79, 1)";
        return "rgba(79, 77, 76, 1)";
    }, [isFocused, fieldValue, isActive, brand, isDisabled]);
    const getLabelBackgroundColor = useCallback(() => {
        if (isDisabled && fieldValue)
            return "rgba(240, 240, 240, 1)";
        if (isDisabled && !isFocused && !isActive)
            return "transparent";
        if (isActive || fieldValue) {
            return `linear-gradient(to top, ${isHover && !isFocused && !isActive ? "rgba(240, 240, 240, 1)" : "white"} 0%, ${isHover && !isFocused && !isActive ? "rgba(240, 240, 240, 1)" : "white"} 42%, white 42%, white 100%`;
        }
        return "transparent";
    }, [isDisabled, isFocused, fieldValue, isActive, isHover]);
    const labelStyle = useMemo(() => ({
        color: getLabelBorder(),
        backgroundColor: getLabelBackgroundColor(),
    }), [getLabelBorder, getLabelBackgroundColor]);
    const messageColor = useMemo(() => {
        if (isDisabled && state === "success")
            return "rgb(0, 130, 5)";
        if (isDisabled)
            return "rgb(125, 125, 125)";
        if (state === "error")
            return "rgb(202, 48, 43)";
        if (state === "warning")
            return "rgb(208, 109, 16)";
        if (state === "success")
            return "rgb(0, 130, 5)";
        return "rgb(48, 101, 130)";
    }, [state, isDisabled]);
    const fieldTextColor = useMemo(() => {
        if (brand === "staysure") {
            if (isDisabled)
                return "rgba(125, 125, 125, 1)";
            return "rgba(39, 36, 39, 1)";
        }
        if (brand === "avanti") {
            if (isDisabled)
                return "rgba(79, 77, 76, 1)";
            return "rgba(46, 45, 44, 1)";
        }
        return "rgba(39, 36, 39, 1)";
    }, [brand, isDisabled]);
    const fieldTextOpacity = useMemo(() => {
        if (brand === "staysure") {
            if (isDisabled)
                return 0.7;
            return 1;
        }
        if (brand === "avanti") {
            if (isDisabled)
                return 0.7;
            return 1;
        }
        return 1;
    }, [brand, isDisabled]);
    const setClassName = useMemo(() => {
        if (isActive)
            return "active-";
        if (state === "error")
            return "error-";
        if (isHover)
            return "hover-";
        return "";
    }, [isActive, state, isHover]);
    const onFocusInput = () => {
        const input = ref.current;
        if (input) {
            input.focus();
        }
    };
    return (jsxs("div", { style: { width }, children: [hint && (jsx("div", { style: {
                    textAlign: "right",
                    fontSize: 16,
                    fontWeight: 350,
                    color: "rgba(79, 79, 79, 1)",
                    padding: "none",
                    marginBottom: 8,
                    lineHeight: "24px",
                }, children: hint })), jsxs("div", { id: id, "data-testid": id, role: "textbox", tabIndex: -1, onMouseEnter: () => setIsHover(true), onMouseLeave: () => setIsHover(false), "aria-label": label, "aria-labelledby": `${id}-label`, "aria-hidden": "true", className: `${setClassName}text-input ${fieldValue ? "has-value " : ""}text-input-block`, style: {
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    height: "56px",
                    // padding: "16px 24px",
                    border: inputStyle.border,
                    borderRadius: 8,
                    backgroundColor: inputStyle.backgroundColor,
                    outline: isHover && !isDisabled && activeHoverd && !isFocused
                        ? "2px solid rgba(171, 185, 195, 1)"
                        : "none",
                }, onClick: () => {
                    onFocusInput();
                }, children: [jsx("input", Object.assign({}, mergeProps(inputProps, focusProps), { ref: ref, id: `${id}-input`, "data-testid": `${id}-input`, type: type !== null && type !== void 0 ? type : "text", onMouseDown: handleMouseDown, onMouseUp: handleMouseUp, onMouseLeave: handleMouseUp, onBlur: handleBlur, onFocus: handleFocus, onChange: handleChange, disabled: isDisabled, maxLength: maxLength, value: fieldValue, className: `${accesibilityClassName} ${inputFieldClassName}`, style: {
                            height: "100%",
                            width: "100%",
                            border: "none",
                            borderRadius: 8,
                            padding: `16px ${labelLeftPadding !== null && labelLeftPadding !== void 0 ? labelLeftPadding : "24px"}`,
                            boxSizing: "border-box",
                            outline: "none",
                            fontSize: 16,
                            fontWeight: 600,
                            backgroundColor: inputStyle.backgroundColor,
                            color: fieldTextColor,
                            WebkitTextFillColor: fieldTextColor,
                            opacity: fieldTextOpacity,
                            caretColor: "#000",
                        } })), jsx("label", Object.assign({}, labelProps, { id: `${id}-label`, "data-testid": `${id}-label`, htmlFor: `${id}-input`, "aria-label": `${label}-label`, "aria-labelledby": label, style: {
                            position: "absolute",
                            left: isActive || fieldValue ? 0 : labelLeftPadding !== null && labelLeftPadding !== void 0 ? labelLeftPadding : 24,
                            top: isActive || fieldValue ? 10 : "50%",
                            transform: isActive || fieldValue
                                ? "translateY(-100%) scale(0.75)"
                                : "translateY(-50%) scale(1)",
                            transition: "top 0.2s ease, transform 0.2s ease, left 0.2s ease",
                            background: labelStyle.backgroundColor,
                            padding: isActive || fieldValue ? "0 4px 0 4px" : 0,
                            color: labelStyle.color,
                            fontSize: 16,
                            fontWeight: isActive || fieldValue ? 500 : 600,
                            borderRadius: 120,
                        }, children: label }))] }), message && state === "error" ? (jsx("div", Object.assign({}, errorMessageProps, { id: `${id}-message`, "data-testid": `${id}-message`, style: Object.assign({ textAlign: "left", fontSize: 14, fontWeight: 600, color: messageColor, padding: "none", marginTop: 4, lineHeight: "21px", width: 320 }, msgCustomStyles), children: message }))) : null, message && state !== "error" ? (jsx("div", { id: `${id}-message`, "data-testid": `${id}-message`, style: Object.assign({ textAlign: "left", fontSize: 14, fontWeight: 600, color: messageColor, padding: "none", marginTop: 4, lineHeight: "21px", width: 320 }, msgCustomStyles), children: message })) : null] }));
}

function CalendarIcon({ testId, size = "M", width, height, stroke, strokeWidth = 1.5, fill, id = "", className = "", brand = "staysure", semanticColor = "light", }) {
    const sizeMap = useMemo(() => getSizeMap(size), [size]);
    const fillValue = useMemo(() => {
        // Check if the brand and semanticColor are not undefined
        if (brand && semanticColor) {
            // Check if the brand is available in the colorMap
            const validBrand = colorMapCalendarIcon[brand] ? brand : "default";
            // Check if the semanticColor is available in the colorMap
            const validSemanticColor = colorMapCalendarIcon[validBrand][semanticColor]
                ? semanticColor
                : "light";
            // Check if the semanticColor is available in the colorMap
            return {
                fill: fill !== null && fill !== void 0 ? fill : colorMapCalendarIcon[validBrand][validSemanticColor].fill,
                stroke: stroke !== null && stroke !== void 0 ? stroke : colorMapCalendarIcon[validBrand][validSemanticColor].stroke,
            };
        }
        // default values
        return {
            fill: fill !== null && fill !== void 0 ? fill : colorMapCalendarIcon.default.light.fill,
            stroke: stroke !== null && stroke !== void 0 ? stroke : colorMapCalendarIcon.default.light.stroke,
        };
    }, [semanticColor, stroke, brand, fill]);
    return (jsx("svg", { width: width !== null && width !== void 0 ? width : sizeMap, height: height !== null && height !== void 0 ? height : sizeMap, "data-testid": testId, fill: fillValue.fill, className: `iconCompLibrary_calender_svg_${className}`, id: `iconCompLibrary_calender_svg_id_${id}`, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: jsx("path", { d: "M16 2V6M8 2V6M3 10H21M5 4H19C20.1046 4 21 4.89543 21 6V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V6C3 4.89543 3.89543 4 5 4Z", stroke: fillValue.stroke, strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }) }));
}

function ChevronLeftIcon({ testId, size = "M", width, height, stroke = "#272427", strokeWidth = 1.5, fill = "none", id = "", className = "", }) {
    const sizeMap = useMemo(() => getSizeMap(size), [size]);
    return (jsx("svg", { width: width !== null && width !== void 0 ? width : sizeMap, height: height !== null && height !== void 0 ? height : sizeMap, "data-testid": testId, fill: fill, className: `iconCompLibrary_chevron_svg_${className}`, id: `iconCompLibrary_chevron_svg_id_${id}`, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: jsx("path", { d: "M15 18L9 12L15 6", stroke: stroke, strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }) }));
}

function ChevronRightIcon({ testId, size = "M", width, height, stroke, strokeWidth = 1.5, fill = "none", id = "", className = "", brand = "staysure", semanticColor = "light", }) {
    const sizeMap = useMemo(() => getSizeMap(size), [size]);
    const strokeColor = useMemo(() => {
        if (brand && semanticColor) {
            const validBrand = colorMapChevronIcon[brand] ? brand : "default";
            const validSemanticColor = colorMapChevronIcon[validBrand][semanticColor]
                ? semanticColor
                : "light";
            return stroke !== null && stroke !== void 0 ? stroke : colorMapChevronIcon[validBrand][validSemanticColor];
        }
        return stroke !== null && stroke !== void 0 ? stroke : colorMapChevronIcon.default.light;
    }, [semanticColor, stroke, brand]);
    return (jsx("svg", { width: width !== null && width !== void 0 ? width : sizeMap, height: height !== null && height !== void 0 ? height : sizeMap, "data-testid": testId, fill: fill, className: `iconCompLibrary_chevron_svg_${className}`, id: `iconCompLibrary_chevron_svg_id_${id}`, xmlns: "http://www.w3.org/2000/svg", children: jsx("path", { d: "M9 18L15 12L9 6", stroke: strokeColor, strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }) }));
}

function ChevronUpIcon({ testId, width, height, id = "", className = "", stroke, strokeWidth = 1.5, size = "M", brand = "staysure", semanticColor = "light", }) {
    const sizeMap = useMemo(() => {
        switch (size) {
            case "S":
                return 16;
            case "L":
                return 32;
            case "XL":
                return 48;
            case "XXL":
                return 56;
            default:
                return 24;
        }
    }, [size]);
    const strokeColor = useMemo(() => {
        if (brand && semanticColor) {
            const validBrand = colorMapChevronIcon[brand] ? brand : "default";
            const validSemanticColor = colorMapChevronIcon[validBrand][semanticColor]
                ? semanticColor
                : "light";
            return stroke !== null && stroke !== void 0 ? stroke : colorMapChevronIcon[validBrand][validSemanticColor];
        }
        return stroke !== null && stroke !== void 0 ? stroke : colorMapChevronIcon.default.light;
    }, [semanticColor, stroke, brand]);
    return (jsx("svg", { width: width !== null && width !== void 0 ? width : sizeMap, height: height !== null && height !== void 0 ? height : sizeMap, fill: "none", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", "data-testid": testId, className: `iconCompLibrary_chevronUpIcon_svg_${className}`, id: `iconCompLibrary_chevronUpIcon_svg_id_${id}`, children: jsx("path", { className: `iconCompLibrary_chevronUpIcon_path_${className}`, id: `iconCompLibrary_chevronUpIcon_path_id_${id}`, d: "M18 15L12 9L6 15" // Updated path to match the ChevronUpIcon SVG
            , stroke: strokeColor, strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }) }));
}

// eslint-disable-next-line import/prefer-default-export
function ListBox$1(props) {
    const ref = React.useRef(null);
    const { listBoxRef = ref, state } = props;
    const { listBoxProps } = useListBox(props, state, listBoxRef);
    return (jsx("ul", Object.assign({}, listBoxProps, { ref: listBoxRef, className: "list-box-class", style: Object.assign({ padding: 0, listStyle: "none", border: "1px solid gray", maxHeight: 300, overflow: "auto", width: "100%" }, props.listBoxStyles), children: [...state.collection].map((item) => (jsx(Option$1, { item: item, state: state, focusedItemStyles: props.focusedItemStyles, listBoxSingleItemStyles: props.listBoxSingleItemStyles, selectedItemStyles: props.selectedItemStyles }, item.key))) })));
}
function Option$1(_a) {
    var { item, state } = _a, props = __rest(_a, ["item", "state"]);
    const ref = React.useRef(null);
    const { optionProps, isFocused, isSelected } = useOption({
        key: item.key,
    }, state, ref);
    return (jsx("li", Object.assign({}, optionProps, { ref: ref, style: Object.assign(Object.assign(Object.assign({ height: "30px" }, props.listBoxSingleItemStyles), (isFocused ? Object.assign({}, props.focusedItemStyles) : {})), (isSelected ? Object.assign({}, props.selectedItemStyles) : {})), "data-testid": `search-dropdown-item-${item.key}-test-id`, children: item.rendered })));
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
const $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c = typeof document !== 'undefined' ? (React__default).useLayoutEffect : () => {};

/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $8ae05eaa5c114e9c$export$7f54fc3180508a52(fn) {
  const ref = (useRef)(null);
  ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(() => {
    ref.current = fn;
  }, [fn]);
  // @ts-ignore
  return (useCallback)((...args) => {
    const f = ref.current;
    return f === null || f === void 0 ? void 0 : f(...args);
  }, []);
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule

// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $b5e257d569688ac6$var$defaultContext = {
  prefix: String(Math.round(Math.random() * 10000000000)),
  current: 0
};
const $b5e257d569688ac6$var$SSRContext = /*#__PURE__*/(React__default).createContext($b5e257d569688ac6$var$defaultContext);
const $b5e257d569688ac6$var$IsSSRContext = /*#__PURE__*/(React__default).createContext(false);
let $b5e257d569688ac6$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
let $b5e257d569688ac6$var$componentIds = new WeakMap();
function $b5e257d569688ac6$var$useCounter(isDisabled = false) {
  let ctx = (useContext)($b5e257d569688ac6$var$SSRContext);
  let ref = (useRef)(null);
  // eslint-disable-next-line rulesdir/pure-render
  if (ref.current === null && !isDisabled) {
    var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
    // This means our id counter will be incremented twice instead of once. This is a problem because on the
    // server, components are only rendered once and so ids generated on the server won't match the client.
    // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
    // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
    // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
    // To ensure that we only increment the global counter once, we store the starting id for this component in
    // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
    // Since React runs the second render immediately after the first, this is safe.
    // @ts-ignore
    let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (React__default).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
    if (currentOwner) {
      let prevComponentValue = $b5e257d569688ac6$var$componentIds.get(currentOwner);
      if (prevComponentValue == null)
        // On the first render, and first call to useId, store the id and state in our weak map.
        $b5e257d569688ac6$var$componentIds.set(currentOwner, {
          id: ctx.current,
          state: currentOwner.memoizedState
        });else if (currentOwner.memoizedState !== prevComponentValue.state) {
        // On the second render, the memoizedState gets reset by React.
        // Reset the counter, and remove from the weak map so we don't
        // do this for subsequent useId calls.
        ctx.current = prevComponentValue.id;
        $b5e257d569688ac6$var$componentIds.delete(currentOwner);
      }
    }
    // eslint-disable-next-line rulesdir/pure-render
    ref.current = ++ctx.current;
  }
  // eslint-disable-next-line rulesdir/pure-render
  return ref.current;
}
function $b5e257d569688ac6$var$useLegacySSRSafeId(defaultId) {
  let ctx = (useContext)($b5e257d569688ac6$var$SSRContext);
  // If we are rendering in a non-DOM environment, and there's no SSRProvider,
  // provide a warning to hint to the developer to add one.
  if (ctx === $b5e257d569688ac6$var$defaultContext && !$b5e257d569688ac6$var$canUseDOM) console.warn('When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.');
  let counter = $b5e257d569688ac6$var$useCounter(!!defaultId);
  let prefix = ctx === $b5e257d569688ac6$var$defaultContext && process.env.NODE_ENV === 'test' ? 'react-aria' : `react-aria${ctx.prefix}`;
  return defaultId || `${prefix}-${counter}`;
}
function $b5e257d569688ac6$var$useModernSSRSafeId(defaultId) {
  // @ts-ignore
  let id = (React__default).useId();
  let [didSSR] = (useState)($b5e257d569688ac6$export$535bd6ca7f90a273());
  let prefix = didSSR || process.env.NODE_ENV === 'test' ? 'react-aria' : `react-aria${$b5e257d569688ac6$var$defaultContext.prefix}`;
  return defaultId || `${prefix}-${id}`;
}
const $b5e257d569688ac6$export$619500959fc48b26 = typeof (React__default)['useId'] === 'function' ? $b5e257d569688ac6$var$useModernSSRSafeId : $b5e257d569688ac6$var$useLegacySSRSafeId;
function $b5e257d569688ac6$var$getSnapshot() {
  return false;
}
function $b5e257d569688ac6$var$getServerSnapshot() {
  return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $b5e257d569688ac6$var$subscribe(onStoreChange) {
  // noop
  return () => {};
}
function $b5e257d569688ac6$export$535bd6ca7f90a273() {
  // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
  if (typeof (React__default)['useSyncExternalStore'] === 'function') return (React__default)['useSyncExternalStore']($b5e257d569688ac6$var$subscribe, $b5e257d569688ac6$var$getSnapshot, $b5e257d569688ac6$var$getServerSnapshot);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return (useContext)($b5e257d569688ac6$var$IsSSRContext);
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

// copied from SSRProvider.tsx to reduce exports, if needed again, consider sharing
let $bdb11010cef70236$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
let $bdb11010cef70236$var$idsUpdaterMap = new Map();
function $bdb11010cef70236$export$f680877a34711e37(defaultId) {
  let [value, setValue] = (useState)(defaultId);
  let nextId = (useRef)(null);
  let res = ($b5e257d569688ac6$export$619500959fc48b26)(value);
  let updateValue = (useCallback)(val => {
    nextId.current = val;
  }, []);
  if ($bdb11010cef70236$var$canUseDOM) $bdb11010cef70236$var$idsUpdaterMap.set(res, updateValue);
  ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(() => {
    let r = res;
    return () => {
      $bdb11010cef70236$var$idsUpdaterMap.delete(r);
    };
  }, [res]);
  // This cannot cause an infinite loop because the ref is updated first.
  // eslint-disable-next-line
  (useEffect)(() => {
    let newId = nextId.current;
    if (newId) {
      nextId.current = null;
      setValue(newId);
    }
  });
  return res;
}
function $bdb11010cef70236$export$cd8c9cb68f842629(idA, idB) {
  if (idA === idB) return idA;
  let setIdA = $bdb11010cef70236$var$idsUpdaterMap.get(idA);
  if (setIdA) {
    setIdA(idB);
    return idB;
  }
  let setIdB = $bdb11010cef70236$var$idsUpdaterMap.get(idB);
  if (setIdB) {
    setIdB(idA);
    return idA;
  }
  return idB;
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
    * Calls all functions in the order they were chained with the same arguments.
    */function $ff5963eb1fccf552$export$e08e3b67e392101e(...callbacks) {
  return (...args) => {
    for (let callback of callbacks) if (typeof callback === 'function') callback(...args);
  };
}

const $431fbd86ca7dc216$export$b204af158042fbac = el => {
  var _el_ownerDocument;
  return (_el_ownerDocument = el === null || el === void 0 ? void 0 : el.ownerDocument) !== null && _el_ownerDocument !== void 0 ? _el_ownerDocument : document;
};
const $431fbd86ca7dc216$export$f21a1ffae260145a = el => {
  if (el && 'window' in el && el.window === el) return el;
  const doc = $431fbd86ca7dc216$export$b204af158042fbac(el);
  return doc.defaultView || window;
};

function r(e) {
  var t,
    f,
    n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;else if ("object" == typeof e) if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
  } else for (f in e) e[f] && (n && (n += " "), n += f);
  return n;
}
function clsx() {
  for (var e, t, f = 0, n = "", o = arguments.length; f < o; f++) (e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
  return n;
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $3ef42575df84b30b$export$9d1611c77c2fe928(...args) {
  // Start with a base clone of the first argument. This is a lot faster than starting
  // with an empty object and adding properties as we go.
  let result = {
    ...args[0]
  };
  for (let i = 1; i < args.length; i++) {
    let props = args[i];
    for (let key in props) {
      let a = result[key];
      let b = props[key];
      // Chain events
      if (typeof a === 'function' && typeof b === 'function' &&
      // This is a lot faster than a regex.
      key[0] === 'o' && key[1] === 'n' && key.charCodeAt(2) >= /* 'A' */65 && key.charCodeAt(2) <= /* 'Z' */90) result[key] = ($ff5963eb1fccf552$export$e08e3b67e392101e)(a, b);else if ((key === 'className' || key === 'UNSAFE_className') && typeof a === 'string' && typeof b === 'string') result[key] = (clsx)(a, b);else if (key === 'id' && a && b) result.id = ($bdb11010cef70236$export$cd8c9cb68f842629)(a, b);else result[key] = b !== undefined ? b : a;
    }
  }
  return result;
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */function $7215afc6de606d6b$export$de79e2c695e052f3(element) {
  if ($7215afc6de606d6b$var$supportsPreventScroll()) element.focus({
    preventScroll: true
  });else {
    let scrollableElements = $7215afc6de606d6b$var$getScrollableElements(element);
    element.focus();
    $7215afc6de606d6b$var$restoreScrollPosition(scrollableElements);
  }
}
let $7215afc6de606d6b$var$supportsPreventScrollCached = null;
function $7215afc6de606d6b$var$supportsPreventScroll() {
  if ($7215afc6de606d6b$var$supportsPreventScrollCached == null) {
    $7215afc6de606d6b$var$supportsPreventScrollCached = false;
    try {
      let focusElem = document.createElement('div');
      focusElem.focus({
        get preventScroll() {
          $7215afc6de606d6b$var$supportsPreventScrollCached = true;
          return true;
        }
      });
    } catch (e) {
      // Ignore
    }
  }
  return $7215afc6de606d6b$var$supportsPreventScrollCached;
}
function $7215afc6de606d6b$var$getScrollableElements(element) {
  let parent = element.parentNode;
  let scrollableElements = [];
  let rootScrollingElement = document.scrollingElement || document.documentElement;
  while (parent instanceof HTMLElement && parent !== rootScrollingElement) {
    if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) scrollableElements.push({
      element: parent,
      scrollTop: parent.scrollTop,
      scrollLeft: parent.scrollLeft
    });
    parent = parent.parentNode;
  }
  if (rootScrollingElement instanceof HTMLElement) scrollableElements.push({
    element: rootScrollingElement,
    scrollTop: rootScrollingElement.scrollTop,
    scrollLeft: rootScrollingElement.scrollLeft
  });
  return scrollableElements;
}
function $7215afc6de606d6b$var$restoreScrollPosition(scrollableElements) {
  for (let {
    element: element,
    scrollTop: scrollTop,
    scrollLeft: scrollLeft
  } of scrollableElements) {
    element.scrollTop = scrollTop;
    element.scrollLeft = scrollLeft;
  }
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */function $c87311424ea30a05$var$testUserAgent(re) {
  var _window_navigator_userAgentData;
  if (typeof window === 'undefined' || window.navigator == null) return false;
  return ((_window_navigator_userAgentData = window.navigator['userAgentData']) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.brands.some(brand => re.test(brand.brand))) || re.test(window.navigator.userAgent);
}
function $c87311424ea30a05$var$testPlatform(re) {
  var _window_navigator_userAgentData;
  return typeof window !== 'undefined' && window.navigator != null ? re.test(((_window_navigator_userAgentData = window.navigator['userAgentData']) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.platform) || window.navigator.platform) : false;
}
function $c87311424ea30a05$export$9ac100e40613ea10() {
  return $c87311424ea30a05$var$testPlatform(/^Mac/i);
}
function $c87311424ea30a05$export$186c6964ca17d99() {
  return $c87311424ea30a05$var$testPlatform(/^iPhone/i);
}
function $c87311424ea30a05$export$7bef049ce92e4224() {
  return $c87311424ea30a05$var$testPlatform(/^iPad/i) ||
  // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  $c87311424ea30a05$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
}
function $c87311424ea30a05$export$fedb369cb70207f1() {
  return $c87311424ea30a05$export$186c6964ca17d99() || $c87311424ea30a05$export$7bef049ce92e4224();
}
function $c87311424ea30a05$export$78551043582a6a98() {
  return $c87311424ea30a05$var$testUserAgent(/AppleWebKit/i) && !$c87311424ea30a05$export$6446a186d09e379e();
}
function $c87311424ea30a05$export$6446a186d09e379e() {
  return $c87311424ea30a05$var$testUserAgent(/Chrome/i);
}
function $c87311424ea30a05$export$a11b0059900ceec8() {
  return $c87311424ea30a05$var$testUserAgent(/Android/i);
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We store a global list of elements that are currently transitioning,
// mapped to a set of CSS properties that are transitioning for that element.
// This is necessary rather than a simple count of transitions because of browser
// bugs, e.g. Chrome sometimes fires both transitionend and transitioncancel rather
// than one or the other. So we need to track what's actually transitioning so that
// we can ignore these duplicate events.
let $bbed8b41f857bcc0$var$transitionsByElement = new Map();
// A list of callbacks to call once there are no transitioning elements.
let $bbed8b41f857bcc0$var$transitionCallbacks = new Set();
function $bbed8b41f857bcc0$var$setupGlobalEvents() {
  if (typeof window === 'undefined') return;
  function isTransitionEvent(event) {
    return 'propertyName' in event;
  }
  let onTransitionStart = e => {
    if (!isTransitionEvent(e) || !e.target) return;
    // Add the transitioning property to the list for this element.
    let transitions = $bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
    if (!transitions) {
      transitions = new Set();
      $bbed8b41f857bcc0$var$transitionsByElement.set(e.target, transitions);
      // The transitioncancel event must be registered on the element itself, rather than as a global
      // event. This enables us to handle when the node is deleted from the document while it is transitioning.
      // In that case, the cancel event would have nowhere to bubble to so we need to handle it directly.
      e.target.addEventListener('transitioncancel', onTransitionEnd, {
        once: true
      });
    }
    transitions.add(e.propertyName);
  };
  let onTransitionEnd = e => {
    if (!isTransitionEvent(e) || !e.target) return;
    // Remove property from list of transitioning properties.
    let properties = $bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
    if (!properties) return;
    properties.delete(e.propertyName);
    // If empty, remove transitioncancel event, and remove the element from the list of transitioning elements.
    if (properties.size === 0) {
      e.target.removeEventListener('transitioncancel', onTransitionEnd);
      $bbed8b41f857bcc0$var$transitionsByElement.delete(e.target);
    }
    // If no transitioning elements, call all of the queued callbacks.
    if ($bbed8b41f857bcc0$var$transitionsByElement.size === 0) {
      for (let cb of $bbed8b41f857bcc0$var$transitionCallbacks) cb();
      $bbed8b41f857bcc0$var$transitionCallbacks.clear();
    }
  };
  document.body.addEventListener('transitionrun', onTransitionStart);
  document.body.addEventListener('transitionend', onTransitionEnd);
}
if (typeof document !== 'undefined') {
  if (document.readyState !== 'loading') $bbed8b41f857bcc0$var$setupGlobalEvents();else document.addEventListener('DOMContentLoaded', $bbed8b41f857bcc0$var$setupGlobalEvents);
}
function $bbed8b41f857bcc0$export$24490316f764c430(fn) {
  // Wait one frame to see if an animation starts, e.g. a transition on mount.
  requestAnimationFrame(() => {
    // If no transitions are running, call the function immediately.
    // Otherwise, add it to a list of callbacks to run at the end of the animation.
    if ($bbed8b41f857bcc0$var$transitionsByElement.size === 0) fn();else $bbed8b41f857bcc0$var$transitionCallbacks.add(fn);
  });
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
function $313b98861ee5dd6c$export$d6875122194c7b44(props, defaultLabel) {
  let {
    id: id,
    'aria-label': label,
    'aria-labelledby': labelledBy
  } = props;
  // If there is both an aria-label and aria-labelledby,
  // combine them by pointing to the element itself.
  id = ($bdb11010cef70236$export$f680877a34711e37)(id);
  if (labelledBy && label) {
    let ids = new Set([id, ...labelledBy.trim().split(/\s+/)]);
    labelledBy = [...ids].join(' ');
  } else if (labelledBy) labelledBy = labelledBy.trim().split(/\s+/).join(' ');
  // If no labels are provided, use the default
  if (!label && !labelledBy && defaultLabel) label = defaultLabel;
  return {
    id: id,
    'aria-label': label,
    'aria-labelledby': labelledBy
  };
}

function $9daab02d461809db$var$hasResizeObserver() {
  return typeof window.ResizeObserver !== 'undefined';
}
function $9daab02d461809db$export$683480f191c0e3ea(options) {
  const {
    ref: ref,
    onResize: onResize
  } = options;
  (useEffect)(() => {
    let element = ref === null || ref === void 0 ? void 0 : ref.current;
    if (!element) return;
    if (!$9daab02d461809db$var$hasResizeObserver()) {
      window.addEventListener('resize', onResize, false);
      return () => {
        window.removeEventListener('resize', onResize, false);
      };
    } else {
      const resizeObserverInstance = new window.ResizeObserver(entries => {
        if (!entries.length) return;
        onResize();
      });
      resizeObserverInstance.observe(element);
      return () => {
        if (element) resizeObserverInstance.unobserve(element);
      };
    }
  }, [onResize, ref]);
}

/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */function $cc38e7bd3fc7b213$export$2bb74740c4e19def(node, checkForOverflow) {
  let style = window.getComputedStyle(node);
  let isScrollable = /(auto|scroll)/.test(style.overflow + style.overflowX + style.overflowY);
  if (isScrollable && checkForOverflow) isScrollable = node.scrollHeight !== node.clientHeight || node.scrollWidth !== node.clientWidth;
  return isScrollable;
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
function $62d8ded9296f3872$export$cfa2225e87938781(node, checkForOverflow) {
  let scrollableNode = node;
  if (($cc38e7bd3fc7b213$export$2bb74740c4e19def)(scrollableNode, checkForOverflow)) scrollableNode = scrollableNode.parentElement;
  while (scrollableNode && !($cc38e7bd3fc7b213$export$2bb74740c4e19def)(scrollableNode, checkForOverflow)) scrollableNode = scrollableNode.parentElement;
  return scrollableNode || document.scrollingElement || document.documentElement;
}

/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
function $6a7db85432448f7f$export$60278871457622de(event) {
  // JAWS/NVDA with Firefox.
  if (event.mozInputSource === 0 && event.isTrusted) return true;
  // Android TalkBack's detail value varies depending on the event listener providing the event so we have specific logic here instead
  // If pointerType is defined, event is from a click listener. For events from mousedown listener, detail === 0 is a sufficient check
  // to detect TalkBack virtual clicks.
  if (($c87311424ea30a05$export$a11b0059900ceec8)() && event.pointerType) return event.type === 'click' && event.buttons === 1;
  return event.detail === 0 && !event.pointerType;
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
    * Takes a value and forces it to the closest min/max if it's outside. Also forces it to the closest valid step.
    */function $9446cca9a3875146$export$7d15b64cf5a3a4c4(value, min = -Infinity, max = Infinity) {
  let newValue = Math.min(Math.max(value, min), max);
  return newValue;
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
const $edcf132a9284368a$var$AXIS = {
  top: 'top',
  bottom: 'top',
  left: 'left',
  right: 'left'
};
const $edcf132a9284368a$var$FLIPPED_DIRECTION = {
  top: 'bottom',
  bottom: 'top',
  left: 'right',
  right: 'left'
};
const $edcf132a9284368a$var$CROSS_AXIS = {
  top: 'left',
  left: 'top'
};
const $edcf132a9284368a$var$AXIS_SIZE = {
  top: 'height',
  left: 'width'
};
const $edcf132a9284368a$var$TOTAL_SIZE = {
  width: 'totalWidth',
  height: 'totalHeight'
};
const $edcf132a9284368a$var$PARSED_PLACEMENT_CACHE = {};
// @ts-ignore
let $edcf132a9284368a$var$visualViewport = typeof document !== 'undefined' && window.visualViewport;
function $edcf132a9284368a$var$getContainerDimensions(containerNode) {
  let width = 0,
    height = 0,
    totalWidth = 0,
    totalHeight = 0,
    top = 0,
    left = 0;
  let scroll = {};
  let isPinchZoomedIn = ($edcf132a9284368a$var$visualViewport === null || $edcf132a9284368a$var$visualViewport === void 0 ? void 0 : $edcf132a9284368a$var$visualViewport.scale) > 1;
  if (containerNode.tagName === 'BODY') {
    let documentElement = document.documentElement;
    totalWidth = documentElement.clientWidth;
    totalHeight = documentElement.clientHeight;
    var _visualViewport_width;
    width = (_visualViewport_width = $edcf132a9284368a$var$visualViewport === null || $edcf132a9284368a$var$visualViewport === void 0 ? void 0 : $edcf132a9284368a$var$visualViewport.width) !== null && _visualViewport_width !== void 0 ? _visualViewport_width : totalWidth;
    var _visualViewport_height;
    height = (_visualViewport_height = $edcf132a9284368a$var$visualViewport === null || $edcf132a9284368a$var$visualViewport === void 0 ? void 0 : $edcf132a9284368a$var$visualViewport.height) !== null && _visualViewport_height !== void 0 ? _visualViewport_height : totalHeight;
    scroll.top = documentElement.scrollTop || containerNode.scrollTop;
    scroll.left = documentElement.scrollLeft || containerNode.scrollLeft;
    // The goal of the below is to get a top/left value that represents the top/left of the visual viewport with
    // respect to the layout viewport origin. This combined with the scrollTop/scrollLeft will allow us to calculate
    // coordinates/values with respect to the visual viewport or with respect to the layout viewport.
    if ($edcf132a9284368a$var$visualViewport) {
      top = $edcf132a9284368a$var$visualViewport.offsetTop;
      left = $edcf132a9284368a$var$visualViewport.offsetLeft;
    }
  } else {
    ({
      width: width,
      height: height,
      top: top,
      left: left
    } = $edcf132a9284368a$var$getOffset(containerNode));
    scroll.top = containerNode.scrollTop;
    scroll.left = containerNode.scrollLeft;
    totalWidth = width;
    totalHeight = height;
  }
  if (($c87311424ea30a05$export$78551043582a6a98)() && (containerNode.tagName === 'BODY' || containerNode.tagName === 'HTML') && isPinchZoomedIn) {
    // Safari will report a non-zero scrollTop/Left for the non-scrolling body/HTML element when pinch zoomed in unlike other browsers.
    // Set to zero for parity calculations so we get consistent positioning of overlays across all browsers.
    // Also switch to visualViewport.pageTop/pageLeft so that we still accomodate for scroll positioning for body/HTML elements that are actually scrollable
    // before pinch zoom happens
    scroll.top = 0;
    scroll.left = 0;
    top = $edcf132a9284368a$var$visualViewport.pageTop;
    left = $edcf132a9284368a$var$visualViewport.pageLeft;
  }
  return {
    width: width,
    height: height,
    totalWidth: totalWidth,
    totalHeight: totalHeight,
    scroll: scroll,
    top: top,
    left: left
  };
}
function $edcf132a9284368a$var$getScroll(node) {
  return {
    top: node.scrollTop,
    left: node.scrollLeft,
    width: node.scrollWidth,
    height: node.scrollHeight
  };
}
// Determines the amount of space required when moving the overlay to ensure it remains in the boundary
function $edcf132a9284368a$var$getDelta(axis, offset, size,
// The dimensions of the boundary element that the popover is
// positioned within (most of the time this is the <body>).
boundaryDimensions,
// The dimensions of the containing block element that the popover is
// positioned relative to (e.g. parent with position: relative).
// Usually this is the same as the boundary element, but if the popover
// is portaled somewhere other than the body and has an ancestor with
// position: relative/absolute, it will be different.
containerDimensions, padding, containerOffsetWithBoundary) {
  let containerScroll = containerDimensions.scroll[axis];
  // The height/width of the boundary. Matches the axis along which we are adjusting the overlay position
  let boundarySize = boundaryDimensions[$edcf132a9284368a$var$AXIS_SIZE[axis]];
  // Calculate the edges of the boundary (accomodating for the boundary padding) and the edges of the overlay.
  // Note that these values are with respect to the visual viewport (aka 0,0 is the top left of the viewport)
  let boundaryStartEdge = boundaryDimensions.scroll[$edcf132a9284368a$var$AXIS[axis]] + padding;
  let boundaryEndEdge = boundarySize + boundaryDimensions.scroll[$edcf132a9284368a$var$AXIS[axis]] - padding;
  let startEdgeOffset = offset - containerScroll + containerOffsetWithBoundary[axis] - boundaryDimensions[$edcf132a9284368a$var$AXIS[axis]];
  let endEdgeOffset = offset - containerScroll + size + containerOffsetWithBoundary[axis] - boundaryDimensions[$edcf132a9284368a$var$AXIS[axis]];
  // If any of the overlay edges falls outside of the boundary, shift the overlay the required amount to align one of the overlay's
  // edges with the closest boundary edge.
  if (startEdgeOffset < boundaryStartEdge) return boundaryStartEdge - startEdgeOffset;else if (endEdgeOffset > boundaryEndEdge) return Math.max(boundaryEndEdge - endEdgeOffset, boundaryStartEdge - startEdgeOffset);else return 0;
}
function $edcf132a9284368a$var$getMargins(node) {
  let style = window.getComputedStyle(node);
  return {
    top: parseInt(style.marginTop, 10) || 0,
    bottom: parseInt(style.marginBottom, 10) || 0,
    left: parseInt(style.marginLeft, 10) || 0,
    right: parseInt(style.marginRight, 10) || 0
  };
}
function $edcf132a9284368a$var$parsePlacement(input) {
  if ($edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input]) return $edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input];
  let [placement, crossPlacement] = input.split(' ');
  let axis = $edcf132a9284368a$var$AXIS[placement] || 'right';
  let crossAxis = $edcf132a9284368a$var$CROSS_AXIS[axis];
  if (!$edcf132a9284368a$var$AXIS[crossPlacement]) crossPlacement = 'center';
  let size = $edcf132a9284368a$var$AXIS_SIZE[axis];
  let crossSize = $edcf132a9284368a$var$AXIS_SIZE[crossAxis];
  $edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input] = {
    placement: placement,
    crossPlacement: crossPlacement,
    axis: axis,
    crossAxis: crossAxis,
    size: size,
    crossSize: crossSize
  };
  return $edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[input];
}
function $edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset) {
  let {
    placement: placement,
    crossPlacement: crossPlacement,
    axis: axis,
    crossAxis: crossAxis,
    size: size,
    crossSize: crossSize
  } = placementInfo;
  let position = {};
  // button position
  position[crossAxis] = childOffset[crossAxis];
  if (crossPlacement === 'center')
    //  + (button size / 2) - (overlay size / 2)
    // at this point the overlay center should match the button center
    position[crossAxis] += (childOffset[crossSize] - overlaySize[crossSize]) / 2;else if (crossPlacement !== crossAxis)
    //  + (button size) - (overlay size)
    // at this point the overlay bottom should match the button bottom
    position[crossAxis] += childOffset[crossSize] - overlaySize[crossSize];
  /* else {
  the overlay top should match the button top
  } */
  position[crossAxis] += crossOffset;
  // overlay top overlapping arrow with button bottom
  const minPosition = childOffset[crossAxis] - overlaySize[crossSize] + arrowSize + arrowBoundaryOffset;
  // overlay bottom overlapping arrow with button top
  const maxPosition = childOffset[crossAxis] + childOffset[crossSize] - arrowSize - arrowBoundaryOffset;
  position[crossAxis] = ($9446cca9a3875146$export$7d15b64cf5a3a4c4)(position[crossAxis], minPosition, maxPosition);
  // Floor these so the position isn't placed on a partial pixel, only whole pixels. Shouldn't matter if it was floored or ceiled, so chose one.
  if (placement === axis) {
    // If the container is positioned (non-static), then we use the container's actual
    // height, as `bottom` will be relative to this height.  But if the container is static,
    // then it can only be the `document.body`, and `bottom` will be relative to _its_
    // container, which should be as large as boundaryDimensions.
    const containerHeight = isContainerPositioned ? containerOffsetWithBoundary[size] : boundaryDimensions[$edcf132a9284368a$var$TOTAL_SIZE[size]];
    position[$edcf132a9284368a$var$FLIPPED_DIRECTION[axis]] = Math.floor(containerHeight - childOffset[axis] + offset);
  } else position[axis] = Math.floor(childOffset[axis] + childOffset[size] + offset);
  return position;
}
function $edcf132a9284368a$var$getMaxHeight(position, boundaryDimensions, containerOffsetWithBoundary, isContainerPositioned, margins, padding, overlayHeight, heightGrowthDirection) {
  const containerHeight = isContainerPositioned ? containerOffsetWithBoundary.height : boundaryDimensions[$edcf132a9284368a$var$TOTAL_SIZE.height];
  // For cases where position is set via "bottom" instead of "top", we need to calculate the true overlay top with respect to the boundary. Reverse calculate this with the same method
  // used in computePosition.
  let overlayTop = position.top != null ? containerOffsetWithBoundary.top + position.top : containerOffsetWithBoundary.top + (containerHeight - position.bottom - overlayHeight);
  let maxHeight = heightGrowthDirection !== 'top' ?
  // We want the distance between the top of the overlay to the bottom of the boundary
  Math.max(0, boundaryDimensions.height + boundaryDimensions.top + boundaryDimensions.scroll.top // this is the bottom of the boundary
  - overlayTop // this is the top of the overlay
  - (margins.top + margins.bottom + padding // save additional space for margin and padding
  )) : Math.max(0, overlayTop + overlayHeight // this is the bottom of the overlay
  - (boundaryDimensions.top + boundaryDimensions.scroll.top // this is the top of the boundary
  ) - (margins.top + margins.bottom + padding // save additional space for margin and padding
  ));
  return Math.min(boundaryDimensions.height - padding * 2, maxHeight);
}
function $edcf132a9284368a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding, placementInfo) {
  let {
    placement: placement,
    axis: axis,
    size: size
  } = placementInfo;
  if (placement === axis) return Math.max(0, childOffset[axis] - boundaryDimensions[axis] - boundaryDimensions.scroll[axis] + containerOffsetWithBoundary[axis] - margins[axis] - margins[$edcf132a9284368a$var$FLIPPED_DIRECTION[axis]] - padding);
  return Math.max(0, boundaryDimensions[size] + boundaryDimensions[axis] + boundaryDimensions.scroll[axis] - containerOffsetWithBoundary[axis] - childOffset[axis] - childOffset[size] - margins[axis] - margins[$edcf132a9284368a$var$FLIPPED_DIRECTION[axis]] - padding);
}
function $edcf132a9284368a$export$6839422d1f33cee9(placementInput, childOffset, overlaySize, scrollSize, margins, padding, flip, boundaryDimensions, containerDimensions, containerOffsetWithBoundary, offset, crossOffset, isContainerPositioned, userSetMaxHeight, arrowSize, arrowBoundaryOffset) {
  let placementInfo = $edcf132a9284368a$var$parsePlacement(placementInput);
  let {
    size: size,
    crossAxis: crossAxis,
    crossSize: crossSize,
    placement: placement,
    crossPlacement: crossPlacement
  } = placementInfo;
  let position = $edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset);
  let normalizedOffset = offset;
  let space = $edcf132a9284368a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding + offset, placementInfo);
  // Check if the scroll size of the overlay is greater than the available space to determine if we need to flip
  if (flip && scrollSize[size] > space) {
    let flippedPlacementInfo = $edcf132a9284368a$var$parsePlacement(`${$edcf132a9284368a$var$FLIPPED_DIRECTION[placement]} ${crossPlacement}`);
    let flippedPosition = $edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, flippedPlacementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset);
    let flippedSpace = $edcf132a9284368a$var$getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding + offset, flippedPlacementInfo);
    // If the available space for the flipped position is greater than the original available space, flip.
    if (flippedSpace > space) {
      placementInfo = flippedPlacementInfo;
      position = flippedPosition;
      normalizedOffset = offset;
    }
  }
  // Determine the direction the height of the overlay can grow so that we can choose how to calculate the max height
  let heightGrowthDirection = 'bottom';
  if (placementInfo.axis === 'top') {
    if (placementInfo.placement === 'top') heightGrowthDirection = 'top';else if (placementInfo.placement === 'bottom') heightGrowthDirection = 'bottom';
  } else if (placementInfo.crossAxis === 'top') {
    if (placementInfo.crossPlacement === 'top') heightGrowthDirection = 'bottom';else if (placementInfo.crossPlacement === 'bottom') heightGrowthDirection = 'top';
  }
  let delta = $edcf132a9284368a$var$getDelta(crossAxis, position[crossAxis], overlaySize[crossSize], boundaryDimensions, containerDimensions, padding, containerOffsetWithBoundary);
  position[crossAxis] += delta;
  let maxHeight = $edcf132a9284368a$var$getMaxHeight(position, boundaryDimensions, containerOffsetWithBoundary, isContainerPositioned, margins, padding, overlaySize.height, heightGrowthDirection);
  if (userSetMaxHeight && userSetMaxHeight < maxHeight) maxHeight = userSetMaxHeight;
  overlaySize.height = Math.min(overlaySize.height, maxHeight);
  position = $edcf132a9284368a$var$computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, normalizedOffset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset);
  delta = $edcf132a9284368a$var$getDelta(crossAxis, position[crossAxis], overlaySize[crossSize], boundaryDimensions, containerDimensions, padding, containerOffsetWithBoundary);
  position[crossAxis] += delta;
  let arrowPosition = {};
  // All values are transformed so that 0 is at the top/left of the overlay depending on the orientation
  // Prefer the arrow being in the center of the trigger/overlay anchor element
  let preferredArrowPosition = childOffset[crossAxis] + .5 * childOffset[crossSize] - position[crossAxis];
  // Min/Max position limits for the arrow with respect to the overlay
  const arrowMinPosition = arrowSize / 2 + arrowBoundaryOffset;
  const arrowMaxPosition = overlaySize[crossSize] - arrowSize / 2 - arrowBoundaryOffset;
  // Min/Max position limits for the arrow with respect to the trigger/overlay anchor element
  const arrowOverlappingChildMinEdge = childOffset[crossAxis] - position[crossAxis] + arrowSize / 2;
  const arrowOverlappingChildMaxEdge = childOffset[crossAxis] + childOffset[crossSize] - position[crossAxis] - arrowSize / 2;
  // Clamp the arrow positioning so that it always is within the bounds of the anchor and the overlay
  const arrowPositionOverlappingChild = ($9446cca9a3875146$export$7d15b64cf5a3a4c4)(preferredArrowPosition, arrowOverlappingChildMinEdge, arrowOverlappingChildMaxEdge);
  arrowPosition[crossAxis] = ($9446cca9a3875146$export$7d15b64cf5a3a4c4)(arrowPositionOverlappingChild, arrowMinPosition, arrowMaxPosition);
  return {
    position: position,
    maxHeight: maxHeight,
    arrowOffsetLeft: arrowPosition.left,
    arrowOffsetTop: arrowPosition.top,
    placement: placementInfo.placement
  };
}
function $edcf132a9284368a$export$b3ceb0cbf1056d98(opts) {
  let {
    placement: placement,
    targetNode: targetNode,
    overlayNode: overlayNode,
    scrollNode: scrollNode,
    padding: padding,
    shouldFlip: shouldFlip,
    boundaryElement: boundaryElement,
    offset: offset,
    crossOffset: crossOffset,
    maxHeight: maxHeight,
    arrowSize = 0,
    arrowBoundaryOffset = 0
  } = opts;
  let container = overlayNode instanceof HTMLElement ? $edcf132a9284368a$var$getContainingBlock(overlayNode) : document.documentElement;
  let isViewportContainer = container === document.documentElement;
  const containerPositionStyle = window.getComputedStyle(container).position;
  let isContainerPositioned = !!containerPositionStyle && containerPositionStyle !== 'static';
  let childOffset = isViewportContainer ? $edcf132a9284368a$var$getOffset(targetNode) : $edcf132a9284368a$var$getPosition(targetNode, container);
  if (!isViewportContainer) {
    let {
      marginTop: marginTop,
      marginLeft: marginLeft
    } = window.getComputedStyle(targetNode);
    childOffset.top += parseInt(marginTop, 10) || 0;
    childOffset.left += parseInt(marginLeft, 10) || 0;
  }
  let overlaySize = $edcf132a9284368a$var$getOffset(overlayNode);
  let margins = $edcf132a9284368a$var$getMargins(overlayNode);
  overlaySize.width += margins.left + margins.right;
  overlaySize.height += margins.top + margins.bottom;
  let scrollSize = $edcf132a9284368a$var$getScroll(scrollNode);
  let boundaryDimensions = $edcf132a9284368a$var$getContainerDimensions(boundaryElement);
  let containerDimensions = $edcf132a9284368a$var$getContainerDimensions(container);
  // If the container is the HTML element wrapping the body element, the retrieved scrollTop/scrollLeft will be equal to the
  // body element's scroll. Set the container's scroll values to 0 since the overlay's edge position value in getDelta don't then need to be further offset
  // by the container scroll since they are essentially the same containing element and thus in the same coordinate system
  let containerOffsetWithBoundary = boundaryElement.tagName === 'BODY' ? $edcf132a9284368a$var$getOffset(container) : $edcf132a9284368a$var$getPosition(container, boundaryElement);
  if (container.tagName === 'HTML' && boundaryElement.tagName === 'BODY') {
    containerDimensions.scroll.top = 0;
    containerDimensions.scroll.left = 0;
  }
  return $edcf132a9284368a$export$6839422d1f33cee9(placement, childOffset, overlaySize, scrollSize, margins, padding, shouldFlip, boundaryDimensions, containerDimensions, containerOffsetWithBoundary, offset, crossOffset, isContainerPositioned, maxHeight, arrowSize, arrowBoundaryOffset);
}
function $edcf132a9284368a$var$getOffset(node) {
  let {
    top: top,
    left: left,
    width: width,
    height: height
  } = node.getBoundingClientRect();
  let {
    scrollTop: scrollTop,
    scrollLeft: scrollLeft,
    clientTop: clientTop,
    clientLeft: clientLeft
  } = document.documentElement;
  return {
    top: top + scrollTop - clientTop,
    left: left + scrollLeft - clientLeft,
    width: width,
    height: height
  };
}
function $edcf132a9284368a$var$getPosition(node, parent) {
  let style = window.getComputedStyle(node);
  let offset;
  if (style.position === 'fixed') {
    let {
      top: top,
      left: left,
      width: width,
      height: height
    } = node.getBoundingClientRect();
    offset = {
      top: top,
      left: left,
      width: width,
      height: height
    };
  } else {
    offset = $edcf132a9284368a$var$getOffset(node);
    let parentOffset = $edcf132a9284368a$var$getOffset(parent);
    let parentStyle = window.getComputedStyle(parent);
    parentOffset.top += (parseInt(parentStyle.borderTopWidth, 10) || 0) - parent.scrollTop;
    parentOffset.left += (parseInt(parentStyle.borderLeftWidth, 10) || 0) - parent.scrollLeft;
    offset.top -= parentOffset.top;
    offset.left -= parentOffset.left;
  }
  offset.top -= parseInt(style.marginTop, 10) || 0;
  offset.left -= parseInt(style.marginLeft, 10) || 0;
  return offset;
}
// Returns the containing block of an element, which is the element that
// this element will be positioned relative to.
// https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block
function $edcf132a9284368a$var$getContainingBlock(node) {
  // The offsetParent of an element in most cases equals the containing block.
  // https://w3c.github.io/csswg-drafts/cssom-view/#dom-htmlelement-offsetparent
  let offsetParent = node.offsetParent;
  // The offsetParent algorithm terminates at the document body,
  // even if the body is not a containing block. Double check that
  // and use the documentElement if so.
  if (offsetParent && offsetParent === document.body && window.getComputedStyle(offsetParent).position === 'static' && !$edcf132a9284368a$var$isContainingBlock(offsetParent)) offsetParent = document.documentElement;
  // TODO(later): handle table elements?
  // The offsetParent can be null if the element has position: fixed, or a few other cases.
  // We have to walk up the tree manually in this case because fixed positioned elements
  // are still positioned relative to their containing block, which is not always the viewport.
  if (offsetParent == null) {
    offsetParent = node.parentElement;
    while (offsetParent && !$edcf132a9284368a$var$isContainingBlock(offsetParent)) offsetParent = offsetParent.parentElement;
  }
  // Fall back to the viewport.
  return offsetParent || document.documentElement;
}
// https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
function $edcf132a9284368a$var$isContainingBlock(node) {
  let style = window.getComputedStyle(node);
  return style.transform !== 'none' || /transform|perspective/.test(style.willChange) || style.filter !== 'none' || style.contain === 'paint' ||
  // @ts-ignore
  'backdropFilter' in style && style.backdropFilter !== 'none' ||
  // @ts-ignore
  'WebkitBackdropFilter' in style && style.WebkitBackdropFilter !== 'none';
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
const $dd149f63282afbbf$export$f6211563215e3b37 = new WeakMap();
function $dd149f63282afbbf$export$18fc8428861184da(opts) {
  let {
    triggerRef: triggerRef,
    isOpen: isOpen,
    onClose: onClose
  } = opts;
  (useEffect)(() => {
    if (!isOpen || onClose === null) return;
    let onScroll = e => {
      // Ignore if scrolling an scrollable region outside the trigger's tree.
      let target = e.target;
      // window is not a Node and doesn't have contain, but window contains everything
      if (!triggerRef.current || target instanceof Node && !target.contains(triggerRef.current)) return;
      let onCloseHandler = onClose || $dd149f63282afbbf$export$f6211563215e3b37.get(triggerRef.current);
      if (onCloseHandler) onCloseHandler();
    };
    window.addEventListener('scroll', onScroll, true);
    return () => {
      window.removeEventListener('scroll', onScroll, true);
    };
  }, [isOpen, onClose, triggerRef]);
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // https://en.wikipedia.org/wiki/Right-to-left
const $148a7a147e38ea7f$var$RTL_SCRIPTS = new Set(['Arab', 'Syrc', 'Samr', 'Mand', 'Thaa', 'Mend', 'Nkoo', 'Adlm', 'Rohg', 'Hebr']);
const $148a7a147e38ea7f$var$RTL_LANGS = new Set(['ae', 'ar', 'arc', 'bcc', 'bqi', 'ckb', 'dv', 'fa', 'glk', 'he', 'ku', 'mzn', 'nqo', 'pnb', 'ps', 'sd', 'ug', 'ur', 'yi']);
function $148a7a147e38ea7f$export$702d680b21cbd764(localeString) {
  // If the Intl.Locale API is available, use it to get the locale's text direction.
  // @ts-ignore
  if (Intl.Locale) {
    let locale = new Intl.Locale(localeString).maximize();
    // Use the text info object to get the direction if possible.
    // @ts-ignore - this was implemented as a property by some browsers before it was standardized as a function.
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getTextInfo
    let textInfo = typeof locale.getTextInfo === 'function' ? locale.getTextInfo() : locale.textInfo;
    if (textInfo) return textInfo.direction === 'rtl';
    // Fallback: guess using the script.
    // This is more accurate than guessing by language, since languages can be written in multiple scripts.
    if (locale.script) return $148a7a147e38ea7f$var$RTL_SCRIPTS.has(locale.script);
  }
  // If not, just guess by the language (first part of the locale)
  let lang = localeString.split('-')[0];
  return $148a7a147e38ea7f$var$RTL_LANGS.has(lang);
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

// Locale passed from server by PackageLocalizationProvider.
const $1e5a04cdaf7d1af8$var$localeSymbol = Symbol.for('react-aria.i18n.locale');
function $1e5a04cdaf7d1af8$export$f09106e7c6677ec5() {
  let locale = typeof window !== 'undefined' && window[$1e5a04cdaf7d1af8$var$localeSymbol] || typeof navigator !== 'undefined' && (navigator.language || navigator.userLanguage) || 'en-US';
  try {
    // @ts-ignore
    Intl.DateTimeFormat.supportedLocalesOf([locale]);
  } catch (_err) {
    locale = 'en-US';
  }
  return {
    locale: locale,
    direction: ($148a7a147e38ea7f$export$702d680b21cbd764)(locale) ? 'rtl' : 'ltr'
  };
}
let $1e5a04cdaf7d1af8$var$currentLocale = $1e5a04cdaf7d1af8$export$f09106e7c6677ec5();
let $1e5a04cdaf7d1af8$var$listeners = new Set();
function $1e5a04cdaf7d1af8$var$updateLocale() {
  $1e5a04cdaf7d1af8$var$currentLocale = $1e5a04cdaf7d1af8$export$f09106e7c6677ec5();
  for (let listener of $1e5a04cdaf7d1af8$var$listeners) listener($1e5a04cdaf7d1af8$var$currentLocale);
}
function $1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a() {
  let isSSR = ($b5e257d569688ac6$export$535bd6ca7f90a273)();
  let [defaultLocale, setDefaultLocale] = (useState)($1e5a04cdaf7d1af8$var$currentLocale);
  (useEffect)(() => {
    if ($1e5a04cdaf7d1af8$var$listeners.size === 0) window.addEventListener('languagechange', $1e5a04cdaf7d1af8$var$updateLocale);
    $1e5a04cdaf7d1af8$var$listeners.add(setDefaultLocale);
    return () => {
      $1e5a04cdaf7d1af8$var$listeners.delete(setDefaultLocale);
      if ($1e5a04cdaf7d1af8$var$listeners.size === 0) window.removeEventListener('languagechange', $1e5a04cdaf7d1af8$var$updateLocale);
    };
  }, []);
  // We cannot determine the browser's language on the server, so default to
  // en-US. This will be updated after hydration on the client to the correct value.
  if (isSSR) return {
    locale: 'en-US',
    direction: 'ltr'
  };
  return defaultLocale;
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

const $18f2051aff69b9bf$var$I18nContext = /*#__PURE__*/(React__default).createContext(null);
function $18f2051aff69b9bf$export$43bb16f9c6d9e3f7() {
  let defaultLocale = ($1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a)();
  let context = (useContext)($18f2051aff69b9bf$var$I18nContext);
  return context || defaultLocale;
}

/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */const $5b160d28a433310d$var$localeSymbol = Symbol.for('react-aria.i18n.locale');
const $5b160d28a433310d$var$stringsSymbol = Symbol.for('react-aria.i18n.strings');
let $5b160d28a433310d$var$cachedGlobalStrings = undefined;
class $5b160d28a433310d$export$c17fa47878dc55b6 {
  /** Returns a localized string for the given key and locale. */getStringForLocale(key, locale) {
    let strings = this.getStringsForLocale(locale);
    let string = strings[key];
    if (!string) throw new Error(`Could not find intl message ${key} in ${locale} locale`);
    return string;
  }
  /** Returns all localized strings for the given locale. */
  getStringsForLocale(locale) {
    let strings = this.strings[locale];
    if (!strings) {
      strings = $5b160d28a433310d$var$getStringsForLocale(locale, this.strings, this.defaultLocale);
      this.strings[locale] = strings;
    }
    return strings;
  }
  static getGlobalDictionaryForPackage(packageName) {
    if (typeof window === 'undefined') return null;
    let locale = window[$5b160d28a433310d$var$localeSymbol];
    if ($5b160d28a433310d$var$cachedGlobalStrings === undefined) {
      let globalStrings = window[$5b160d28a433310d$var$stringsSymbol];
      if (!globalStrings) return null;
      $5b160d28a433310d$var$cachedGlobalStrings = {};
      for (let pkg in globalStrings) $5b160d28a433310d$var$cachedGlobalStrings[pkg] = new $5b160d28a433310d$export$c17fa47878dc55b6({
        [locale]: globalStrings[pkg]
      }, locale);
    }
    let dictionary = $5b160d28a433310d$var$cachedGlobalStrings === null || $5b160d28a433310d$var$cachedGlobalStrings === void 0 ? void 0 : $5b160d28a433310d$var$cachedGlobalStrings[packageName];
    if (!dictionary) throw new Error(`Strings for package "${packageName}" were not included by LocalizedStringProvider. Please add it to the list passed to createLocalizedStringDictionary.`);
    return dictionary;
  }
  constructor(messages, defaultLocale = 'en-US') {
    // Clone messages so we don't modify the original object.
    // Filter out entries with falsy values which may have been caused by applying optimize-locales-plugin.
    this.strings = Object.fromEntries(Object.entries(messages).filter(([, v]) => v));
    this.defaultLocale = defaultLocale;
  }
}
function $5b160d28a433310d$var$getStringsForLocale(locale, strings, defaultLocale = 'en-US') {
  // If there is an exact match, use it.
  if (strings[locale]) return strings[locale];
  // Attempt to find the closest match by language.
  // For example, if the locale is fr-CA (French Canadian), but there is only
  // an fr-FR (France) set of strings, use that.
  // This could be replaced with Intl.LocaleMatcher once it is supported.
  // https://github.com/tc39/proposal-intl-localematcher
  let language = $5b160d28a433310d$var$getLanguage(locale);
  if (strings[language]) return strings[language];
  for (let key in strings) {
    if (key.startsWith(language + '-')) return strings[key];
  }
  // Nothing close, use english.
  return strings[defaultLocale];
}
function $5b160d28a433310d$var$getLanguage(locale) {
  // @ts-ignore
  if (Intl.Locale)
    // @ts-ignore
    return new Intl.Locale(locale).language;
  return locale.split('-')[0];
}

/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */const $6db58dc88e78b024$var$pluralRulesCache = new Map();
const $6db58dc88e78b024$var$numberFormatCache = new Map();
class $6db58dc88e78b024$export$2f817fcdc4b89ae0 {
  /** Formats a localized string for the given key with the provided variables. */format(key, variables) {
    let message = this.strings.getStringForLocale(key, this.locale);
    return typeof message === 'function' ? message(variables, this) : message;
  }
  plural(count, options, type = 'cardinal') {
    let opt = options['=' + count];
    if (opt) return typeof opt === 'function' ? opt() : opt;
    let key = this.locale + ':' + type;
    let pluralRules = $6db58dc88e78b024$var$pluralRulesCache.get(key);
    if (!pluralRules) {
      pluralRules = new Intl.PluralRules(this.locale, {
        type: type
      });
      $6db58dc88e78b024$var$pluralRulesCache.set(key, pluralRules);
    }
    let selected = pluralRules.select(count);
    opt = options[selected] || options.other;
    return typeof opt === 'function' ? opt() : opt;
  }
  number(value) {
    let numberFormat = $6db58dc88e78b024$var$numberFormatCache.get(this.locale);
    if (!numberFormat) {
      numberFormat = new Intl.NumberFormat(this.locale);
      $6db58dc88e78b024$var$numberFormatCache.set(this.locale, numberFormat);
    }
    return numberFormat.format(value);
  }
  select(options, value) {
    let opt = options[value] || options.other;
    return typeof opt === 'function' ? opt() : opt;
  }
  constructor(locale, strings) {
    this.locale = locale;
    this.strings = strings;
  }
}

/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

const $fca6afa0e843324b$var$cache = new WeakMap();
function $fca6afa0e843324b$var$getCachedDictionary(strings) {
  let dictionary = $fca6afa0e843324b$var$cache.get(strings);
  if (!dictionary) {
    dictionary = new ($5b160d28a433310d$export$c17fa47878dc55b6)(strings);
    $fca6afa0e843324b$var$cache.set(strings, dictionary);
  }
  return dictionary;
}
function $fca6afa0e843324b$export$87b761675e8eaa10(strings, packageName) {
  return packageName && ($5b160d28a433310d$export$c17fa47878dc55b6).getGlobalDictionaryForPackage(packageName) || $fca6afa0e843324b$var$getCachedDictionary(strings);
}
function $fca6afa0e843324b$export$f12b703ca79dfbb1(strings, packageName) {
  let {
    locale: locale
  } = ($18f2051aff69b9bf$export$43bb16f9c6d9e3f7)();
  let dictionary = $fca6afa0e843324b$export$87b761675e8eaa10(strings, packageName);
  return (useMemo)(() => new ($6db58dc88e78b024$export$2f817fcdc4b89ae0)(locale, dictionary), [locale, dictionary]);
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

// @ts-ignore
let $2a41e45df1593e64$var$visualViewport = typeof document !== 'undefined' && window.visualViewport;
function $2a41e45df1593e64$export$d39e1813b3bdd0e1(props) {
  let {
    direction: direction
  } = ($18f2051aff69b9bf$export$43bb16f9c6d9e3f7)();
  let {
    arrowSize = 0,
    targetRef: targetRef,
    overlayRef: overlayRef,
    scrollRef = overlayRef,
    placement = 'bottom',
    containerPadding = 12,
    shouldFlip = true,
    boundaryElement = typeof document !== 'undefined' ? document.body : null,
    offset = 0,
    crossOffset = 0,
    shouldUpdatePosition = true,
    isOpen = true,
    onClose: onClose,
    maxHeight: maxHeight,
    arrowBoundaryOffset = 0
  } = props;
  let [position, setPosition] = (useState)({
    position: {},
    arrowOffsetLeft: undefined,
    arrowOffsetTop: undefined,
    maxHeight: undefined,
    placement: undefined
  });
  let deps = [shouldUpdatePosition, placement, overlayRef.current, targetRef.current, scrollRef.current, containerPadding, shouldFlip, boundaryElement, offset, crossOffset, isOpen, direction, maxHeight, arrowBoundaryOffset, arrowSize];
  // Note, the position freezing breaks if body sizes itself dynamicly with the visual viewport but that might
  // just be a non-realistic use case
  // Upon opening a overlay, record the current visual viewport scale so we can freeze the overlay styles
  let lastScale = (useRef)($2a41e45df1593e64$var$visualViewport === null || $2a41e45df1593e64$var$visualViewport === void 0 ? void 0 : $2a41e45df1593e64$var$visualViewport.scale);
  (useEffect)(() => {
    if (isOpen) lastScale.current = $2a41e45df1593e64$var$visualViewport === null || $2a41e45df1593e64$var$visualViewport === void 0 ? void 0 : $2a41e45df1593e64$var$visualViewport.scale;
  }, [isOpen]);
  let updatePosition = (useCallback)(() => {
    if (shouldUpdatePosition === false || !isOpen || !overlayRef.current || !targetRef.current || !scrollRef.current || !boundaryElement) return;
    if (($2a41e45df1593e64$var$visualViewport === null || $2a41e45df1593e64$var$visualViewport === void 0 ? void 0 : $2a41e45df1593e64$var$visualViewport.scale) !== lastScale.current) return;
    // Always reset the overlay's previous max height if not defined by the user so that we can compensate for
    // RAC collections populating after a second render and properly set a correct max height + positioning when it populates.
    let overlay = overlayRef.current;
    if (!maxHeight && overlayRef.current) {
      var _window_visualViewport;
      overlay.style.top = '0px';
      overlay.style.bottom = '';
      var _window_visualViewport_height;
      overlay.style.maxHeight = ((_window_visualViewport_height = (_window_visualViewport = window.visualViewport) === null || _window_visualViewport === void 0 ? void 0 : _window_visualViewport.height) !== null && _window_visualViewport_height !== void 0 ? _window_visualViewport_height : window.innerHeight) + 'px';
    }
    let position = ($edcf132a9284368a$export$b3ceb0cbf1056d98)({
      placement: $2a41e45df1593e64$var$translateRTL(placement, direction),
      overlayNode: overlayRef.current,
      targetNode: targetRef.current,
      scrollNode: scrollRef.current,
      padding: containerPadding,
      shouldFlip: shouldFlip,
      boundaryElement: boundaryElement,
      offset: offset,
      crossOffset: crossOffset,
      maxHeight: maxHeight,
      arrowSize: arrowSize,
      arrowBoundaryOffset: arrowBoundaryOffset
    });
    // Modify overlay styles directly so positioning happens immediately without the need of a second render
    // This is so we don't have to delay autoFocus scrolling or delay applying preventScroll for popovers
    overlay.style.top = '';
    overlay.style.bottom = '';
    Object.keys(position.position).forEach(key => overlay.style[key] = position.position[key] + 'px');
    overlay.style.maxHeight = position.maxHeight != null ? position.maxHeight + 'px' : undefined;
    // Trigger a set state for a second render anyway for arrow positioning
    setPosition(position);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  // Update position when anything changes
  // eslint-disable-next-line react-hooks/exhaustive-deps
  ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(updatePosition, deps);
  // Update position on window resize
  $2a41e45df1593e64$var$useResize(updatePosition);
  // Update position when the overlay changes size (might need to flip).
  ($9daab02d461809db$export$683480f191c0e3ea)({
    ref: overlayRef,
    onResize: updatePosition
  });
  // Reposition the overlay and do not close on scroll while the visual viewport is resizing.
  // This will ensure that overlays adjust their positioning when the iOS virtual keyboard appears.
  let isResizing = (useRef)(false);
  ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(() => {
    let timeout;
    let onResize = () => {
      isResizing.current = true;
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        isResizing.current = false;
      }, 500);
      updatePosition();
    };
    // Only reposition the overlay if a scroll event happens immediately as a result of resize (aka the virtual keyboard has appears)
    // We don't want to reposition the overlay if the user has pinch zoomed in and is scrolling the viewport around.
    let onScroll = () => {
      if (isResizing.current) onResize();
    };
    $2a41e45df1593e64$var$visualViewport === null || $2a41e45df1593e64$var$visualViewport === void 0 ? void 0 : $2a41e45df1593e64$var$visualViewport.addEventListener('resize', onResize);
    $2a41e45df1593e64$var$visualViewport === null || $2a41e45df1593e64$var$visualViewport === void 0 ? void 0 : $2a41e45df1593e64$var$visualViewport.addEventListener('scroll', onScroll);
    return () => {
      $2a41e45df1593e64$var$visualViewport === null || $2a41e45df1593e64$var$visualViewport === void 0 ? void 0 : $2a41e45df1593e64$var$visualViewport.removeEventListener('resize', onResize);
      $2a41e45df1593e64$var$visualViewport === null || $2a41e45df1593e64$var$visualViewport === void 0 ? void 0 : $2a41e45df1593e64$var$visualViewport.removeEventListener('scroll', onScroll);
    };
  }, [updatePosition]);
  let close = (useCallback)(() => {
    if (!isResizing.current) onClose();
  }, [onClose, isResizing]);
  // When scrolling a parent scrollable region of the trigger (other than the body),
  // we hide the popover. Otherwise, its position would be incorrect.
  ($dd149f63282afbbf$export$18fc8428861184da)({
    triggerRef: targetRef,
    isOpen: isOpen,
    onClose: onClose && close
  });
  return {
    overlayProps: {
      style: {
        position: 'absolute',
        zIndex: 100000,
        ...position.position,
        maxHeight: position.maxHeight
      }
    },
    placement: position.placement,
    arrowProps: {
      'aria-hidden': 'true',
      role: 'presentation',
      style: {
        left: position.arrowOffsetLeft,
        top: position.arrowOffsetTop
      }
    },
    updatePosition: updatePosition
  };
}
function $2a41e45df1593e64$var$useResize(onResize) {
  ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(() => {
    window.addEventListener('resize', onResize, false);
    return () => {
      window.removeEventListener('resize', onResize, false);
    };
  }, [onResize]);
}
function $2a41e45df1593e64$var$translateRTL(position, direction) {
  if (direction === 'rtl') return position.replace('start', 'right').replace('end', 'left');
  return position.replace('start', 'left').replace('end', 'right');
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
const $ae1eeba8b9eafd08$export$5165eccb35aaadb5 = (React__default).createContext({
  register: () => {}
});
$ae1eeba8b9eafd08$export$5165eccb35aaadb5.displayName = 'PressResponderContext';

function $f1ab8c75478c6f73$export$cf75428e0b9ed1ea({
  children: children
}) {
  let context = (useMemo)(() => ({
    register: () => {}
  }), []);
  return /*#__PURE__*/(React__default).createElement(($ae1eeba8b9eafd08$export$5165eccb35aaadb5).Provider, {
    value: context
  }, children);
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

class $8a9cb279dc87e130$export$905e7fc544a71f36 {
  isDefaultPrevented() {
    return this.nativeEvent.defaultPrevented;
  }
  preventDefault() {
    this.defaultPrevented = true;
    this.nativeEvent.preventDefault();
  }
  stopPropagation() {
    this.nativeEvent.stopPropagation();
    this.isPropagationStopped = () => true;
  }
  isPropagationStopped() {
    return false;
  }
  persist() {}
  constructor(type, nativeEvent) {
    this.nativeEvent = nativeEvent;
    this.target = nativeEvent.target;
    this.currentTarget = nativeEvent.currentTarget;
    this.relatedTarget = nativeEvent.relatedTarget;
    this.bubbles = nativeEvent.bubbles;
    this.cancelable = nativeEvent.cancelable;
    this.defaultPrevented = nativeEvent.defaultPrevented;
    this.eventPhase = nativeEvent.eventPhase;
    this.isTrusted = nativeEvent.isTrusted;
    this.timeStamp = nativeEvent.timeStamp;
    this.type = type;
  }
}
function $8a9cb279dc87e130$export$715c682d09d639cc(onBlur) {
  let stateRef = (useRef)({
    isFocused: false,
    observer: null
  });
  // Clean up MutationObserver on unmount. See below.
  // eslint-disable-next-line arrow-body-style
  ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(() => {
    const state = stateRef.current;
    return () => {
      if (state.observer) {
        state.observer.disconnect();
        state.observer = null;
      }
    };
  }, []);
  let dispatchBlur = ($8ae05eaa5c114e9c$export$7f54fc3180508a52)(e => {
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
  });
  // This function is called during a React onFocus event.
  return (useCallback)(e => {
    // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
    // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
    // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
    // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
    if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) {
      stateRef.current.isFocused = true;
      let target = e.target;
      let onBlurHandler = e => {
        stateRef.current.isFocused = false;
        if (target.disabled)
          // For backward compatibility, dispatch a (fake) React synthetic event.
          dispatchBlur(new $8a9cb279dc87e130$export$905e7fc544a71f36('blur', e));
        // We no longer need the MutationObserver once the target is blurred.
        if (stateRef.current.observer) {
          stateRef.current.observer.disconnect();
          stateRef.current.observer = null;
        }
      };
      target.addEventListener('focusout', onBlurHandler, {
        once: true
      });
      stateRef.current.observer = new MutationObserver(() => {
        if (stateRef.current.isFocused && target.disabled) {
          var _stateRef_current_observer;
          (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 ? void 0 : _stateRef_current_observer.disconnect();
          let relatedTargetEl = target === document.activeElement ? null : document.activeElement;
          target.dispatchEvent(new FocusEvent('blur', {
            relatedTarget: relatedTargetEl
          }));
          target.dispatchEvent(new FocusEvent('focusout', {
            bubbles: true,
            relatedTarget: relatedTargetEl
          }));
        }
      });
      stateRef.current.observer.observe(target, {
        attributes: true,
        attributeFilter: ['disabled']
      });
    }
  }, [dispatchBlur]);
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions

let $507fabe10e71c6fb$var$currentModality = null;
let $507fabe10e71c6fb$var$changeHandlers = new Set();
let $507fabe10e71c6fb$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
function $507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
  for (let handler of $507fabe10e71c6fb$var$changeHandlers) handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */
function $507fabe10e71c6fb$var$isValidKey(e) {
  // Control and Shift keys trigger when navigating back to the tab with keyboard.
  return !(e.metaKey || !($c87311424ea30a05$export$9ac100e40613ea10)() && e.altKey || e.ctrlKey || e.key === 'Control' || e.key === 'Shift' || e.key === 'Meta');
}
function $507fabe10e71c6fb$var$handleKeyboardEvent(e) {
  $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
  if ($507fabe10e71c6fb$var$isValidKey(e)) {
    $507fabe10e71c6fb$var$currentModality = 'keyboard';
    $507fabe10e71c6fb$var$triggerChangeHandlers('keyboard', e);
  }
}
function $507fabe10e71c6fb$var$handlePointerEvent(e) {
  $507fabe10e71c6fb$var$currentModality = 'pointer';
  if (e.type === 'mousedown' || e.type === 'pointerdown') {
    $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    $507fabe10e71c6fb$var$triggerChangeHandlers('pointer', e);
  }
}
function $507fabe10e71c6fb$var$handleClickEvent(e) {
  if (($6a7db85432448f7f$export$60278871457622de)(e)) {
    $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    $507fabe10e71c6fb$var$currentModality = 'virtual';
  }
}
function $507fabe10e71c6fb$var$handleFocusEvent(e) {
  // Firefox fires two extra focus events when the user first clicks into an iframe:
  // first on the window, then on the document. We ignore these events so they don't
  // cause keyboard focus rings to appear.
  if (e.target === window || e.target === document) return;
  // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
  // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
  if (!$507fabe10e71c6fb$var$hasEventBeforeFocus && !$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
    $507fabe10e71c6fb$var$currentModality = 'virtual';
    $507fabe10e71c6fb$var$triggerChangeHandlers('virtual', e);
  }
  $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
  $507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $507fabe10e71c6fb$var$handleWindowBlur() {
  // When the window is blurred, reset state. This is necessary when tabbing out of the window,
  // for example, since a subsequent focus event won't be fired.
  $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
  $507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */
function $507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
  if (typeof window === 'undefined' || $507fabe10e71c6fb$export$d90243b58daecda7.get(($431fbd86ca7dc216$export$f21a1ffae260145a)(element))) return;
  const windowObject = ($431fbd86ca7dc216$export$f21a1ffae260145a)(element);
  const documentObject = ($431fbd86ca7dc216$export$b204af158042fbac)(element);
  // Programmatic focus() calls shouldn't affect the current input modality.
  // However, we need to detect other cases when a focus event occurs without
  // a preceding user event (e.g. screen reader focus). Overriding the focus
  // method on HTMLElement.prototype is a bit hacky, but works.
  let focus = windowObject.HTMLElement.prototype.focus;
  windowObject.HTMLElement.prototype.focus = function () {
    $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    focus.apply(this, arguments);
  };
  documentObject.addEventListener('keydown', $507fabe10e71c6fb$var$handleKeyboardEvent, true);
  documentObject.addEventListener('keyup', $507fabe10e71c6fb$var$handleKeyboardEvent, true);
  documentObject.addEventListener('click', $507fabe10e71c6fb$var$handleClickEvent, true);
  // Register focus events on the window so they are sure to happen
  // before React's event listeners (registered on the document).
  windowObject.addEventListener('focus', $507fabe10e71c6fb$var$handleFocusEvent, true);
  windowObject.addEventListener('blur', $507fabe10e71c6fb$var$handleWindowBlur, false);
  if (typeof PointerEvent !== 'undefined') {
    documentObject.addEventListener('pointerdown', $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.addEventListener('pointermove', $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.addEventListener('pointerup', $507fabe10e71c6fb$var$handlePointerEvent, true);
  } else {
    documentObject.addEventListener('mousedown', $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.addEventListener('mousemove', $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.addEventListener('mouseup', $507fabe10e71c6fb$var$handlePointerEvent, true);
  }
  // Add unmount handler
  windowObject.addEventListener('beforeunload', () => {
    $507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
  }, {
    once: true
  });
  $507fabe10e71c6fb$export$d90243b58daecda7.set(windowObject, {
    focus: focus
  });
}
const $507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener) => {
  const windowObject = ($431fbd86ca7dc216$export$f21a1ffae260145a)(element);
  const documentObject = ($431fbd86ca7dc216$export$b204af158042fbac)(element);
  if (loadListener) documentObject.removeEventListener('DOMContentLoaded', loadListener);
  if (!$507fabe10e71c6fb$export$d90243b58daecda7.has(windowObject)) return;
  windowObject.HTMLElement.prototype.focus = $507fabe10e71c6fb$export$d90243b58daecda7.get(windowObject).focus;
  documentObject.removeEventListener('keydown', $507fabe10e71c6fb$var$handleKeyboardEvent, true);
  documentObject.removeEventListener('keyup', $507fabe10e71c6fb$var$handleKeyboardEvent, true);
  documentObject.removeEventListener('click', $507fabe10e71c6fb$var$handleClickEvent, true);
  windowObject.removeEventListener('focus', $507fabe10e71c6fb$var$handleFocusEvent, true);
  windowObject.removeEventListener('blur', $507fabe10e71c6fb$var$handleWindowBlur, false);
  if (typeof PointerEvent !== 'undefined') {
    documentObject.removeEventListener('pointerdown', $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.removeEventListener('pointermove', $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.removeEventListener('pointerup', $507fabe10e71c6fb$var$handlePointerEvent, true);
  } else {
    documentObject.removeEventListener('mousedown', $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.removeEventListener('mousemove', $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.removeEventListener('mouseup', $507fabe10e71c6fb$var$handlePointerEvent, true);
  }
  $507fabe10e71c6fb$export$d90243b58daecda7.delete(windowObject);
};
function $507fabe10e71c6fb$export$2f1888112f558a7d(element) {
  const documentObject = ($431fbd86ca7dc216$export$b204af158042fbac)(element);
  let loadListener;
  if (documentObject.readyState !== 'loading') $507fabe10e71c6fb$var$setupGlobalFocusEvents(element);else {
    loadListener = () => {
      $507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    };
    documentObject.addEventListener('DOMContentLoaded', loadListener);
  }
  return () => $507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== 'undefined') $507fabe10e71c6fb$export$2f1888112f558a7d();
function $507fabe10e71c6fb$export$630ff653c5ada6a9() {
  return $507fabe10e71c6fb$var$currentModality;
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions

function $9ab94262bd0047c7$export$420e68273165f4ec(props) {
  let {
    isDisabled: isDisabled,
    onBlurWithin: onBlurWithin,
    onFocusWithin: onFocusWithin,
    onFocusWithinChange: onFocusWithinChange
  } = props;
  let state = (useRef)({
    isFocusWithin: false
  });
  let onBlur = (useCallback)(e => {
    // We don't want to trigger onBlurWithin and then immediately onFocusWithin again
    // when moving focus inside the element. Only trigger if the currentTarget doesn't
    // include the relatedTarget (where focus is moving).
    if (state.current.isFocusWithin && !e.currentTarget.contains(e.relatedTarget)) {
      state.current.isFocusWithin = false;
      if (onBlurWithin) onBlurWithin(e);
      if (onFocusWithinChange) onFocusWithinChange(false);
    }
  }, [onBlurWithin, onFocusWithinChange, state]);
  let onSyntheticFocus = ($8a9cb279dc87e130$export$715c682d09d639cc)(onBlur);
  let onFocus = (useCallback)(e => {
    // Double check that document.activeElement actually matches e.target in case a previously chained
    // focus handler already moved focus somewhere else.
    if (!state.current.isFocusWithin && document.activeElement === e.target) {
      if (onFocusWithin) onFocusWithin(e);
      if (onFocusWithinChange) onFocusWithinChange(true);
      state.current.isFocusWithin = true;
      onSyntheticFocus(e);
    }
  }, [onFocusWithin, onFocusWithinChange, onSyntheticFocus]);
  if (isDisabled) return {
    focusWithinProps: {
      // These should not have been null, that would conflict in mergeProps
      onFocus: undefined,
      onBlur: undefined
    }
  };
  return {
    focusWithinProps: {
      onFocus: onFocus,
      onBlur: onBlur
    }
  };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions

function $e0b6e0b68ec7f50f$export$872b660ac5a1ff98(props) {
  let {
    ref: ref,
    onInteractOutside: onInteractOutside,
    isDisabled: isDisabled,
    onInteractOutsideStart: onInteractOutsideStart
  } = props;
  let stateRef = (useRef)({
    isPointerDown: false,
    ignoreEmulatedMouseEvents: false
  });
  let onPointerDown = ($8ae05eaa5c114e9c$export$7f54fc3180508a52)(e => {
    if (onInteractOutside && $e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) {
      if (onInteractOutsideStart) onInteractOutsideStart(e);
      stateRef.current.isPointerDown = true;
    }
  });
  let triggerInteractOutside = ($8ae05eaa5c114e9c$export$7f54fc3180508a52)(e => {
    if (onInteractOutside) onInteractOutside(e);
  });
  (useEffect)(() => {
    let state = stateRef.current;
    if (isDisabled) return;
    const element = ref.current;
    const documentObject = ($431fbd86ca7dc216$export$b204af158042fbac)(element);
    // Use pointer events if available. Otherwise, fall back to mouse and touch events.
    if (typeof PointerEvent !== 'undefined') {
      let onPointerUp = e => {
        if (state.isPointerDown && $e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) triggerInteractOutside(e);
        state.isPointerDown = false;
      };
      // changing these to capture phase fixed combobox
      documentObject.addEventListener('pointerdown', onPointerDown, true);
      documentObject.addEventListener('pointerup', onPointerUp, true);
      return () => {
        documentObject.removeEventListener('pointerdown', onPointerDown, true);
        documentObject.removeEventListener('pointerup', onPointerUp, true);
      };
    } else {
      let onMouseUp = e => {
        if (state.ignoreEmulatedMouseEvents) state.ignoreEmulatedMouseEvents = false;else if (state.isPointerDown && $e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) triggerInteractOutside(e);
        state.isPointerDown = false;
      };
      let onTouchEnd = e => {
        state.ignoreEmulatedMouseEvents = true;
        if (state.isPointerDown && $e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) triggerInteractOutside(e);
        state.isPointerDown = false;
      };
      documentObject.addEventListener('mousedown', onPointerDown, true);
      documentObject.addEventListener('mouseup', onMouseUp, true);
      documentObject.addEventListener('touchstart', onPointerDown, true);
      documentObject.addEventListener('touchend', onTouchEnd, true);
      return () => {
        documentObject.removeEventListener('mousedown', onPointerDown, true);
        documentObject.removeEventListener('mouseup', onMouseUp, true);
        documentObject.removeEventListener('touchstart', onPointerDown, true);
        documentObject.removeEventListener('touchend', onTouchEnd, true);
      };
    }
  }, [ref, isDisabled, onPointerDown, triggerInteractOutside]);
}
function $e0b6e0b68ec7f50f$var$isValidEvent(event, ref) {
  if (event.button > 0) return false;
  if (event.target) {
    // if the event target is no longer in the document, ignore
    const ownerDocument = event.target.ownerDocument;
    if (!ownerDocument || !ownerDocument.documentElement.contains(event.target)) return false;
    // If the target is within a top layer element (e.g. toasts), ignore.
    if (event.target.closest('[data-react-aria-top-layer]')) return false;
  }
  return ref.current && !ref.current.contains(event.target);
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $6a99195332edec8b$export$80f3e147d781571c(element) {
  // If the user is interacting with a virtual cursor, e.g. screen reader, then
  // wait until after any animated transitions that are currently occurring on
  // the page before shifting focus. This avoids issues with VoiceOver on iOS
  // causing the page to scroll when moving focus if the element is transitioning
  // from off the screen.
  const ownerDocument = ($431fbd86ca7dc216$export$b204af158042fbac)(element);
  if (($507fabe10e71c6fb$export$630ff653c5ada6a9)() === 'virtual') {
    let lastFocusedElement = ownerDocument.activeElement;
    ($bbed8b41f857bcc0$export$24490316f764c430)(() => {
      // If focus did not move and the element is still in the document, focus it.
      if (ownerDocument.activeElement === lastFocusedElement && element.isConnected) ($7215afc6de606d6b$export$de79e2c695e052f3)(element);
    });
  } else ($7215afc6de606d6b$export$de79e2c695e052f3)(element);
}

/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
function $645f2e67b85a24c9$var$isStyleVisible(element) {
  const windowObject = ($431fbd86ca7dc216$export$f21a1ffae260145a)(element);
  if (!(element instanceof windowObject.HTMLElement) && !(element instanceof windowObject.SVGElement)) return false;
  let {
    display: display,
    visibility: visibility
  } = element.style;
  let isVisible = display !== 'none' && visibility !== 'hidden' && visibility !== 'collapse';
  if (isVisible) {
    const {
      getComputedStyle: getComputedStyle
    } = element.ownerDocument.defaultView;
    let {
      display: computedDisplay,
      visibility: computedVisibility
    } = getComputedStyle(element);
    isVisible = computedDisplay !== 'none' && computedVisibility !== 'hidden' && computedVisibility !== 'collapse';
  }
  return isVisible;
}
function $645f2e67b85a24c9$var$isAttributeVisible(element, childElement) {
  return !element.hasAttribute('hidden') &&
  // Ignore HiddenSelect when tree walking.
  !element.hasAttribute('data-react-aria-prevent-focus') && (element.nodeName === 'DETAILS' && childElement && childElement.nodeName !== 'SUMMARY' ? element.hasAttribute('open') : true);
}
function $645f2e67b85a24c9$export$e989c0fffaa6b27a(element, childElement) {
  return element.nodeName !== '#comment' && $645f2e67b85a24c9$var$isStyleVisible(element) && $645f2e67b85a24c9$var$isAttributeVisible(element, childElement) && (!element.parentElement || $645f2e67b85a24c9$export$e989c0fffaa6b27a(element.parentElement, element));
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

const $9bf71ea28793e738$var$FocusContext = /*#__PURE__*/(React__default).createContext(null);
let $9bf71ea28793e738$var$activeScope = null;
function $9bf71ea28793e738$export$20e40289641fbbb6(props) {
  let {
    children: children,
    contain: contain,
    restoreFocus: restoreFocus,
    autoFocus: autoFocus
  } = props;
  let startRef = (useRef)(null);
  let endRef = (useRef)(null);
  let scopeRef = (useRef)([]);
  let {
    parentNode: parentNode
  } = (useContext)($9bf71ea28793e738$var$FocusContext) || {};
  // Create a tree node here so we can add children to it even before it is added to the tree.
  let node = (useMemo)(() => new $9bf71ea28793e738$var$TreeNode({
    scopeRef: scopeRef
  }), [scopeRef]);
  ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(() => {
    // If a new scope mounts outside the active scope, (e.g. DialogContainer launched from a menu),
    // use the active scope as the parent instead of the parent from context. Layout effects run bottom
    // up, so if the parent is not yet added to the tree, don't do this. Only the outer-most FocusScope
    // that is being added should get the activeScope as its parent.
    let parent = parentNode || $9bf71ea28793e738$export$d06fae2ee68b101e.root;
    if ($9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(parent.scopeRef) && $9bf71ea28793e738$var$activeScope && !$9bf71ea28793e738$var$isAncestorScope($9bf71ea28793e738$var$activeScope, parent.scopeRef)) {
      let activeNode = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($9bf71ea28793e738$var$activeScope);
      if (activeNode) parent = activeNode;
    }
    // Add the node to the parent, and to the tree.
    parent.addChild(node);
    $9bf71ea28793e738$export$d06fae2ee68b101e.addNode(node);
  }, [node, parentNode]);
  ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(() => {
    let node = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);
    if (node) node.contain = !!contain;
  }, [contain]);
  ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(() => {
    var _startRef_current;
    // Find all rendered nodes between the sentinels and add them to the scope.
    let node = (_startRef_current = startRef.current) === null || _startRef_current === void 0 ? void 0 : _startRef_current.nextSibling;
    let nodes = [];
    while (node && node !== endRef.current) {
      nodes.push(node);
      node = node.nextSibling;
    }
    scopeRef.current = nodes;
  }, [children]);
  $9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restoreFocus, contain);
  $9bf71ea28793e738$var$useFocusContainment(scopeRef, contain);
  $9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain);
  $9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus);
  // This needs to be an effect so that activeScope is updated after the FocusScope tree is complete.
  // It cannot be a useLayoutEffect because the parent of this node hasn't been attached in the tree yet.
  (useEffect)(() => {
    const activeElement = ($431fbd86ca7dc216$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : undefined).activeElement;
    let scope = null;
    if ($9bf71ea28793e738$var$isElementInScope(activeElement, scopeRef.current)) {
      // We need to traverse the focusScope tree and find the bottom most scope that
      // contains the active element and set that as the activeScope.
      for (let node of $9bf71ea28793e738$export$d06fae2ee68b101e.traverse()) if (node.scopeRef && $9bf71ea28793e738$var$isElementInScope(activeElement, node.scopeRef.current)) scope = node;
      if (scope === $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef)) $9bf71ea28793e738$var$activeScope = scope.scopeRef;
    }
  }, [scopeRef]);
  // This layout effect cleanup is so that the tree node is removed synchronously with react before the RAF
  // in useRestoreFocus cleanup runs.
  ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(() => {
    return () => {
      var _focusScopeTree_getTreeNode_parent, _focusScopeTree_getTreeNode;
      var _focusScopeTree_getTreeNode_parent_scopeRef;
      // Scope may have been re-parented.
      let parentScope = (_focusScopeTree_getTreeNode_parent_scopeRef = (_focusScopeTree_getTreeNode = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : (_focusScopeTree_getTreeNode_parent = _focusScopeTree_getTreeNode.parent) === null || _focusScopeTree_getTreeNode_parent === void 0 ? void 0 : _focusScopeTree_getTreeNode_parent.scopeRef) !== null && _focusScopeTree_getTreeNode_parent_scopeRef !== void 0 ? _focusScopeTree_getTreeNode_parent_scopeRef : null;
      if ((scopeRef === $9bf71ea28793e738$var$activeScope || $9bf71ea28793e738$var$isAncestorScope(scopeRef, $9bf71ea28793e738$var$activeScope)) && (!parentScope || $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(parentScope))) $9bf71ea28793e738$var$activeScope = parentScope;
      $9bf71ea28793e738$export$d06fae2ee68b101e.removeTreeNode(scopeRef);
    };
  }, [scopeRef]);
  let focusManager = (useMemo)(() => $9bf71ea28793e738$var$createFocusManagerForScope(scopeRef), []);
  let value = (useMemo)(() => ({
    focusManager: focusManager,
    parentNode: node
  }), [node, focusManager]);
  return /*#__PURE__*/(React__default).createElement($9bf71ea28793e738$var$FocusContext.Provider, {
    value: value
  }, /*#__PURE__*/(React__default).createElement("span", {
    "data-focus-scope-start": true,
    hidden: true,
    ref: startRef
  }), children, /*#__PURE__*/(React__default).createElement("span", {
    "data-focus-scope-end": true,
    hidden: true,
    ref: endRef
  }));
}
function $9bf71ea28793e738$var$createFocusManagerForScope(scopeRef) {
  return {
    focusNext(opts = {}) {
      let scope = scopeRef.current;
      let {
        from: from,
        tabbable: tabbable,
        wrap: wrap,
        accept: accept
      } = opts;
      let node = from || ($431fbd86ca7dc216$export$b204af158042fbac)(scope[0]).activeElement;
      let sentinel = scope[0].previousElementSibling;
      let scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope);
      let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable: tabbable,
        accept: accept
      }, scope);
      walker.currentNode = $9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
      let nextNode = walker.nextNode();
      if (!nextNode && wrap) {
        walker.currentNode = sentinel;
        nextNode = walker.nextNode();
      }
      if (nextNode) $9bf71ea28793e738$var$focusElement(nextNode, true);
      return nextNode;
    },
    focusPrevious(opts = {}) {
      let scope = scopeRef.current;
      let {
        from: from,
        tabbable: tabbable,
        wrap: wrap,
        accept: accept
      } = opts;
      let node = from || ($431fbd86ca7dc216$export$b204af158042fbac)(scope[0]).activeElement;
      let sentinel = scope[scope.length - 1].nextElementSibling;
      let scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope);
      let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable: tabbable,
        accept: accept
      }, scope);
      walker.currentNode = $9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
      let previousNode = walker.previousNode();
      if (!previousNode && wrap) {
        walker.currentNode = sentinel;
        previousNode = walker.previousNode();
      }
      if (previousNode) $9bf71ea28793e738$var$focusElement(previousNode, true);
      return previousNode;
    },
    focusFirst(opts = {}) {
      let scope = scopeRef.current;
      let {
        tabbable: tabbable,
        accept: accept
      } = opts;
      let scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope);
      let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable: tabbable,
        accept: accept
      }, scope);
      walker.currentNode = scope[0].previousElementSibling;
      let nextNode = walker.nextNode();
      if (nextNode) $9bf71ea28793e738$var$focusElement(nextNode, true);
      return nextNode;
    },
    focusLast(opts = {}) {
      let scope = scopeRef.current;
      let {
        tabbable: tabbable,
        accept: accept
      } = opts;
      let scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope);
      let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable: tabbable,
        accept: accept
      }, scope);
      walker.currentNode = scope[scope.length - 1].nextElementSibling;
      let previousNode = walker.previousNode();
      if (previousNode) $9bf71ea28793e738$var$focusElement(previousNode, true);
      return previousNode;
    }
  };
}
const $9bf71ea28793e738$var$focusableElements = ['input:not([disabled]):not([type=hidden])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'a[href]', 'area[href]', 'summary', 'iframe', 'object', 'embed', 'audio[controls]', 'video[controls]', '[contenteditable]'];
const $9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR = $9bf71ea28793e738$var$focusableElements.join(':not([hidden]),') + ',[tabindex]:not([disabled]):not([hidden])';
$9bf71ea28793e738$var$focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const $9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR = $9bf71ea28793e738$var$focusableElements.join(':not([hidden]):not([tabindex="-1"]),');
function $9bf71ea28793e738$var$getScopeRoot(scope) {
  return scope[0].parentElement;
}
function $9bf71ea28793e738$var$shouldContainFocus(scopeRef) {
  let scope = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($9bf71ea28793e738$var$activeScope);
  while (scope && scope.scopeRef !== scopeRef) {
    if (scope.contain) return false;
    scope = scope.parent;
  }
  return true;
}
function $9bf71ea28793e738$var$useFocusContainment(scopeRef, contain) {
  let focusedNode = (useRef)();
  let raf = (useRef)();
  ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(() => {
    let scope = scopeRef.current;
    if (!contain) {
      // if contain was changed, then we should cancel any ongoing waits to pull focus back into containment
      if (raf.current) {
        cancelAnimationFrame(raf.current);
        raf.current = undefined;
      }
      return;
    }
    const ownerDocument = ($431fbd86ca7dc216$export$b204af158042fbac)(scope ? scope[0] : undefined);
    // Handle the Tab key to contain focus within the scope
    let onKeyDown = e => {
      if (e.key !== 'Tab' || e.altKey || e.ctrlKey || e.metaKey || !$9bf71ea28793e738$var$shouldContainFocus(scopeRef) || e.isComposing) return;
      let focusedElement = ownerDocument.activeElement;
      let scope = scopeRef.current;
      if (!scope || !$9bf71ea28793e738$var$isElementInScope(focusedElement, scope)) return;
      let scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope);
      let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable: true
      }, scope);
      if (!focusedElement) return;
      walker.currentNode = focusedElement;
      let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
      if (!nextElement) {
        walker.currentNode = e.shiftKey ? scope[scope.length - 1].nextElementSibling : scope[0].previousElementSibling;
        nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
      }
      e.preventDefault();
      if (nextElement) $9bf71ea28793e738$var$focusElement(nextElement, true);
    };
    let onFocus = e => {
      // If focusing an element in a child scope of the currently active scope, the child becomes active.
      // Moving out of the active scope to an ancestor is not allowed.
      if ((!$9bf71ea28793e738$var$activeScope || $9bf71ea28793e738$var$isAncestorScope($9bf71ea28793e738$var$activeScope, scopeRef)) && $9bf71ea28793e738$var$isElementInScope(e.target, scopeRef.current)) {
        $9bf71ea28793e738$var$activeScope = scopeRef;
        focusedNode.current = e.target;
      } else if ($9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$9bf71ea28793e738$var$isElementInChildScope(e.target, scopeRef)) {
        // If a focus event occurs outside the active scope (e.g. user tabs from browser location bar),
        // restore focus to the previously focused node or the first tabbable element in the active scope.
        if (focusedNode.current) focusedNode.current.focus();else if ($9bf71ea28793e738$var$activeScope && $9bf71ea28793e738$var$activeScope.current) $9bf71ea28793e738$var$focusFirstInScope($9bf71ea28793e738$var$activeScope.current);
      } else if ($9bf71ea28793e738$var$shouldContainFocus(scopeRef)) focusedNode.current = e.target;
    };
    let onBlur = e => {
      // Firefox doesn't shift focus back to the Dialog properly without this
      if (raf.current) cancelAnimationFrame(raf.current);
      raf.current = requestAnimationFrame(() => {
        // Use document.activeElement instead of e.relatedTarget so we can tell if user clicked into iframe
        if (ownerDocument.activeElement && $9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$9bf71ea28793e738$var$isElementInChildScope(ownerDocument.activeElement, scopeRef)) {
          $9bf71ea28793e738$var$activeScope = scopeRef;
          if (ownerDocument.body.contains(e.target)) {
            var _focusedNode_current;
            focusedNode.current = e.target;
            (_focusedNode_current = focusedNode.current) === null || _focusedNode_current === void 0 ? void 0 : _focusedNode_current.focus();
          } else if ($9bf71ea28793e738$var$activeScope.current) $9bf71ea28793e738$var$focusFirstInScope($9bf71ea28793e738$var$activeScope.current);
        }
      });
    };
    ownerDocument.addEventListener('keydown', onKeyDown, false);
    ownerDocument.addEventListener('focusin', onFocus, false);
    scope === null || scope === void 0 ? void 0 : scope.forEach(element => element.addEventListener('focusin', onFocus, false));
    scope === null || scope === void 0 ? void 0 : scope.forEach(element => element.addEventListener('focusout', onBlur, false));
    return () => {
      ownerDocument.removeEventListener('keydown', onKeyDown, false);
      ownerDocument.removeEventListener('focusin', onFocus, false);
      scope === null || scope === void 0 ? void 0 : scope.forEach(element => element.removeEventListener('focusin', onFocus, false));
      scope === null || scope === void 0 ? void 0 : scope.forEach(element => element.removeEventListener('focusout', onBlur, false));
    };
  }, [scopeRef, contain]);
  // This is a useLayoutEffect so it is guaranteed to run before our async synthetic blur
  // eslint-disable-next-line arrow-body-style
  ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(() => {
    return () => {
      if (raf.current) cancelAnimationFrame(raf.current);
    };
  }, [raf]);
}
function $9bf71ea28793e738$var$isElementInAnyScope(element) {
  return $9bf71ea28793e738$var$isElementInChildScope(element);
}
function $9bf71ea28793e738$var$isElementInScope(element, scope) {
  if (!element) return false;
  if (!scope) return false;
  return scope.some(node => node.contains(element));
}
function $9bf71ea28793e738$var$isElementInChildScope(element, scope = null) {
  // If the element is within a top layer element (e.g. toasts), always allow moving focus there.
  if (element instanceof Element && element.closest('[data-react-aria-top-layer]')) return true;
  // node.contains in isElementInScope covers child scopes that are also DOM children,
  // but does not cover child scopes in portals.
  for (let {
    scopeRef: s
  } of $9bf71ea28793e738$export$d06fae2ee68b101e.traverse($9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scope))) {
    if (s && $9bf71ea28793e738$var$isElementInScope(element, s.current)) return true;
  }
  return false;
}
function $9bf71ea28793e738$export$1258395f99bf9cbf(element) {
  return $9bf71ea28793e738$var$isElementInChildScope(element, $9bf71ea28793e738$var$activeScope);
}
function $9bf71ea28793e738$var$isAncestorScope(ancestor, scope) {
  var _focusScopeTree_getTreeNode;
  let parent = (_focusScopeTree_getTreeNode = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scope)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : _focusScopeTree_getTreeNode.parent;
  while (parent) {
    if (parent.scopeRef === ancestor) return true;
    parent = parent.parent;
  }
  return false;
}
function $9bf71ea28793e738$var$focusElement(element, scroll = false) {
  if (element != null && !scroll) try {
    (0, $6a99195332edec8b$export$80f3e147d781571c)(element);
  } catch (err) {
    // ignore
  } else if (element != null) try {
    element.focus();
  } catch (err) {
    // ignore
  }
}
function $9bf71ea28793e738$var$focusFirstInScope(scope, tabbable = true) {
  let sentinel = scope[0].previousElementSibling;
  let scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope);
  let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
    tabbable: tabbable
  }, scope);
  walker.currentNode = sentinel;
  let nextNode = walker.nextNode();
  // If the scope does not contain a tabbable element, use the first focusable element.
  if (tabbable && !nextNode) {
    scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope);
    walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
      tabbable: false
    }, scope);
    walker.currentNode = sentinel;
    nextNode = walker.nextNode();
  }
  $9bf71ea28793e738$var$focusElement(nextNode);
}
function $9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus) {
  const autoFocusRef = (React__default).useRef(autoFocus);
  (useEffect)(() => {
    if (autoFocusRef.current) {
      $9bf71ea28793e738$var$activeScope = scopeRef;
      const ownerDocument = ($431fbd86ca7dc216$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : undefined);
      if (!$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, $9bf71ea28793e738$var$activeScope.current) && scopeRef.current) $9bf71ea28793e738$var$focusFirstInScope(scopeRef.current);
    }
    autoFocusRef.current = false;
  }, [scopeRef]);
}
function $9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restore, contain) {
  // tracks the active scope, in case restore and contain are both false.
  // if either are true, this is tracked in useRestoreFocus or useFocusContainment.
  ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(() => {
    if (restore || contain) return;
    let scope = scopeRef.current;
    const ownerDocument = ($431fbd86ca7dc216$export$b204af158042fbac)(scope ? scope[0] : undefined);
    let onFocus = e => {
      let target = e.target;
      if ($9bf71ea28793e738$var$isElementInScope(target, scopeRef.current)) $9bf71ea28793e738$var$activeScope = scopeRef;else if (!$9bf71ea28793e738$var$isElementInAnyScope(target)) $9bf71ea28793e738$var$activeScope = null;
    };
    ownerDocument.addEventListener('focusin', onFocus, false);
    scope === null || scope === void 0 ? void 0 : scope.forEach(element => element.addEventListener('focusin', onFocus, false));
    return () => {
      ownerDocument.removeEventListener('focusin', onFocus, false);
      scope === null || scope === void 0 ? void 0 : scope.forEach(element => element.removeEventListener('focusin', onFocus, false));
    };
  }, [scopeRef, restore, contain]);
}
function $9bf71ea28793e738$var$shouldRestoreFocus(scopeRef) {
  let scope = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($9bf71ea28793e738$var$activeScope);
  while (scope && scope.scopeRef !== scopeRef) {
    if (scope.nodeToRestore) return false;
    scope = scope.parent;
  }
  return (scope === null || scope === void 0 ? void 0 : scope.scopeRef) === scopeRef;
}
function $9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain) {
  // create a ref during render instead of useLayoutEffect so the active element is saved before a child with autoFocus=true mounts.
  // eslint-disable-next-line no-restricted-globals
  const nodeToRestoreRef = (useRef)(typeof document !== 'undefined' ? ($431fbd86ca7dc216$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : undefined).activeElement : null);
  // restoring scopes should all track if they are active regardless of contain, but contain already tracks it plus logic to contain the focus
  // restoring-non-containing scopes should only care if they become active so they can perform the restore
  ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(() => {
    let scope = scopeRef.current;
    const ownerDocument = ($431fbd86ca7dc216$export$b204af158042fbac)(scope ? scope[0] : undefined);
    if (!restoreFocus || contain) return;
    let onFocus = () => {
      // If focusing an element in a child scope of the currently active scope, the child becomes active.
      // Moving out of the active scope to an ancestor is not allowed.
      if ((!$9bf71ea28793e738$var$activeScope || $9bf71ea28793e738$var$isAncestorScope($9bf71ea28793e738$var$activeScope, scopeRef)) && $9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, scopeRef.current)) $9bf71ea28793e738$var$activeScope = scopeRef;
    };
    ownerDocument.addEventListener('focusin', onFocus, false);
    scope === null || scope === void 0 ? void 0 : scope.forEach(element => element.addEventListener('focusin', onFocus, false));
    return () => {
      ownerDocument.removeEventListener('focusin', onFocus, false);
      scope === null || scope === void 0 ? void 0 : scope.forEach(element => element.removeEventListener('focusin', onFocus, false));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scopeRef, contain]);
  ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(() => {
    const ownerDocument = ($431fbd86ca7dc216$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : undefined);
    if (!restoreFocus) return;
    // Handle the Tab key so that tabbing out of the scope goes to the next element
    // after the node that had focus when the scope mounted. This is important when
    // using portals for overlays, so that focus goes to the expected element when
    // tabbing out of the overlay.
    let onKeyDown = e => {
      if (e.key !== 'Tab' || e.altKey || e.ctrlKey || e.metaKey || !$9bf71ea28793e738$var$shouldContainFocus(scopeRef) || e.isComposing) return;
      let focusedElement = ownerDocument.activeElement;
      if (!$9bf71ea28793e738$var$isElementInScope(focusedElement, scopeRef.current)) return;
      let treeNode = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);
      if (!treeNode) return;
      let nodeToRestore = treeNode.nodeToRestore;
      // Create a DOM tree walker that matches all tabbable elements
      let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(ownerDocument.body, {
        tabbable: true
      });
      // Find the next tabbable element after the currently focused element
      walker.currentNode = focusedElement;
      let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
      if (!nodeToRestore || !ownerDocument.body.contains(nodeToRestore) || nodeToRestore === ownerDocument.body) {
        nodeToRestore = undefined;
        treeNode.nodeToRestore = undefined;
      }
      // If there is no next element, or it is outside the current scope, move focus to the
      // next element after the node to restore to instead.
      if ((!nextElement || !$9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current)) && nodeToRestore) {
        walker.currentNode = nodeToRestore;
        // Skip over elements within the scope, in case the scope immediately follows the node to restore.
        do nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode(); while ($9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current));
        e.preventDefault();
        e.stopPropagation();
        if (nextElement) $9bf71ea28793e738$var$focusElement(nextElement, true);else
          // If there is no next element and the nodeToRestore isn't within a FocusScope (i.e. we are leaving the top level focus scope)
          // then move focus to the body.
          // Otherwise restore focus to the nodeToRestore (e.g menu within a popover -> tabbing to close the menu should move focus to menu trigger)
          if (!$9bf71ea28793e738$var$isElementInAnyScope(nodeToRestore)) focusedElement.blur();else $9bf71ea28793e738$var$focusElement(nodeToRestore, true);
      }
    };
    if (!contain) ownerDocument.addEventListener('keydown', onKeyDown, true);
    return () => {
      if (!contain) ownerDocument.removeEventListener('keydown', onKeyDown, true);
    };
  }, [scopeRef, restoreFocus, contain]);
  // useLayoutEffect instead of useEffect so the active element is saved synchronously instead of asynchronously.
  ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(() => {
    const ownerDocument = ($431fbd86ca7dc216$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : undefined);
    if (!restoreFocus) return;
    let treeNode = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);
    if (!treeNode) return;
    var _nodeToRestoreRef_current;
    treeNode.nodeToRestore = (_nodeToRestoreRef_current = nodeToRestoreRef.current) !== null && _nodeToRestoreRef_current !== void 0 ? _nodeToRestoreRef_current : undefined;
    return () => {
      let treeNode = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);
      if (!treeNode) return;
      let nodeToRestore = treeNode.nodeToRestore;
      // if we already lost focus to the body and this was the active scope, then we should attempt to restore
      if (restoreFocus && nodeToRestore && (
      // eslint-disable-next-line react-hooks/exhaustive-deps
      $9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, scopeRef.current) || ownerDocument.activeElement === ownerDocument.body && $9bf71ea28793e738$var$shouldRestoreFocus(scopeRef))) {
        // freeze the focusScopeTree so it persists after the raf, otherwise during unmount nodes are removed from it
        let clonedTree = $9bf71ea28793e738$export$d06fae2ee68b101e.clone();
        requestAnimationFrame(() => {
          // Only restore focus if we've lost focus to the body, the alternative is that focus has been purposefully moved elsewhere
          if (ownerDocument.activeElement === ownerDocument.body) {
            // look up the tree starting with our scope to find a nodeToRestore still in the DOM
            let treeNode = clonedTree.getTreeNode(scopeRef);
            while (treeNode) {
              if (treeNode.nodeToRestore && treeNode.nodeToRestore.isConnected) {
                $9bf71ea28793e738$var$focusElement(treeNode.nodeToRestore);
                return;
              }
              treeNode = treeNode.parent;
            }
            // If no nodeToRestore was found, focus the first element in the nearest
            // ancestor scope that is still in the tree.
            treeNode = clonedTree.getTreeNode(scopeRef);
            while (treeNode) {
              if (treeNode.scopeRef && treeNode.scopeRef.current && $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(treeNode.scopeRef)) {
                $9bf71ea28793e738$var$focusFirstInScope(treeNode.scopeRef.current, true);
                return;
              }
              treeNode = treeNode.parent;
            }
          }
        });
      }
    };
  }, [scopeRef, restoreFocus]);
}
function $9bf71ea28793e738$export$2d6ec8fc375ceafa(root, opts, scope) {
  let selector = (opts === null || opts === void 0 ? void 0 : opts.tabbable) ? $9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR : $9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR;
  let walker = ($431fbd86ca7dc216$export$b204af158042fbac)(root).createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
    acceptNode(node) {
      var _opts_from;
      // Skip nodes inside the starting node.
      if (opts === null || opts === void 0 ? void 0 : (_opts_from = opts.from) === null || _opts_from === void 0 ? void 0 : _opts_from.contains(node)) return NodeFilter.FILTER_REJECT;
      if (node.matches(selector) && ($645f2e67b85a24c9$export$e989c0fffaa6b27a)(node) && (!scope || $9bf71ea28793e738$var$isElementInScope(node, scope)) && (!(opts === null || opts === void 0 ? void 0 : opts.accept) || opts.accept(node))) return NodeFilter.FILTER_ACCEPT;
      return NodeFilter.FILTER_SKIP;
    }
  });
  if (opts === null || opts === void 0 ? void 0 : opts.from) walker.currentNode = opts.from;
  return walker;
}
class $9bf71ea28793e738$var$Tree {
  get size() {
    return this.fastMap.size;
  }
  getTreeNode(data) {
    return this.fastMap.get(data);
  }
  addTreeNode(scopeRef, parent, nodeToRestore) {
    let parentNode = this.fastMap.get(parent !== null && parent !== void 0 ? parent : null);
    if (!parentNode) return;
    let node = new $9bf71ea28793e738$var$TreeNode({
      scopeRef: scopeRef
    });
    parentNode.addChild(node);
    node.parent = parentNode;
    this.fastMap.set(scopeRef, node);
    if (nodeToRestore) node.nodeToRestore = nodeToRestore;
  }
  addNode(node) {
    this.fastMap.set(node.scopeRef, node);
  }
  removeTreeNode(scopeRef) {
    // never remove the root
    if (scopeRef === null) return;
    let node = this.fastMap.get(scopeRef);
    if (!node) return;
    let parentNode = node.parent;
    // when we remove a scope, check if any sibling scopes are trying to restore focus to something inside the scope we're removing
    // if we are, then replace the siblings restore with the restore from the scope we're removing
    for (let current of this.traverse()) if (current !== node && node.nodeToRestore && current.nodeToRestore && node.scopeRef && node.scopeRef.current && $9bf71ea28793e738$var$isElementInScope(current.nodeToRestore, node.scopeRef.current)) current.nodeToRestore = node.nodeToRestore;
    let children = node.children;
    if (parentNode) {
      parentNode.removeChild(node);
      if (children.size > 0) children.forEach(child => parentNode && parentNode.addChild(child));
    }
    this.fastMap.delete(node.scopeRef);
  }
  // Pre Order Depth First
  *traverse(node = this.root) {
    if (node.scopeRef != null) yield node;
    if (node.children.size > 0) for (let child of node.children) yield* this.traverse(child);
  }
  clone() {
    var _node_parent;
    let newTree = new $9bf71ea28793e738$var$Tree();
    var _node_parent_scopeRef;
    for (let node of this.traverse()) newTree.addTreeNode(node.scopeRef, (_node_parent_scopeRef = (_node_parent = node.parent) === null || _node_parent === void 0 ? void 0 : _node_parent.scopeRef) !== null && _node_parent_scopeRef !== void 0 ? _node_parent_scopeRef : null, node.nodeToRestore);
    return newTree;
  }
  constructor() {
    this.fastMap = new Map();
    this.root = new $9bf71ea28793e738$var$TreeNode({
      scopeRef: null
    });
    this.fastMap.set(null, this.root);
  }
}
class $9bf71ea28793e738$var$TreeNode {
  addChild(node) {
    this.children.add(node);
    node.parent = this;
  }
  removeChild(node) {
    this.children.delete(node);
    node.parent = undefined;
  }
  constructor(props) {
    this.children = new Set();
    this.contain = false;
    this.scopeRef = props.scopeRef;
  }
}
let $9bf71ea28793e738$export$d06fae2ee68b101e = new $9bf71ea28793e738$var$Tree();

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

const $a11501f3d1d39e6c$var$visibleOverlays = [];
function $a11501f3d1d39e6c$export$ea8f71083e90600f(props, ref) {
  let {
    onClose: onClose,
    shouldCloseOnBlur: shouldCloseOnBlur,
    isOpen: isOpen,
    isDismissable = false,
    isKeyboardDismissDisabled = false,
    shouldCloseOnInteractOutside: shouldCloseOnInteractOutside
  } = props;
  // Add the overlay ref to the stack of visible overlays on mount, and remove on unmount.
  (useEffect)(() => {
    if (isOpen) $a11501f3d1d39e6c$var$visibleOverlays.push(ref);
    return () => {
      let index = $a11501f3d1d39e6c$var$visibleOverlays.indexOf(ref);
      if (index >= 0) $a11501f3d1d39e6c$var$visibleOverlays.splice(index, 1);
    };
  }, [isOpen, ref]);
  // Only hide the overlay when it is the topmost visible overlay in the stack
  let onHide = () => {
    if ($a11501f3d1d39e6c$var$visibleOverlays[$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref && onClose) onClose();
  };
  let onInteractOutsideStart = e => {
    if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.target)) {
      if ($a11501f3d1d39e6c$var$visibleOverlays[$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref) {
        e.stopPropagation();
        e.preventDefault();
      }
    }
  };
  let onInteractOutside = e => {
    if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.target)) {
      if ($a11501f3d1d39e6c$var$visibleOverlays[$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref) {
        e.stopPropagation();
        e.preventDefault();
      }
      onHide();
    }
  };
  // Handle the escape key
  let onKeyDown = e => {
    if (e.key === 'Escape' && !isKeyboardDismissDisabled && !e.nativeEvent.isComposing) {
      e.stopPropagation();
      e.preventDefault();
      onHide();
    }
  };
  // Handle clicking outside the overlay to close it
  ($e0b6e0b68ec7f50f$export$872b660ac5a1ff98)({
    ref: ref,
    onInteractOutside: isDismissable && isOpen ? onInteractOutside : null,
    onInteractOutsideStart: onInteractOutsideStart
  });
  let {
    focusWithinProps: focusWithinProps
  } = ($9ab94262bd0047c7$export$420e68273165f4ec)({
    isDisabled: !shouldCloseOnBlur,
    onBlurWithin: e => {
      // Do not close if relatedTarget is null, which means focus is lost to the body.
      // That can happen when switching tabs, or due to a VoiceOver/Chrome bug with Control+Option+Arrow navigation.
      // Clicking on the body to close the overlay should already be handled by useInteractOutside.
      // https://github.com/adobe/react-spectrum/issues/4130
      // https://github.com/adobe/react-spectrum/issues/4922
      //
      // If focus is moving into a child focus scope (e.g. menu inside a dialog),
      // do not close the outer overlay. At this point, the active scope should
      // still be the outer overlay, since blur events run before focus.
      if (!e.relatedTarget || ($9bf71ea28793e738$export$1258395f99bf9cbf)(e.relatedTarget)) return;
      if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.relatedTarget)) onClose();
    }
  });
  let onPointerDownUnderlay = e => {
    // fixes a firefox issue that starts text selection https://bugzilla.mozilla.org/show_bug.cgi?id=1675846
    if (e.target === e.currentTarget) e.preventDefault();
  };
  return {
    overlayProps: {
      onKeyDown: onKeyDown,
      ...focusWithinProps
    },
    underlayProps: {
      onPointerDown: onPointerDownUnderlay
    }
  };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
// @ts-ignore
const $49c51c25361d4cd2$var$visualViewport = typeof document !== 'undefined' && window.visualViewport;
// HTML input types that do not cause the software keyboard to appear.
const $49c51c25361d4cd2$var$nonTextInputTypes = new Set(['checkbox', 'radio', 'range', 'color', 'file', 'image', 'button', 'submit', 'reset']);
// The number of active usePreventScroll calls. Used to determine whether to revert back to the original page style/scroll position
let $49c51c25361d4cd2$var$preventScrollCount = 0;
let $49c51c25361d4cd2$var$restore;
function $49c51c25361d4cd2$export$ee0f7cc6afcd1c18(options = {}) {
  let {
    isDisabled: isDisabled
  } = options;
  ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(() => {
    if (isDisabled) return;
    $49c51c25361d4cd2$var$preventScrollCount++;
    if ($49c51c25361d4cd2$var$preventScrollCount === 1) {
      if (($c87311424ea30a05$export$fedb369cb70207f1)()) $49c51c25361d4cd2$var$restore = $49c51c25361d4cd2$var$preventScrollMobileSafari();else $49c51c25361d4cd2$var$restore = $49c51c25361d4cd2$var$preventScrollStandard();
    }
    return () => {
      $49c51c25361d4cd2$var$preventScrollCount--;
      if ($49c51c25361d4cd2$var$preventScrollCount === 0) $49c51c25361d4cd2$var$restore();
    };
  }, [isDisabled]);
}
// For most browsers, all we need to do is set `overflow: hidden` on the root element, and
// add some padding to prevent the page from shifting when the scrollbar is hidden.
function $49c51c25361d4cd2$var$preventScrollStandard() {
  return ($ff5963eb1fccf552$export$e08e3b67e392101e)($49c51c25361d4cd2$var$setStyle(document.documentElement, 'paddingRight', `${window.innerWidth - document.documentElement.clientWidth}px`), $49c51c25361d4cd2$var$setStyle(document.documentElement, 'overflow', 'hidden'));
}
// Mobile Safari is a whole different beast. Even with overflow: hidden,
// it still scrolls the page in many situations:
//
// 1. When the bottom toolbar and address bar are collapsed, page scrolling is always allowed.
// 2. When the keyboard is visible, the viewport does not resize. Instead, the keyboard covers part of
//    it, so it becomes scrollable.
// 3. When tapping on an input, the page always scrolls so that the input is centered in the visual viewport.
//    This may cause even fixed position elements to scroll off the screen.
// 4. When using the next/previous buttons in the keyboard to navigate between inputs, the whole page always
//    scrolls, even if the input is inside a nested scrollable element that could be scrolled instead.
//
// In order to work around these cases, and prevent scrolling without jankiness, we do a few things:
//
// 1. Prevent default on `touchmove` events that are not in a scrollable element. This prevents touch scrolling
//    on the window.
// 2. Set `overscroll-behavior: contain` on nested scrollable regions so they do not scroll the page when at
//    the top or bottom. Work around a bug where this does not work when the element does not actually overflow
//    by preventing default in a `touchmove` event.
// 3. Prevent default on `touchend` events on input elements and handle focusing the element ourselves.
// 4. When focusing an input, apply a transform to trick Safari into thinking the input is at the top
//    of the page, which prevents it from scrolling the page. After the input is focused, scroll the element
//    into view ourselves, without scrolling the whole page.
// 5. Offset the body by the scroll position using a negative margin and scroll to the top. This should appear the
//    same visually, but makes the actual scroll position always zero. This is required to make all of the
//    above work or Safari will still try to scroll the page when focusing an input.
// 6. As a last resort, handle window scroll events, and scroll back to the top. This can happen when attempting
//    to navigate to an input with the next/previous buttons that's outside a modal.
function $49c51c25361d4cd2$var$preventScrollMobileSafari() {
  let scrollable;
  let restoreScrollableStyles;
  let onTouchStart = e => {
    // Store the nearest scrollable parent element from the element that the user touched.
    scrollable = ($62d8ded9296f3872$export$cfa2225e87938781)(e.target, true);
    if (scrollable === document.documentElement && scrollable === document.body) return;
    // Prevent scrolling up when at the top and scrolling down when at the bottom
    // of a nested scrollable area, otherwise mobile Safari will start scrolling
    // the window instead.
    if (scrollable instanceof HTMLElement && window.getComputedStyle(scrollable).overscrollBehavior === 'auto') restoreScrollableStyles = $49c51c25361d4cd2$var$setStyle(scrollable, 'overscrollBehavior', 'contain');
  };
  let onTouchMove = e => {
    // Prevent scrolling the window.
    if (!scrollable || scrollable === document.documentElement || scrollable === document.body) {
      e.preventDefault();
      return;
    }
    // overscroll-behavior should prevent scroll chaining, but currently does not
    // if the element doesn't actually overflow. https://bugs.webkit.org/show_bug.cgi?id=243452
    // This checks that both the width and height do not overflow, otherwise we might
    // block horizontal scrolling too. In that case, adding `touch-action: pan-x` to
    // the element will prevent vertical page scrolling. We can't add that automatically
    // because it must be set before the touchstart event.
    if (scrollable.scrollHeight === scrollable.clientHeight && scrollable.scrollWidth === scrollable.clientWidth) e.preventDefault();
  };
  let onTouchEnd = e => {
    let target = e.target;
    // Apply this change if we're not already focused on the target element
    if ($49c51c25361d4cd2$var$willOpenKeyboard(target) && target !== document.activeElement) {
      e.preventDefault();
      setupStyles();
      // Apply a transform to trick Safari into thinking the input is at the top of the page
      // so it doesn't try to scroll it into view. When tapping on an input, this needs to
      // be done before the "focus" event, so we have to focus the element ourselves.
      target.style.transform = 'translateY(-2000px)';
      target.focus();
      requestAnimationFrame(() => {
        target.style.transform = '';
      });
    }
    if (restoreScrollableStyles) restoreScrollableStyles();
  };
  let onFocus = e => {
    let target = e.target;
    if ($49c51c25361d4cd2$var$willOpenKeyboard(target)) {
      setupStyles();
      // Transform also needs to be applied in the focus event in cases where focus moves
      // other than tapping on an input directly, e.g. the next/previous buttons in the
      // software keyboard. In these cases, it seems applying the transform in the focus event
      // is good enough, whereas when tapping an input, it must be done before the focus event. 🤷‍♂️
      target.style.transform = 'translateY(-2000px)';
      requestAnimationFrame(() => {
        target.style.transform = '';
        // This will have prevented the browser from scrolling the focused element into view,
        // so we need to do this ourselves in a way that doesn't cause the whole page to scroll.
        if ($49c51c25361d4cd2$var$visualViewport) {
          if ($49c51c25361d4cd2$var$visualViewport.height < window.innerHeight)
            // If the keyboard is already visible, do this after one additional frame
            // to wait for the transform to be removed.
            requestAnimationFrame(() => {
              $49c51c25361d4cd2$var$scrollIntoView(target);
            });else
            // Otherwise, wait for the visual viewport to resize before scrolling so we can
            // measure the correct position to scroll to.
            $49c51c25361d4cd2$var$visualViewport.addEventListener('resize', () => $49c51c25361d4cd2$var$scrollIntoView(target), {
              once: true
            });
        }
      });
    }
  };
  let restoreStyles = null;
  let setupStyles = () => {
    if (restoreStyles) return;
    let onWindowScroll = () => {
      // Last resort. If the window scrolled, scroll it back to the top.
      // It should always be at the top because the body will have a negative margin (see below).
      window.scrollTo(0, 0);
    };
    // Record the original scroll position so we can restore it.
    // Then apply a negative margin to the body to offset it by the scroll position. This will
    // enable us to scroll the window to the top, which is required for the rest of this to work.
    let scrollX = window.pageXOffset;
    let scrollY = window.pageYOffset;
    restoreStyles = ($ff5963eb1fccf552$export$e08e3b67e392101e)($49c51c25361d4cd2$var$addEvent(window, 'scroll', onWindowScroll), $49c51c25361d4cd2$var$setStyle(document.documentElement, 'paddingRight', `${window.innerWidth - document.documentElement.clientWidth}px`), $49c51c25361d4cd2$var$setStyle(document.documentElement, 'overflow', 'hidden'), $49c51c25361d4cd2$var$setStyle(document.body, 'marginTop', `-${scrollY}px`), () => {
      window.scrollTo(scrollX, scrollY);
    });
    // Scroll to the top. The negative margin on the body will make this appear the same.
    window.scrollTo(0, 0);
  };
  let removeEvents = ($ff5963eb1fccf552$export$e08e3b67e392101e)($49c51c25361d4cd2$var$addEvent(document, 'touchstart', onTouchStart, {
    passive: false,
    capture: true
  }), $49c51c25361d4cd2$var$addEvent(document, 'touchmove', onTouchMove, {
    passive: false,
    capture: true
  }), $49c51c25361d4cd2$var$addEvent(document, 'touchend', onTouchEnd, {
    passive: false,
    capture: true
  }), $49c51c25361d4cd2$var$addEvent(document, 'focus', onFocus, true));
  return () => {
    // Restore styles and scroll the page back to where it was.
    restoreScrollableStyles === null || restoreScrollableStyles === void 0 ? void 0 : restoreScrollableStyles();
    restoreStyles === null || restoreStyles === void 0 ? void 0 : restoreStyles();
    removeEvents();
  };
}
// Sets a CSS property on an element, and returns a function to revert it to the previous value.
function $49c51c25361d4cd2$var$setStyle(element, style, value) {
  let cur = element.style[style];
  element.style[style] = value;
  return () => {
    element.style[style] = cur;
  };
}
// Adds an event listener to an element, and returns a function to remove it.
function $49c51c25361d4cd2$var$addEvent(target, event, handler, options) {
  target.addEventListener(event, handler, options);
  return () => {
    target.removeEventListener(event, handler, options);
  };
}
function $49c51c25361d4cd2$var$scrollIntoView(target) {
  let root = document.scrollingElement || document.documentElement;
  while (target && target !== root) {
    // Find the parent scrollable element and adjust the scroll position if the target is not already in view.
    let scrollable = ($62d8ded9296f3872$export$cfa2225e87938781)(target);
    if (scrollable !== document.documentElement && scrollable !== document.body && scrollable !== target) {
      let scrollableTop = scrollable.getBoundingClientRect().top;
      let targetTop = target.getBoundingClientRect().top;
      if (targetTop > scrollableTop + target.clientHeight) scrollable.scrollTop += targetTop - scrollableTop;
    }
    target = scrollable.parentElement;
  }
}
function $49c51c25361d4cd2$var$willOpenKeyboard(target) {
  return target instanceof HTMLInputElement && !$49c51c25361d4cd2$var$nonTextInputTypes.has(target.type) || target instanceof HTMLTextAreaElement || target instanceof HTMLElement && target.isContentEditable;
}

var $773d5888b972f1cf$exports = {};
$773d5888b972f1cf$exports = {
  "dismiss": `\u{62A}\u{62C}\u{627}\u{647}\u{644}`
};

var $d11f19852b941573$exports = {};
$d11f19852b941573$exports = {
  "dismiss": `\u{41E}\u{442}\u{445}\u{432}\u{44A}\u{440}\u{43B}\u{44F}\u{43D}\u{435}`
};

var $b983974c2ee1efb3$exports = {};
$b983974c2ee1efb3$exports = {
  "dismiss": `Odstranit`
};

var $5809cc9d4e92de73$exports = {};
$5809cc9d4e92de73$exports = {
  "dismiss": `Luk`
};

var $c68c2e4fc74398d1$exports = {};
$c68c2e4fc74398d1$exports = {
  "dismiss": `Schlie\xdfen`
};

var $0898b4c153db2b77$exports = {};
$0898b4c153db2b77$exports = {
  "dismiss": `\u{391}\u{3C0}\u{3CC}\u{3C1}\u{3C1}\u{3B9}\u{3C8}\u{3B7}`
};

var $6d74810286a15183$exports = {};
$6d74810286a15183$exports = {
  "dismiss": `Dismiss`
};

var $309d73dc65f78055$exports = {};
$309d73dc65f78055$exports = {
  "dismiss": `Descartar`
};

var $44ad94f7205cf593$exports = {};
$44ad94f7205cf593$exports = {
  "dismiss": `L\xf5peta`
};

var $7c28f5687f0779a9$exports = {};
$7c28f5687f0779a9$exports = {
  "dismiss": `Hylk\xe4\xe4`
};

var $e6d75df4b68bd73a$exports = {};
$e6d75df4b68bd73a$exports = {
  "dismiss": `Rejeter`
};

var $87505c9dab186d0f$exports = {};
$87505c9dab186d0f$exports = {
  "dismiss": `\u{5D4}\u{5EA}\u{5E2}\u{5DC}\u{5DD}`
};

var $553439c3ffb3e492$exports = {};
$553439c3ffb3e492$exports = {
  "dismiss": `Odbaci`
};

var $74cf411061b983a2$exports = {};
$74cf411061b983a2$exports = {
  "dismiss": `Elutas\xedt\xe1s`
};

var $e933f298574dc435$exports = {};
$e933f298574dc435$exports = {
  "dismiss": `Ignora`
};

var $ac91fc9fe02f71f6$exports = {};
$ac91fc9fe02f71f6$exports = {
  "dismiss": `\u{9589}\u{3058}\u{308B}`
};

var $52b96f86422025af$exports = {};
$52b96f86422025af$exports = {
  "dismiss": `\u{BB34}\u{C2DC}`
};

var $c0d724c3e51dafa6$exports = {};
$c0d724c3e51dafa6$exports = {
  "dismiss": `Atmesti`
};

var $c92899672a3fe72e$exports = {};
$c92899672a3fe72e$exports = {
  "dismiss": `Ner\u{101}d\u{12B}t`
};

var $9f576b39d8e7a9d6$exports = {};
$9f576b39d8e7a9d6$exports = {
  "dismiss": `Lukk`
};

var $9d025808aeec81a7$exports = {};
$9d025808aeec81a7$exports = {
  "dismiss": `Negeren`
};

var $fce709921e2c0fa6$exports = {};
$fce709921e2c0fa6$exports = {
  "dismiss": `Zignoruj`
};

var $2599cf0c4ab37f59$exports = {};
$2599cf0c4ab37f59$exports = {
  "dismiss": `Descartar`
};

var $3c220ae7ef8a35fd$exports = {};
$3c220ae7ef8a35fd$exports = {
  "dismiss": `Dispensar`
};

var $93562b5094072f54$exports = {};
$93562b5094072f54$exports = {
  "dismiss": `Revocare`
};

var $cd9e2abd0d06c7b4$exports = {};
$cd9e2abd0d06c7b4$exports = {
  "dismiss": `\u{41F}\u{440}\u{43E}\u{43F}\u{443}\u{441}\u{442}\u{438}\u{442}\u{44C}`
};

var $45375701f409adf1$exports = {};
$45375701f409adf1$exports = {
  "dismiss": `Zru\u{161}i\u{165}`
};

var $27fab53a576de9dd$exports = {};
$27fab53a576de9dd$exports = {
  "dismiss": `Opusti`
};

var $4438748d9952e7c7$exports = {};
$4438748d9952e7c7$exports = {
  "dismiss": `Odbaci`
};

var $0936d7347ef4da4c$exports = {};
$0936d7347ef4da4c$exports = {
  "dismiss": `Avvisa`
};

var $29700c92185d38f8$exports = {};
$29700c92185d38f8$exports = {
  "dismiss": `Kapat`
};

var $662ccaf2be4c25b3$exports = {};
$662ccaf2be4c25b3$exports = {
  "dismiss": `\u{421}\u{43A}\u{430}\u{441}\u{443}\u{432}\u{430}\u{442}\u{438}`
};

var $d80a27deda7cdb3c$exports = {};
$d80a27deda7cdb3c$exports = {
  "dismiss": `\u{53D6}\u{6D88}`
};

var $2b2734393847c884$exports = {};
$2b2734393847c884$exports = {
  "dismiss": `\u{95DC}\u{9589}`
};

var $a2f21f5f14f60553$exports = {};
$a2f21f5f14f60553$exports = {
  "ar-AE": $773d5888b972f1cf$exports,
  "bg-BG": $d11f19852b941573$exports,
  "cs-CZ": $b983974c2ee1efb3$exports,
  "da-DK": $5809cc9d4e92de73$exports,
  "de-DE": $c68c2e4fc74398d1$exports,
  "el-GR": $0898b4c153db2b77$exports,
  "en-US": $6d74810286a15183$exports,
  "es-ES": $309d73dc65f78055$exports,
  "et-EE": $44ad94f7205cf593$exports,
  "fi-FI": $7c28f5687f0779a9$exports,
  "fr-FR": $e6d75df4b68bd73a$exports,
  "he-IL": $87505c9dab186d0f$exports,
  "hr-HR": $553439c3ffb3e492$exports,
  "hu-HU": $74cf411061b983a2$exports,
  "it-IT": $e933f298574dc435$exports,
  "ja-JP": $ac91fc9fe02f71f6$exports,
  "ko-KR": $52b96f86422025af$exports,
  "lt-LT": $c0d724c3e51dafa6$exports,
  "lv-LV": $c92899672a3fe72e$exports,
  "nb-NO": $9f576b39d8e7a9d6$exports,
  "nl-NL": $9d025808aeec81a7$exports,
  "pl-PL": $fce709921e2c0fa6$exports,
  "pt-BR": $2599cf0c4ab37f59$exports,
  "pt-PT": $3c220ae7ef8a35fd$exports,
  "ro-RO": $93562b5094072f54$exports,
  "ru-RU": $cd9e2abd0d06c7b4$exports,
  "sk-SK": $45375701f409adf1$exports,
  "sl-SI": $27fab53a576de9dd$exports,
  "sr-SP": $4438748d9952e7c7$exports,
  "sv-SE": $0936d7347ef4da4c$exports,
  "tr-TR": $29700c92185d38f8$exports,
  "uk-UA": $662ccaf2be4c25b3$exports,
  "zh-CN": $d80a27deda7cdb3c$exports,
  "zh-TW": $2b2734393847c884$exports
};

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

const $5c3e21d68f1c4674$var$styles = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  width: '1px',
  whiteSpace: 'nowrap'
};
function $5c3e21d68f1c4674$export$a966af930f325cab(props = {}) {
  let {
    style: style,
    isFocusable: isFocusable
  } = props;
  let [isFocused, setFocused] = (useState)(false);
  let {
    focusWithinProps: focusWithinProps
  } = ($9ab94262bd0047c7$export$420e68273165f4ec)({
    isDisabled: !isFocusable,
    onFocusWithinChange: val => setFocused(val)
  });
  // If focused, don't hide the element.
  let combinedStyles = (useMemo)(() => {
    if (isFocused) return style;else if (style) return {
      ...$5c3e21d68f1c4674$var$styles,
      ...style
    };else return $5c3e21d68f1c4674$var$styles;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFocused]);
  return {
    visuallyHiddenProps: {
      ...focusWithinProps,
      style: combinedStyles
    }
  };
}
function $5c3e21d68f1c4674$export$439d29a4e110a164(props) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  let {
    children: children,
    elementType: Element = 'div',
    isFocusable: isFocusable,
    style: style,
    ...otherProps
  } = props;
  let {
    visuallyHiddenProps: visuallyHiddenProps
  } = $5c3e21d68f1c4674$export$a966af930f325cab(props);
  return /*#__PURE__*/(React__default).createElement(Element, ($3ef42575df84b30b$export$9d1611c77c2fe928)(otherProps, visuallyHiddenProps), children);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $86ea4cb521eb2e37$export$2317d149ed6f78c4(props) {
  let {
    onDismiss: onDismiss,
    ...otherProps
  } = props;
  let stringFormatter = ($fca6afa0e843324b$export$f12b703ca79dfbb1)(($parcel$interopDefault($a2f21f5f14f60553$exports)), '@react-aria/overlays');
  let labels = ($313b98861ee5dd6c$export$d6875122194c7b44)(otherProps, stringFormatter.format('dismiss'));
  let onClick = () => {
    if (onDismiss) onDismiss();
  };
  return /*#__PURE__*/(React__default).createElement(($5c3e21d68f1c4674$export$439d29a4e110a164), null, /*#__PURE__*/(React__default).createElement("button", {
    ...labels,
    tabIndex: -1,
    onClick: onClick,
    style: {
      width: 1,
      height: 1
    }
  }));
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Keeps a ref count of all hidden elements. Added to when hiding an element, and
// subtracted from when showing it again. When it reaches zero, aria-hidden is removed.
let $5e3802645cc19319$var$refCountMap = new WeakMap();
let $5e3802645cc19319$var$observerStack = [];
function $5e3802645cc19319$export$1c3ebcada18427bf(targets, root = document.body) {
  let visibleNodes = new Set(targets);
  let hiddenNodes = new Set();
  let walk = root => {
    // Keep live announcer and top layer elements (e.g. toasts) visible.
    for (let element of root.querySelectorAll('[data-live-announcer], [data-react-aria-top-layer]')) visibleNodes.add(element);
    let acceptNode = node => {
      // Skip this node and its children if it is one of the target nodes, or a live announcer.
      // Also skip children of already hidden nodes, as aria-hidden is recursive. An exception is
      // made for elements with role="row" since VoiceOver on iOS has issues hiding elements with role="row".
      // For that case we want to hide the cells inside as well (https://bugs.webkit.org/show_bug.cgi?id=222623).
      if (visibleNodes.has(node) || hiddenNodes.has(node.parentElement) && node.parentElement.getAttribute('role') !== 'row') return NodeFilter.FILTER_REJECT;
      // Skip this node but continue to children if one of the targets is inside the node.
      for (let target of visibleNodes) {
        if (node.contains(target)) return NodeFilter.FILTER_SKIP;
      }
      return NodeFilter.FILTER_ACCEPT;
    };
    let walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
      acceptNode: acceptNode
    });
    // TreeWalker does not include the root.
    let acceptRoot = acceptNode(root);
    if (acceptRoot === NodeFilter.FILTER_ACCEPT) hide(root);
    if (acceptRoot !== NodeFilter.FILTER_REJECT) {
      let node = walker.nextNode();
      while (node != null) {
        hide(node);
        node = walker.nextNode();
      }
    }
  };
  let hide = node => {
    var _refCountMap_get;
    let refCount = (_refCountMap_get = $5e3802645cc19319$var$refCountMap.get(node)) !== null && _refCountMap_get !== void 0 ? _refCountMap_get : 0;
    // If already aria-hidden, and the ref count is zero, then this element
    // was already hidden and there's nothing for us to do.
    if (node.getAttribute('aria-hidden') === 'true' && refCount === 0) return;
    if (refCount === 0) node.setAttribute('aria-hidden', 'true');
    hiddenNodes.add(node);
    $5e3802645cc19319$var$refCountMap.set(node, refCount + 1);
  };
  // If there is already a MutationObserver listening from a previous call,
  // disconnect it so the new on takes over.
  if ($5e3802645cc19319$var$observerStack.length) $5e3802645cc19319$var$observerStack[$5e3802645cc19319$var$observerStack.length - 1].disconnect();
  walk(root);
  let observer = new MutationObserver(changes => {
    for (let change of changes) {
      if (change.type !== 'childList' || change.addedNodes.length === 0) continue;
      // If the parent element of the added nodes is not within one of the targets,
      // and not already inside a hidden node, hide all of the new children.
      if (![...visibleNodes, ...hiddenNodes].some(node => node.contains(change.target))) {
        for (let node of change.removedNodes) if (node instanceof Element) {
          visibleNodes.delete(node);
          hiddenNodes.delete(node);
        }
        for (let node of change.addedNodes) {
          if ((node instanceof HTMLElement || node instanceof SVGElement) && (node.dataset.liveAnnouncer === 'true' || node.dataset.reactAriaTopLayer === 'true')) visibleNodes.add(node);else if (node instanceof Element) walk(node);
        }
      }
    }
  });
  observer.observe(root, {
    childList: true,
    subtree: true
  });
  let observerWrapper = {
    observe() {
      observer.observe(root, {
        childList: true,
        subtree: true
      });
    },
    disconnect() {
      observer.disconnect();
    }
  };
  $5e3802645cc19319$var$observerStack.push(observerWrapper);
  return () => {
    observer.disconnect();
    for (let node of hiddenNodes) {
      let count = $5e3802645cc19319$var$refCountMap.get(node);
      if (count === 1) {
        node.removeAttribute('aria-hidden');
        $5e3802645cc19319$var$refCountMap.delete(node);
      } else $5e3802645cc19319$var$refCountMap.set(node, count - 1);
    }
    // Remove this observer from the stack, and start the previous one.
    if (observerWrapper === $5e3802645cc19319$var$observerStack[$5e3802645cc19319$var$observerStack.length - 1]) {
      $5e3802645cc19319$var$observerStack.pop();
      if ($5e3802645cc19319$var$observerStack.length) $5e3802645cc19319$var$observerStack[$5e3802645cc19319$var$observerStack.length - 1].observe();
    } else $5e3802645cc19319$var$observerStack.splice($5e3802645cc19319$var$observerStack.indexOf(observerWrapper), 1);
  };
}

/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $f2f8a6077418541e$export$542a6fd13ac93354(props, state) {
  let {
    triggerRef: triggerRef,
    popoverRef: popoverRef,
    isNonModal: isNonModal,
    isKeyboardDismissDisabled: isKeyboardDismissDisabled,
    shouldCloseOnInteractOutside: shouldCloseOnInteractOutside,
    ...otherProps
  } = props;
  let {
    overlayProps: overlayProps,
    underlayProps: underlayProps
  } = ($a11501f3d1d39e6c$export$ea8f71083e90600f)({
    isOpen: state.isOpen,
    onClose: state.close,
    shouldCloseOnBlur: true,
    isDismissable: !isNonModal,
    isKeyboardDismissDisabled: isKeyboardDismissDisabled,
    shouldCloseOnInteractOutside: shouldCloseOnInteractOutside
  }, popoverRef);
  let {
    overlayProps: positionProps,
    arrowProps: arrowProps,
    placement: placement
  } = ($2a41e45df1593e64$export$d39e1813b3bdd0e1)({
    ...otherProps,
    targetRef: triggerRef,
    overlayRef: popoverRef,
    isOpen: state.isOpen,
    onClose: isNonModal ? state.close : null
  });
  ($49c51c25361d4cd2$export$ee0f7cc6afcd1c18)({
    isDisabled: isNonModal || !state.isOpen
  });
  ($f0a04ccd8dbdd83b$export$e5c5a5f917a5871c)(() => {
    if (state.isOpen && !isNonModal && popoverRef.current) return ($5e3802645cc19319$export$1c3ebcada18427bf)([popoverRef.current]);
  }, [isNonModal, state.isOpen, popoverRef]);
  return {
    popoverProps: ($3ef42575df84b30b$export$9d1611c77c2fe928)(overlayProps, positionProps),
    arrowProps: arrowProps,
    underlayProps: underlayProps,
    placement: placement
  };
}

/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
const $96b38030c423d352$export$60d741e20e0aa309 = /*#__PURE__*/(createContext)({});
function $96b38030c423d352$export$574e9b0fb070c3b0() {
  var _useContext;
  return (_useContext = (useContext)($96b38030c423d352$export$60d741e20e0aa309)) !== null && _useContext !== void 0 ? _useContext : {};
}

/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

const $337b884510726a0d$export$a2200b96afd16271 = /*#__PURE__*/(React__default).createContext(null);
function $337b884510726a0d$export$c6fdb837b070b4ff(props) {
  let isSSR = ($b5e257d569688ac6$export$535bd6ca7f90a273)();
  let {
    portalContainer = isSSR ? null : document.body,
    isExiting: isExiting
  } = props;
  let [contain, setContain] = (useState)(false);
  let contextValue = (useMemo)(() => ({
    contain: contain,
    setContain: setContain
  }), [contain, setContain]);
  let {
    getContainer: getContainer
  } = ($96b38030c423d352$export$574e9b0fb070c3b0)();
  if (!props.portalContainer && getContainer) portalContainer = getContainer();
  if (!portalContainer) return null;
  let contents = props.children;
  if (!props.disableFocusManagement) contents = /*#__PURE__*/(React__default).createElement(($9bf71ea28793e738$export$20e40289641fbbb6), {
    restoreFocus: true,
    contain: contain && !isExiting
  }, contents);
  contents = /*#__PURE__*/(React__default).createElement($337b884510726a0d$export$a2200b96afd16271.Provider, {
    value: contextValue
  }, /*#__PURE__*/(React__default).createElement(($f1ab8c75478c6f73$export$cf75428e0b9ed1ea), null, contents));
  return /*#__PURE__*/($4AOtR$reactdom).createPortal(contents, portalContainer);
}

// eslint-disable-next-line import/prefer-default-export
function Popover$1(props) {
    const ref = React.useRef(null);
    const { popoverRef = ref, state, children, isNonModal } = props;
    const { popoverProps, underlayProps } = $f2f8a6077418541e$export$542a6fd13ac93354(Object.assign(Object.assign({}, props), { popoverRef }), state);
    return (jsxs($337b884510726a0d$export$c6fdb837b070b4ff, { children: [!isNonModal && jsx("div", Object.assign({}, underlayProps)), jsxs("div", Object.assign({}, popoverProps, { ref: popoverRef, style: Object.assign(Object.assign(Object.assign({}, popoverProps.style), props.overLayesrStyles), { width: "100%" }), children: [!isNonModal && jsx($86ea4cb521eb2e37$export$2317d149ed6f78c4, { onDismiss: state.close }), children, jsx($86ea4cb521eb2e37$export$2317d149ed6f78c4, { onDismiss: state.close })] }))] }));
}

const TextInput = styled.input `
  &::placeholder {
    color: ${(props) => props.placeHolderColor ? props.placeHolderColor : `#dbdddd`};
  }

  &:focus-visible {
    outline: none;
  }
`;
function SearchAutocomplete(props) {
    var _a, _b, _c;
    const { contains } = useFilter({ sensitivity: "base" });
    const state = useComboBoxState(Object.assign(Object.assign({}, props), { defaultFilter: contains }));
    const inputRef = React__default.useRef(null);
    const listBoxRef = React__default.useRef(null);
    const popoverRef = React__default.useRef(null);
    const { inputProps, listBoxProps, labelProps } = useComboBox(Object.assign(Object.assign({}, props), { inputRef,
        listBoxRef,
        popoverRef }), state);
    // Get props for the clear button from useSearchField
    const searchProps = {
        label: props.label,
        value: state.inputValue,
        onChange: (v) => state.setInputValue(v),
    };
    const searchState = useSearchFieldState(searchProps);
    const { clearButtonProps } = useSearchField(searchProps, searchState, inputRef);
    const clearButtonRef = React__default.useRef(null);
    const { buttonProps } = useButton(clearButtonProps, clearButtonRef);
    const outerRef = React__default.useRef(null);
    const inputStyle = useMemo(() => ({
        border: "1px solid rgba(48, 101, 130, 1)",
        backgroundColor: "transparent",
    }), []);
    return (jsxs("div", { "data-testid": "search-dropdown-test-id", children: [jsx("label", Object.assign({}, labelProps, { style: Object.assign({}, props.labelStyles), "data-testid": "search-dropdown-label-test-id", children: props.label })), jsxs("div", { ref: outerRef, style: Object.assign({ display: "flex", alignItems: "center" }, props.searchBoxStyles), "data-testid": "search-dropdown-searchbox-test-id", children: [jsx(TextInput, Object.assign({}, inputProps, { ref: inputRef, value: props.isItemSelect &&
                            (state === null || state === void 0 ? void 0 : state.selectedItem) &&
                            ((_a = state === null || state === void 0 ? void 0 : state.selectedItem) === null || _a === void 0 ? void 0 : _a.props)
                            ? (_c = (_b = state === null || state === void 0 ? void 0 : state.selectedItem) === null || _b === void 0 ? void 0 : _b.props) === null || _c === void 0 ? void 0 : _c.textValue
                            : inputProps.value, "data-testid": "search-dropdown-inputfield-test-id", style: {
                            height: "100%",
                            width: "100%",
                            border: inputStyle.border,
                            borderRadius: 8,
                            padding: "16px 24px",
                            boxSizing: "border-box",
                            outline: "none",
                            fontSize: 16,
                            fontWeight: 500,
                            backgroundColor: inputStyle.backgroundColor,
                            color: "rgba(39, 36, 39, 1)",
                            caretColor: "#000",
                        }, placeHolderColor: props.placeHolderColor })), jsx("button", Object.assign({}, buttonProps, { ref: clearButtonRef, onClick: (event) => {
                            if (buttonProps.onClick) {
                                buttonProps.onClick(event);
                            }
                            props === null || props === void 0 ? void 0 : props.setIsItemSelect(false);
                        }, style: Object.assign({ visibility: state.inputValue !== "" && props.isItemSelect
                                ? "visible"
                                : "hidden" }, props.closeBtnStyles), "data-testid": "search-dropdown-clear-btn-test-id", children: jsx("div", { "aria-hidden": "true", children: jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: props.closeIconColor, viewBox: "0 0 16 16", id: "IconChangeColor", children: [" ", jsx("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z", id: "mainIconPathAttribute", stroke: props.closeIconColor, strokeWidth: "2" }), " "] }) }) }))] }), state.isOpen && (jsx(Popover$1, { popoverRef: popoverRef, triggerRef: outerRef, state: state, overLayesrStyles: props.overLayesrStyles, placement: "bottom start", children: jsx(ListBox$1, Object.assign({}, listBoxProps, { listBoxRef: listBoxRef, state: state, listBoxSingleItemStyles: props.listBoxSingleItemStyles, focusedItemStyles: props.focusedItemStyles, listBoxStyles: props.listBoxStyles, selectedItemStyles: props.selectedItemStyles })) }))] }));
}
function SearchListDropdown(props) {
    const allowedChildren = React__default.Children.toArray(props.children)
        .map((child) => {
        if (React__default.isValidElement(child) && child.type === SearchListItem) {
            return {
                item: child,
                value: child.props.value,
                searchableText: child.props.searchableText,
            };
        }
        return null;
    })
        .filter(Boolean);
    const [isItemSelect, setIsItemSelect] = React__default.useState(false);
    const propsList = Object.assign({}, props);
    delete propsList.children;
    delete propsList.errorMsgStyles;
    delete propsList.errorMessage;
    return (jsxs(Fragment, { children: [jsx(SearchAutocomplete, Object.assign({}, propsList, { isItemSelect: isItemSelect, setIsItemSelect: (e) => setIsItemSelect(e), onSelectionChange: (e) => {
                    if (e !== null && (props === null || props === void 0 ? void 0 : props.onSelectionChange)) {
                        props === null || props === void 0 ? void 0 : props.onSelectionChange(e);
                    }
                    if (e !== null) {
                        setIsItemSelect(true);
                    }
                }, children: allowedChildren === null || allowedChildren === void 0 ? void 0 : allowedChildren.map((item) => {
                    return (jsx(Item, { textValue: item === null || item === void 0 ? void 0 : item.searchableText, children: item === null || item === void 0 ? void 0 : item.item }, item === null || item === void 0 ? void 0 : item.value));
                }) })), props.errorMessage && (jsx("div", { style: Object.assign({ color: "red" }, props.errorMsgStyles), "data-testid": "search-dropdown-error-test-id", children: props.errorMessage }))] }));
}
function SearchListItem({ children, }) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return jsx(Fragment, { children: children });
}

var css_248z$5 = "@import url(\"https://use.typekit.net/nwl1eft.css\");\n\n.cal-module_defaultClass__P643k {\n  width: 312px;\n  border-radius: 8px;\n  font-family: \"proxima-nova\", sans-serif !important;\n  display: inline-flex;\n  background: none;\n  margin: 4px 0px 4px 0px;\n  padding: 0px;\n}\n\n.cal-module_errorClass__SW10n {\n  border: 1px solid rgba(202, 48, 43, 1) !important;\n}\n\n.cal-module_warningClass__KOWgV {\n  border: 1px solid rgba(208, 109, 16, 1) !important;\n}\n\n.cal-module_successClass__cNPwK {\n  border: 1px solid rgba(0, 130, 5, 1) !important;\n}\n\n.cal-module_MsgClass__2LjYN {\n  font-size: 14px;\n  font-weight: 600;\n  padding: 8px;\n  letter-spacing: 0em;\n  text-align: left;\n  font-family: \"proxima-nova\", sans-serif !important;\n  display: none;\n}\n\n.cal-module_MsgClass__2LjYN.cal-module_errorMsgClass__Ukqmz {\n  color: rgba(202, 48, 43, 1);\n  display: block;\n}\n\n.cal-module_MsgClass__2LjYN.cal-module_warningMsgClass__5p2iy {\n  color: rgba(208, 109, 16, 1);\n  display: block;\n}\n\n.cal-module_MsgClass__2LjYN.cal-module_successMsgClass__PClyJ {\n  color: rgba(0, 130, 5, 1);\n  display: block;\n}\n\n.cal-module_HintClass__3T4iR {\n  width: 312px;\n  height: 24px;\n  font-family: \"proxima-nova\", sans-serif !important;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  letter-spacing: 0px;\n  text-align: right;\n  color: #4f4f4f;\n  padding: 4px 4px 8px 4px;\n}";
var Styles$3 = {"defaultClass":"cal-module_defaultClass__P643k","errorClass":"cal-module_errorClass__SW10n","warningClass":"cal-module_warningClass__KOWgV","successClass":"cal-module_successClass__cNPwK","MsgClass":"cal-module_MsgClass__2LjYN","errorMsgClass":"cal-module_errorMsgClass__Ukqmz","warningMsgClass":"cal-module_warningMsgClass__5p2iy","successMsgClass":"cal-module_successMsgClass__PClyJ","HintClass":"cal-module_HintClass__3T4iR"};
styleInject(css_248z$5);

// eslint-disable-next-line import/prefer-default-export
const muiLicenseKey = "2bf6764ac594890795f63bdadbb7c97bTz04NDI1OCxFPTE3Mzk1MzkzNjgwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=";

LicenseInfo.setLicenseKey(muiLicenseKey);
const CustomizedCalendarPicker = styled(DateRangePicker) `
  & .MuiOutlinedInput-notchedOutline {
    border: none !important;
  }

  & .MuiInputLabel-animated {
    background: white;
    padding-left: 5px !important;
    padding-right: 5px !important;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0em;
    text-align: left;
    display: flex;
    justify-content: left;
  }

  & .MuiTypography-root {
    display: none;
  }

  input::placeholder {
    color: white;
  }

  input {
    font-weight: 600;
    letter-spacing: 0em;
    text-align: left;
    padding-left: 10px;
    padding-right: 1px;
  }

  &
    .MuiFormControl-root.MuiFormControl-fullWidth.MuiTextField-root:nth-child(
      1
    ) {
    overflow: visible !important;
    .MuiInputBase-input.MuiOutlinedInput-input {
      padding-left: 20px !important;
      padding-right: 1px;
    }
  }

  & .MuiFormControl-root:not(style) ~ .MuiFormControl-root:not(style) {
    margin-left: 0px;
  }

  & .MuiFormControl-fullWidth.MuiTextField-root {
    width: 50% !important;
  }

  & .MuiOutlinedInput-input.Mui-disabled {
    -webkit-text-fill-color: rgba(39, 36, 39, 1);
    color: rgba(39, 36, 39, 1);
  }

  & .MuiInputLabel-outlined.Mui-disabled {
    color: rgba(125, 125, 125, 1);
  }

  & .MuiInputLabel-outlined.MuiInputLabel-shrink.Mui-disabled {
    color: rgba(39, 36, 39, 1);
  }

  & .MuiInputLabel-root {
    font-family: "Proxima Nova", ui-sans-serif, system-ui !important;
    background: ${(props) => props.labelBackgroundColor};
  }

  & .MuiInputLabel-root.Mui-focused {
    color: ${(props) => props.labelTextColor};
  }

  & .MuiInputLabel-root.Mui-blur {
    color: ${(props) => props.labelTextColor};
  }

  & .MuiOutlinedInput-input {
    font-family: "Proxima Nova", ui-sans-serif, system-ui !important;
    text-transform: lowercase;
  }
`;
const CustomizedCalendar = styled(DateRangeCalendar) `
  & .MuiDateRangeCalendar-monthContainer {
    width: 340px;
  }
  & .MuiDateRangePickerDay-day.Mui-selected {
    background: rgba(246, 176, 82, 1) !important;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    color: rgba(39, 36, 39, 1) !important;
    font-family: "Proxima Nova", ui-sans-serif, system-ui !important;
  }

  & .MuiDateRangeCalendar-monthContainer {
    border-radius: 8px !important;
    border: 1px solid rgba(210, 210, 210, 1);
    margin-top: 2px;
  }

  & .MuiDateRangePickerDay-day:hover {
    border-radius: 8px;
  }

  & .MuiDateRangePickerDay-dayInsideRangeInterval {
    background: rgba(240, 240, 240, 1) !important;
    border-radius: 0px;
  }

  & .MuiDateRangePickerDay-day {
    color: rgba(39, 36, 39, 1) !important;
    font-size: 16px;
    font-weight: 400;
    font-family: "Proxima Nova", ui-sans-serif, system-ui !important;
  }

  & .MuiDayCalendar-header span {
    color: rgba(39, 36, 39, 1) !important;
    font-size: 16px;
    font-weight: 700;
    font-family: "Proxima Nova", ui-sans-serif, system-ui !important;
  }

  & .MuiPickersCalendarHeader-label {
    color: rgba(39, 36, 39, 1) !important;
    font-size: 18px;
    font-weight: 700;
    font-family: "Proxima Nova", ui-sans-serif, system-ui !important;
  }

  & .Mui-disabled.MuiPickersDay-root {
    color: rgba(125, 125, 125, 1) !important;
  }

  & .MuiButtonBase-root.MuiPickersArrowSwitcher-button {
    width: 20px;
  }

  & .MuiPickersArrowSwitcher-root {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  & .MuiPickersFadeTransitionGroup-root {
    display: flex;
    position: absolute;
    width: 300px;
    justify-content: center;
    padding-bottom: 8px;
    margin-bottom: 8px;
  }

  & .MuiPickersArrowSwitcher-root {
    padding-bottom: 8px;
    border-bottom: 1px solid rgba(210, 210, 210, 1);
    margin-bottom: 8px;
  }

  & .MuiButtonBase-root.MuiPickersArrowSwitcher-button {
    width: auto;
  }

  & .MuiDateRangePickerDay-day:hover {
    border-radius: 20px !important;
  }

  & .MuiButtonBase-root.MuiPickersDay-root:not(.Mui-selected) {
    border: none;
    border-color: none;
    border-radius: none;
  }

  & .MuiButtonBase-root.MuiPickersDay-root:hover {
    background: #ffd873;
    border-radius: 8px !important;
  }import CalendarIcon from '../icons/calendar/index';


  & .MuiButtonBase-root.MuiPickersDay-root:not(:hover) {
    -webkit-transition: border-radius 0.3s ease;
    transition: border-radius 0.3s ease;
  }
`;
function DateRangePicke(props) {
    var _a, _b;
    const { isError = false, isSuccess = false, isWarning = false, calendarType = "type1", hintText = "", isDisabled = false, onChange, onChangeDateTyping, customizedErrorMessage, dateRangeMinLimit, dateRangeMaxLimit, defaultDate = [], // [new Date("2024-03-29"), new Date("2024-03-30")]
    onErrorMessage, isDateClear = false, isScroolTop = false, isReadOnly = false, calendarPickerId, } = props;
    const [calDisp, setCalDisp] = useState(false);
    const [range, setRange] = useState([
        (_a = defaultDate === null || defaultDate === void 0 ? void 0 : defaultDate[0]) !== null && _a !== void 0 ? _a : null,
        (_b = defaultDate === null || defaultDate === void 0 ? void 0 : defaultDate[1]) !== null && _b !== void 0 ? _b : null,
    ]);
    const [error, setError] = useState(false);
    const datePickerRef = useRef(null);
    const calendarRef = useRef(null);
    const ref = useRef(null);
    // const refDiv: RefObject<Element & HTMLDivElement> = useRef(null);
    const [isFocused, setIsFocused] = useState(false);
    const [isActive, setIsActive] = useState(false);
    const [isHover, setIsHover] = useState(false);
    const [onRangePositionChange, setOnRangePositionChange] = useState("start");
    const handleButtonClick = () => {
        var _a;
        setIsActive(false);
        setIsFocused(false);
        if (range[0] !== null && range[1] !== null) {
            if (calDisp && range[0] && range[1]) {
                setCalDisp(false);
                return;
            }
        }
        setCalDisp(true);
        if (calendarType === "type1") {
            const inputElement = (_a = datePickerRef === null || datePickerRef === void 0 ? void 0 : datePickerRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll("input");
            if ((inputElement === null || inputElement === void 0 ? void 0 : inputElement.length) === 2 &&
                inputElement[0] instanceof HTMLInputElement &&
                inputElement[1] instanceof HTMLInputElement) {
                setIsActive(true);
                if (range[0] === null || (range[0] !== null && range[1] != null))
                    inputElement[0].focus();
                else
                    inputElement[1].focus();
            }
        }
    };
    const scrollInputToTop = () => {
        const inputField = document.getElementById("scrollableInput");
        if (inputField) {
            setTimeout(() => {
                inputField.scrollIntoView({ behavior: "smooth", block: "start" });
            }, 20);
        }
    };
    // const handleDateTyping = (e: DateRange<unknown>) => {
    //   if ((e as Date[])[1] !== null && (e as Date[])[0] < (e as Date[])[1]) {
    //     setRange(e);
    //   } else if (e[0] !== null) {
    //     setRange([e[0], null]);
    //   }
    //   if (onChangeDateTyping) onChangeDateTyping(e);
    // };
    const handleDateTyping = (e) => {
        if (isScroolTop) {
            scrollInputToTop();
        }
        if (e[0] instanceof Date && e[1] instanceof Date) {
            setRange(e);
        }
        else if (e[0] instanceof Date) {
            setRange([e[0], null]);
        }
        else {
            setRange([null, null]);
        }
        if (onChangeDateTyping)
            onChangeDateTyping(e);
    };
    useEffect(() => {
        if (defaultDate && defaultDate[0] && defaultDate[1]) {
            setRange([defaultDate[0], defaultDate[1]]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultDate]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isValid = (date) => {
        const yearLimit = 2000;
        const year = date.getFullYear();
        // Check if the parsed year is within the limit
        if (year <= yearLimit) {
            return false; // Invalid date
        }
        // Perform your date validation logic here
        // For example, check if the date is not null and is a valid date object
        // eslint-disable-next-line no-restricted-globals
        return date !== null && !isNaN(date.getTime());
    };
    const classNameHandle = useMemo(() => {
        if (error || isError) {
            return {
                wrapperClass: `${Styles$3.defaultClass} ${Styles$3.errorClass}`,
                msgClassName: `${Styles$3.MsgClass} ${Styles$3.errorMsgClass}`,
                svgStrokeColor: "rgba(202, 48, 43, 1)",
            };
        }
        if (isWarning) {
            return {
                wrapperClass: `${Styles$3.defaultClass} ${Styles$3.warningClass}`,
                msgClassName: `${Styles$3.MsgClass} ${Styles$3.warningMsgClass}`,
                svgStrokeColor: "rgba(208, 109, 16, 1)",
            };
        }
        if (isSuccess) {
            return {
                wrapperClass: `${Styles$3.defaultClass} ${Styles$3.successClass}`,
                msgClassName: `${Styles$3.MsgClass} ${Styles$3.successMsgClass}`,
                svgStrokeColor: "rgba(0, 130, 5, 1)",
            };
        }
        return {
            wrapperClass: Styles$3.defaultClass,
            msgClassName: Styles$3.MsgClass,
            svgStrokeColor: "#306582",
        };
    }, [error, isError, isWarning, isSuccess]);
    const { buttonProps } = useButton(Object.assign(Object.assign({}, props), { onPress() {
            scrollInputToTop();
            handleButtonClick();
        } }), ref);
    // const divProps = useButton(
    //   {
    //     ...props,
    //     onPress() {
    //       handleButtonClick();
    //     },
    //   },
    //   refDiv
    // );
    const rangeHandler = useMemo(() => {
        if (range[0] instanceof Date && Number.isNaN(range[0].getTime())) {
            return [null, range[1]];
        }
        if (range[1] instanceof Date && Number.isNaN(range[1].getTime())) {
            return [range[0], null];
        }
        if (range[0] !== null && range[1] !== null && isValid(range[1])) {
            setCalDisp(false);
        }
        return range;
    }, [range]);
    // To change the border color of the main div
    const getInputBorder = useCallback(() => {
        if (isHover && !isDisabled)
            return "2px solid rgba(40, 86, 110, 1)";
        if (isFocused && !isActive)
            return "2px solid rgba(54, 143, 233, 1)";
        if (isActive)
            return "2px solid rgba(40, 86, 110, 1)";
        if (isDisabled)
            return "1px solid rgba(210, 210, 210, 1)";
        return "1px solid rgba(48, 101, 130, 1)";
    }, [isHover, isFocused, isActive, isDisabled]);
    // add class to the main div
    const setClassName = useMemo(() => {
        if (isHover && !isDisabled)
            return "thick-border hovered-border";
        if (isFocused && !isActive)
            return "thick-border focus-border";
        if (isActive)
            return "thick-border active-border";
        if (error || isError || isWarning)
            return "error-border";
        return "normal-border";
    }, [isHover, isFocused, isActive, isDisabled, error, isError, isWarning]);
    // To change the background color of the main div
    const getBackgroundColor = useCallback(() => {
        if (isHover && !isActive && !isDisabled)
            return "rgba(240, 240, 240, 1)";
        if (isDisabled)
            return "rgba(240, 240, 240, 1)";
        return "rgba(255, 255, 255, 1)";
    }, [isHover, isActive, isDisabled]);
    // To change the font color of the label
    const getTextColor = useCallback(() => {
        if (isFocused && !isActive && !error)
            return "rgba(0, 107, 214, 1)";
        if (isActive)
            return "rgba(39, 36, 39, 1)";
        return "rgba(79, 79, 79, 1)";
    }, [isActive, isFocused, error]);
    const getTextLabelBackGroundColor = useCallback(() => {
        const isRangeZeroEmpty = range[0] !== null;
        const isRangeOneEmpty = range[1] !== null;
        const isBothRangesNotEmpty = isRangeZeroEmpty && isRangeOneEmpty;
        if (isHover && !isActive)
            return `${isBothRangesNotEmpty
                ? "linear-gradient(to top, rgba(240, 240, 240, 1), white)"
                : "rgba(240, 240, 240, 1)"}`;
        if (isDisabled) {
            if (isBothRangesNotEmpty) {
                return "linear-gradient(to top, rgba(240, 240, 240, 1), white)";
            }
            return "rgba(240, 240, 240, 1)";
        }
        return "rgba(255, 255, 255, 1)";
    }, [isHover, isActive, range, isDisabled]);
    // To change the border shadow of the main div
    const getBoxShadow = useCallback(() => {
        if (isHover)
            return "0px 0px 0px 2px rgba(40, 86, 110, 0.4)";
        return "unset";
    }, [isHover]);
    const inputStyle = useMemo(() => {
        return {
            border: getInputBorder(),
            backgroundColor: getBackgroundColor(),
            labelTextColor: getTextColor(),
            labelBackgroundColor: getTextLabelBackGroundColor(),
            boxShadow: getBoxShadow(),
        };
    }, [
        getInputBorder,
        getBackgroundColor,
        getTextColor,
        getBoxShadow,
        getTextLabelBackGroundColor,
    ]);
    const onChangeHandler = (e) => {
        setRange(e);
        if (onChange)
            onChange(e);
    };
    useEffect(() => {
        const keyListener = (e) => {
            var _a;
            if (e.key === "Tab" && !isDisabled) {
                const inputElements = (_a = datePickerRef === null || datePickerRef === void 0 ? void 0 : datePickerRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll("input");
                if ((inputElements === null || inputElements === void 0 ? void 0 : inputElements.length) === 2 &&
                    inputElements[0] instanceof HTMLInputElement &&
                    inputElements[1] instanceof HTMLInputElement) {
                    setTimeout(() => {
                        const firstInputFocused = inputElements[0] === document.activeElement;
                        const secondInputFocused = inputElements[1] === document.activeElement;
                        setIsFocused(true);
                        if (!firstInputFocused && !secondInputFocused) {
                            setIsFocused(false);
                        }
                    }, 0);
                }
                else {
                    setIsFocused(false);
                }
            }
        };
        document.addEventListener("keydown", keyListener);
        return () => {
            document.removeEventListener("keydown", keyListener);
        };
    }, [isDisabled, datePickerRef]);
    const handleClickOutside = useCallback((event) => {
        if (calDisp &&
            datePickerRef.current &&
            !datePickerRef.current.contains(event.target) &&
            calendarRef.current &&
            !calendarRef.current.contains(event.target)) {
            setCalDisp(false);
        }
    }, [calDisp]);
    useEffect(() => {
        if (calDisp && isScroolTop) {
            scrollInputToTop();
        }
        // Attach the event listener when the component mounts
        document.addEventListener("mousedown", handleClickOutside);
        // Detach the event listener when the component unmounts
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [calDisp, handleClickOutside, isScroolTop]);
    useEffect(() => {
        let isFocusOutListenerAdded = false;
        const calenderElement = calendarRef.current;
        const handleFocusOut = (e) => {
            var _a;
            // when user focused out from calender, close the calender and remove added event listener
            setCalDisp(false);
            (_a = calendarRef === null || calendarRef === void 0 ? void 0 : calendarRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener("focusout", handleFocusOut);
            isFocusOutListenerAdded = false;
        };
        const handleTabKeyPress = (e) => {
            if (
            // listen when user press the tab key
            e.key === "Tab" &&
                calendarRef.current &&
                e.target &&
                calendarRef.current.contains(e.target)) {
                const targetElement = e.target;
                if (
                // when user navigated to dates in calender, add focusout event listener to calender
                targetElement.getAttribute("role") === "gridcell" &&
                    !isFocusOutListenerAdded) {
                    calendarRef.current.addEventListener("focusout", handleFocusOut);
                    isFocusOutListenerAdded = true;
                }
            }
        };
        window.addEventListener("keydown", handleTabKeyPress);
        return () => {
            window.removeEventListener("keydown", handleTabKeyPress);
            if (isFocusOutListenerAdded) {
                calenderElement === null || calenderElement === void 0 ? void 0 : calenderElement.removeEventListener("focusout", handleFocusOut);
            }
        };
    }, []);
    return (jsxs(LocalizationProvider, { dateAdapter: AdapterDateFns, children: [hintText && jsx("div", { className: `${Styles$3.HintClass}`, children: hintText }), jsxs("div", { id: "scrollableInput", 
                // eslint-disable-next-line react/jsx-props-no-spreading
                // {...divProps.buttonProps}
                className: `${classNameHandle.wrapperClass} ${setClassName}`, 
                // ref={refDiv}
                onMouseEnter: () => setIsHover(true), onMouseLeave: () => setIsHover(false), style: {
                    border: inputStyle.border,
                    backgroundColor: inputStyle.backgroundColor,
                    boxShadow: inputStyle.boxShadow,
                }, children: [jsx(CustomizedCalendarPicker, { calendarPickerId: calendarPickerId, labelBackgroundColor: inputStyle.labelBackgroundColor, labelTextColor: inputStyle.labelTextColor, localeText: { start: "From", end: "Until" }, value: isDateClear ? [null, null] : range, calendars: 1, dayOfWeekFormatter: (_day) => {
                            return _day;
                        }, format: "dd/MM/yyyy", disableOpenPicker: true, disabled: calendarType === "type2" || isDisabled, onError: (e) => {
                            scrollInputToTop();
                            // handleErrorMessage(e);
                        }, onChange: handleDateTyping, minDate: dateRangeMinLimit ? new Date(dateRangeMinLimit) : new Date(), maxDate: dateRangeMaxLimit ? new Date(dateRangeMaxLimit) : undefined, ref: datePickerRef, readOnly: isReadOnly, onSelectedSectionsChange: (e) => {
                            if (isScroolTop) {
                                scrollInputToTop();
                            }
                            setCalDisp(true);
                        }, onRangePositionChange: (e) => {
                            setOnRangePositionChange(e);
                        }, rangePosition: onRangePositionChange }), jsx("button", Object.assign({ type: "button" }, buttonProps, { ref: ref, style: {
                            background: "#F0F0F0",
                            minWidth: "56px",
                            height: "56px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "none",
                            borderRadius: "0px 8px 8px 0px",
                            outline: "none",
                        }, "aria-label": "calendar", children: jsx(CalendarIcon, { width: 24, height: 24, stroke: classNameHandle.svgStrokeColor }) }))] }), jsx("div", { className: `${classNameHandle.msgClassName}`, children: customizedErrorMessage }), jsx("div", { ref: calendarRef, style: { width: "340px", gap: "4px" }, className: "customize_calender_wrapper", children: calDisp && (jsx(CustomizedCalendar, { onRangePositionChange: (e) => {
                        setOnRangePositionChange(e);
                    }, rangePosition: onRangePositionChange, slots: {
                        leftArrowIcon: ChevronLeftIcon,
                        rightArrowIcon: ChevronRightIcon,
                    }, calendars: 1, value: rangeHandler, currentMonthCalendarPosition: 1, dayOfWeekFormatter: (_day) => {
                        return _day;
                    }, onChange: (e) => {
                        onChangeHandler(e);
                    }, disablePast: true, minDate: dateRangeMinLimit ? new Date(dateRangeMinLimit) : new Date(), maxDate: dateRangeMaxLimit ? new Date(dateRangeMaxLimit) : undefined, className: Styles$3.calender, disableAutoMonthSwitching: true })) })] }));
}

function PlusCircleIcon({ testId, size = "M", width, height, fill = "#272427", id = "", className = "", }) {
    const sizeMap = useMemo(() => getSizeMap(size), [size]);
    return (jsx("svg", { width: width !== null && width !== void 0 ? width : sizeMap, height: height !== null && height !== void 0 ? height : sizeMap, "data-testid": testId, className: `iconCompLibrary_plusCircle_svg_${className}`, id: `iconCompLibrary_plusCircle_svg_id_${id}`, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM12 7.25C12.4142 7.25 12.75 7.58579 12.75 8V11.25H16C16.4142 11.25 16.75 11.5858 16.75 12C16.75 12.4142 16.4142 12.75 16 12.75H12.75V16C12.75 16.4142 12.4142 16.75 12 16.75C11.5858 16.75 11.25 16.4142 11.25 16V12.75H8C7.58579 12.75 7.25 12.4142 7.25 12C7.25 11.5858 7.58579 11.25 8 11.25H11.25V8C11.25 7.58579 11.5858 7.25 12 7.25Z", fill: fill }) }));
}

function SpinnerDotIcon({ size = "M", width, height, fill = "#D9D9D9", testId = "spinner-dot-icon", duration = 1500, }) {
    const sizeMap = useMemo(() => getSizeMap(size), [size]);
    const [isLoaded, setIsLoaded] = useState(false);
    useEffect(() => {
        setIsLoaded(true);
    }, []);
    const { x } = useSpring({
        loop: true,
        from: { x: 0 },
        to: { x: isLoaded ? 80 : 0 },
        config: { duration },
    });
    const getOpacity = (index, xValue) => {
        if ((index - 1) * 10 <= xValue && xValue <= index * 10) {
            return 0.3;
        }
        return 1;
    };
    return (jsxs("svg", { width: width !== null && width !== void 0 ? width : sizeMap, height: height !== null && height !== void 0 ? height : sizeMap, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg", className: "spinner-dot-icon", "data-testid": testId, fill: fill, style: { "--fill-color": fill }, children: [jsx(animated.rect, { x: "22", width: "4", height: "12", rx: "2", className: "rect rect-1", style: {
                    opacity: x.to((y) => getOpacity(1, y)),
                } }), " ", jsx(animated.rect, { x: "33.9", y: "16.929", width: "4", height: "12", rx: "2", transform: "rotate(-135 33.9 16.929)", className: "rect rect-8", style: {
                    opacity: x.to((y) => getOpacity(2, y)),
                } }), " ", jsx(animated.rect, { x: "36", y: "26", width: "4", height: "12", rx: "2", transform: "rotate(-90 36 26)", className: "rect rect-3", style: {
                    opacity: x.to((y) => getOpacity(3, y)),
                } }), " ", jsx(animated.rect, { x: "31.071", y: "33.9", width: "4", height: "12", rx: "2", transform: "rotate(-45 31.071 33.9)", className: "rect rect-6", style: {
                    opacity: x.to((y) => getOpacity(4, y)),
                } }), " ", jsx(animated.rect, { x: "22", y: "36", width: "4", height: "12", rx: "2", className: "rect rect-2", style: {
                    opacity: x.to((y) => getOpacity(5, y)),
                } }), " ", jsx(animated.rect, { x: "8.444", y: "42.385", width: "4", height: "12", rx: "2", transform: "rotate(-135 8.444 42.385)", className: "rect rect-7", style: {
                    opacity: x.to((y) => getOpacity(6, y)),
                } }), " ", jsx(animated.rect, { y: "26", width: "4", height: "12", rx: "2", transform: "rotate(-90 0 26)", className: "rect rect-4", style: {
                    opacity: x.to((y) => getOpacity(7, y)),
                } }), " ", jsx(animated.rect, { x: "5.615", y: "8.444", width: "4", height: "12", rx: "2", transform: "rotate(-45 5.615 8.444)", className: "rect rect-5", style: {
                    opacity: x.to((y) => getOpacity(8, y)),
                } }), " "] }));
}

function ShieldCardIcon({ testId, size = "M", width, height, stroke = "#272427", strokeWidth = 1, className, fill = "none", id, }) {
    const sizeMap = useMemo(() => getSizeMap(size), [size]);
    return (jsx("svg", { "data-testid": testId, width: width !== null && width !== void 0 ? width : sizeMap, height: height !== null && height !== void 0 ? height : sizeMap, viewBox: "0 0 21 22", fill: fill, xmlns: "http://www.w3.org/2000/svg", className: className, id: id, children: jsx("path", { d: "M17 6.93494V3.93494L9 0.934937L1 3.93494V10.9349C1 16.9349 9 20.9349 9 20.9349C9 20.9349 13.577 18.6464 15.807 14.9349M8.86328 9.89154H19.2973M9.90668 7.28302H18.2539C18.8301 7.28302 19.2973 7.75017 19.2973 8.32642V13.5434C19.2973 14.1197 18.8301 14.5868 18.2539 14.5868H9.90668C9.33043 14.5868 8.86328 14.1197 8.86328 13.5434V8.32642C8.86328 7.75017 9.33043 7.28302 9.90668 7.28302Z", stroke: stroke, strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }) }));
}

function UsersIcon({ testId, size = "M", width, height, className, fill = "none", }) {
    const sizeMap = useMemo(() => getSizeMap(size), [size]);
    return (jsx("svg", { "data-testid": testId, width: width !== null && width !== void 0 ? width : sizeMap, height: height !== null && height !== void 0 ? height : sizeMap, viewBox: "0 0 24 25", fill: fill, xmlns: "http://www.w3.org/2000/svg", className: className, children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.75 7.93491C5.75 6.13998 7.20507 4.68491 9 4.68491C10.7949 4.68491 12.25 6.13998 12.25 7.93491C12.25 9.72983 10.7949 11.1849 9 11.1849C7.20507 11.1849 5.75 9.72983 5.75 7.93491ZM9 3.18491C6.37665 3.18491 4.25 5.31155 4.25 7.93491C4.25 10.5583 6.37665 12.6849 9 12.6849C11.6234 12.6849 13.75 10.5583 13.75 7.93491C13.75 5.31155 11.6234 3.18491 9 3.18491ZM6 15.1849C4.74022 15.1849 3.53204 15.6854 2.64124 16.5761C1.75045 17.4669 1.25 18.6751 1.25 19.9349V21.9349C1.25 22.3491 1.58579 22.6849 2 22.6849C2.41421 22.6849 2.75 22.3491 2.75 21.9349V19.9349C2.75 19.073 3.09241 18.2463 3.7019 17.6368C4.3114 17.0273 5.13805 16.6849 6 16.6849H12C12.862 16.6849 13.6886 17.0273 14.2981 17.6368C14.9076 18.2463 15.25 19.073 15.25 19.9349V21.9349C15.25 22.3491 15.5858 22.6849 16 22.6849C16.4142 22.6849 16.75 22.3491 16.75 21.9349V19.9349C16.75 18.6751 16.2496 17.4669 15.3588 16.5761C14.468 15.6854 13.2598 15.1849 12 15.1849H6ZM18.2738 15.8773C18.3774 15.4762 18.7864 15.2351 19.1875 15.3386C20.2065 15.6017 21.1093 16.1958 21.7541 17.0276C22.3989 17.8594 22.7492 18.8818 22.75 19.9342V19.9348V21.9348C22.75 22.349 22.4142 22.6848 22 22.6848C21.5858 22.6848 21.25 22.349 21.25 21.9348V19.9353V19.935C21.2494 19.2151 21.0097 18.5156 20.5686 17.9466C20.1274 17.3775 19.5097 16.971 18.8125 16.791C18.4114 16.6874 18.1703 16.2783 18.2738 15.8773ZM16.186 3.33823C15.7848 3.23549 15.3762 3.47749 15.2734 3.87876C15.1707 4.28003 15.4127 4.68861 15.814 4.79135C16.5131 4.97035 17.1327 5.37692 17.5752 5.94698C18.0177 6.51704 18.2578 7.21815 18.2578 7.93979C18.2578 8.66143 18.0177 9.36254 17.5752 9.9326C17.1327 10.5027 16.5131 10.9092 15.814 11.0882C15.4127 11.191 15.1707 11.5995 15.2734 12.0008C15.3762 12.4021 15.7848 12.6441 16.186 12.5414C17.2078 12.2797 18.1134 11.6855 18.7601 10.8524C19.4068 10.0192 19.7578 8.99449 19.7578 7.93979C19.7578 6.88509 19.4068 5.86038 18.7601 5.02722C18.1134 4.19406 17.2078 3.59983 16.186 3.33823Z", fill: "#4F4F4F" }) }));
}

function ShieldCheckIcon({ testId, size = "M", width, height, stroke = "#272427", strokeWidth = 1, fill = "none", className, id, }) {
    const sizeMap = useMemo(() => getSizeMap(size), [size]);
    return (jsx("svg", { "data-testid": testId, width: width !== null && width !== void 0 ? width : sizeMap, height: height !== null && height !== void 0 ? height : sizeMap, viewBox: "0 0 21 22", fill: fill, xmlns: "http://www.w3.org/2000/svg", className: className, id: id, children: jsx("path", { d: "M6 10.9349L8 12.9349L12 8.93491M9 20.9349C9 20.9349 17 16.9349 17 10.9349V3.93491L9 0.934906L1 3.93491V10.9349C1 16.9349 9 20.9349 9 20.9349Z", stroke: stroke, strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }) }));
}

function Button({ onClick, isActive, className, label, id }) {
    return (jsx("button", { "data-testid": "tab-button", id: id, onClick: onClick, type: "button", className: `${className} ${isActive ? "ToggleBtnActive" : "ToggleBtnInactive"} ToggleBtn
      }`, children: label }));
}

function ButtonTab({ className, tabs, defaultActiveTab, isDefaultTogle = true, onClick = () => undefined, }) {
    const [activeTabBtn, setActiveTabBtn] = useState(defaultActiveTab !== null && defaultActiveTab !== void 0 ? defaultActiveTab : "");
    const handleButtonClick = (tabNumber) => {
        if (isDefaultTogle) {
            setActiveTabBtn(tabNumber);
        }
    };
    useEffect(() => {
        setActiveTabBtn(defaultActiveTab !== null && defaultActiveTab !== void 0 ? defaultActiveTab : "");
    }, [defaultActiveTab]);
    return (jsx("div", { "data-testid": "button-tab", className: `${className}`, style: {
            display: "flex",
            columnGap: "8px",
        }, children: tabs.map((tab) => (jsx(Button, { id: tab.id, onClick: () => {
                onClick(tab.value);
                handleButtonClick(tab.value);
            }, isActive: activeTabBtn === tab.value, label: tab === null || tab === void 0 ? void 0 : tab.label, className: tab.className }, tab.label))) }));
}

var css_248z$4 = ".TagSearchField-module_popularCountryHeader__OA0UT {\n    padding: 8px 16px 0;\n    color: #272427;\n    font-weight: bold;\n  }\n  \n  .TagSearchField-module_popularCountryContainer__VutLS {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    padding: 8px 0;\n    padding-left: 20px;\n  }\n  \n  .TagSearchField-module_popularCountryImage__AxJiW {\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    margin-right: 8px;\n  }\n  \n  .TagSearchField-module_popularCountryItem__B79RL {\n    color: #272427;\n    font-weight: normal;\n    overflow: hidden; \n    position: relative; \n  }\n  \n  .TagSearchField-module_popularCountryItem__B79RL::before {\n    content: \"\"; \n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: transparent; \n    z-index: 0; \n  }\n  \n  .TagSearchField-module_popularCountryItem__B79RL:hover::before {\n    background-color: rgba(0, 0, 0, 0.04);\n    width: 96%; \n    transform: translateX(8px); \n  }\n  \n";
var TagSearchStyles = {"popularCountryHeader":"TagSearchField-module_popularCountryHeader__OA0UT","popularCountryContainer":"TagSearchField-module_popularCountryContainer__VutLS","popularCountryImage":"TagSearchField-module_popularCountryImage__AxJiW","popularCountryItem":"TagSearchField-module_popularCountryItem__B79RL"};
styleInject(css_248z$4);

const GlobalStyle = createGlobalStyle `
  body .MuiAutocomplete-popper{
    top: 7px !important;
  }`;
const Container$1 = styled.div `
  display: inline-block;
`;
const AlertMessage = styled.div `
  position: absolute;
  color: ${({ $alertFontColor }) => $alertFontColor};
`;
const shouldForwardProp = (customProps) => (prop) => !customProps.includes(prop);
const StyledAutocomplete = styled(Autocomplete).withConfig({
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    shouldForwardProp: shouldForwardProp([
        "$hasValues",
        "$alertState",
        "$width",
        "$brand",
    ]),
}) `
  & * {
    border: none !important;
  }

  border: ${(props) => props.$hasValues ? "2px solid #306582" : "1px solid #306582"};
  border-radius: 8px;
  width: ${(props) => props.$width || "348px"};

  ${(props) => props.$alertState === "success" && "border: 2px solid #008205 !important"};

  ${(props) => props.$alertState === "warning" && "border: 2px solid #D06D10 !important;"}

  ${(props) => props.$alertState === "error" && "border: 2px solid #CA302B !important;"}

  &:hover {
    background-color: #f0f0f0;
    border: 2px solid #28566e;
    outline: 2px solid #a9bbc5;
  }

  & .MuiFormLabel-root {
    color: blue;
  }

  & .MuiInputLabel-shrink {
    display: none;
  }

  & .Mui-disabled {
    background-color: #f0f0f0;
    box-shadow: none;
    cursor: not-allowed;
    color: #7d7d7d;
  }

  & .Mui-disabled:hover {
    border: none;
    outline: none;
  }

  & .Mui-disabled.MuiAutocomplete-tag {
    background-color: #e6e6e6 !important;
    color: #7d7d7d;
    border: 1px solid #d2d2d2;
  }

  & .MuiAutocomplete-tag {
    background-color: ${(props) => props.$brand === "staysure" ? "#306582" : "#005a5e"};
    color: white;
  }

  & .MuiFormLabel-root {
    color: #4f4f4f;
  }

  & .MuiSvgIcon-root {
    fill: white;
  }

  & .MuiSvgIcon-root.Mui-disabled {
    fill: #7d7d7d;
  }
`;
function TagSearchField({ $width, $alertState, $brand = "staysure", alertMessage = "", $alertFontColor = "", optionList, tagFieldPlaceholderText = "Search Country", disabled = false, spacing = "comfortable", semanticColor = "Light Background", onInputChange, values, onChange, loading = false, loadingText, noOptionsText, freeSolo, popularCountryTitle = "Popular destinations", popularCountryHeaderClassName = "", popularCountryClassName = "", popularCountryImageClassName = "", popularCountries = [], selectOnFocus = true, tagFieldPlaceholderClassName = "", }) {
    const [selectedTags, setSelectedTags] = useState([]);
    const countryRef = useRef(null);
    const hasMountedRef = useRef(false);
    const [isTabPressed, setIsTabPressed] = useState(false);
    const [queryInput, setQueryInput] = useState("");
    const [inputOnFous, setInputOnFocus] = useState(false);
    const [startTyping, setStartTyping] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    function handleInputChange(e, query, reason) {
        setQueryInput(query);
        if (onInputChange) {
            onInputChange(e, query, reason);
        }
    }
    const filteredPopularCountries = popularCountries.filter((country) => !selectedTags.some((tag) => tag.parentName === country.parentName &&
        tag.parentCode === country.parentCode));
    useEffect(() => {
        const allPopularSelected = popularCountries.every((country) => selectedTags.some((tag) => tag.parentCode === country.parentCode));
        if (allPopularSelected) {
            setIsOpen(false);
        }
        if (allPopularSelected && startTyping) {
            setIsOpen(true);
        }
    }, [popularCountries, selectedTags, startTyping]);
    useEffect(() => {
        if (values) {
            setSelectedTags(values);
        }
    }, [values]);
    useEffect(() => {
        var _a;
        if (queryInput.length === 0 && inputOnFous) {
            setIsOpen(selectedTags.length === 0 || startTyping);
        }
        else {
            setIsOpen((queryInput.length > 2 && ((_a = optionList === null || optionList === void 0 ? void 0 : optionList.length) !== null && _a !== void 0 ? _a : 0) > 0) ||
                (queryInput.length > 2 && !!noOptionsText));
        }
        if (queryInput.length > 0) {
            setStartTyping(true);
        }
    }, [
        queryInput,
        inputOnFous,
        selectedTags,
        startTyping,
        optionList,
        noOptionsText,
        popularCountries.length,
    ]);
    useEffect(() => {
        const keyListener = (e) => {
            if (e.key === "Tab") {
                if (countryRef.current) {
                    const inputElements = countryRef.current.querySelectorAll("input");
                    if ((inputElements === null || inputElements === void 0 ? void 0 : inputElements.length) === 1 &&
                        inputElements[0] instanceof HTMLInputElement) {
                        setTimeout(() => {
                            const inputFocused = inputElements[0] === document.activeElement;
                            setIsTabPressed(true);
                            if (!inputFocused) {
                                setIsTabPressed(false);
                            }
                        }, 0);
                    }
                    else {
                        setIsTabPressed(false);
                    }
                }
            }
            else {
                setIsTabPressed(false);
            }
        };
        document.addEventListener("keydown", keyListener);
        return () => {
            document.removeEventListener("keydown", keyListener);
        };
    }, [countryRef]);
    const handleTagChange = (event, 
    // eslint-disable-next-line @typescript-eslint/no-shadow
    values) => {
        if (values) {
            setStartTyping(false);
            const updatedTags = [...selectedTags];
            if (values.length > updatedTags.length) {
                const selectedElement = values[values.length - 1];
                const selectedObject = updatedTags.find((obj) => (obj === null || obj === void 0 ? void 0 : obj.parentName) === selectedElement.parentName);
                if (!selectedObject) {
                    const singleElement = {
                        type: "Country",
                        parentCode: selectedElement.parentCode,
                        parentName: selectedElement.parentName,
                        displayLabel: selectedElement.parentName,
                    };
                    updatedTags.push(singleElement);
                }
                setSelectedTags(updatedTags);
            }
            else {
                setSelectedTags(values);
            }
            // eslint-disable-next-line no-param-reassign
            if (onChange) {
                onChange(event, values);
            }
            // setTimeout(() => {
            //   const inputElement = countryRef?.current?.querySelector("input");
            //   if (inputElement) {
            //     inputElement.focus();
            //   }
            // }, 0);
        }
    };
    useEffect(() => {
        var _a;
        if (selectedTags.length > 0) {
            const inputElement = (_a = countryRef === null || countryRef === void 0 ? void 0 : countryRef.current) === null || _a === void 0 ? void 0 : _a.querySelector("input");
            if (!hasMountedRef.current) {
                inputElement === null || inputElement === void 0 ? void 0 : inputElement.blur();
                hasMountedRef.current = true;
                return;
            }
            inputElement === null || inputElement === void 0 ? void 0 : inputElement.focus();
            setIsOpen(false);
        }
    }, [selectedTags]);
    const handleClickOutside = useCallback((event) => {
        var _a;
        if ((_a = countryRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target)) {
            setIsOpen(true);
        }
    }, []);
    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [handleClickOutside]);
    const handleFocus = () => {
        setInputOnFocus(true);
        const shouldOpenDropdown = !queryInput.length || popularCountries.length > 0;
        if (shouldOpenDropdown) {
            setIsOpen(true);
        }
    };
    // function handleSelectedLable(countryName: string) {
    //   return countryName;
    // }
    const modifiers = [
        {
            name: "flip",
            options: {
                fallbackPlacements: [],
            },
        },
    ];
    const isFirefox = typeof navigator !== "undefined" && /firefox/i.test(navigator.userAgent);
    return (jsxs(Fragment, { children: [jsx(GlobalStyle, {}), jsxs(Container$1, { children: [jsx(StyledAutocomplete, { open: isOpen, ListboxProps: {
                            sx: Object.assign(Object.assign({ overflowY: "auto", "&::-webkit-scrollbar": {
                                    width: "8px !important",
                                }, "&::-webkit-scrollbar-thumb": {
                                    backgroundColor: "#D2D2D2",
                                    borderRadius: "120px",
                                } }, (isFirefox && {
                                scrollbarColor: "#D2D2D2 transparent",
                            })), { "@supports (-webkit-overflow-scrolling: touch)": {
                                    "-webkit-overflow-scrolling": "touch",
                                    "&::-webkit-scrollbar": {
                                        width: "8px !important",
                                    },
                                    "&::-webkit-scrollbar-thumb": {
                                        backgroundColor: "#D2D2D2",
                                        borderRadius: "120px",
                                    },
                                } }),
                        }, ref: countryRef, onFocus: handleFocus, onBlur: () => setIsOpen(false), "$width": $width, style: {
                            outlineOffset: isTabPressed ? 2 : 0,
                            outline: isTabPressed ? "2px solid #368fe9" : "none",
                        }, options: queryInput.length > 0
                            ? (optionList !== null && optionList !== void 0 ? optionList : [{ label: "No options available" }])
                            : filteredPopularCountries, "$alertState": $alertState, "$brand": $brand, multiple: true, loading: loading, loadingText: loadingText, value: selectedTags, id: "checkboxes-tags-demo", blurOnSelect: !(window.innerWidth > styles$1.PTM.screenSize["screenSize-s"]), 
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        forcePopupIcon: false, clearIcon: null, disabled: disabled, selectOnFocus: selectOnFocus, freeSolo: freeSolo, noOptionsText: noOptionsText, 
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        getOptionLabel: (option) => option.displayLabel, filterOptions: (options) => options, 
                        // // eslint-disable-next-line react/jsx-no-bind
                        onInputChange: handleInputChange, 
                        // eslint-disable-next-line @typescript-eslint/no-shadow
                        onChange: (event, values) => handleTagChange(event, values), className: `tag_search_component_library 
                    tag_search_component_library${spacing}
                    tag_search_component_library${semanticColor === "Light Background"
                            ? "semantic_light"
                            : "semantic_dark"}

          `, "$hasValues": selectedTags ? selectedTags.length > 0 : false, 
                        // eslint-disable-next-line @typescript-eslint/no-shadow
                        renderTags: (tagValue, getTagProps) => {
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            return tagValue.map((option, index) => {
                                const _a = getTagProps({ index }), restProps = __rest(_a, ["key"]);
                                const prop = Object.assign({}, restProps);
                                return (jsx(Chip, Object.assign({ label: option.displayLabel }, prop), `${option.displayLabel}-${index}`));
                            });
                        }, 
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        renderOption: (props, option, { selected, index }) => {
                            if (option.parentName) {
                                const selectedObject = selectedTags.find((obj) => (obj === null || obj === void 0 ? void 0 : obj.parentName) === option.parentName);
                                if (selectedObject) {
                                    // eslint-disable-next-line no-param-reassign
                                    selected = true;
                                }
                            }
                            return popularCountries.length > 0 && queryInput.length < 1 ? (jsxs("div", { children: [index === 0 && (jsx("div", { className: `${TagSearchStyles.popularCountryHeader} ${popularCountryHeaderClassName}`, children: popularCountryTitle })), createElement("li", Object.assign({}, props, { key: `${option === null || option === void 0 ? void 0 : option.displayLabel}-${index}`, className: `${TagSearchStyles.popularCountryItem} ${popularCountryClassName}` }),
                                        jsxs("div", { className: TagSearchStyles.popularCountryContainer, children: [jsx("img", { src: option.countryImage, alt: option.parentName, className: `${TagSearchStyles.popularCountryImage} ${popularCountryImageClassName}` }), jsx("span", { children: typeof option === "object" &&
                                                        option !== null &&
                                                        "displayLabel" in option &&
                                                        typeof option.displayLabel === "string"
                                                        ? option.displayLabel
                                                        : "" })] }))] })) : (createElement("li", Object.assign({}, props, { key: `${option === null || option === void 0 ? void 0 : option.displayLabel}-${index}`, style: {
                                    marginLeft: "5px",
                                    marginRight: "5px",
                                    marginBottom: "2px",
                                    backgroundColor: selected ? "#e3e3e3" : "",
                                } }), typeof option === "object" &&
                                option !== null &&
                                "displayLabel" in option &&
                                typeof option.displayLabel === "string"
                                ? option.displayLabel
                                : "No options available"));
                        }, renderInput: (params) => {
                            return (jsx(TextField$2
                            // eslint-disable-next-line react/jsx-props-no-spreading
                            , Object.assign({}, params, { label: tagFieldPlaceholderText, InputLabelProps: {
                                    className: tagFieldPlaceholderClassName,
                                }, onClick: () => {
                                    setIsOpen(true);
                                }, sx: {
                                    "& .MuiOutlinedInput-root": {
                                        "& input": { color: "#272427" },
                                    },
                                } })));
                        }, 
                        // eslint-disable-next-line react/no-unstable-nested-components
                        PopperComponent: (props) => {
                            return (jsx(Popper
                            // eslint-disable-next-line react/jsx-props-no-spreading
                            , Object.assign({}, props, { modifiers: modifiers, popperOptions: {
                                    placement: "bottom",
                                } })));
                        } }), jsx(AlertMessage, { "$alertFontColor": $alertFontColor, className: `alert_message_tagsearch 
                    ${$alertState === "error" ? "error" : ""}
                    ${$alertState === "warning" ? "warning" : ""}
                    ${$alertState === "success" ? "success" : ""}`, children: alertMessage })] })] }));
}

function PaymentFailedIcon({ testId, size = "XXL", width, height, stroke = "#272427", }) {
    const sizeMap = useMemo(() => getSizeMap(size), [size]);
    return (jsxs("svg", { width: width !== null && width !== void 0 ? width : sizeMap, height: height !== null && height !== void 0 ? height : sizeMap, viewBox: "0 0 64 64", "data-testid": testId, className: "iconCompLibrary_paymentFailedIcon_svg", id: "iconCompLibrary_paymentFailedIcon_svg_id", xmlns: "http://www.w3.org/2000/svg", children: [jsx("rect", { x: "6", y: "11", width: "51", height: "16", fill: "#E3D6F1" }), jsx("path", { d: "M30.5617 54.7468H16.9349C7.46823 54.7468 5.06836 52.4001 5.06836 43.0401V21.1201C5.06836 12.6401 7.04161 9.92014 14.4816 9.49347C15.2283 9.4668 16.0549 9.44012 16.9349 9.44012H46.5617C56.0284 9.44012 58.4282 11.7868 58.4282 21.1468V32.9068", stroke: stroke, strokeWidth: 3, strokeLinecap: "round", strokeLinejoin: "round", fill: "transparent" }), jsx("path", { d: "M47.735 58.7467C53.6261 58.7467 58.4017 53.9711 58.4017 48.0801C58.4017 42.189 53.6261 37.4134 47.735 37.4134C41.844 37.4134 37.0684 42.189 37.0684 48.0801C37.0684 53.9711 41.844 58.7467 47.735 58.7467Z", fill: "#E3D6F1", stroke: stroke, strokeWidth: 3, strokeMiterlimit: "10", strokeLinecap: "round", strokeLinejoin: "round" }), jsx("path", { d: "M50.5856 51.0668L44.959 45.4135", stroke: stroke, strokeWidth: 2.5, strokeMiterlimit: "10", strokeLinecap: "round", strokeLinejoin: "round", fill: "white" }), jsx("path", { d: "M50.5342 45.4933L44.8809 51.12", stroke: stroke, strokeWidth: 2.5, strokeMiterlimit: "10", strokeLinecap: "round", strokeLinejoin: "round", fill: "white" }), jsx("path", { d: "M15.7344 42.7468H26.401", stroke: stroke, strokeWidth: 2.5, strokeMiterlimit: "10", strokeLinecap: "round", strokeLinejoin: "round", fill: "white" }), jsx("path", { d: "M5.06836 26.7468H58.4017", stroke: stroke, strokeWidth: 3, strokeMiterlimit: "10", strokeLinecap: "round", strokeLinejoin: "round", fill: "white" })] }));
}

function Option({ item, state, listClassName = "", availableListOptionsStyles = {}, focusedListTextColor, focusedListBackgroundColor, }) {
    const ref = useRef(null);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { optionProps, isFocused, isDisabled } = useOption({ key: item.key }, state, ref);
    return (jsx("li", Object.assign({}, optionProps, { ref: ref, style: Object.assign({ outline: "none", cursor: "pointer", display: "flex", justifyContent: "space-between", background: isFocused ? focusedListBackgroundColor : "transparent", color: isFocused ? focusedListTextColor : "#272427" }, availableListOptionsStyles), className: listClassName, children: item.rendered })));
}
function ListBox(props) {
    const ref = useRef(null);
    const { listBoxRef = ref, state, listBoxStyle = {}, unorderedListClassName, listClassName, focusedListTextColor, focusedListBackgroundColor, availableListOptionsStyles = {}, } = props;
    const { listBoxProps } = useListBox(props, state, listBoxRef);
    return (jsx("ul", Object.assign({}, listBoxProps, { ref: listBoxRef, className: unorderedListClassName, style: Object.assign({ outline: "none" }, listBoxStyle), children: [...state.collection].map((item) => (jsx(Option, { item: item, state: state, listClassName: listClassName, focusedListTextColor: focusedListTextColor, focusedListBackgroundColor: focusedListBackgroundColor, availableListOptionsStyles: availableListOptionsStyles }, item.key))) })));
}

function Popover(_a) {
    var { children, state } = _a, props = __rest(_a, ["children", "state"]);
    const popoverRef = useRef(null);
    const { popoverProps, underlayProps } = usePopover(Object.assign(Object.assign({}, props), { popoverRef }), state);
    return (jsxs(Overlay, { children: [jsx("div", Object.assign({}, underlayProps, { style: { position: "relative", inset: 0 } })), jsxs("div", Object.assign({}, popoverProps, { ref: popoverRef, style: Object.assign(Object.assign({}, popoverProps.style), { 
                    // background: 'var(--page-background)',
                    backgroundColor: "white", borderRadius: "8px", marginTop: "10px" }), className: "list-overlay", children: [jsx(DismissButton, { onDismiss: state.close }), children, jsx(DismissButton, { onDismiss: state.close })] }))] }));
}

const Container = styled.div `
  display: inline-block;
`;
const DropdownButton = styled.button `
  display: flex;
  align-items: center;
  justify-content: space-between;
  outline: none;
`;
function Select(_a) {
    var { isDisabled = false, label = "", alertState = null, placeholderText = "From £15.95pp", spacing = "comfortable", semanticColor = "Light Background", dropdownBtnStyle = {}, id = "", children, className = "", unorderedListClassName, listClassName, leftActiveIcon, isActiveLeftIcon = false, listBoxStyle, availableListOptionsStyles, focusedListTextColor = "#272427", focusedListBackgroundColor = "#7d7d7d14" } = _a, props = __rest(_a, ["isDisabled", "label", "alertState", "placeholderText", "spacing", "semanticColor", "dropdownBtnStyle", "id", "children", "className", "unorderedListClassName", "listClassName", "leftActiveIcon", "isActiveLeftIcon", "listBoxStyle", "availableListOptionsStyles", "focusedListTextColor", "focusedListBackgroundColor"]);
    const state = useSelectState(Object.assign(Object.assign({}, props), { isDisabled, children: children }));
    const ref = useRef(null);
    const { triggerProps, valueProps, menuProps } = useSelect(Object.assign(Object.assign({}, props), { isDisabled, "aria-label": label || "dropdown-label" }), state, ref);
    const [isHovered, setIsHovered] = useState(false);
    const [isTabPressed, setIsTabPressed] = useState(true);
    const [isMousePressed, setIsMousePressed] = useState(false);
    const { hoverProps } = useHover({
        isDisabled,
        onHoverChange: (hovered) => {
            setIsHovered(hovered);
        },
    });
    const { buttonProps } = useButton(Object.assign(Object.assign({}, triggerProps), { isDisabled,
        onPressStart(e) {
            if (triggerProps.onPressStart)
                triggerProps.onPressStart(e);
            if (e.pointerType !== "keyboard") {
                setIsTabPressed(false);
                setIsMousePressed(true);
            }
            else {
                setIsTabPressed(true);
                setIsMousePressed(false);
            }
        },
        onBlur(e) {
            if (triggerProps.onBlur)
                triggerProps.onBlur(e);
            if (e.relatedTarget === null) {
                setIsTabPressed(true);
                setIsMousePressed(false);
            }
        } }), ref);
    return (jsxs(Container, { children: [jsxs("div", { children: [jsx("div", { className: "hint_label", children: label }), jsx(HiddenSelect, { isDisabled: true, state: state, triggerRef: ref }), jsx(DropdownButton
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    , Object.assign({}, mergeProps(buttonProps, hoverProps), { ref: ref, disabled: isDisabled, style: Object.assign({ outline: state.isFocused && isTabPressed && !isMousePressed
                                ? "2px solid #368fe9"
                                : "none", outlineOffset: state.isFocused && isTabPressed && !isMousePressed ? "2px" : "0" }, dropdownBtnStyle), id: id, "data-testid": id, className: `${className} aco_dropdown_component_library 
            ${isHovered ? "hovered" : ""} 
            ${state.isFocused ? "focused" : ""}
            ${state.isOpen ? "filled" : ""} 
            ${state.selectedItem ? "active" : ""} 
            ${alertState === "error" ? "error" : ""}
            ${alertState === "warning" ? "warning" : ""}
            ${alertState === "success" ? "success" : ""}
            ${isDisabled ? "disabled" : ""}
            aco_dropdown_component_library${spacing}
            aco_dropdown_component_library${semanticColor === "Light Background"
                            ? "semantic_light"
                            : "semantic_dark"}
        `, "aria-label": "dropdown", children: jsxs("div", { className: `aco_dropdown_button_body_component_library
          ${state.selectedItem ? "active" : ""}`, children: [isActiveLeftIcon && leftActiveIcon && state.selectedItem && (jsx("div", { className: "left_icon_icon_component_library", "data-testid": "optional-icon", children: leftActiveIcon })), jsx("div", Object.assign({}, valueProps, { className: `aco_placeholder_text_component_library 
                          ${state.isOpen ? "filled" : ""}
                          ${state.selectedItem ? "active" : ""}
                          ${alertState === "error" ? "error" : ""}
                          ${alertState === "warning" ? "warning" : ""}
                          ${alertState === "success" ? "success" : ""}
                       `, children: state.selectedItem
                                        ? state.selectedItem.textValue
                                        : placeholderText })), jsx("div", { "aria-hidden": "true", className: `aco_arrow_head_icon_component_library
              ${state.selectedItem ? "active" : ""}`, children: jsx(ChevronDownIcon, { stroke: `${state.selectedItem ? "#ffffff" : "#272427"}` }) })] }) }))] }), state.isOpen && (jsx(Popover, { state: state, triggerRef: ref, placement: "bottom start", children: jsx(ListBox
                // eslint-disable-next-line react/jsx-props-no-spreading
                , Object.assign({}, menuProps, { listBoxStyle: Object.assign({}, listBoxStyle), availableListOptionsStyles: Object.assign({}, availableListOptionsStyles), state: state, unorderedListClassName: unorderedListClassName, listClassName: listClassName, focusedListTextColor: focusedListTextColor, focusedListBackgroundColor: focusedListBackgroundColor })) }))] }));
}
function DropdownItem({ children, }) {
    return children;
}
function mapDropdownItems(children) {
    return React__default.Children.toArray(children)
        .map((child) => {
        var _a, _b;
        if (React__default.isValidElement(child) && child.type === DropdownItem) {
            return {
                item: child,
                value: (_a = child.props.value) !== null && _a !== void 0 ? _a : "",
                keyValue: (_b = child.props.keyValue) !== null && _b !== void 0 ? _b : "",
            };
        }
        return null;
    })
        .filter(Boolean);
}
function Dropdown(_a) {
    var { children, listBoxStyle } = _a, props = __rest(_a, ["children", "listBoxStyle"]);
    const allowedChildren = mapDropdownItems(children);
    const propsList = Object.assign({}, props);
    delete propsList.children;
    return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    jsx(Select, Object.assign({}, propsList, { listBoxStyle: listBoxStyle, children: allowedChildren === null || allowedChildren === void 0 ? void 0 : allowedChildren.map((item) => {
            var _a;
            return (jsx(Item, { textValue: item === null || item === void 0 ? void 0 : item.value, children: item === null || item === void 0 ? void 0 : item.item }, (_a = item === null || item === void 0 ? void 0 : item.keyValue) !== null && _a !== void 0 ? _a : item === null || item === void 0 ? void 0 : item.value));
        }) })));
}

var css_248z$3 = "@import url(\"https://use.typekit.net/nwl1eft.css\");\n\n.SingleDatePicker-module_defaultClass__5O1TZ {\n  width: 196px;\n  height: 56px;\n  gap: 8px;\n  border-radius: 8px;\n  display: inline-flex;\n  background: none;\n  justify-content: right;\n}\n\n.SingleDatePicker-module_calendarContainer__miVSF {\n  width: 304px !important;\n  height: 360px !important;\n  padding: 12px !important;\n  margin-top: 4px !important;\n  border-radius: 8px;\n  background: #ffffff;\n  border: 1px solid #d2d2d2;\n  box-shadow: 0px 0px 12px 0px #0f172a1c;\n}\n\n.SingleDatePicker-module_errorClass__pHGPT {\n  border: 2px solid rgba(202, 48, 43, 1) !important;\n}\n\n.SingleDatePicker-module_warningClass__ictBr {\n  border: 2px solid rgba(208, 109, 16, 1) !important;\n}\n\n.SingleDatePicker-module_successClass__qEovk {\n  border: 2px solid rgba(0, 130, 5, 1) !important;\n}\n\n.SingleDatePicker-module_MsgClass__LlrDw {\n  font-size: 14px;\n  font-weight: 600;\n  padding: 8px;\n  letter-spacing: 0em;\n  text-align: left;\n  display: none;\n}\n\n.SingleDatePicker-module_MsgClass__LlrDw.SingleDatePicker-module_errorMsgClass__AN3YG {\n  color: rgba(202, 48, 43, 1);\n  display: block;\n}\n\n.SingleDatePicker-module_MsgClass__LlrDw.SingleDatePicker-module_warningMsgClass__is1e6 {\n  color: rgba(208, 109, 16, 1);\n  display: block;\n}\n\n.SingleDatePicker-module_MsgClass__LlrDw.SingleDatePicker-module_successMsgClass__V-Oez {\n  color: rgba(0, 130, 5, 1);\n  display: block;\n}\n\n.SingleDatePicker-module_HintClass__Ya-dE {\n  width: 196px;\n  height: 24px;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  letter-spacing: 0px;\n  text-align: right;\n  color: #4f4f4f;\n  padding: 4px 4px 8px 4px;\n}\n\n.SingleDatePicker-module_FontClassStaysure__VDR3I {\n  font-family: \"proxima-nova\", sans-serif;\n}\n\n.SingleDatePicker-module_FontClassAvanthi__oF0fm {\n  font-family:\n    \"faktum\",\n    DM Serif Display,\n    sans-serif;\n}\n";
var Styles$2 = {"defaultClass":"SingleDatePicker-module_defaultClass__5O1TZ","calendarContainer":"SingleDatePicker-module_calendarContainer__miVSF","errorClass":"SingleDatePicker-module_errorClass__pHGPT","warningClass":"SingleDatePicker-module_warningClass__ictBr","successClass":"SingleDatePicker-module_successClass__qEovk","MsgClass":"SingleDatePicker-module_MsgClass__LlrDw","errorMsgClass":"SingleDatePicker-module_errorMsgClass__AN3YG","warningMsgClass":"SingleDatePicker-module_warningMsgClass__is1e6","successMsgClass":"SingleDatePicker-module_successMsgClass__V-Oez","HintClass":"SingleDatePicker-module_HintClass__Ya-dE","FontClassStaysure":"SingleDatePicker-module_FontClassStaysure__VDR3I","FontClassAvanthi":"SingleDatePicker-module_FontClassAvanthi__oF0fm"};
styleInject(css_248z$3);

const CustomizedDateField = styled(DateField) `
  & .MuiOutlinedInput-notchedOutline {
    border: none !important;
  }

  & .MuiInputBase-input.MuiOutlinedInput-input {
    font-family: ${(props) => props.brand === "staysure"
    ? `"Proxima Nova", ui-sans-serif, system-ui`
    : `"faktum", DM Serif Display, sans-serif`} !important;
    font-size: 16px !important;
    font-weight: 600 !important;
  }

  & .MuiInputLabel-root {
    background: ${(props) => props.animatedlabelbackground};
    color: ${(props) => props.animatedlabeltextcolor} !important;
    font-family: ${(props) => props.brand === "staysure"
    ? `"Proxima Nova", ui-sans-serif, system-ui`
    : `"faktum", DM Serif Display, sans-serif`} !important;
    font-size: 12px;
    font-weight: 500;
  }

  input {
    color: ${(props) => props.brand === "staysure" ? `#272427` : `#2E2D2C`} !important;
  }

  & .MuiInputLabel-root.Mui-focused {
    font-family: ${(props) => props.brand === "staysure"
    ? `"Proxima Nova", ui-sans-serif, system-ui`
    : `"faktum", ui-sans-serif, sans-serif`} !important;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    width: auto;
  }

  & .MuiInputLabel-root.MuiInputLabel-root {
    display: flex !important;
    font-family: ${(props) => props.brand === "staysure"
    ? `"Proxima Nova", ui-sans-serif, system-ui`
    : `"faktum", ui-sans-serif, sans-serif`} !important;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    width: auto;
    color: ${(props) => (props.brand === "staysure" ? `#272427` : `#2E2D2C`)};
    align-items: center !important;
    padding-left: 4px !important;
    padding-right: 4px !important;
  }

  & .MuiInputLabel-root.MuiInputLabel-root.Mui-focused {
    padding-left: 4px !important;
    padding-right: 4px !important;
  }

  & .MuiInputLabel-root.MuiInputLabel-root.MuiFormLabel-filled {
    color: ${(props) => (props === null || props === void 0 ? void 0 : props.istabfocus) === "true"
    ? `#368FE9`
    : `${props.brand === "staysure" ? `#272427` : `#2E2D2C`}`} !important;
  }

  & .MuiOutlinedInput-input {
    font-family: ${(props) => props.brand === "staysure"
    ? `"Proxima Nova", ui-sans-serif, system-ui`
    : `"faktum", ui-sans-serif, sans-serif`} !important;
    font-size: 16px;
    font-weight: 600;
    text-transform: uppercase;
  }
`;
const CustomizedDateCalendar$1 = styled(DateCalendar) `
  & .MuiDateRangePickerDay-day {
    color: ${(props) => (props.brand === "staysure" ? `#272427` : `#2E2D2C`)};
    font-size: 16px;
    font-weight: 400;
    font-family: ${(props) => props.brand === "staysure"
    ? `"Proxima Nova", ui-sans-serif, system-ui`
    : `"faktum", DM Serif Display, sans-serif`} !important;
  }

  & .MuiDayCalendar-header span {
    color: ${(props) => (props.brand === "staysure" ? `#272427` : `#2E2D2C`)};
    font-size: 16px;
    font-weight: 700;
    font-family: ${(props) => props.brand === "staysure"
    ? `"Proxima Nova", ui-sans-serif, system-ui`
    : `"faktum", DM Serif Display, sans-serif`} !important;
  }

  & .MuiPickersCalendarHeader-label {
    color: ${(props) => (props.brand === "staysure" ? `#272427` : `#2E2D2C`)};
    font-size: 18px;
    font-weight: 700;
    font-family: ${(props) => props.brand === "staysure"
    ? `"Proxima Nova", ui-sans-serif, system-ui`
    : `"faktum", DM Serif Display, sans-serif`} !important;
    margin-top: 5px;
  }

  & .MuiPickersCalendarHeader-switchViewButton {
    display: none !important;
  }

  & .MuiPickersFadeTransitionGroup-root {
    display: flex;
    position: absolute;
    width: 300px;
    justify-content: center;
    padding-bottom: 1px;
    margin-bottom: 1px;
  }

  & .MuiPickersArrowSwitcher-root {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  & .MuiButtonBase-root.MuiPickersArrowSwitcher-button {
    width: auto;
    margin-bottom: 10px;
  }

  & .MuiPickersCalendarHeader-root {
    margin-bottom: 10px;
  }

  &
    .MuiPickersFadeTransitionGroup-root.MuiDateCalendar-viewTransitionContainer {
    margin-top: 68px;
  }

  & .MuiPickersCalendarHeader-root.MuiPickersCalendarHeader-root {
    padding-left: 0px;
  }

  & .MuiPickersDay-root {
    font-size: 16px;
    font-weight: 400;
    font-family: ${(props) => props.brand === "staysure"
    ? `"Proxima Nova", ui-sans-serif, system-ui`
    : `"faktum", DM Serif Display, sans-serif`} !important;
  }

  & .MuiButtonBase-root.MuiPickersDay-root.Mui-selected {
    background: #f6b052;
    border-radius: 8px;
    font-weight: 700;
  }

  & .MuiPickersYear-yearButton {
    font-size: 16px;
    font-weight: 400;
    font-family: ${(props) => props.brand === "staysure"
    ? `"Proxima Nova", ui-sans-serif, system-ui`
    : `"faktum", DM Serif Display, sans-serif`} !important;
    color: ${(props) => (props.brand === "staysure" ? `#272427` : `#2E2D2C`)};
  }

  & .MuiPickersYear-yearButton.Mui-selected {
    background: #f6b052 !important;
  }

  & .MuiPickersArrowSwitcher-root {
    border-bottom: 1px solid rgba(210, 210, 210, 1);
    margin-left: 10px;
    align-items: center !important;
    margin-top: 10px;
  }

  & .MuiButtonBase-root.MuiPickersDay-root {
    color: ${(props) => (props.brand === "staysure" ? `#272427` : `#2E2D2C`)};
  }

  & .MuiPickersCalendarHeader-labelContainer {
    margin-bottom: 5px;
  }

  & .MuiButtonBase-root.MuiPickersDay-root:not(.Mui-selected) {
    border: none;
    border-color: none;
    border-radius: none;
  }

  & .MuiButtonBase-root.MuiPickersDay-root:hover {
    background: #ffd873;
    border-radius: 8px !important;
  }

  & .MuiButtonBase-root.MuiPickersDay-root:not(:hover) {
    -webkit-transition: border-radius 0.3s ease;
    transition: border-radius 0.3s ease;
  }

  & .MuiButtonBase-root.MuiPickersDay-root:focus {
    border: 1px solid #368fe9 !important;
    border-radius: 8px !important;
    background: none;
  }
`;
function SingleDatePicker(props) {
    const { customizedMessage = "Message", isError = false, isSuccess = false, isWarning = false, hintText, isDisabled, onChange, minimumDate, maximumDate, classNameDateField, classNameCalendar, width, disablePastDates, defaultDate, label = "From", openTo = "day", isDateClear = false, dateView, isScroolTop = false, activeHoverd = true, onBlur, brand = "staysure", onCalenderViewUpdate, isReadOnly = false, isMobile = false, } = props;
    const [calendarOpen, setCalendarOpen] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);
    const [isActive, setIsActive] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const [isTabPressed, setIsTabPressed] = useState(false);
    const [error, setError] = useState(false);
    // const [year, setYear] = useState<unknown>(null);
    // const [month, setMonth] = useState<unknown>(null);
    // Ref for button
    const ref = useRef(null);
    // const refDiv: RefObject<Element & HTMLDivElement> = useRef(null);
    const dateFieldRef = useRef(null);
    const calendarRef = useRef(null);
    useEffect(() => {
        if (defaultDate) {
            setSelectedDate(defaultDate);
        }
        else {
            setSelectedDate(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultDate]);
    const handleDate = (date) => {
        setSelectedDate(date);
        if (onChange) {
            onChange(date);
        }
    };
    useEffect(() => {
        if (onCalenderViewUpdate)
            onCalenderViewUpdate(calendarOpen);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [calendarOpen]);
    const handleCalendarOpen = () => {
        if (calendarOpen) {
            setCalendarOpen(false);
            setIsActive(false);
            return;
        }
        if (dateFieldRef.current) {
            const inputElement = dateFieldRef.current.querySelectorAll("input");
            if (inputElement.length > 0) {
                inputElement[0].focus();
                setCalendarOpen(true);
                setIsActive(true);
            }
        }
    };
    const scrollInputToTop = () => {
        const inputField = document.getElementById("scrollableInput");
        if (inputField) {
            inputField.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };
    const { buttonProps } = useButton(Object.assign(Object.assign({}, props), { onPress() {
            scrollInputToTop();
            handleCalendarOpen();
        } }), ref);
    // const mainDivRef = useButton(
    //   {
    //     ...props,
    //     onPress() {
    //       handleCalendarOpen();
    //     },
    //   },
    //   refDiv
    // );
    const getDateFieldBorder = useCallback(() => {
        if (isFocused && isTabPressed) {
            return "2px solid #368FE9";
        }
        if (isHovered && activeHoverd && !isDisabled && !isFocused) {
            return brand === "staysure"
                ? "2px solid rgba(40, 86, 110, 1)"
                : "2px solid rgba(22, 70, 72, 1)";
        }
        if (isActive) {
            return brand === "staysure"
                ? "2px solid rgba(40, 86, 110, 1)"
                : "2px solid rgba(22, 70, 72, 1)";
        }
        if (isDisabled) {
            return brand === "staysure" ? "#E0E0E0" : "#D2CECA";
        }
        return brand === "staysure" ? "1px solid #306582" : "1px solid #005A5E";
    }, [
        isFocused,
        isTabPressed,
        isHovered,
        activeHoverd,
        isDisabled,
        isActive,
        brand,
    ]);
    const getDateFieldBackgroundColor = useCallback(() => {
        if (isHovered && activeHoverd && !isDisabled && !isFocused) {
            return "#F0F0F0";
        }
        if (isDisabled) {
            return "#F0F0F0";
        }
        return "rgba(255, 255, 255, 1)";
    }, [isHovered, isDisabled, isFocused, activeHoverd]);
    const getDateFieldBoxShadow = useCallback(() => {
        if (isHovered && activeHoverd) {
            return "0px 0px 0px 2px #28566E66";
        }
        return "unset";
    }, [isHovered, activeHoverd]);
    const getAnimationTextLabelBackGroundColor = useCallback(() => {
        if (isHovered && activeHoverd && !isDisabled && !isFocused) {
            return `${selectedDate ? "linear-gradient(to top, rgba(240, 240, 240, 1), white)" : "rgba(240, 240, 240, 1)"}`;
        }
        if (isDisabled) {
            return `${selectedDate ? "linear-gradient(to top, rgba(240, 240, 240, 1), white)" : "rgba(240, 240, 240, 1)"}`;
        }
        return "rgba(255, 255, 255, 1)";
    }, [isHovered, selectedDate, isDisabled, isFocused, activeHoverd]);
    const getAnimationTextLabelTextColor = useCallback(() => {
        if (isFocused && isTabPressed)
            return "#368FE9";
        return "#4f4f4f";
    }, [isFocused, isTabPressed]);
    const dateFieldStyle = useMemo(() => {
        return {
            border: getDateFieldBorder(),
            boxShadow: getDateFieldBoxShadow(),
            background: getDateFieldBackgroundColor(),
            animationLabelBackgroundColor: getAnimationTextLabelBackGroundColor(),
            animationLabelTextColor: getAnimationTextLabelTextColor(),
        };
    }, [
        getDateFieldBorder,
        getDateFieldBoxShadow,
        getDateFieldBackgroundColor,
        getAnimationTextLabelBackGroundColor,
        getAnimationTextLabelTextColor,
    ]);
    const dynamicStyleClass = useMemo(() => {
        const font = brand === "staysure" ? Styles$2.FontClassStaysure : Styles$2.FontClassAvanthi;
        if (error || isError) {
            return {
                wrapperClass: `${Styles$2.defaultClass} ${Styles$2.errorClass} ${font}`,
                msgClassName: `${Styles$2.MsgClass} ${Styles$2.errorMsgClass} ${font}`,
                svgStrokeColor: "rgba(202, 48, 43, 1)",
            };
        }
        if (isWarning) {
            return {
                wrapperClass: `${Styles$2.defaultClass} ${Styles$2.warningClass} ${font}`,
                msgClassName: `${Styles$2.MsgClass} ${Styles$2.warningMsgClass} ${font}`,
                svgStrokeColor: "rgba(208, 109, 16, 1)",
            };
        }
        if (isSuccess) {
            return {
                wrapperClass: `${Styles$2.defaultClass} ${Styles$2.successClass} ${font}`,
                msgClassName: `${Styles$2.MsgClass} ${Styles$2.successMsgClass} ${font}`,
                svgStrokeColor: "rgba(0, 130, 5, 1)",
            };
        }
        return {
            wrapperClass: ` ${Styles$2.defaultClass} ${font}`,
            msgClassName: `${Styles$2.MsgClass} ${font}`,
            svgStrokeColor: brand === "staysure" ? "#306582" : "#005A5E",
        };
    }, [error, isError, isWarning, isSuccess, brand]);
    // set class name based on error, warning, success
    const setClassName = useMemo(() => {
        if (isHovered && activeHoverd && !isDisabled && !isFocused)
            return "thick-border hovered-border";
        if (isFocused && isTabPressed)
            return "thick-border focus-border";
        if (isActive)
            return "thick-border active-border";
        if (error || isError || isWarning)
            return "error-border";
        return "normal-border";
    }, [
        isHovered,
        isDisabled,
        isFocused,
        isTabPressed,
        isActive,
        error,
        isError,
        isWarning,
        activeHoverd,
    ]);
    useEffect(() => {
        const keyListener = (e) => {
            if (e.key === "Tab" && !isDisabled) {
                if (dateFieldRef.current) {
                    const inputElements = dateFieldRef.current.querySelectorAll("input");
                    if ((inputElements === null || inputElements === void 0 ? void 0 : inputElements.length) === 1 &&
                        inputElements[0] instanceof HTMLInputElement) {
                        setTimeout(() => {
                            const inputFocused = inputElements[0] === document.activeElement;
                            setIsTabPressed(true);
                            if (!inputFocused) {
                                setIsTabPressed(false);
                            }
                        }, 0);
                    }
                    else {
                        setIsTabPressed(false);
                    }
                }
            }
            else {
                setIsTabPressed(false);
            }
        };
        document.addEventListener("keydown", keyListener);
        return () => {
            document.removeEventListener("keydown", keyListener);
        };
    }, [isDisabled, dateFieldRef]);
    useEffect(() => {
        if (calendarOpen && isScroolTop) {
            scrollInputToTop();
        }
        const handleOutsideClick = (event) => {
            var _a;
            if (calendarOpen &&
                !((_a = dateFieldRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target)) &&
                calendarRef.current &&
                !calendarRef.current.contains(event.target)) {
                setCalendarOpen(false);
            }
        };
        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, [calendarOpen, isScroolTop]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isValid = (date) => {
        // Perform your date validation logic here
        // For example, check if the date is not null and is a valid date object
        // eslint-disable-next-line no-restricted-globals
        return date !== null && !isNaN(date.getTime());
    };
    return (jsxs(LocalizationProvider, { dateAdapter: AdapterDateFns, children: [hintText && (jsx("div", { style: { minWidth: "196px", width }, className: `${Styles$2.HintClass} ${brand === "staysure" ? Styles$2.FontClassStaysure : Styles$2.FontClassAvanthi}`, children: hintText })), jsxs("div", { id: "scrollableInput", 
                // eslint-disable-next-line react/jsx-props-no-spreading
                // {...mainDivRef.buttonProps}
                className: `${dynamicStyleClass.wrapperClass} ${setClassName}`, 
                // ref={refDiv}
                onMouseEnter: () => setIsHovered(true), onMouseLeave: () => setIsHovered(false), style: {
                    border: dateFieldStyle.border,
                    boxShadow: dateFieldStyle.boxShadow,
                    background: dateFieldStyle.background,
                    minWidth: "196px",
                    width,
                }, children: [jsx(CustomizedDateField, { animatedlabelbackground: `${dateFieldStyle.animationLabelBackgroundColor}`, animatedlabeltextcolor: `${dateFieldStyle.animationLabelTextColor}`, brand: brand, istabfocus: isFocused && isTabPressed ? "true" : "false", label: label, value: isDateClear ? null : selectedDate, ref: dateFieldRef, onChange: (value) => {
                            if (isValid(value)) {
                                handleDate(value);
                            }
                            else if (onChange) {
                                onChange(value);
                            }
                        }, onFocus: () => {
                            if (isScroolTop) {
                                scrollInputToTop();
                            }
                            setIsFocused(true);
                        }, onSelectedSectionsChange: () => {
                            if (isScroolTop) {
                                scrollInputToTop();
                            }
                            if (isMobile) {
                                setCalendarOpen(true);
                            }
                        }, onBlur: () => {
                            if (isScroolTop) {
                                scrollInputToTop();
                            }
                            setIsFocused(false);
                            setIsTabPressed(false);
                            if (onBlur) {
                                onBlur();
                            }
                        }, onError: () => {
                            // handleErrors(e);
                        }, disabled: isDisabled, className: `${classNameDateField}`, format: "dd/MM/yyyy", minDate: minimumDate, maxDate: maximumDate, readOnly: isReadOnly }), jsx("button", Object.assign({}, buttonProps, { ref: ref, 
                        // onClick={() => scrollInputToTop()}
                        type: "button", style: {
                            background: "#F0F0F0",
                            minWidth: "56px",
                            height: "56px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "none",
                            borderRadius: "0px 8px 8px 0px",
                            outline: "none",
                        }, "aria-label": "calendar", children: jsx(CalendarIcon, { width: 24, height: 24, stroke: dynamicStyleClass.svgStrokeColor }) }))] }), jsx("div", { className: `${dynamicStyleClass.msgClassName}`, children: customizedMessage }), jsx("div", { style: { width: "304px" }, className: "customize_calender_wrapper single_date_picker_wrapper", ref: calendarRef, children: calendarOpen && (jsx(CustomizedDateCalendar$1, { brand: brand, openTo: openTo, onChange: (value, selectionState) => {
                        handleDate(value);
                        if (selectionState && selectionState === "finish") {
                            setCalendarOpen(false);
                        }
                    }, slots: {
                        leftArrowIcon: ChevronLeftIcon,
                        rightArrowIcon: ChevronRightIcon,
                    }, value: selectedDate !== null && selectedDate !== void 0 ? selectedDate : defaultDate, defaultValue: defaultDate, dayOfWeekFormatter: (_day) => {
                        return _day;
                    }, className: `${Styles$2.calendarContainer} ${classNameCalendar}`, minDate: minimumDate, maxDate: maximumDate, disablePast: disablePastDates, views: dateView })) })] }));
}

var css_248z$2 = "@import url(\"https://use.typekit.net/nwl1eft.css\");\n\n.DateInput-module_dobContainer__hWHk9 {\n  display: flex;\n  align-items: center;\n  border: 1px solid rgb(48, 102, 130);\n  border-radius: 8px;\n  padding: 16px 24px 16px 24px;\n  width: 200px;\n  position: relative;\n  height: 12px;\n}\n\n.DateInput-module_dobContainer__hWHk9:focus {\n  border-color: rgba(54, 143, 233, 1);\n  box-shadow: 0 0 0 2px rgba(54, 143, 233, 1);\n}\n\n.DateInput-module_dobContainer__hWHk9:focus-visible {\n  border: none !important;\n  outline: none !important;\n}\n\n.DateInput-module_dobContainer__hWHk9:focus-within {\n  border-color: rgba(40, 86, 110, 1);\n  border-width: 2px;\n}\n\n.DateInput-module_dobContainer__hWHk9:active {\n  border-color: rgba(54, 143, 233, 1);\n  /* Change border color on focus */\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n  /* Add a focus shadow */\n}\n\n.DateInput-module_dobAciveContainer__N1hGf {\n  border-color: rgba(54, 143, 233, 1);\n  box-shadow: 0 0 0 2px rgba(54, 143, 233, 1);\n  display: flex;\n  align-items: center;\n  /* border: 1px solid rgba(54, 143, 233, 1); */\n  border-radius: 8px;\n  padding: 16px 24px 16px 24px;\n  width: 200px;\n  position: relative;\n  height: 12px;\n}\n\n.DateInput-module_dobDisabledContainer__UIWw7 {\n  display: flex;\n  align-items: center;\n  border-radius: 8px;\n  padding: 16px 24px 16px 24px;\n  width: 200px;\n  position: relative;\n  height: 12px;\n  background-color: rgba(240, 240, 240, 1);\n  border: 2px solid rgba(210, 210, 210, 1);\n}\n\n\n.DateInput-module_dobContainer__hWHk9:has(.DateInput-module_dobInput__tW4iD:not(:placeholder-shown)) {\n  border-width: 2px;\n}\n\n.DateInput-module_dobContainer__hWHk9:has(.DateInput-module_dobInput__tW4iD:not(:placeholder-shown)) .DateInput-module_separator__WIZen {\n  color: #272427;\n}\n\n.DateInput-module_error__KXGIi {\n  border-color: rgba(202, 48, 43, 1) !important;\n  /* Red border for error */\n}\n\n.DateInput-module_dobInput__tW4iD {\n  border: none;\n  outline: none;\n  font-family: \"proxima-nova\", sans-serif;\n  font-size: 16px;\n  background-color: transparent;\n  padding-block: 0;\n  padding-inline: 0;\n  color: #272427;\n  direction: ltr;\n}\n\n.DateInput-module_dobInput__tW4iD:disabled {\n  color: #7D7D7D;\n  -webkit-text-fill-color: #7D7D7D;\n  opacity: 0.7;\n  font-weight: 500;\n}\n\n.DateInput-module_dobInput__tW4iD::placeholder {\n  color: #7d7d7d;\n  font-weight: 600;\n}\n\n.DateInput-module_dobInput__tW4iD[class~=\"date-input\"]:placeholder-shown {\n  width: 18px;\n}\n\n.DateInput-module_dobInput__tW4iD[class~=\"month-input\"]:placeholder-shown {\n  width: 27px;\n}\n\n.DateInput-module_dobInput__tW4iD[class~=\"date-input\"]:not(:placeholder-shown) {\n  width: 21px;\n}\n\n.DateInput-module_dobInput__tW4iD[class~=\"month-input\"]:not(:placeholder-shown) {\n  width: 21px;\n}\n\n.DateInput-module_dobInput__tW4iD[class~=\"year-input\"] {\n  width: 40px;\n}\n\n.DateInput-module_dobContainer__hWHk9:has(.DateInput-module_avantiDobInput__-Gd0F:not(:placeholder-shown)) {\n  border-width: 2px;\n}\n\n.DateInput-module_dobContainer__hWHk9:has(.DateInput-module_avantiDobInput__-Gd0F:not(:placeholder-shown)) .DateInput-module_separator__WIZen {\n  color: #272427;\n}\n\n.DateInput-module_avantiDobInput__-Gd0F {\n  border: none;\n  outline: none;\n  font-family: \"proxima-nova\", sans-serif;\n  font-size: 16px;\n  background-color: transparent;\n  padding-block: 0;\n  padding-inline: 0;\n  color: #272427;\n  direction: ltr;\n}\n\n.DateInput-module_avantiDobInput__-Gd0F::placeholder {\n  color: #7d7d7d;\n  font-weight: 600;\n}\n\n.DateInput-module_avantiDobInput__-Gd0F[class~=\"date-input\"]:placeholder-shown {\n  width: 20px;\n}\n\n.DateInput-module_avantiDobInput__-Gd0F[class~=\"month-input\"]:placeholder-shown {\n  width: 30px;\n}\n\n.DateInput-module_avantiDobInput__-Gd0F[class~=\"date-input\"]:not(:placeholder-shown) {\n  width: 22px;\n}\n\n.DateInput-module_avantiDobInput__-Gd0F[class~=\"month-input\"]:not(:placeholder-shown) {\n  width: 22px;\n}\n\n.DateInput-module_avantiDobInput__-Gd0F[class~=\"year-input\"]:placeholder-shown {\n  width: 40px;\n}\n\n.DateInput-module_avantiDobInput__-Gd0F[class~=\"year-input\"]:not(:placeholder-shown) {\n  width: 43px;\n}\n\n.DateInput-module_separator__WIZen {\n  color: #7d7d7d;\n  -webkit-text-fill-color: #7d7d7d;\n  margin-left: 4px;\n  margin-right: 4px;\n  font-weight: 600;\n  line-height: 24px;\n  font-size: 16px;\n}\n.DateInput-module_disabledSeparator__-jpAP {\n  opacity: 0.7;\n}\n\n.DateInput-module_dobContainer__hWHk9:hover {\n  border: 2px solid rgba(40, 86, 110, 1);\n  background-color: rgba(240, 240, 240, 1);\n  box-shadow: 0px 0px 0px 2px rgba(40, 86, 110, 0.4);\n}\n\n.DateInput-module_dobLabel__axDHE {\n  position: absolute;\n  font-family: \"proxima-nova\", sans-serif;\n  font-size: 16px;\n  color: #4f4f4f;\n  line-height: 24px;\n  font-weight: 600;\n}\n\n.DateInput-module_disabledDobLabel__UnwDq {\n  position: relative;\n  top: -27px;\n  left: -12px;\n  font-family: \"proxima-nova\", sans-serif;\n  font-size: 12px;\n  color: #7D7D7D;\n  background-color: rgba(255, 255, 255, 1);\n  padding: 0 2px;\n  font-weight: 500;\n  line-height: 16px;\n  border-radius: 8px;\n}\n\n.DateInput-module_hoverdDOBLabel__FA5su {\n  background-color: rgba(240, 240, 240, 1) !important;\n}\n\n.DateInput-module_showBorder__ddQ-h {\n  position: relative;\n  top: -24px;\n  left: -12px;\n  font-family: \"proxima-nova\", sans-serif;\n  font-size: 12px;\n  color: #272427;\n  background-color: rgba(255, 255, 255, 1);\n  padding: 0 2px;\n  font-weight: 500;\n  line-height: 16px;\n}\n\n.DateInput-module_showActiveBorder__hUl8U {\n  position: relative;\n  top: -24px;\n  left: -12px;\n  font-family: \"proxima-nova\", sans-serif;\n  font-size: 12px;\n  background-color: rgba(255, 255, 255, 1);\n  color: rgba(54, 143, 233, 1);\n  padding: 0 2px;\n  font-weight: 500;\n  line-height: 16px;\n}\n\n.DateInput-module_MsgClass__77awu {\n  font-size: 14px;\n  font-weight: 600;\n  /* top: 40px; */\n  /* left: -8px; */\n  /* position: absolute; */\n  padding: 8px;\n  /* letter-spacing: 0em; */\n  text-align: left;\n  font-family: \"proxima-nova\", sans-serif !important;\n  /* display: none; */\n}\n\n.DateInput-module_MsgClass__77awu.DateInput-module_errorMsgClass__lyWF1 {\n  color: rgba(202, 48, 43, 1);\n  display: block;\n}\n\n.DateInput-module_MsgClass__77awu.DateInput-module_warningMsgClass__FQbBZ {\n  color: rgba(208, 109, 16, 1);\n  display: block;\n}\n\n.DateInput-module_MsgClass__77awu.DateInput-module_successMsgClass__oO86D {\n  color: rgba(0, 130, 5, 1);\n  display: block;\n}\n\n.DateInput-module_myInput__TaYsW {\n  position: absolute;\n}\n\n.DateInput-module_fontStaysure__1swv6 {\n  font-family: \"proxima-nova\", sans-serif;\n}\n\n.DateInput-module_fontAvanti__p6bUj {\n  font-family: \"faktum\", sans-serif !important;\n  font-weight: 600;\n  /* color: #2e2d2c; */\n}\n";
var Styles$1 = {"dobContainer":"DateInput-module_dobContainer__hWHk9","dobAciveContainer":"DateInput-module_dobAciveContainer__N1hGf","dobDisabledContainer":"DateInput-module_dobDisabledContainer__UIWw7","dobInput":"DateInput-module_dobInput__tW4iD","separator":"DateInput-module_separator__WIZen","error":"DateInput-module_error__KXGIi","avantiDobInput":"DateInput-module_avantiDobInput__-Gd0F","disabledSeparator":"DateInput-module_disabledSeparator__-jpAP","dobLabel":"DateInput-module_dobLabel__axDHE","disabledDobLabel":"DateInput-module_disabledDobLabel__UnwDq","hoverdDOBLabel":"DateInput-module_hoverdDOBLabel__FA5su","showBorder":"DateInput-module_showBorder__ddQ-h","showActiveBorder":"DateInput-module_showActiveBorder__hUl8U","MsgClass":"DateInput-module_MsgClass__77awu","errorMsgClass":"DateInput-module_errorMsgClass__lyWF1","warningMsgClass":"DateInput-module_warningMsgClass__FQbBZ","successMsgClass":"DateInput-module_successMsgClass__oO86D","myInput":"DateInput-module_myInput__TaYsW","fontStaysure":"DateInput-module_fontStaysure__1swv6","fontAvanti":"DateInput-module_fontAvanti__p6bUj"};
styleInject(css_248z$2);

function DateInput(props) {
    const { isError = false, customizedMessage, hintLabel = "Date of Birth", isSuccess = false, isWarning = false, isDisabled = false, dobWrapperClass, onChange, onBlur, defaultDate, dobErrorMsgClass, outerWraperClass, scrollableInputId = "scrollableInput", isDOBScrollable = false, onDateComplete, brand, dayId = "day-input", monthId = "month-input", yearId = "year-input", } = props;
    const [day, setDay] = useState("");
    const [month, setMonth] = useState("");
    const [year, setYear] = useState("");
    const [error, setError] = useState(false);
    const [showLabel, setShowLabel] = useState(!defaultDate);
    const [isScrollable, setIsScrollable] = useState();
    const dayRef = useRef(null);
    const monthRef = useRef(null);
    const yearRef = useRef(null);
    const containerRef = useRef(null);
    const [customErrorMessage, setCustomErrorMessage] = useState();
    const [isTabPressed, setIsTabPressed] = useState(false);
    const [isDOBContainerActive, setIsDOBContainerActive] = useState(false);
    const [initLoad, setInitLoad] = useState(true);
    const [isHovered, setIsHovered] = useState(false);
    const [inputFieldIsSelected, setInputFieldIsSelected] = useState(false);
    const prevCustomizedMessageRef = useRef(undefined);
    const prevIsDOBScrollableRef = useRef(undefined);
    const prevIsErrorRef = useRef(undefined);
    useEffect(() => {
        if (prevCustomizedMessageRef.current !== customizedMessage || defaultDate) {
            setCustomErrorMessage(customizedMessage);
        }
        if (prevIsErrorRef.current !== isError || defaultDate) {
            setError(isError);
        }
        prevCustomizedMessageRef.current = customizedMessage;
        prevIsErrorRef.current = isError;
    }, [customizedMessage, isError, defaultDate]);
    useEffect(() => {
        if (prevIsDOBScrollableRef.current !== isDOBScrollable) {
            setIsScrollable(isDOBScrollable);
        }
        prevIsDOBScrollableRef.current = isDOBScrollable;
    }, [isDOBScrollable]);
    const isIOS = () => typeof navigator !== "undefined" &&
        /iPad|iPhone|iPod/.test(navigator.userAgent);
    const validateDate = (inputDay, inputMonth, inputYear) => {
        var _a, _b;
        const dayNum = parseInt(inputDay, 10);
        const monthNum = parseInt(inputMonth, 10);
        const yearNum = parseInt(inputYear, 10);
        if (!inputDay || !inputMonth || !inputYear) {
            return "";
        }
        if (dayNum === 0 && inputDay.length === 1) {
            return "";
        }
        if (monthNum === 0 && inputMonth.length === 1) {
            return "";
        }
        if (inputDay === "00" && inputDay.length === 2) {
            (_a = dayRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            return "";
        }
        if (inputMonth === "00" && inputMonth.length === 2) {
            (_b = monthRef.current) === null || _b === void 0 ? void 0 : _b.focus();
            return "";
        }
        if (dayNum > 31 || monthNum > 12 || inputYear.length !== 4) {
            return "Invalid Date";
        }
        // Check for invalid dates in February
        if (monthNum === 2) {
            if (dayNum > 29) {
                setError(true);
                return "Invalid Date";
            }
            if (dayNum === 29) {
                // Check if the year is a leap year
                const isLeapYear = (yearNum % 4 === 0 && yearNum % 100 !== 0) || yearNum % 400 === 0;
                if (!isLeapYear) {
                    setError(true);
                    return "Invalid Date";
                }
            }
        }
        const date = new Date(yearNum, monthNum - 1, dayNum);
        if (date.getDate() !== dayNum ||
            date.getMonth() !== monthNum - 1 ||
            date.getFullYear() !== yearNum) {
            setError(true);
            return "Invalid Date";
        }
        return "";
    };
    const handleDate = (dayEntered, monthEntered, yearEntered, isBackSpacePress) => {
        if (onChange && (!initLoad || !defaultDate)) {
            if (yearEntered && monthEntered && dayEntered) {
                const errorMsg = validateDate(dayEntered, monthEntered, yearEntered);
                let inputDate;
                if (!errorMsg) {
                    inputDate = new Date(parseInt(yearEntered, 10), parseInt(monthEntered, 10) - 1, parseInt(dayEntered, 10));
                }
                else {
                    inputDate = "Invalid Date";
                }
                onChange(inputDate);
            }
            else if ((!dayEntered && !monthEntered && !yearEntered) ||
                (dayEntered && monthEntered && !yearEntered && isBackSpacePress) ||
                (dayEntered && !monthEntered && yearEntered && isBackSpacePress) ||
                (!dayEntered && monthEntered && yearEntered && isBackSpacePress)) {
                onChange(null);
            }
        }
    };
    const handleDayChange = (e) => {
        var _a, _b;
        const value = e.target.value.replace(/\D/g, "");
        if (value === "" || (parseInt(value, 10) <= 31 && value.length <= 2)) {
            setDay(value);
            const dayValue = value || "";
            const monthValue = month || "";
            const yearValue = year || "";
            if (value === "00" && value.length === 2) {
                setDay("");
                (_a = dayRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }
            const errorMsg = validateDate(dayValue, monthValue, yearValue);
            setError(errorMsg !== "");
            if (errorMsg === "" && value.length === 2 && value !== "00") {
                if (isIOS()) {
                    // iOS workaround: Delay focus to prevent unwanted scroll
                    setTimeout(() => {
                        var _a;
                        (_a = monthRef.current) === null || _a === void 0 ? void 0 : _a.focus({ preventScroll: true });
                    }, 300);
                }
                else {
                    (_b = monthRef.current) === null || _b === void 0 ? void 0 : _b.focus();
                }
            }
            if (value.length === 2 && value !== "00") {
                handleDate(value, month, year);
            }
        }
    };
    useEffect(() => {
        if (defaultDate) {
            setShowLabel(false);
        }
        if (initLoad && defaultDate) {
            setInitLoad(false);
            setDay(String(defaultDate.getDate()).padStart(2, "0"));
            setMonth(String(defaultDate.getMonth() + 1).padStart(2, "0"));
            setYear(String(defaultDate.getFullYear()));
        }
    }, [defaultDate, initLoad]);
    const dynamicStyleClass = useMemo(() => {
        if (error || isError) {
            return {
                wrapperClass: `${Styles$1.defaultClass} ${Styles$1.errorClass}`,
                msgClassName: `${Styles$1.MsgClass} ${Styles$1.errorMsgClass}`,
            };
        }
        if (isWarning) {
            return {
                wrapperClass: `${Styles$1.defaultClass} ${Styles$1.warningClass}`,
                msgClassName: `${Styles$1.MsgClass} ${Styles$1.warningMsgClass}`,
            };
        }
        if (isSuccess) {
            return {
                wrapperClass: `${Styles$1.defaultClass} ${Styles$1.successClass}`,
                msgClassName: `${Styles$1.MsgClass} ${Styles$1.successMsgClass}`,
            };
        }
        return {
            wrapperClass: Styles$1.defaultClass,
            msgClassName: Styles$1.MsgClass,
        };
    }, [error, isError, isWarning, isSuccess]);
    let labelClassName = "";
    let separatorClassName = "";
    if (isDisabled) {
        separatorClassName = `${Styles$1.separator} ${Styles$1.disabledSeparator}`;
    }
    else {
        separatorClassName = Styles$1.separator;
    }
    if (showLabel) {
        labelClassName = Styles$1.dobLabel;
    }
    else if (isTabPressed && isDOBContainerActive) {
        labelClassName = Styles$1.showActiveBorder;
    }
    else {
        labelClassName = Styles$1.showBorder;
    }
    if (isHovered) {
        labelClassName += ` ${Styles$1.hoverdDOBLabel}`;
    }
    if (isDisabled) {
        labelClassName = `${Styles$1.disabledDobLabel}`;
    }
    let dobContainerClassName = "";
    if (isDisabled) {
        dobContainerClassName = Styles$1.dobDisabledContainer;
    }
    else if (isTabPressed && isDOBContainerActive) {
        dobContainerClassName = Styles$1.dobAciveContainer;
    }
    else {
        dobContainerClassName = Styles$1.dobContainer;
    }
    const handleMonthChange = (e) => {
        var _a, _b;
        const value = e.target.value.replace(/\D/g, "");
        if (value === "" || (parseInt(value, 10) <= 12 && value.length <= 2)) {
            setMonth(value);
            const dayValue = day || "";
            const monthValue = value || "";
            const yearValue = year || "";
            if (value === "00" && value.length === 2) {
                setMonth("");
                (_a = monthRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }
            const errorMsg = validateDate(dayValue, monthValue, yearValue);
            setError(errorMsg !== "");
            if (errorMsg === "" && value.length === 2 && value !== "00") {
                if (isIOS()) {
                    // iOS workaround: Delay focus to prevent unwanted scroll
                    setTimeout(() => {
                        var _a;
                        (_a = yearRef.current) === null || _a === void 0 ? void 0 : _a.focus({ preventScroll: true });
                    }, 300);
                }
                else {
                    (_b = yearRef.current) === null || _b === void 0 ? void 0 : _b.focus();
                }
            }
            if (value.length === 2 && value !== "00") {
                handleDate(day, value, year);
            }
        }
    };
    const handleYearChange = (e) => {
        var _a, _b;
        const value = e.target.value.replace(/\D/g, "");
        if (value.length <= 4) {
            setYear(value);
            setError(false);
            if (value === "0000" && value.length === 4) {
                setYear("");
                (_a = yearRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }
            if (value.length === 4 && value !== "0000") {
                (_b = yearRef.current) === null || _b === void 0 ? void 0 : _b.blur();
            }
        }
        if (day && month && value.length === 4 && value !== "0000") {
            handleDate(day, month, value);
        }
    };
    // useEffect(() => {
    //   if (day.length === 2 && !defaultDate && day !== "00") {
    //     monthRef.current?.focus();
    //   }
    // }, [day, day.length, defaultDate]);
    useEffect(() => {
        if (!day && !month && !year) {
            handleDate(null, null, null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [day, month, year]);
    useEffect(() => {
        const handleClickOutside = (e) => {
            var _a, _b, _c;
            if (containerRef.current &&
                !containerRef.current.contains(e.target)) {
                setIsTabPressed(false);
                if (!day && !month && !year) {
                    setShowLabel(true);
                    (_a = dayRef.current) === null || _a === void 0 ? void 0 : _a.blur();
                    (_b = monthRef.current) === null || _b === void 0 ? void 0 : _b.blur();
                    (_c = yearRef.current) === null || _c === void 0 ? void 0 : _c.blur();
                }
            }
        };
        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, [day, month, year]);
    const scrollInputToTop = () => {
        const inputField = document.getElementById(scrollableInputId);
        if (inputField && isScrollable) {
            inputField.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };
    const handleContainerClick = () => {
        var _a;
        setShowLabel(false);
        if (!day && !month && !year) {
            (_a = dayRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    };
    const handleMouseEnter = () => {
        setIsHovered(true);
    };
    const handleMouseLeave = () => {
        setIsHovered(false);
    };
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Tab") {
                setIsTabPressed(true);
            }
            else {
                setIsTabPressed(false);
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        // Clean up the event listener on component unmount
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);
    const handleDayOnBlue = () => {
        setShowLabel(!day && !month && !year);
        setIsDOBContainerActive(false);
        if (!dayRef.current) {
            return;
        }
        const dayValue = dayRef.current.value;
        if (dayValue === "0" && day.length === 1) {
            setDay("");
        }
        if ((dayValue === "1" ||
            dayValue === "2" ||
            dayValue === "3" ||
            dayValue === "4" ||
            dayValue === "5" ||
            dayValue === "6" ||
            dayValue === "7" ||
            dayValue === "8" ||
            dayValue === "9") &&
            day.length === 1) {
            setDay(`0${dayValue}`);
            handleDate(day, month, year);
        }
    };
    const handleMonthOnBlue = () => {
        if (!monthRef.current) {
            return;
        }
        const monthValue = monthRef.current.value;
        if (monthValue === "0" && month.length === 1) {
            setMonth("");
        }
        if ((monthValue === "1" ||
            monthValue === "2" ||
            monthValue === "3" ||
            monthValue === "4" ||
            monthValue === "5" ||
            monthValue === "6" ||
            monthValue === "7" ||
            monthValue === "8" ||
            monthValue === "9") &&
            month.length === 1) {
            setMonth(`0${monthValue}`);
            handleDate(day, month, year);
        }
    };
    const handleYearOnBlue = () => {
        if (year === "0" || year === "00" || year === "000") {
            setYear("");
        }
    };
    const handleDayKeyDown = (e) => {
        if (inputFieldIsSelected && e.key === "Backspace") {
            handleDate(null, month, year, true);
            return;
        }
        if (e.key === "Backspace") {
            if (day === "01" ||
                day === "02" ||
                day === "03" ||
                day === "04" ||
                day === "05" ||
                day === "06" ||
                day === "07" ||
                day === "08" ||
                day === "09" ||
                day === "0" ||
                day.length === 1) {
                handleDate(null, month, year, true);
            }
        }
    };
    const handleMonthKeyDown = (e) => {
        if (inputFieldIsSelected && e.key === "Backspace") {
            handleDate(day, null, year, true);
            return;
        }
        if (e.key === "Backspace") {
            if (month === "01" ||
                month === "02" ||
                month === "03" ||
                month === "04" ||
                month === "05" ||
                month === "06" ||
                month === "07" ||
                month === "08" ||
                month === "09" ||
                month === "0" ||
                month.length === 1) {
                handleDate(day, null, year, true);
            }
        }
    };
    const handleYearKeyDown = (e) => {
        if (inputFieldIsSelected && e.key === "Backspace") {
            handleDate(day, month, null, true);
            return;
        }
        if (e.key === "Backspace") {
            if (year.length <= 4) {
                handleDate(day, month, null, true);
            }
        }
    };
    const handleDayOnSelect = (event) => {
        const inputElement = event.currentTarget;
        const isSelected = inputElement.selectionStart !== inputElement.selectionEnd;
        if (isSelected) {
            setInputFieldIsSelected(true);
        }
        else {
            setInputFieldIsSelected(false);
        }
    };
    const handleMonthOnSelect = (event) => {
        const inputElement = event.currentTarget;
        const isSelected = inputElement.selectionStart !== inputElement.selectionEnd;
        if (isSelected) {
            setInputFieldIsSelected(true);
        }
        else {
            setInputFieldIsSelected(false);
        }
    };
    const handleYearOnSelect = (event) => {
        const inputElement = event.currentTarget;
        const isSelected = inputElement.selectionStart !== inputElement.selectionEnd;
        if (isSelected) {
            setInputFieldIsSelected(true);
        }
        else {
            setInputFieldIsSelected(false);
        }
    };
    const fontClass = brand === "staysure" ? Styles$1.fontStaysure : Styles$1.fontAvanti;
    const dobInputClass = brand === "staysure" ? Styles$1.dobInput : Styles$1.avantiDobInput;
    const handleMainContainerBlur = (event) => {
        var _a;
        if (!((_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.relatedTarget))) {
            onBlur === null || onBlur === void 0 ? void 0 : onBlur();
        }
    };
    useEffect(() => {
        if (onDateComplete) {
            const typedDigits = `${day || ""}${month || ""}${year || ""}`;
            onDateComplete(typedDigits);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [day, month, year]);
    return (jsxs("div", { role: "button", tabIndex: -1, className: outerWraperClass, onClick: () => scrollInputToTop(), onBlur: handleMainContainerBlur, children: [jsxs("div", { onFocus: () => {
                    setIsDOBContainerActive(true);
                    setShowLabel(false);
                }, className: ` ${dobContainerClassName} ${error ? Styles$1.error : ""} ${dobWrapperClass}`, tabIndex: -1, ref: containerRef, onClick: handleContainerClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, role: "button", id: scrollableInputId, children: [jsx("div", { className: `${labelClassName} ${isHovered || (defaultDate && isDisabled)
                            ? Styles$1.hoverdDOBLabel
                            : ""} ${fontClass}`, children: hintLabel }), jsxs("div", { className: `input-wrapper ${Styles$1.myInput}`, children: [jsx("input", { "data-testid": dayId, onFocus: () => {
                                    var _a;
                                    (_a = dayRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                                }, onBlur: handleDayOnBlue, onSelect: handleDayOnSelect, onKeyDown: handleDayKeyDown, type: "tel", disabled: isDisabled, value: day, onChange: handleDayChange, ref: dayRef, maxLength: 2, placeholder: showLabel ? "" : "dd", className: `${dobInputClass} date-input ${fontClass}` }), !showLabel && jsx("span", { className: separatorClassName, children: "/" }), jsx("input", { "data-testid": monthId, type: "tel", onBlur: handleMonthOnBlue, disabled: isDisabled, value: month, onChange: handleMonthChange, onSelect: handleMonthOnSelect, ref: monthRef, onKeyDown: handleMonthKeyDown, maxLength: 2, placeholder: showLabel ? "" : "mm", className: `${dobInputClass} month-input ${fontClass}` }), !showLabel && jsx("span", { className: separatorClassName, children: "/" }), jsx("input", { "data-testid": yearId, onKeyDown: handleYearKeyDown, onBlur: () => {
                                    // setIsTabPressed(false);
                                    handleYearOnBlue();
                                    setIsDOBContainerActive(false);
                                    setShowLabel(!day && !month && !year);
                                }, type: "tel", disabled: isDisabled, value: year, onChange: handleYearChange, onSelect: handleYearOnSelect, ref: yearRef, maxLength: 4, placeholder: showLabel ? "" : "yyyy", className: `${dobInputClass} year-input ${fontClass}` })] })] }), error && (jsx("div", { className: `${dynamicStyleClass.msgClassName} ${dobErrorMsgClass} ${fontClass}`, children: error ? customErrorMessage : "" }))] }));
}

function DocumentIcon({ testId, size = "M", width, height, stroke = "#272427", strokeWidth = 1.5, fill = "none", id = "", className = "", }) {
    const sizeMap = useMemo(() => getSizeMap(size), [size]);
    return (jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: width !== null && width !== void 0 ? width : sizeMap, height: height !== null && height !== void 0 ? height : sizeMap, "data-testid": testId, viewBox: "0 0 24 24", fill: fill, className: `iconCompLibrary_document_svg_${className}`, id: `iconCompLibrary_document_svg_id_${id}`, children: jsx("path", { d: "M14 2V8H20M14.5 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V7.5L14.5 2Z", stroke: stroke, strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }) }));
}

const defaultBarColors = {
    info: "#006BD6",
    positive: "#008205",
    warning: "#D06D10",
    critical: "#CA302B",
};
const defaultBgColors = {
    info: "#EDF2FF",
    positive: "#E8F7E9",
    warning: "#FFF0E9",
    critical: "#FFEFEF",
};
function NotificationCard({ type, isCloseIconVisible, closeIcon, className, title, description, footerSection, onClose, }) {
    return (jsxs("div", { className: `${className} componet-lib-notificationBar`, style: {
            padding: "8px 12px 8px 8px",
            display: "flex",
            backgroundColor: defaultBgColors[type],
            borderRadius: "8px",
            border: `1px solid ${defaultBarColors[type]}`,
            position: "relative",
        }, children: [jsx("div", { style: { width: "24px" }, children: jsx(Divider, { orientation: "vertical", style: { marginRight: "16px", borderRadius: "4px" }, thickness: 8, className: "componet-lib-notificationBar-Divider", color: defaultBarColors[type] }) }), jsxs("div", { style: {
                    width: "calc(100% - 24px)",
                    paddingTop: "8px",
                    paddingBottom: "8px",
                }, children: [jsxs("div", { style: {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "start",
                        }, className: "componet-lib-notificationBar-headerSection", children: [title && (jsx("div", { className: "componet-lib-notificationBar-title", children: title })), isCloseIconVisible && (jsx("div", { style: {
                                    width: "24px",
                                    height: "24px",
                                    position: "absolute",
                                    right: "16px",
                                    top: "20px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }, className: "componet-lib-notificationBar-closeIcon", children: closeIcon !== undefined ? (closeIcon) : (jsx(Button$1, { style: {
                                        borderColor: "transparent",
                                        backgroundColor: "transparent",
                                        paddingRight: "8px",
                                        cursor: "pointer",
                                        border: "none",
                                        outline: "none",
                                    }, onClick: () => {
                                        if (onClose)
                                            onClose();
                                    }, btnType: "icon", icon: jsx(XIcon, { stroke: "#272427" }), "aria-label": "close" })) }))] }), description && (jsx("div", { className: "componet-lib-notificationBar-description", children: description })), footerSection && (jsx("div", { className: "componet-lib-notificationBar-footerSection", children: footerSection }))] })] }));
}

var css_248z$1 = "@import url(\"https://use.typekit.net/nwl1eft.css\");\n\n.SingleDayPicker-module_defaultClass__MW7qx {\n  width: 196px;\n  height: 56px;\n  gap: 8px;\n  border-radius: 8px;\n  font-family: \"proxima-nova\", sans-serif !important;\n  display: inline-flex;\n  background: none;\n  justify-content: right;\n}\n\n.SingleDayPicker-module_mainWrapper__fU13p :focus-visible {\n  outline: \"2px solid red\" !important;\n  border: \"2px solid blue\";\n}\n\n.SingleDayPicker-module_mainWrapper__fU13p :active {\n  outline: \"2px solid red\" !important;\n  border: \"2px solid blue\";\n}\n\n.SingleDayPicker-module_calendarContainer__IpRiP {\n  width: 308px !important;\n  height: 360px !important;\n  padding: 12px !important;\n  margin-top: 4px !important;\n  font-family: \"proxima-nova\", sans-serif !important;\n  border-radius: 8px;\n  background: #ffffff;\n  border: 1px solid #d2d2d2;\n  box-shadow: 0px 0px 12px 0px #0f172a1c;\n}\n\n.SingleDayPicker-module_errorClass__iOOQO {\n  border: 2px solid rgba(202, 48, 43, 1) !important;\n}\n\n.SingleDayPicker-module_textInput__bpLWj {\n  border: none;\n  outline: none;\n  font-family: \"proxima-nova\", sans-serif;\n  font-size: 16px;\n  background-color: transparent;\n  padding-block: 0;\n  padding-inline: 0;\n  color: #272427;\n  direction: ltr;\n  font-weight: 600;\n  line-height: 24px;\n}\n\n.SingleDayPicker-module_textInput__bpLWj:placeholder-shown {\n  color: rgba(79, 79, 79, 1) !important;\n}\n\n.SingleDayPicker-module_mainWrapper__fU13p:has(input:placeholder-shown) [class~=\"input-label\"] {\n  color: rgba(79, 79, 79, 1);\n}\n\n.SingleDayPicker-module_dayInputField__rhtbh {\n  width: 19px;\n}\n\n.SingleDayPicker-module_monthInputField__9CHyF {\n  width: 19px;\n}\n\n.SingleDayPicker-module_monthInputField__9CHyF:placeholder-shown {\n  width: 27px;\n}\n\n.SingleDayPicker-module_yearInputField__Llej4 {\n  width: 40px;\n}\n\n.SingleDayPicker-module_separator__U9IX8 {\n  color: #7d7d7d;\n}\n\n.SingleDayPicker-module_warningClass__Zjh-T {\n  border: 2px solid rgba(208, 109, 16, 1) !important;\n}\n\n.SingleDayPicker-module_successClass__2h-pX {\n  border: 2px solid rgba(0, 130, 5, 1) !important;\n}\n\n.SingleDayPicker-module_MsgClass__uhqxn {\n  font-size: 14px;\n  font-weight: 600;\n  padding: 8px;\n  letter-spacing: 0em;\n  text-align: left;\n  font-family: \"proxima-nova\", sans-serif !important;\n  display: none;\n}\n\n.SingleDayPicker-module_MsgClass__uhqxn.SingleDayPicker-module_errorMsgClass__AEyO7 {\n  color: rgba(202, 48, 43, 1);\n  display: block;\n}\n\n.SingleDayPicker-module_MsgClass__uhqxn.SingleDayPicker-module_warningMsgClass__obfdD {\n  color: rgba(208, 109, 16, 1);\n  display: block;\n}\n\n.SingleDayPicker-module_MsgClass__uhqxn.SingleDayPicker-module_successMsgClass__i2Nzf {\n  color: rgba(0, 130, 5, 1);\n  display: block;\n}\n\n.SingleDayPicker-module_HintClass__0KSGy {\n  width: 196px;\n  height: 24px;\n  font-family: \"proxima-nova\", sans-serif !important;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  letter-spacing: 0px;\n  text-align: right;\n  color: #4f4f4f;\n  padding: 4px 4px 8px 4px;\n}\n\n.SingleDayPicker-module_highlightPlaceholder__AplYu::placeholder {\n  background-color: #0089fa;\n  font-weight: bold;\n  color: white;\n}\n\n.SingleDayPicker-module_mainWrapper__fU13p [class~=\"input-wrapper\"] {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n  padding: 16px 0px 16px 24px;\n  border-radius: 8px;\n  max-height: 56px;\n}\n\n.SingleDayPicker-module_mainWrapper__fU13p [class~=\"input-label\"] {\n  position: absolute;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 16px;\n  color: #272427;\n  top: -9px;\n  background-color: #fff;\n  z-index: 2;\n  padding: 0 4px;\n  left: 4px;\n}\n\n.SingleDayPicker-module_mainWrapper__fU13p[class~=\"hovered-border\"] [class~=\"input-label\"] {\n  background-color: rgba(240, 240, 240, 1);\n}\n\n.SingleDayPicker-module_mainWrapper__fU13p[class~=\"thick-border\"] [class~=\"input-wrapper\"] {\n  padding-left: 23px;\n  top: -1px;\n}\n\n.SingleDayPicker-module_mainWrapper__fU13p[class~=\"thick-border\"] [class~=\"input-label\"] {\n  left: 3px;\n}\n\n.SingleDayPicker-module_mainWrapper__fU13p [class~=\"calendar-icon-button\"] svg {\n  position: relative;\n}\n\n.SingleDayPicker-module_mainWrapper__fU13p[class~=\"thick-border\"] [class~=\"calendar-icon-button\"] svg {\n  left: -1px;\n  top: -1px;\n}\n\n@media (max-width: 904px) {\n  .SingleDayPicker-module_mainWrapper__fU13p [class~=\"input-wrapper\"] {\n    padding-left: 16px;\n  }\n}\n";
var Styles = {"defaultClass":"SingleDayPicker-module_defaultClass__MW7qx","mainWrapper":"SingleDayPicker-module_mainWrapper__fU13p","calendarContainer":"SingleDayPicker-module_calendarContainer__IpRiP","errorClass":"SingleDayPicker-module_errorClass__iOOQO","textInput":"SingleDayPicker-module_textInput__bpLWj","dayInputField":"SingleDayPicker-module_dayInputField__rhtbh","monthInputField":"SingleDayPicker-module_monthInputField__9CHyF","yearInputField":"SingleDayPicker-module_yearInputField__Llej4","separator":"SingleDayPicker-module_separator__U9IX8","warningClass":"SingleDayPicker-module_warningClass__Zjh-T","successClass":"SingleDayPicker-module_successClass__2h-pX","MsgClass":"SingleDayPicker-module_MsgClass__uhqxn","errorMsgClass":"SingleDayPicker-module_errorMsgClass__AEyO7","warningMsgClass":"SingleDayPicker-module_warningMsgClass__obfdD","successMsgClass":"SingleDayPicker-module_successMsgClass__i2Nzf","HintClass":"SingleDayPicker-module_HintClass__0KSGy","highlightPlaceholder":"SingleDayPicker-module_highlightPlaceholder__AplYu"};
styleInject(css_248z$1);

const CustomizedDateCalendar = styled(DateCalendar) `
  & .MuiDateRangePickerDay-day {
    color: rgba(39, 36, 39, 1) !important;
    font-size: 16px;
    font-weight: 400;
    font-family: "Proxima Nova", ui-sans-serif, system-ui !important;
  }

  & .MuiDayCalendar-header span {
    color: rgba(39, 36, 39, 1) !important;
    font-size: 16px;
    font-weight: 700;
    font-family: "Proxima Nova", ui-sans-serif, system-ui !important;
  }

  & .MuiPickersCalendarHeader-label {
    color: rgba(39, 36, 39, 1) !important;
    font-size: 18px;
    font-weight: 700;
    font-family: "Proxima Nova", ui-sans-serif, system-ui !important;
    margin-top: 5px;
  }

  & .MuiPickersCalendarHeader-switchViewButton {
    display: none !important;
  }

  & .MuiPickersFadeTransitionGroup-root {
    display: flex;
    position: absolute;
    width: 300px;
    justify-content: center;
    padding-bottom: 1px;
    margin-bottom: 1px;
  }

  & .MuiPickersArrowSwitcher-root {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  & .MuiButtonBase-root.MuiPickersArrowSwitcher-button {
    width: auto;
    margin-bottom: 10px;
  }

  & .MuiPickersCalendarHeader-root {
    margin-bottom: 10px;
  }

  &
    .MuiPickersFadeTransitionGroup-root.MuiDateCalendar-viewTransitionContainer {
    margin-top: 68px;
  }

  & .MuiPickersCalendarHeader-root.MuiPickersCalendarHeader-root {
    padding-left: 0px;
  }

  & .MuiPickersDay-root {
    font-size: 16px;
    font-weight: 400;
    font-family: "Proxima Nova", ui-sans-serif, system-ui !important;
  }

  & .MuiButtonBase-root.MuiPickersDay-root.Mui-selected {
    background: #f6b052;
    border-radius: 8px;
  }

  & .MuiPickersYear-yearButton {
    font-size: 16px;
    font-weight: 400;
    font-family: "Proxima Nova", ui-sans-serif, system-ui !important;
    color: rgba(39, 36, 39, 1) !important;
  }

  & .MuiPickersYear-yearButton.Mui-selected {
    background: #f6b052 !important;
  }

  & .MuiPickersArrowSwitcher-root {
    border-bottom: 1px solid rgba(210, 210, 210, 1);
    margin-left: 10px;
    align-items: center !important;
    margin-top: 10px;
  }

  & .MuiButtonBase-root.MuiPickersDay-root {
    color: rgba(39, 36, 39, 1);
  }

  & .MuiPickersCalendarHeader-labelContainer {
    margin-bottom: 5px;
  }

  & .MuiButtonBase-root.MuiPickersDay-root:not(.Mui-selected) {
    border: none;
    border-color: none;
    border-radius: none;
  }

  & .MuiButtonBase-root.MuiPickersDay-root:hover {
    background: #ffd873;
    border-radius: 8px !important;
  }

  & .MuiButtonBase-root.MuiPickersDay-root:not(:hover) {
    -webkit-transition: border-radius 0.3s ease;
    transition: border-radius 0.3s ease;
  }

  & .MuiButtonBase-root.MuiPickersDay-root:focus {
    border: 1px solid #368fe9 !important;
    border-radius: 8px !important;
    background: none;
  }
`;
function SingleDayPicker(props) {
    const { customizedMessage = "Message", isError = false, isSuccess = false, isWarning = false, isDisabled, onChange, minimumDate, maximumDate, classNameCalendar, width, disablePastDates = true, 
    // defaultDate = new Date(
    //   "Wed Jul 17 2024 08:01:54 GMT+0530 (India Standard Time)"
    // ),
    defaultDate, openTo = "day", dateView, isScroolTop = false, activeHoverd = true, isDateClear = false, } = props;
    const [calendarOpen, setCalendarOpen] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);
    const [isActive, setIsActive] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const [isTabPressed, setIsTabPressed] = useState(false);
    const [errorMessage, setErrorMessage] = useState(customizedMessage);
    const [error, setError] = useState(false);
    const [initLoad, setInitLoad] = useState(true);
    // const [year, setYear] = useState<unknown>(null);
    // const [month, setMonth] = useState<unknown>(null);
    // Ref for button
    const ref = useRef(null);
    // const refDiv: RefObject<Element & HTMLDivElement> = useRef(null);
    const dateFieldRef = useRef(null);
    const calendarRef = useRef(null);
    const [day, setDay] = useState("");
    const [month, setMonth] = useState("");
    const [year, setYear] = useState("");
    const dayRef = useRef(null);
    const monthRef = useRef(null);
    const yearRef = useRef(null);
    const validateDate = (inputDay, inputMonth, inputYear) => {
        const dayNum = parseInt(inputDay, 10);
        const monthNum = parseInt(inputMonth, 10);
        const yearNum = parseInt(inputYear, 10);
        if (!inputDay || !inputMonth || !inputYear) {
            return "";
        }
        if (dayNum > 31 || monthNum > 12 || inputYear.length !== 4) {
            return "Invalid Date";
        }
        // Check for invalid dates in February
        if (monthNum === 2) {
            if (dayNum > 29) {
                setError(true);
                return "Invalid Date";
            }
            if (dayNum === 29) {
                // Check if the year is a leap year
                const isLeapYear = (yearNum % 4 === 0 && yearNum % 100 !== 0) || yearNum % 400 === 0;
                if (!isLeapYear) {
                    setError(true);
                    return "Invalid Date";
                }
            }
        }
        const date = new Date(yearNum, monthNum - 1, dayNum);
        if (date.getDate() !== dayNum ||
            date.getMonth() !== monthNum - 1 ||
            date.getFullYear() !== yearNum) {
            setError(true);
            return "Invalid Date";
        }
        return "";
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const handleDate = (date) => {
        if (date) {
            const dateObj = new Date(date);
            setDay(dateObj.getDate().toString().padStart(2, "0"));
            setMonth((dateObj.getMonth() + 1).toString().padStart(2, "0"));
            setYear(dateObj.getFullYear().toString());
        }
        setError(false);
        setSelectedDate(date);
        setCalendarOpen(false);
        if (onChange) {
            onChange(date);
        }
    };
    const handleDayChange = (e) => {
        var _a, _b;
        const value = e.target.value.replace(/\D/g, "");
        if (value === "" || (parseInt(value, 10) <= 31 && value.length <= 2)) {
            setDay(value);
            const dayValue = value || "";
            const monthValue = month || "";
            const yearValue = year || "";
            if (value === "00") {
                setDay("");
                (_a = dayRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                return;
            }
            const errorMsg = validateDate(dayValue, monthValue, yearValue);
            setError(errorMsg !== "");
            setErrorMessage(errorMsg);
            if (errorMsg === "" && value.length === 2) {
                if (month !== "" && year !== "") {
                    const inputDate = new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(value, 10));
                    handleDate(inputDate);
                }
                setDay(value.padStart(2, "0"));
                (_b = monthRef.current) === null || _b === void 0 ? void 0 : _b.focus();
            }
        }
    };
    const handleMonthChange = (e) => {
        var _a, _b;
        const value = e.target.value.replace(/\D/g, "");
        if (value === "" || (parseInt(value, 10) <= 12 && value.length <= 2)) {
            setMonth(value);
            const dayValue = day || "";
            const monthValue = value || "";
            const yearValue = year || "";
            if (value === "00") {
                setMonth("");
                (_a = monthRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                return;
            }
            const errorMsg = validateDate(dayValue, monthValue, yearValue);
            if (errorMsg) {
                setError(true);
                setErrorMessage(errorMsg);
            }
            if (!errorMsg && value.length === 2) {
                if (day !== "" && year !== "") {
                    const inputDate = new Date(parseInt(year, 10), parseInt(value, 10) - 1, parseInt(day, 10));
                    handleDate(inputDate);
                }
                (_b = yearRef.current) === null || _b === void 0 ? void 0 : _b.focus();
            }
        }
    };
    useEffect(() => {
        if (isDateClear) {
            setDay("");
            setMonth("");
            setYear("");
        }
    }, [isDateClear]);
    useEffect(() => {
        if (initLoad && defaultDate && !isDateClear) {
            setInitLoad(false);
            handleDate(defaultDate);
        }
    }, [defaultDate, handleDate, initLoad, isDateClear]);
    useEffect(() => {
        if (isError) {
            setError(isError);
        }
        if (customizedMessage) {
            setErrorMessage(customizedMessage);
        }
    }, [customizedMessage, isError]);
    const handleYearChange = (e) => {
        var _a, _b;
        const value = e.target.value.replace(/\D/g, "");
        if (value.length <= 4) {
            setError(false);
            setYear(value);
            if (value.length === 4) {
                const dayValue = day || "";
                const monthValue = month || "";
                const yearValue = value;
                if (value === "0000") {
                    setYear("");
                    (_a = yearRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                }
                const errorMsg = validateDate(dayValue, monthValue, yearValue);
                if (errorMsg) {
                    setError(true);
                    setErrorMessage(errorMsg);
                }
                else {
                    if (day && month && value.length === 4) {
                        const inputDate = new Date(parseInt(value, 10), parseInt(month, 10) - 1, parseInt(day, 10));
                        handleDate(inputDate);
                    }
                    (_b = yearRef.current) === null || _b === void 0 ? void 0 : _b.blur();
                }
            }
        }
    };
    const handleCalendarOpen = () => {
        if (calendarOpen) {
            setIsActive(false);
            return;
        }
        if (dateFieldRef.current) {
            const inputElement = dateFieldRef.current.querySelectorAll("input");
            if (inputElement.length > 0) {
                inputElement[0].focus();
                setCalendarOpen(true);
                setIsActive(true);
            }
        }
    };
    const scrollInputToTop = () => {
        const inputField = document.getElementById("scrollableInput");
        if (inputField) {
            inputField.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };
    const { buttonProps } = useButton(Object.assign(Object.assign({}, props), { onPress() {
            handleCalendarOpen();
        } }), ref);
    const getDateFieldBorder = useCallback(() => {
        if (isFocused && isTabPressed) {
            return "2px solid #368FE9";
        }
        if (isHovered && activeHoverd && !isDisabled && !isFocused) {
            return "2px solid rgba(40, 86, 110, 1)";
        }
        if (isFocused && calendarOpen) {
            return "2px solid rgba(40, 86, 110, 1)";
        }
        if (isActive) {
            return "2px solid #306582";
        }
        if (isDisabled) {
            return "1px solid #E0E0E0";
        }
        return "1px solid #306582";
    }, [
        isFocused,
        isHovered,
        isDisabled,
        isTabPressed,
        isActive,
        activeHoverd,
        calendarOpen,
    ]);
    const getDateFieldBackgroundColor = useCallback(() => {
        if (isHovered && activeHoverd && !isDisabled && !isFocused) {
            return "#F0F0F0";
        }
        if (isDisabled) {
            return "#F0F0F0";
        }
        return "rgba(255, 255, 255, 1)";
    }, [isHovered, isDisabled, isFocused, activeHoverd]);
    const getDateFieldBoxShadow = useCallback(() => {
        if (isHovered && activeHoverd) {
            return "0px 0px 0px 2px #28566E66";
        }
        return "unset";
    }, [isHovered, activeHoverd]);
    const getAnimationTextLabelBackGroundColor = useCallback(() => {
        if (isHovered && activeHoverd && !isDisabled && !isFocused) {
            return `${selectedDate
                ? "linear-gradient(to top, rgba(240, 240, 240, 1), white)"
                : "rgba(240, 240, 240, 1)"}`;
        }
        if (isDisabled) {
            return `${selectedDate
                ? "linear-gradient(to top, rgba(240, 240, 240, 1), white)"
                : "rgba(240, 240, 240, 1)"}`;
        }
        return "rgba(255, 255, 255, 1)";
    }, [isHovered, selectedDate, isDisabled, isFocused, activeHoverd]);
    const getAnimationTextLabelTextColor = useCallback(() => {
        if (isFocused && isTabPressed)
            return "#368FE9";
        return "#4F4F4F";
    }, [isFocused, isTabPressed]);
    const dateFieldStyle = useMemo(() => {
        return {
            border: getDateFieldBorder(),
            boxShadow: getDateFieldBoxShadow(),
            background: getDateFieldBackgroundColor(),
            animationLabelBackgroundColor: getAnimationTextLabelBackGroundColor(),
            animationLabelTextColor: getAnimationTextLabelTextColor(),
        };
    }, [
        getDateFieldBorder,
        getDateFieldBoxShadow,
        getDateFieldBackgroundColor,
        getAnimationTextLabelBackGroundColor,
        getAnimationTextLabelTextColor,
    ]);
    const dynamicStyleClass = useMemo(() => {
        if (error || isError) {
            return {
                wrapperClass: `${Styles.defaultClass} ${Styles.errorClass}`,
                msgClassName: `${Styles.MsgClass} ${Styles.errorMsgClass}`,
                svgStrokeColor: "rgba(202, 48, 43, 1)",
            };
        }
        if (isWarning) {
            return {
                wrapperClass: `${Styles.defaultClass} ${Styles.warningClass}`,
                msgClassName: `${Styles.MsgClass} ${Styles.warningMsgClass}`,
                svgStrokeColor: "rgba(208, 109, 16, 1)",
            };
        }
        if (isSuccess) {
            return {
                wrapperClass: `${Styles.defaultClass} ${Styles.successClass}`,
                msgClassName: `${Styles.MsgClass} ${Styles.successMsgClass}`,
                svgStrokeColor: "rgba(0, 130, 5, 1)",
            };
        }
        return {
            wrapperClass: Styles.defaultClass,
            msgClassName: Styles.MsgClass,
            svgStrokeColor: "#306582",
        };
    }, [error, isError, isWarning, isSuccess]);
    // set class name based on error, warning, success
    const setClassName = useMemo(() => {
        if (isHovered && activeHoverd && !isDisabled && !isFocused)
            return "thick-border hovered-border";
        if (isFocused && isTabPressed)
            return "thick-border focus-border";
        if (isActive)
            return "thick-border active-border";
        if (error || isError || isWarning)
            return "error-border";
        return "normal-border";
    }, [
        isHovered,
        isDisabled,
        isFocused,
        isTabPressed,
        isActive,
        error,
        isError,
        isWarning,
        activeHoverd,
    ]);
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Tab") {
                setIsTabPressed(true);
            }
            else {
                setIsTabPressed(false);
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        // Clean up the event listener on component unmount
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);
    useEffect(() => {
        if (calendarOpen && isScroolTop) {
            scrollInputToTop();
        }
        const handleOutsideClick = (event) => {
            var _a;
            if (calendarOpen &&
                !((_a = dateFieldRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target)) &&
                calendarRef.current &&
                !calendarRef.current.contains(event.target)) ;
        };
        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, [calendarOpen, isScroolTop]);
    const handleDayKeyDown = useCallback((event) => {
        var _a, _b;
        if (event.key === "Tab" && day.length === 1) {
            setDay(`0${day}`);
            (_a = monthRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            event.preventDefault();
        }
        if (event.key === "Tab" && day === "0") {
            setDay("");
            (_b = monthRef.current) === null || _b === void 0 ? void 0 : _b.focus();
            event.preventDefault();
        }
        const currentDay = parseInt(day, 10);
        if (event.key === "ArrowRight" && monthRef.current) {
            monthRef.current.focus();
            event.preventDefault();
        }
        else if (event.key === "ArrowUp") {
            if (Number.isNaN(currentDay)) {
                const getCurrentDay = new Date().getDate() - 1;
                const newDay = getCurrentDay + 1;
                setDay(newDay.toString().padStart(2, "0"));
                const errorMsg = validateDate(newDay.toString(), month, year);
                setError(true);
                setErrorMessage(errorMsg);
                if (month && year && !errorMsg) {
                    const inputDate = new Date(parseInt(year, 10), parseInt(month, 10) - 1, newDay);
                    handleDate(inputDate);
                }
                event.preventDefault();
            }
            else {
                const newDay = currentDay === 31 ? 1 : currentDay + 1;
                setDay(newDay.toString().padStart(2, "0"));
                const errorMsg = validateDate(newDay.toString(), month, year);
                setError(true);
                setErrorMessage(errorMsg);
                if (month && year && !errorMsg) {
                    const inputDate = new Date(parseInt(year, 10), parseInt(month, 10) - 1, newDay);
                    handleDate(inputDate);
                }
                event.preventDefault();
            }
        }
        else if (event.key === "ArrowDown") {
            if (Number.isNaN(currentDay)) {
                const getCurrentDay = new Date().getDate() + 1;
                const newDay = getCurrentDay - 1;
                setDay(newDay.toString().padStart(2, "0"));
                const errorMsg = validateDate(newDay.toString(), month, year);
                setError(true);
                setErrorMessage(errorMsg);
                if (month && year && !errorMsg) {
                    const inputDate = new Date(parseInt(year, 10), parseInt(month, 10) - 1, newDay);
                    handleDate(inputDate);
                }
                event.preventDefault();
            }
            else {
                const newDay = currentDay === 1 ? 31 : currentDay - 1;
                setDay(newDay.toString().padStart(2, "0"));
                const errorMsg = validateDate(newDay.toString(), month, year);
                setError(true);
                setErrorMessage(errorMsg);
                if (month && year && !errorMsg) {
                    const inputDate = new Date(parseInt(year, 10), parseInt(month, 10) - 1, newDay);
                    handleDate(inputDate);
                }
                event.preventDefault();
            }
        }
    }, [day, handleDate, month, year]);
    const handleMonthKeyDown = useCallback((event) => {
        const currentMonth = parseInt(month, 10);
        if (event.key === "ArrowLeft" && dayRef.current) {
            dayRef.current.focus();
            event.preventDefault();
        }
        else if (event.key === "ArrowRight" && yearRef.current) {
            yearRef.current.focus();
            event.preventDefault();
        }
        else if (event.key === "ArrowUp") {
            if (Number.isNaN(currentMonth)) {
                const getCurrentMonth = new Date().getMonth();
                const newMonth = getCurrentMonth + 1;
                setMonth(newMonth.toString().padStart(2, "0"));
                const errorMsg = validateDate(day, newMonth.toString(), year);
                setError(true);
                setErrorMessage(errorMsg);
                if (day && year && !errorMsg) {
                    const inputDate = new Date(parseInt(year, 10), newMonth - 1, parseInt(day, 10));
                    handleDate(inputDate);
                }
                event.preventDefault();
            }
            else {
                const newMonth = currentMonth === 12 ? 1 : currentMonth + 1;
                setMonth(newMonth.toString().padStart(2, "0"));
                const errorMsg = validateDate(day, newMonth.toString(), year);
                setError(true);
                setErrorMessage(errorMsg);
                if (day && year && !errorMsg) {
                    const inputDate = new Date(parseInt(year, 10), newMonth - 1, parseInt(day, 10));
                    handleDate(inputDate);
                }
                event.preventDefault();
            }
        }
        else if (event.key === "ArrowDown") {
            if (Number.isNaN(currentMonth)) {
                const getCurrentMonth = new Date().getMonth() + 2;
                const newMonth = getCurrentMonth - 1;
                setMonth(newMonth.toString().padStart(2, "0"));
                const errorMsg = validateDate(day, newMonth.toString(), year);
                setError(true);
                setErrorMessage(errorMsg);
                if (day && year && !errorMsg) {
                    const inputDate = new Date(parseInt(year, 10), newMonth - 1, parseInt(day, 10));
                    handleDate(inputDate);
                }
                event.preventDefault();
            }
            else {
                const newMonth = currentMonth === 1 ? 12 : currentMonth - 1;
                setMonth(newMonth.toString().padStart(2, "0"));
                const errorMsg = validateDate(day, newMonth.toString(), year);
                setError(true);
                setErrorMessage(errorMsg);
                if (day && year && !errorMsg) {
                    const inputDate = new Date(parseInt(year, 10), newMonth - 1, parseInt(day, 10));
                    handleDate(inputDate);
                }
                event.preventDefault();
            }
        }
    }, [day, month, year, handleDate]);
    const handleYearKeyDown = useCallback((event) => {
        var _a;
        const currentYear = parseInt(year, 10);
        if (event.key === "Tab" && year <= "999") {
            setYear("");
            (_a = yearRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            // event.preventDefault();
        }
        if (event.key === "ArrowLeft" && monthRef.current) {
            monthRef.current.focus();
            event.preventDefault();
        }
        else if (event.key === "ArrowUp") {
            if (Number.isNaN(currentYear)) {
                const getCurrentYear = new Date().getFullYear() - 1;
                const newYear = getCurrentYear + 1;
                setYear(newYear.toString());
                const errorMsg = validateDate(day, month, newYear.toString());
                setError(true);
                setErrorMessage(errorMsg);
                if (day && month && !errorMsg) {
                    const inputDate = new Date(newYear, parseInt(month, 10) - 1, parseInt(day, 10));
                    handleDate(inputDate);
                }
                event.preventDefault();
            }
            else {
                const newYear = currentYear + 1;
                setYear(newYear.toString());
                const errorMsg = validateDate(day, month, newYear.toString());
                setError(true);
                setErrorMessage(errorMsg);
                if (day && month && !errorMsg) {
                    const inputDate = new Date(newYear, parseInt(month, 10) - 1, parseInt(day, 10));
                    handleDate(inputDate);
                }
                event.preventDefault();
            }
        }
        else if (event.key === "ArrowDown") {
            if (Number.isNaN(currentYear)) {
                const getCurrentYear = new Date().getFullYear() + 1;
                const newYear = getCurrentYear - 1;
                setYear(newYear.toString());
                const errorMsg = validateDate(day, month, newYear.toString());
                setError(true);
                setErrorMessage(errorMsg);
                if (day && month && !errorMsg) {
                    const inputDate = new Date(newYear, parseInt(month, 10) - 1, parseInt(day, 10));
                    handleDate(inputDate);
                }
                event.preventDefault();
            }
            else {
                const newYear = currentYear - 1;
                setYear(newYear.toString());
                const errorMsg = validateDate(day, month, newYear.toString());
                setError(true);
                setErrorMessage(errorMsg);
                if (day && month && !errorMsg) {
                    const inputDate = new Date(newYear, parseInt(month, 10) - 1, parseInt(day, 10));
                    handleDate(inputDate);
                }
                event.preventDefault();
            }
        }
    }, [day, month, year, handleDate]);
    const handleHighlightFocus = (e) => {
        e.target.select();
        {
            e.target.classList.add(Styles.highlightPlaceholder);
        }
    };
    const handleHighlightBlur = (e) => {
        e.target.classList.remove(Styles.highlightPlaceholder);
    };
    const handleDayOnBlue = (e) => {
        handleHighlightBlur(e);
        if (!dayRef.current) {
            return;
        }
        const dayValue = dayRef.current.value;
        if (dayValue === "0" && day.length === 1) {
            setDay("");
        }
        if ((dayValue === "1" ||
            dayValue === "2" ||
            dayValue === "3" ||
            dayValue === "4" ||
            dayValue === "5" ||
            dayValue === "6" ||
            dayValue === "7" ||
            dayValue === "8" ||
            dayValue === "9") &&
            day.length === 1) {
            setDay(`0${dayValue}`);
        }
    };
    const handleMonthOnBlue = (e) => {
        handleHighlightBlur(e);
        if (!monthRef.current) {
            return;
        }
        const monthValue = monthRef.current.value;
        if (monthValue === "0" && month.length === 1) {
            setMonth("");
        }
        if ((monthValue === "1" ||
            monthValue === "2" ||
            monthValue === "3" ||
            monthValue === "4" ||
            monthValue === "5" ||
            monthValue === "6" ||
            monthValue === "7" ||
            monthValue === "8" ||
            monthValue === "9") &&
            month.length === 1) {
            setMonth(`0${monthValue}`);
        }
    };
    const handleYearOnBlue = (e) => {
        handleHighlightBlur(e);
        if (year === "0" || year === "00" || year === "000") {
            setYear("");
        }
    };
    return (jsxs(LocalizationProvider, { dateAdapter: AdapterDateFns, children: [jsxs("div", { id: "scrollableInput", className: `${dynamicStyleClass.wrapperClass} ${setClassName} ${Styles.mainWrapper}`, onFocus: () => {
                    setIsFocused(true);
                }, onBlur: () => {
                    setIsFocused(false);
                }, onMouseEnter: () => setIsHovered(true), onMouseLeave: () => setIsHovered(false), style: {
                    border: dateFieldStyle.border,
                    boxShadow: dateFieldStyle.boxShadow,
                    background: dateFieldStyle.background,
                    minWidth: "196px",
                    width,
                }, children: [jsxs("div", { style: {
                            backgroundColor: dateFieldStyle.background,
                        }, className: "input-wrapper", children: [jsx("label", { htmlFor: "startDay", className: "input-label", children: "From" }), jsx("input", { "data-testid": "day-input", onKeyDown: handleDayKeyDown, type: "tel", placeholder: "dd", id: "startDay", value: day, onChange: handleDayChange, onFocus: handleHighlightFocus, onBlur: handleDayOnBlue, ref: dayRef, maxLength: 2, autoComplete: "off", className: `${Styles.dayInputField} ${Styles.textInput}` }), jsx("span", { className: Styles.separator, children: " / " }), jsx("input", { type: "tel", max: 12, min: 1, maxLength: 2, onKeyDown: handleMonthKeyDown, value: month, ref: monthRef, onChange: handleMonthChange, onFocus: handleHighlightFocus, onBlur: handleMonthOnBlue, placeholder: "mm", id: "month", autoComplete: "off", required: true, 
                                // disabled={isInputDisabled}
                                className: `${Styles.monthInputField} ${Styles.textInput}` }), jsx("span", { className: Styles.separator, children: " / " }), jsx("input", { type: "tel", max: 9999, min: 1000, maxLength: 4, ref: yearRef, value: year, onKeyDown: handleYearKeyDown, onChange: handleYearChange, onFocus: handleHighlightFocus, onBlur: handleYearOnBlue, placeholder: "yyyy", id: "startYear", autoComplete: "off", required: true, 
                                // disabled={isInputDisabled}
                                className: `${Styles.yearInputField} ${Styles.textInput}` })] }), jsx("button", Object.assign({}, buttonProps, { ref: ref, onKeyDown: (event) => {
                            if (event.key === "Tab") {
                                setCalendarOpen(calendarOpen);
                            }
                        }, onClick: () => {
                            setCalendarOpen(!calendarOpen);
                            scrollInputToTop();
                        }, type: "button", style: {
                            background: "#F0F0F0",
                            minWidth: "56px",
                            height: "56px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "none",
                            borderRadius: "0px 8px 8px 0px",
                            outline: "none",
                        }, "aria-label": "calendar", className: "calendar-icon-button", children: jsx(CalendarIcon, { width: 24, height: 24, stroke: dynamicStyleClass.svgStrokeColor }) }))] }), jsx("div", { className: `${dynamicStyleClass.msgClassName}`, children: errorMessage }), jsx("div", { style: { width: "304px" }, className: "customize_calender_wrapper single_date_picker_wrapper", ref: calendarRef, children: calendarOpen && (jsx(CustomizedDateCalendar, { openTo: openTo, onChange: (value, selectionState) => {
                        handleDate(value);
                        if (selectionState && selectionState === "finish") {
                            setCalendarOpen(false);
                        }
                    }, slots: {
                        leftArrowIcon: ChevronLeftIcon,
                        rightArrowIcon: ChevronRightIcon,
                    }, value: selectedDate !== null && selectedDate !== void 0 ? selectedDate : defaultDate, defaultValue: defaultDate, dayOfWeekFormatter: (_day) => {
                        return _day;
                    }, className: `${Styles.calendarContainer} ${classNameCalendar}`, minDate: minimumDate, maxDate: maximumDate, disablePast: disablePastDates, views: dateView })) })] }));
}

// eslint-disable-next-line import/prefer-default-export
function ratePerformance(rating) {
    if (rating >= 0 && rating <= 1) {
        return "Poor";
    }
    if (rating > 1 && rating <= 2) {
        return "Fair";
    }
    if (rating > 2 && rating <= 3) {
        return "Good";
    }
    if (rating > 3 && rating <= 4) {
        return "Very Good";
    }
    if (rating > 4 && rating <= 5) {
        return "Excellent";
    }
    return "Invalid Rating";
}

function TrustPilotLogo({ testId }) {
    return (jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: "116", height: "29", viewBox: "0 0 116 29", fill: "none", "data-testid": testId, children: [jsxs("g", { clipPath: "url(#clip0_5662_2826)", children: [jsx("path", { d: "M30.7531 10.0728H42.3839V12.259H37.8107V24.5489H35.2959V12.259H30.7429V10.0728H30.7531ZM41.887 14.0672H44.0367V16.09H44.0773C44.1483 15.804 44.2801 15.5281 44.4728 15.2625C44.6654 14.9969 44.8987 14.7415 45.1725 14.527C45.4462 14.3022 45.7504 14.1285 46.0851 13.9855C46.4197 13.8527 46.7645 13.7812 47.1092 13.7812C47.3729 13.7812 47.5655 13.7914 47.6669 13.8016C47.7683 13.8118 47.8698 13.8323 47.9813 13.8425V16.0696C47.8191 16.0389 47.6568 16.0185 47.4844 15.9981C47.312 15.9776 47.1498 15.9674 46.9876 15.9674C46.6022 15.9674 46.2372 16.0491 45.8924 16.2024C45.5476 16.3556 45.2536 16.5906 45.0001 16.8869C44.7466 17.1933 44.5438 17.5611 44.3917 18.0106C44.2396 18.4601 44.1686 18.9709 44.1686 19.5532V24.5387H41.8769V14.0672H41.887ZM58.517 24.5489H56.2659V23.088H56.2253C55.9414 23.6192 55.5256 24.0381 54.9679 24.3548C54.4102 24.6715 53.8423 24.8349 53.2643 24.8349C51.8954 24.8349 50.9017 24.4978 50.2933 23.8133C49.6848 23.1289 49.3806 22.097 49.3806 20.7179V14.0672H51.6723V20.4931C51.6723 21.4126 51.8447 22.0664 52.1996 22.4444C52.5444 22.8224 53.0413 23.0165 53.67 23.0165C54.1567 23.0165 54.5522 22.945 54.8766 22.7917C55.2011 22.6385 55.4648 22.4444 55.6574 22.189C55.8602 21.9438 56.0022 21.6373 56.0935 21.29C56.1847 20.9426 56.2253 20.5646 56.2253 20.156V14.0774H58.517V24.5489ZM62.421 21.1878C62.4919 21.8621 62.7455 22.332 63.1815 22.6078C63.6277 22.8735 64.1549 23.0165 64.7735 23.0165C64.9864 23.0165 65.2298 22.9961 65.5036 22.9654C65.7774 22.9348 66.041 22.8632 66.2743 22.7713C66.5176 22.6794 66.7103 22.5363 66.8725 22.3524C67.0246 22.1686 67.0956 21.9336 67.0855 21.6373C67.0753 21.3411 66.9638 21.0959 66.761 20.912C66.5582 20.7179 66.3047 20.5749 65.9903 20.4523C65.676 20.3399 65.3211 20.2377 64.9155 20.156C64.5098 20.0743 64.1042 19.9823 63.6885 19.8904C63.2626 19.7984 62.8469 19.6758 62.4514 19.543C62.0559 19.4102 61.701 19.2263 61.3867 18.9914C61.0723 18.7666 60.8188 18.4703 60.6363 18.1128C60.4436 17.7552 60.3524 17.3159 60.3524 16.7847C60.3524 16.2126 60.4943 15.7427 60.7681 15.3545C61.0419 14.9662 61.3968 14.6598 61.8126 14.4248C62.2384 14.1898 62.7049 14.0264 63.222 13.9242C63.7392 13.8323 64.2361 13.7812 64.7025 13.7812C65.2399 13.7812 65.7571 13.8425 66.2438 13.9549C66.7306 14.0672 67.1767 14.2511 67.5722 14.5167C67.9677 14.7721 68.2922 15.1093 68.5558 15.5179C68.8194 15.9266 68.9817 16.4271 69.0527 17.0095H66.6596C66.548 16.4578 66.3047 16.0798 65.9092 15.8959C65.5137 15.7018 65.0574 15.6099 64.5504 15.6099C64.3882 15.6099 64.1955 15.6201 63.9724 15.6507C63.7493 15.6814 63.5465 15.7324 63.3437 15.804C63.1511 15.8755 62.9888 15.9878 62.8469 16.1309C62.715 16.2739 62.6441 16.4578 62.6441 16.6928C62.6441 16.9788 62.7455 17.2036 62.9381 17.3772C63.1308 17.5509 63.3843 17.6939 63.6986 17.8165C64.013 17.9289 64.3679 18.0311 64.7735 18.1128C65.1791 18.1945 65.5949 18.2865 66.0207 18.3784C66.4365 18.4703 66.8421 18.5929 67.2477 18.7257C67.6533 18.8586 68.0082 19.0424 68.3226 19.2774C68.6369 19.5124 68.8904 19.7984 69.0831 20.1458C69.2758 20.4931 69.3772 20.9324 69.3772 21.4432C69.3772 22.0664 69.2352 22.5874 68.9513 23.0267C68.6673 23.4558 68.3023 23.8133 67.8561 24.079C67.41 24.3446 66.9029 24.5489 66.3554 24.6715C65.8078 24.7941 65.2602 24.8554 64.7228 24.8554C64.0637 24.8554 63.4553 24.7839 62.8976 24.6306C62.3398 24.4774 61.8531 24.2526 61.4475 23.9564C61.0419 23.6499 60.7174 23.2719 60.4842 22.8224C60.251 22.3729 60.1293 21.8314 60.109 21.2082H62.421V21.1878ZM69.9856 14.0672H71.7195V10.9207H74.0112V14.0672H76.0798V15.7937H74.0112V21.3921C74.0112 21.6373 74.0214 21.8416 74.0417 22.0255C74.0619 22.1992 74.1126 22.3524 74.1836 22.475C74.2546 22.5976 74.3661 22.6896 74.5182 22.7509C74.6704 22.8122 74.863 22.8428 75.1267 22.8428C75.2889 22.8428 75.4511 22.8428 75.6134 22.8326C75.7756 22.8224 75.9379 22.802 76.1001 22.7611V24.5489C75.8466 24.5795 75.5931 24.6 75.3599 24.6306C75.1165 24.6613 74.8732 24.6715 74.6197 24.6715C74.0112 24.6715 73.5245 24.6102 73.1595 24.4978C72.7944 24.3854 72.5003 24.2118 72.2975 23.987C72.0846 23.7623 71.9528 23.4864 71.8717 23.1493C71.8007 22.8122 71.75 22.424 71.7398 21.9949V15.8142H70.0059V14.0672H69.9856ZM77.7023 14.0672H79.8723V15.4873H79.9128C80.2373 14.8743 80.6835 14.4452 81.2615 14.1796C81.8395 13.914 82.458 13.7812 83.1374 13.7812C83.9588 13.7812 84.6686 13.9242 85.277 14.2205C85.8854 14.5065 86.3925 14.9049 86.7981 15.4157C87.2037 15.9266 87.4977 16.5191 87.7005 17.1933C87.9033 17.8676 88.0047 18.5929 88.0047 19.3591C88.0047 20.0641 87.9135 20.7485 87.731 21.4024C87.5484 22.0664 87.2746 22.6487 86.9096 23.1595C86.5446 23.6703 86.0781 24.0687 85.5102 24.3752C84.9424 24.6817 84.2833 24.8349 83.5126 24.8349C83.178 24.8349 82.8434 24.8043 82.5087 24.743C82.1741 24.6817 81.8496 24.5795 81.5454 24.4467C81.2412 24.3139 80.9472 24.1403 80.6936 23.9257C80.43 23.7112 80.2171 23.466 80.0345 23.1902H79.994V28.4208H77.7023V14.0672ZM85.7131 19.3183C85.7131 18.8483 85.6522 18.3886 85.5305 17.9391C85.4089 17.4896 85.2263 17.1014 84.983 16.7541C84.7396 16.4067 84.4354 16.1309 84.0805 15.9266C83.7154 15.7222 83.2997 15.6099 82.8332 15.6099C81.8699 15.6099 81.1398 15.947 80.6531 16.6212C80.1664 17.2955 79.923 18.1945 79.923 19.3183C79.923 19.8495 79.9838 20.3399 80.1157 20.7894C80.2475 21.2389 80.43 21.6271 80.6936 21.954C80.9472 22.2809 81.2514 22.5363 81.6063 22.7202C81.9612 22.9143 82.3769 23.0063 82.8434 23.0063C83.3707 23.0063 83.8067 22.8939 84.1717 22.6794C84.5368 22.4648 84.8308 22.1788 85.0641 21.8416C85.2973 21.4943 85.4697 21.1061 85.5711 20.6668C85.6623 20.2275 85.7131 19.778 85.7131 19.3183ZM89.759 10.0728H92.0507V12.259H89.759V10.0728ZM89.759 14.0672H92.0507V24.5489H89.759V14.0672ZM94.099 10.0728H96.3907V24.5489H94.099V10.0728ZM103.418 24.8349C102.586 24.8349 101.846 24.6919 101.197 24.4161C100.548 24.1403 100.001 23.752 99.5443 23.2719C99.0981 22.7815 98.7534 22.1992 98.5202 21.5249C98.2869 20.8507 98.1652 20.1049 98.1652 19.2978C98.1652 18.501 98.2869 17.7654 98.5202 17.0912C98.7534 16.4169 99.0981 15.8346 99.5443 15.3442C99.9905 14.8539 100.548 14.4759 101.197 14.2C101.846 13.9242 102.586 13.7812 103.418 13.7812C104.249 13.7812 104.99 13.9242 105.639 14.2C106.288 14.4759 106.835 14.8641 107.291 15.3442C107.738 15.8346 108.082 16.4169 108.316 17.0912C108.549 17.7654 108.671 18.501 108.671 19.2978C108.671 20.1049 108.549 20.8507 108.316 21.5249C108.082 22.1992 107.738 22.7815 107.291 23.2719C106.845 23.7623 106.288 24.1403 105.639 24.4161C104.99 24.6919 104.249 24.8349 103.418 24.8349ZM103.418 23.0063C103.925 23.0063 104.371 22.8939 104.746 22.6794C105.121 22.4648 105.426 22.1788 105.669 21.8314C105.912 21.4841 106.085 21.0857 106.206 20.6464C106.318 20.2071 106.379 19.7576 106.379 19.2978C106.379 18.8483 106.318 18.4091 106.206 17.9595C106.095 17.51 105.912 17.1218 105.669 16.7745C105.426 16.4271 105.121 16.1513 104.746 15.9368C104.371 15.7222 103.925 15.6099 103.418 15.6099C102.911 15.6099 102.465 15.7222 102.09 15.9368C101.714 16.1513 101.41 16.4374 101.167 16.7745C100.923 17.1218 100.751 17.51 100.629 17.9595C100.518 18.4091 100.457 18.8483 100.457 19.2978C100.457 19.7576 100.518 20.2071 100.629 20.6464C100.741 21.0857 100.923 21.4841 101.167 21.8314C101.41 22.1788 101.714 22.4648 102.09 22.6794C102.465 22.9041 102.911 23.0063 103.418 23.0063ZM109.34 14.0672H111.074V10.9207H113.365V14.0672H115.434V15.7937H113.365V21.3921C113.365 21.6373 113.376 21.8416 113.396 22.0255C113.416 22.1992 113.467 22.3524 113.538 22.475C113.609 22.5976 113.72 22.6896 113.872 22.7509C114.025 22.8122 114.217 22.8428 114.481 22.8428C114.643 22.8428 114.805 22.8428 114.968 22.8326C115.13 22.8224 115.292 22.802 115.454 22.7611V24.5489C115.201 24.5795 114.947 24.6 114.714 24.6306C114.471 24.6613 114.227 24.6715 113.974 24.6715C113.365 24.6715 112.879 24.6102 112.514 24.4978C112.149 24.3854 111.855 24.2118 111.652 23.987C111.439 23.7623 111.307 23.4864 111.226 23.1493C111.155 22.8122 111.104 22.424 111.094 21.9949V15.8142H109.36V14.0672H109.34Z", fill: "white", className: "fillText" }), jsx("path", { d: "M28.0761 10.073H17.5708L14.326 0L11.0709 10.073L0.565674 10.0628L9.07332 16.2946L5.81831 26.3574L14.326 20.1358L22.8235 26.3574L19.5786 16.2946L28.0761 10.073Z", fill: "#00B67A", className: "fillStar" }), jsx("path", { d: "M20.3089 18.5726L19.5788 16.2944L14.3262 20.1357L20.3089 18.5726Z", fill: "#005128", className: "fillStartInnerPart" })] }), jsx("defs", { children: jsx("clipPath", { id: "clip0_5662_2826", children: jsx("rect", { width: "114.868", height: "28.4211", fill: "white", transform: "translate(0.565674)" }) }) })] }));
}

const FIVE_STAR_ID = "Trustpilot_ratings_FiveStar";
function FiveStar() {
    return (jsx("g", { id: FIVE_STAR_ID, stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", children: jsx("g", { children: jsxs("g", { children: [jsx("rect", { id: "Rectangle-path1", fill: "#00B67A", fillRule: "nonzero", x: "0", y: "0", width: "96", height: "96" }), jsx("rect", { id: "Rectangle-path2", fill: "#00B67A", fillRule: "nonzero", x: "104", y: "0", width: "96", height: "96" }), jsx("rect", { id: "Rectangle-path3", fill: "#00B67A", fillRule: "nonzero", x: "208", y: "0", width: "96", height: "96" }), jsx("rect", { id: "Rectangle-path4", fill: "#00B67A", fillRule: "nonzero", x: "312", y: "0", width: "96", height: "96" }), jsx("rect", { id: "Rectangle-path5", fill: "#00B67A", fillRule: "nonzero", x: "416", y: "0", width: "96", height: "96" }), jsx("path", { d: "M48,64.7 L62.6,61 L68.7,79.8 L48,64.7 Z M81.6,40.4 L55.9,40.4 L48,16.2 L40.1,40.4 L14.4,40.4 L35.2,55.4 L27.3,79.6 L48.1,64.6 L60.9,55.4 L81.6,40.4 L81.6,40.4 L81.6,40.4 L81.6,40.4 Z", id: "Shape1", fill: "#FFFFFF", fillRule: "nonzero" }), jsx("path", { d: "M152,64.7 L166.6,61 L172.7,79.8 L152,64.7 Z M185.6,40.4 L159.9,40.4 L152,16.2 L144.1,40.4 L118.4,40.4 L139.2,55.4 L131.3,79.6 L152.1,64.6 L164.9,55.4 L185.6,40.4 L185.6,40.4 L185.6,40.4 L185.6,40.4 Z", id: "Shape2", fill: "#FFFFFF", fillRule: "nonzero" }), jsx("path", { d: "M256,64.7 L270.6,61 L276.7,79.8 L256,64.7 Z M289.6,40.4 L263.9,40.4 L256,16.2 L248.1,40.4 L222.4,40.4 L243.2,55.4 L235.3,79.6 L256.1,64.6 L268.9,55.4 L289.6,40.4 L289.6,40.4 L289.6,40.4 L289.6,40.4 Z", id: "Shape3", fill: "#FFFFFF", fillRule: "nonzero" }), jsx("path", { d: "M360,64.7 L374.6,61 L380.7,79.8 L360,64.7 Z M393.6,40.4 L367.9,40.4 L360,16.2 L352.1,40.4 L326.4,40.4 L347.2,55.4 L339.3,79.6 L360.1,64.6 L372.9,55.4 L393.6,40.4 L393.6,40.4 L393.6,40.4 L393.6,40.4 Z", id: "Shape4", fill: "#FFFFFF", fillRule: "nonzero" }), jsx("path", { d: "M464,64.7 L478.6,61 L484.7,79.8 L464,64.7 Z M497.6,40.4 L471.9,40.4 L464,16.2 L456.1,40.4 L430.4,40.4 L451.2,55.4 L443.3,79.6 L464.1,64.6 L476.9,55.4 L497.6,40.4 L497.6,40.4 L497.6,40.4 L497.6,40.4 Z", id: "Shape5", fill: "#FFFFFF", fillRule: "nonzero" })] }) }) }));
}

const FOUR_HALF_STAR_ID = "Trustpilot_ratings_FourHalfStar";
function FourHalfStar() {
    return (jsx("g", { id: FOUR_HALF_STAR_ID, stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", children: jsx("g", { children: jsxs("g", { children: [jsx("rect", { id: "Rectangle-path1", fill: "#00B67A", fillRule: "nonzero", x: "0", y: "0", width: "96", height: "96" }), jsx("rect", { id: "Rectangle-path2", fill: "#00B67A", fillRule: "nonzero", x: "104", y: "0", width: "96", height: "96" }), jsx("rect", { id: "Rectangle-path3", fill: "#00B67A", fillRule: "nonzero", x: "208", y: "0", width: "96", height: "96" }), jsx("rect", { id: "Rectangle-path4", fill: "#00B67A", fillRule: "nonzero", x: "312", y: "0", width: "96", height: "96" }), jsxs("g", { id: "Half", transform: "translate(416.000000, 0.000000)", fillRule: "nonzero", children: [jsx("rect", { id: "Rectangle-path5", fill: "#DCDCE6", x: "48", y: "0", width: "48", height: "96" }), jsx("rect", { id: "Rectangle-path6", fill: "#00B67A", x: "0", y: "0", width: "48", height: "96" })] }), jsx("path", { d: "M48,64.7 L62.6,61 L68.7,79.8 L48,64.7 Z M81.6,40.4 L55.9,40.4 L48,16.2 L40.1,40.4 L14.4,40.4 L35.2,55.4 L27.3,79.6 L48.1,64.6 L60.9,55.4 L81.6,40.4 L81.6,40.4 L81.6,40.4 L81.6,40.4 Z", id: "Shape1", fill: "#FFFFFF", fillRule: "nonzero" }), jsx("path", { d: "M152,64.7 L166.6,61 L172.7,79.8 L152,64.7 Z M185.6,40.4 L159.9,40.4 L152,16.2 L144.1,40.4 L118.4,40.4 L139.2,55.4 L131.3,79.6 L152.1,64.6 L164.9,55.4 L185.6,40.4 L185.6,40.4 L185.6,40.4 L185.6,40.4 Z", id: "Shape2", fill: "#FFFFFF", fillRule: "nonzero" }), jsx("path", { d: "M256,64.7 L270.6,61 L276.7,79.8 L256,64.7 Z M289.6,40.4 L263.9,40.4 L256,16.2 L248.1,40.4 L222.4,40.4 L243.2,55.4 L235.3,79.6 L256.1,64.6 L268.9,55.4 L289.6,40.4 L289.6,40.4 L289.6,40.4 L289.6,40.4 Z", id: "Shape3", fill: "#FFFFFF", fillRule: "nonzero" }), jsx("path", { d: "M360,64.7 L374.6,61 L380.7,79.8 L360,64.7 Z M393.6,40.4 L367.9,40.4 L360,16.2 L352.1,40.4 L326.4,40.4 L347.2,55.4 L339.3,79.6 L360.1,64.6 L372.9,55.4 L393.6,40.4 L393.6,40.4 L393.6,40.4 L393.6,40.4 Z", id: "Shape4", fill: "#FFFFFF", fillRule: "nonzero" }), jsx("path", { d: "M464,64.7 L478.6,61 L484.7,79.8 L464,64.7 Z M497.6,40.4 L471.9,40.4 L464,16.2 L456.1,40.4 L430.4,40.4 L451.2,55.4 L443.3,79.6 L464.1,64.6 L476.9,55.4 L497.6,40.4 L497.6,40.4 L497.6,40.4 L497.6,40.4 Z", id: "Shape5", fill: "#FFFFFF", fillRule: "nonzero" })] }) }) }));
}

const FOUR_STAR_ID = "Trustpilot_ratings_FourStar";
function FourStar() {
    return (jsx("g", { id: FOUR_STAR_ID, stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", children: jsx("g", { children: jsxs("g", { children: [jsx("rect", { id: "Rectangle-path1", fill: "#73CF11", fillRule: "nonzero", x: "0", y: "0", width: "96", height: "96" }), jsx("rect", { id: "Rectangle-path2", fill: "#73CF11", fillRule: "nonzero", x: "104", y: "0", width: "96", height: "96" }), jsx("rect", { id: "Rectangle-path3", fill: "#73CF11", fillRule: "nonzero", x: "208", y: "0", width: "96", height: "96" }), jsx("rect", { id: "Rectangle-path4", fill: "#73CF11", fillRule: "nonzero", x: "312", y: "0", width: "96", height: "96" }), jsx("rect", { id: "Rectangle-path5", fill: "#DCDCE6", fillRule: "nonzero", x: "416", y: "0", width: "96", height: "96" }), jsx("path", { d: "M48,64.7 L62.6,61 L68.7,79.8 L48,64.7 Z M81.6,40.4 L55.9,40.4 L48,16.2 L40.1,40.4 L14.4,40.4 L35.2,55.4 L27.3,79.6 L48.1,64.6 L60.9,55.4 L81.6,40.4 L81.6,40.4 L81.6,40.4 L81.6,40.4 Z", id: "Shape1", fill: "#FFFFFF", fillRule: "nonzero" }), jsx("path", { d: "M152,64.7 L166.6,61 L172.7,79.8 L152,64.7 Z M185.6,40.4 L159.9,40.4 L152,16.2 L144.1,40.4 L118.4,40.4 L139.2,55.4 L131.3,79.6 L152.1,64.6 L164.9,55.4 L185.6,40.4 L185.6,40.4 L185.6,40.4 L185.6,40.4 Z", id: "Shape2", fill: "#FFFFFF", fillRule: "nonzero" }), jsx("path", { d: "M256,64.7 L270.6,61 L276.7,79.8 L256,64.7 Z M289.6,40.4 L263.9,40.4 L256,16.2 L248.1,40.4 L222.4,40.4 L243.2,55.4 L235.3,79.6 L256.1,64.6 L268.9,55.4 L289.6,40.4 L289.6,40.4 L289.6,40.4 L289.6,40.4 Z", id: "Shape3", fill: "#FFFFFF", fillRule: "nonzero" }), jsx("path", { d: "M360,64.7 L374.6,61 L380.7,79.8 L360,64.7 Z M393.6,40.4 L367.9,40.4 L360,16.2 L352.1,40.4 L326.4,40.4 L347.2,55.4 L339.3,79.6 L360.1,64.6 L372.9,55.4 L393.6,40.4 L393.6,40.4 L393.6,40.4 L393.6,40.4 Z", id: "Shape4", fill: "#FFFFFF", fillRule: "nonzero" }), jsx("path", { d: "M464,64.7 L478.6,61 L484.7,79.8 L464,64.7 Z M497.6,40.4 L471.9,40.4 L464,16.2 L456.1,40.4 L430.4,40.4 L451.2,55.4 L443.3,79.6 L464.1,64.6 L476.9,55.4 L497.6,40.4 L497.6,40.4 L497.6,40.4 L497.6,40.4 Z", id: "Shape5", fill: "#FFFFFF", fillRule: "nonzero" })] }) }) }));
}

const ONE_HALF_STAR_ID = "Trustpilot_ratings_OneHalfStar";
function OneHalfStar() {
    return (jsx("g", { id: ONE_HALF_STAR_ID, stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", children: jsxs("g", { fillRule: "nonzero", children: [jsx("rect", { id: "Rectangle-path1", fill: "#FF3722", x: "0", y: "0", width: "96", height: "96" }), jsx("rect", { id: "Rectangle-path2", fill: "#DCDCE6", x: "104", y: "0", width: "96", height: "96" }), jsx("rect", { id: "Rectangle-path3", fill: "#FF3722", x: "104", y: "0", width: "48", height: "96" }), jsx("rect", { id: "Rectangle-path4", fill: "#DCDCE6", x: "208", y: "0", width: "96", height: "96" }), jsx("rect", { id: "Rectangle-path5", fill: "#DCDCE6", x: "312", y: "0", width: "96", height: "96" }), jsx("rect", { id: "Rectangle-path6", fill: "#DCDCE6", x: "416", y: "0", width: "96", height: "96" }), jsx("path", { d: "M48,64.7 L62.6,61 L68.7,79.8 L48,64.7 Z M81.6,40.4 L55.9,40.4 L48,16.2 L40.1,40.4 L14.4,40.4 L35.2,55.4 L27.3,79.6 L48.1,64.6 L60.9,55.4 L81.6,40.4 L81.6,40.4 L81.6,40.4 L81.6,40.4 Z", id: "Shape1", fill: "#FFFFFF" }), jsx("path", { d: "M152,64.7 L166.6,61 L172.7,79.8 L152,64.7 Z M185.6,40.4 L159.9,40.4 L152,16.2 L144.1,40.4 L118.4,40.4 L139.2,55.4 L131.3,79.6 L152.1,64.6 L164.9,55.4 L185.6,40.4 L185.6,40.4 L185.6,40.4 L185.6,40.4 Z", id: "Shape2", fill: "#FFFFFF" }), jsx("path", { d: "M256,64.7 L270.6,61 L276.7,79.8 L256,64.7 Z M289.6,40.4 L263.9,40.4 L256,16.2 L248.1,40.4 L222.4,40.4 L243.2,55.4 L235.3,79.6 L256.1,64.6 L268.9,55.4 L289.6,40.4 L289.6,40.4 L289.6,40.4 L289.6,40.4 Z", id: "Shape3", fill: "#FFFFFF" }), jsx("path", { d: "M360,64.7 L374.6,61 L380.7,79.8 L360,64.7 Z M393.6,40.4 L367.9,40.4 L360,16.2 L352.1,40.4 L326.4,40.4 L347.2,55.4 L339.3,79.6 L360.1,64.6 L372.9,55.4 L393.6,40.4 L393.6,40.4 L393.6,40.4 L393.6,40.4 Z", id: "Shape4", fill: "#FFFFFF" }), jsx("path", { d: "M464,64.7 L478.6,61 L484.7,79.8 L464,64.7 Z M497.6,40.4 L471.9,40.4 L464,16.2 L456.1,40.4 L430.4,40.4 L451.2,55.4 L443.3,79.6 L464.1,64.6 L476.9,55.4 L497.6,40.4 L497.6,40.4 L497.6,40.4 L497.6,40.4 Z", id: "Shape5", fill: "#FFFFFF" })] }) }));
}

function OneStar() {
    return (jsx("g", { id: "Trustpilot_ratings_OneStar", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", children: jsx("g", { children: jsxs("g", { children: [jsx("rect", { id: "Rectangle-path1", fill: "#FF3722", fillRule: "nonzero", x: "0", y: "0", width: "96", height: "96" }), jsx("rect", { id: "Rectangle-path2", fill: "#DCDCE6", fillRule: "nonzero", x: "104", y: "0", width: "96", height: "96" }), jsx("rect", { id: "Rectangle-path3", fill: "#DCDCE6", fillRule: "nonzero", x: "208", y: "0", width: "96", height: "96" }), jsx("rect", { id: "Rectangle-path4", fill: "#DCDCE6", fillRule: "nonzero", x: "312", y: "0", width: "96", height: "96" }), jsx("rect", { id: "Rectangle-path5", fill: "#DCDCE6", fillRule: "nonzero", x: "416", y: "0", width: "96", height: "96" }), jsx("path", { d: "M48,64.7 L62.6,61 L68.7,79.8 L48,64.7 Z M81.6,40.4 L55.9,40.4 L48,16.2 L40.1,40.4 L14.4,40.4 L35.2,55.4 L27.3,79.6 L48.1,64.6 L60.9,55.4 L81.6,40.4 L81.6,40.4 L81.6,40.4 L81.6,40.4 Z", id: "Shape1", fill: "#FFFFFF", fillRule: "nonzero" }), jsx("path", { d: "M152,64.7 L166.6,61 L172.7,79.8 L152,64.7 Z M185.6,40.4 L159.9,40.4 L152,16.2 L144.1,40.4 L118.4,40.4 L139.2,55.4 L131.3,79.6 L152.1,64.6 L164.9,55.4 L185.6,40.4 L185.6,40.4 L185.6,40.4 L185.6,40.4 Z", id: "Shape2", fill: "#FFFFFF", fillRule: "nonzero" }), jsx("path", { d: "M256,64.7 L270.6,61 L276.7,79.8 L256,64.7 Z M289.6,40.4 L263.9,40.4 L256,16.2 L248.1,40.4 L222.4,40.4 L243.2,55.4 L235.3,79.6 L256.1,64.6 L268.9,55.4 L289.6,40.4 L289.6,40.4 L289.6,40.4 L289.6,40.4 Z", id: "Shape3", fill: "#FFFFFF", fillRule: "nonzero" }), jsx("path", { d: "M360,64.7 L374.6,61 L380.7,79.8 L360,64.7 Z M393.6,40.4 L367.9,40.4 L360,16.2 L352.1,40.4 L326.4,40.4 L347.2,55.4 L339.3,79.6 L360.1,64.6 L372.9,55.4 L393.6,40.4 L393.6,40.4 L393.6,40.4 L393.6,40.4 Z", id: "Shape4", fill: "#FFFFFF", fillRule: "nonzero" }), jsx("path", { d: "M464,64.7 L478.6,61 L484.7,79.8 L464,64.7 Z M497.6,40.4 L471.9,40.4 L464,16.2 L456.1,40.4 L430.4,40.4 L451.2,55.4 L443.3,79.6 L464.1,64.6 L476.9,55.4 L497.6,40.4 L497.6,40.4 L497.6,40.4 L497.6,40.4 Z", id: "Shape5", fill: "#FFFFFF", fillRule: "nonzero" })] }) }) }));
}

const THREE_HALF_STAR_ID = "Trustpilot_ratings_ThreeHalfStar";
function ThreeHalfStar() {
    return (jsx("g", { id: THREE_HALF_STAR_ID, stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", children: jsxs("g", { id: "Trustpilot_ratings_3star-RGB-Copy-3", fillRule: "nonzero", children: [jsx("rect", { id: "Rectangle-path1", fill: "#FFCE00", x: "0", y: "0", width: "96", height: "96" }), jsx("rect", { id: "Rectangle-path2", fill: "#FFCE00", x: "104", y: "0", width: "96", height: "96" }), jsx("rect", { id: "Rectangle-path3", fill: "#FFCE00", x: "208", y: "0", width: "96", height: "96" }), jsx("rect", { id: "Rectangle-path4", fill: "#DCDCE6", x: "312", y: "0", width: "96", height: "96" }), jsx("rect", { id: "Rectangle-path5", fill: "#FFCE00", x: "312", y: "0", width: "48", height: "96" }), jsx("rect", { id: "Rectangle-path6", fill: "#DCDCE6", x: "416", y: "0", width: "96", height: "96" }), jsx("path", { d: "M48,64.7 L62.6,61 L68.7,79.8 L48,64.7 Z M81.6,40.4 L55.9,40.4 L48,16.2 L40.1,40.4 L14.4,40.4 L35.2,55.4 L27.3,79.6 L48.1,64.6 L60.9,55.4 L81.6,40.4 L81.6,40.4 L81.6,40.4 L81.6,40.4 Z", id: "Shape1", fill: "#FFFFFF" }), jsx("path", { d: "M152,64.7 L166.6,61 L172.7,79.8 L152,64.7 Z M185.6,40.4 L159.9,40.4 L152,16.2 L144.1,40.4 L118.4,40.4 L139.2,55.4 L131.3,79.6 L152.1,64.6 L164.9,55.4 L185.6,40.4 L185.6,40.4 L185.6,40.4 L185.6,40.4 Z", id: "Shape2", fill: "#FFFFFF" }), jsx("path", { d: "M256,64.7 L270.6,61 L276.7,79.8 L256,64.7 Z M289.6,40.4 L263.9,40.4 L256,16.2 L248.1,40.4 L222.4,40.4 L243.2,55.4 L235.3,79.6 L256.1,64.6 L268.9,55.4 L289.6,40.4 L289.6,40.4 L289.6,40.4 L289.6,40.4 Z", id: "Shape3", fill: "#FFFFFF" }), jsx("path", { d: "M360,64.7 L374.6,61 L380.7,79.8 L360,64.7 Z M393.6,40.4 L367.9,40.4 L360,16.2 L352.1,40.4 L326.4,40.4 L347.2,55.4 L339.3,79.6 L360.1,64.6 L372.9,55.4 L393.6,40.4 L393.6,40.4 L393.6,40.4 L393.6,40.4 Z", id: "Shape4", fill: "#FFFFFF" }), jsx("path", { d: "M464,64.7 L478.6,61 L484.7,79.8 L464,64.7 Z M497.6,40.4 L471.9,40.4 L464,16.2 L456.1,40.4 L430.4,40.4 L451.2,55.4 L443.3,79.6 L464.1,64.6 L476.9,55.4 L497.6,40.4 L497.6,40.4 L497.6,40.4 L497.6,40.4 Z", id: "Shape5", fill: "#FFFFFF" })] }) }));
}

const THREE_STAR_ID = "Trustpilot_ratings_ThreeStar";
function ThreeStar() {
    return (jsx("g", { id: THREE_STAR_ID, stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", children: jsx("g", { children: jsxs("g", { children: [jsx("rect", { id: "Rectangle-path1", fill: "#FFCE00", fillRule: "nonzero", x: "0", y: "0", width: "96", height: "96" }), jsx("rect", { id: "Rectangle-path2", fill: "#FFCE00", fillRule: "nonzero", x: "104", y: "0", width: "96", height: "96" }), jsx("rect", { id: "Rectangle-path3", fill: "#FFCE00", fillRule: "nonzero", x: "208", y: "0", width: "96", height: "96" }), jsx("rect", { id: "Rectangle-path4", fill: "#DCDCE6", fillRule: "nonzero", x: "312", y: "0", width: "96", height: "96" }), jsx("rect", { id: "Rectangle-path5", fill: "#DCDCE6", fillRule: "nonzero", x: "416", y: "0", width: "96", height: "96" }), jsx("path", { d: "M48,64.7 L62.6,61 L68.7,79.8 L48,64.7 Z M81.6,40.4 L55.9,40.4 L48,16.2 L40.1,40.4 L14.4,40.4 L35.2,55.4 L27.3,79.6 L48.1,64.6 L60.9,55.4 L81.6,40.4 L81.6,40.4 L81.6,40.4 L81.6,40.4 Z", id: "Shape1", fill: "#FFFFFF", fillRule: "nonzero" }), jsx("path", { d: "M152,64.7 L166.6,61 L172.7,79.8 L152,64.7 Z M185.6,40.4 L159.9,40.4 L152,16.2 L144.1,40.4 L118.4,40.4 L139.2,55.4 L131.3,79.6 L152.1,64.6 L164.9,55.4 L185.6,40.4 L185.6,40.4 L185.6,40.4 L185.6,40.4 Z", id: "Shape2", fill: "#FFFFFF", fillRule: "nonzero" }), jsx("path", { d: "M256,64.7 L270.6,61 L276.7,79.8 L256,64.7 Z M289.6,40.4 L263.9,40.4 L256,16.2 L248.1,40.4 L222.4,40.4 L243.2,55.4 L235.3,79.6 L256.1,64.6 L268.9,55.4 L289.6,40.4 L289.6,40.4 L289.6,40.4 L289.6,40.4 Z", id: "Shape3", fill: "#FFFFFF", fillRule: "nonzero" }), jsx("path", { d: "M360,64.7 L374.6,61 L380.7,79.8 L360,64.7 Z M393.6,40.4 L367.9,40.4 L360,16.2 L352.1,40.4 L326.4,40.4 L347.2,55.4 L339.3,79.6 L360.1,64.6 L372.9,55.4 L393.6,40.4 L393.6,40.4 L393.6,40.4 L393.6,40.4 Z", id: "Shape4", fill: "#FFFFFF", fillRule: "nonzero" }), jsx("path", { d: "M464,64.7 L478.6,61 L484.7,79.8 L464,64.7 Z M497.6,40.4 L471.9,40.4 L464,16.2 L456.1,40.4 L430.4,40.4 L451.2,55.4 L443.3,79.6 L464.1,64.6 L476.9,55.4 L497.6,40.4 L497.6,40.4 L497.6,40.4 L497.6,40.4 Z", id: "Shape5", fill: "#FFFFFF", fillRule: "nonzero" })] }) }) }));
}

const TWO_HALF_STAR_ID = "Trustpilot_ratings_TwoHalfStar";
function TwoHalfStar() {
    return (jsx("g", { id: TWO_HALF_STAR_ID, stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", children: jsxs("g", { fillRule: "nonzero", children: [jsx("rect", { id: "Rectangle-path1", fill: "#FF8622", x: "0", y: "0", width: "96", height: "96" }), jsx("rect", { id: "Rectangle-path2", fill: "#FF8622", x: "104", y: "0", width: "96", height: "96" }), jsx("rect", { id: "Rectangle-path3", fill: "#DCDCE6", x: "208", y: "0", width: "96", height: "96" }), jsx("rect", { id: "Rectangle-path4", fill: "#FF8622", x: "208", y: "0", width: "48", height: "96" }), jsx("rect", { id: "Rectangle-path5", fill: "#DCDCE6", x: "312", y: "0", width: "96", height: "96" }), jsx("rect", { id: "Rectangle-path6", fill: "#DCDCE6", x: "416", y: "0", width: "96", height: "96" }), jsx("path", { d: "M48,64.7 L62.6,61 L68.7,79.8 L48,64.7 Z M81.6,40.4 L55.9,40.4 L48,16.2 L40.1,40.4 L14.4,40.4 L35.2,55.4 L27.3,79.6 L48.1,64.6 L60.9,55.4 L81.6,40.4 L81.6,40.4 L81.6,40.4 L81.6,40.4 Z", id: "Shape1", fill: "#FFFFFF" }), jsx("path", { d: "M152,64.7 L166.6,61 L172.7,79.8 L152,64.7 Z M185.6,40.4 L159.9,40.4 L152,16.2 L144.1,40.4 L118.4,40.4 L139.2,55.4 L131.3,79.6 L152.1,64.6 L164.9,55.4 L185.6,40.4 L185.6,40.4 L185.6,40.4 L185.6,40.4 Z", id: "Shape2", fill: "#FFFFFF" }), jsx("path", { d: "M256,64.7 L270.6,61 L276.7,79.8 L256,64.7 Z M289.6,40.4 L263.9,40.4 L256,16.2 L248.1,40.4 L222.4,40.4 L243.2,55.4 L235.3,79.6 L256.1,64.6 L268.9,55.4 L289.6,40.4 L289.6,40.4 L289.6,40.4 L289.6,40.4 Z", id: "Shape3", fill: "#FFFFFF" }), jsx("path", { d: "M360,64.7 L374.6,61 L380.7,79.8 L360,64.7 Z M393.6,40.4 L367.9,40.4 L360,16.2 L352.1,40.4 L326.4,40.4 L347.2,55.4 L339.3,79.6 L360.1,64.6 L372.9,55.4 L393.6,40.4 L393.6,40.4 L393.6,40.4 L393.6,40.4 Z", id: "Shape4", fill: "#FFFFFF" }), jsx("path", { d: "M464,64.7 L478.6,61 L484.7,79.8 L464,64.7 Z M497.6,40.4 L471.9,40.4 L464,16.2 L456.1,40.4 L430.4,40.4 L451.2,55.4 L443.3,79.6 L464.1,64.6 L476.9,55.4 L497.6,40.4 L497.6,40.4 L497.6,40.4 L497.6,40.4 Z", id: "Shape5", fill: "#FFFFFF" })] }) }));
}

const TWO_STAR_ID = "Trustpilot_ratings_TwoStar";
function TwoStar() {
    return (jsx("g", { id: TWO_STAR_ID, stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", children: jsx("g", { children: jsxs("g", { children: [jsx("rect", { id: "Rectangle-path1", fill: "#FF8622", fillRule: "nonzero", x: "0", y: "0", width: "96", height: "96" }), jsx("rect", { id: "Rectangle-path2", fill: "#FF8622", fillRule: "nonzero", x: "104", y: "0", width: "96", height: "96" }), jsx("rect", { id: "Rectangle-path3", fill: "#DCDCE6", fillRule: "nonzero", x: "208", y: "0", width: "96", height: "96" }), jsx("rect", { id: "Rectangle-path4", fill: "#DCDCE6", fillRule: "nonzero", x: "312", y: "0", width: "96", height: "96" }), jsx("rect", { id: "Rectangle-path5", fill: "#DCDCE6", fillRule: "nonzero", x: "416", y: "0", width: "96", height: "96" }), jsx("path", { d: "M48,64.7 L62.6,61 L68.7,79.8 L48,64.7 Z M81.6,40.4 L55.9,40.4 L48,16.2 L40.1,40.4 L14.4,40.4 L35.2,55.4 L27.3,79.6 L48.1,64.6 L60.9,55.4 L81.6,40.4 L81.6,40.4 L81.6,40.4 L81.6,40.4 Z", id: "Shape1", fill: "#FFFFFF", fillRule: "nonzero" }), jsx("path", { d: "M152,64.7 L166.6,61 L172.7,79.8 L152,64.7 Z M185.6,40.4 L159.9,40.4 L152,16.2 L144.1,40.4 L118.4,40.4 L139.2,55.4 L131.3,79.6 L152.1,64.6 L164.9,55.4 L185.6,40.4 L185.6,40.4 L185.6,40.4 L185.6,40.4 Z", id: "Shape2", fill: "#FFFFFF", fillRule: "nonzero" }), jsx("path", { d: "M256,64.7 L270.6,61 L276.7,79.8 L256,64.7 Z M289.6,40.4 L263.9,40.4 L256,16.2 L248.1,40.4 L222.4,40.4 L243.2,55.4 L235.3,79.6 L256.1,64.6 L268.9,55.4 L289.6,40.4 L289.6,40.4 L289.6,40.4 L289.6,40.4 Z", id: "Shape3", fill: "#FFFFFF", fillRule: "nonzero" }), jsx("path", { d: "M360,64.7 L374.6,61 L380.7,79.8 L360,64.7 Z M393.6,40.4 L367.9,40.4 L360,16.2 L352.1,40.4 L326.4,40.4 L347.2,55.4 L339.3,79.6 L360.1,64.6 L372.9,55.4 L393.6,40.4 L393.6,40.4 L393.6,40.4 L393.6,40.4 Z", id: "Shape4", fill: "#FFFFFF", fillRule: "nonzero" }), jsx("path", { d: "M464,64.7 L478.6,61 L484.7,79.8 L464,64.7 Z M497.6,40.4 L471.9,40.4 L464,16.2 L456.1,40.4 L430.4,40.4 L451.2,55.4 L443.3,79.6 L464.1,64.6 L476.9,55.4 L497.6,40.4 L497.6,40.4 L497.6,40.4 L497.6,40.4 Z", id: "Shape5", fill: "#FFFFFF", fillRule: "nonzero" })] }) }) }));
}

const ZERO_STAR_ID = "Trustpilot_ratings_ZeroStar";
function ZeroStar() {
    return (jsx("g", { id: ZERO_STAR_ID, stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", children: jsx("g", { children: jsxs("g", { children: [jsx("rect", { id: "Rectangle-path1", fill: "#DCDCE6", fillRule: "nonzero", x: "0", y: "0", width: "96", height: "96" }), jsx("rect", { id: "Rectangle-path2", fill: "#DCDCE6", fillRule: "nonzero", x: "104", y: "0", width: "96", height: "96" }), jsx("rect", { id: "Rectangle-path3", fill: "#DCDCE6", fillRule: "nonzero", x: "208", y: "0", width: "96", height: "96" }), jsx("rect", { id: "Rectangle-path4", fill: "#DCDCE6", fillRule: "nonzero", x: "312", y: "0", width: "96", height: "96" }), jsx("rect", { id: "Rectangle-path5", fill: "#DCDCE6", fillRule: "nonzero", x: "416", y: "0", width: "96", height: "96" }), jsx("path", { d: "M48,64.7 L62.6,61 L68.7,79.8 L48,64.7 Z M81.6,40.4 L55.9,40.4 L48,16.2 L40.1,40.4 L14.4,40.4 L35.2,55.4 L27.3,79.6 L48.1,64.6 L60.9,55.4 L81.6,40.4 L81.6,40.4 L81.6,40.4 L81.6,40.4 Z", id: "Shape1", fill: "#FFFFFF", fillRule: "nonzero" }), jsx("path", { d: "M152,64.7 L166.6,61 L172.7,79.8 L152,64.7 Z M185.6,40.4 L159.9,40.4 L152,16.2 L144.1,40.4 L118.4,40.4 L139.2,55.4 L131.3,79.6 L152.1,64.6 L164.9,55.4 L185.6,40.4 L185.6,40.4 L185.6,40.4 L185.6,40.4 Z", id: "Shape2", fill: "#FFFFFF", fillRule: "nonzero" }), jsx("path", { d: "M256,64.7 L270.6,61 L276.7,79.8 L256,64.7 Z M289.6,40.4 L263.9,40.4 L256,16.2 L248.1,40.4 L222.4,40.4 L243.2,55.4 L235.3,79.6 L256.1,64.6 L268.9,55.4 L289.6,40.4 L289.6,40.4 L289.6,40.4 L289.6,40.4 Z", id: "Shape3", fill: "#FFFFFF", fillRule: "nonzero" }), jsx("path", { d: "M360,64.7 L374.6,61 L380.7,79.8 L360,64.7 Z M393.6,40.4 L367.9,40.4 L360,16.2 L352.1,40.4 L326.4,40.4 L347.2,55.4 L339.3,79.6 L360.1,64.6 L372.9,55.4 L393.6,40.4 L393.6,40.4 L393.6,40.4 L393.6,40.4 Z", id: "Shape4", fill: "#FFFFFF", fillRule: "nonzero" }), jsx("path", { d: "M464,64.7 L478.6,61 L484.7,79.8 L464,64.7 Z M497.6,40.4 L471.9,40.4 L464,16.2 L456.1,40.4 L430.4,40.4 L451.2,55.4 L443.3,79.6 L464.1,64.6 L476.9,55.4 L497.6,40.4 L497.6,40.4 L497.6,40.4 L497.6,40.4 Z", id: "Shape5", fill: "#FFFFFF", fillRule: "nonzero" })] }) }) }));
}

function TrustPilotStars(_a) {
    var { rating = 5 } = _a, props = __rest(_a, ["rating"]);
    return (jsxs("svg", Object.assign({ viewBox: "0 0 512 96", height: "28.421px", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", "aria-labelledby": "trust-pilot-rating-title trust-pilot-rating-desc", role: "img" }, props, { children: [jsx("title", { id: "trust-pilot-rating-title", children: {
                    0: "Trustpilot Zero stars rating",
                    1: "Trustpilot One star",
                    1.5: "Trustpilot One and a half stars rating",
                    2: "Trustpilot Two stars rating",
                    2.5: "Trustpilot Two and a half stars rating",
                    3: "Trustpilot Three stars rating",
                    3.5: "Trustpilot Three and a half stars rating",
                    4: "Trustpilot Four stars rating",
                    4.5: "Trustpilot Four and a half stars rating",
                    5: "Trustpilot Five stars rating",
                }[rating] }), jsx("desc", { id: "trust-pilot-rating-desc", children: "An illustration of the Trustpilot Stars Logo" }), rating === 0 && jsx(ZeroStar, {}), rating > 0 && rating <= 1 && jsx(OneStar, {}), rating > 1 && rating <= 1.5 && jsx(OneHalfStar, {}), rating > 1.5 && rating <= 2 && jsx(TwoStar, {}), rating > 2 && rating <= 2.5 && jsx(TwoHalfStar, {}), rating > 2.5 && rating <= 3 && jsx(ThreeStar, {}), rating > 3 && rating <= 3.5 && jsx(ThreeHalfStar, {}), rating > 3.5 && rating <= 4 && jsx(FourStar, {}), rating > 4 && rating <= 4.8 && jsx(FourHalfStar, {}), rating > 4.8 && rating <= 5 && jsx(FiveStar, {})] })));
}

var css_248z = ".TrustpilotMini-module_textElement__nBcXV {\n  font-family: Helvetica, Arial, sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16px;\n}\n\n@media (min-width: 768px) {\n  .TrustpilotMini-module_textElement__nBcXV {\n    font-size: 14.211px;\n    line-height: 18.947px;\n  }\n}\n\n.TrustpilotMini-module_textElementBold__PDdcv {\n  font-family: Helvetica, Arial, sans-serif;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 16px;\n}\n\n@media (min-width: 768px) {\n  .TrustpilotMini-module_textElementBold__PDdcv {\n    font-size: 14.211px;\n    line-height: 18.947px;\n  }\n}\n\n.TrustpilotMini-module_flexColumnCentered__oSbQ3 {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.TrustpilotMini-module_textCenter__WB8Ef {\n  text-align: center;\n  justify-content: center;\n}\n\n.TrustpilotMini-module_trustpilotRatingsUrl__2Z0t5 {\n  text-decoration: none;\n}\n\n.TrustpilotMini-module_trustpilotStars__DacnR {\n  margin-top: 7.015px;\n  margin-bottom: 7.015px;\n}\n";
var styles = {"textElement":"TrustpilotMini-module_textElement__nBcXV","textElementBold":"TrustpilotMini-module_textElementBold__PDdcv","flexColumnCentered":"TrustpilotMini-module_flexColumnCentered__oSbQ3","textCenter":"TrustpilotMini-module_textCenter__WB8Ef","trustpilotRatingsUrl":"TrustpilotMini-module_trustpilotRatingsUrl__2Z0t5","trustpilotStars":"TrustpilotMini-module_trustpilotStars__DacnR"};
styleInject(css_248z);

/**
 * @visibleName Trustpilot
 */
function Trustpilot({ rating }) {
    return (jsxs("div", { "data-testid": "trustpilot-id", 
        // className="flex flex-col items-center justify-center"
        className: styles.flexColumnCentered, children: [jsx(TrustPilotLogo, {}), jsx(TrustPilotStars, { className: styles.trustpilotStars, rating: rating })] }));
}

function TrustpilotMini({ stars = 0, score, link, totalReviews, trustpilotClassName = "", }) {
    return (jsx("div", { "data-testid": "trustpilot-rating", children: jsxs("a", { href: link, target: "_blank", rel: "noreferrer", className: `${styles.trustpilotRatingsUrl} ${trustpilotClassName}`, children: [jsx(Trustpilot, { rating: stars }), jsxs("div", { className: styles.textCenter, children: [jsx("span", { className: `frontTextPerformance ${styles.textElement}`, children: score
                                ? ratePerformance(score)
                                : "\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0" }), jsxs("span", { className: `middleTextScore ${styles.textElementBold}`, children: [" ", score ||
                                    "\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0", " ", "|", " ", (totalReviews && totalReviews.toLocaleString()) ||
                                    "\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0", " "] }), jsx("span", { className: `endTextReviews ${styles.textElement}`, children: "reviews" })] })] }) }));
}

function PlusIcon({ testId, size = "M", width, height, stroke = "#272427", strokeWidth = 1, fill = "none", className, id, }) {
    const sizeMap = useMemo(() => getSizeMap(size), [size]);
    return (jsx("svg", { "data-testid": testId, width: width !== null && width !== void 0 ? width : sizeMap, height: height !== null && height !== void 0 ? height : sizeMap, viewBox: "0 0 24 24", fill: fill, xmlns: "http://www.w3.org/2000/svg", className: className, id: id, children: jsx("g", { id: "Plus", children: jsx("path", { id: "Vector", d: "M12 5V19M5 12H19", stroke: stroke !== null && stroke !== void 0 ? stroke : "currentColor", strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }) }) }));
}

function VisaCardIcon({ testId, size = "M", width, height, fill = "none", }) {
    const sizeMap = useMemo(() => getSizeMap(size), [size]);
    return (jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: width !== null && width !== void 0 ? width : sizeMap, height: height !== null && height !== void 0 ? height : sizeMap, "data-testid": testId, viewBox: "0 0 49 32", fill: "none", className: "iconCompLibrary_visaIcon_svg", id: "iconCompLibrary_visa_icon_svg_id", children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.9363 23.6592H8.77465L5.65395 11.4034C5.50583 10.8396 5.19132 10.3412 4.7287 10.1063C3.57416 9.516 2.30194 9.0462 0.914062 8.80925V8.3374H7.61808C8.54333 8.3374 9.23727 9.0462 9.35293 9.86938L10.9721 18.7099L15.1317 8.3374H19.1776L12.9363 23.6592ZM21.4904 23.6592H17.5601L20.7964 8.3374H24.7267L21.4904 23.6592ZM29.8115 12.5823C29.9272 11.7571 30.6211 11.2853 31.4307 11.2853C32.703 11.1668 34.0888 11.4037 35.2454 11.992L35.9393 8.69317C34.7827 8.22132 33.5105 7.98438 32.356 7.98438C28.5413 7.98438 25.7656 10.1067 25.7656 13.0521C25.7656 15.2929 27.7318 16.4695 29.1196 17.1783C30.6211 17.885 31.1994 18.3569 31.0838 19.0636C31.0838 20.1237 29.9272 20.5956 28.7727 20.5956C27.3848 20.5956 25.9969 20.2422 24.7267 19.6519L24.0328 22.9528C25.4207 23.5411 26.9222 23.778 28.31 23.778C32.5873 23.8944 35.2454 21.7742 35.2454 18.5918C35.2454 14.5841 29.8115 14.3492 29.8115 12.5823ZM49.0015 23.6592L45.8808 8.3374H42.5288C41.8349 8.3374 41.1409 8.80925 40.9096 9.516L35.1309 23.6592H39.1768L39.9844 21.4205H44.9556L45.4182 23.6592H49.0015ZM43.1062 12.4639L44.2608 18.2384H41.0244L43.1062 12.4639Z", fill: fill }) }));
}

function MasterCardIcon({ testId, size = "M", width, height }) {
    const sizeMap = useMemo(() => getSizeMap(size), [size]);
    return (jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: width !== null && width !== void 0 ? width : sizeMap, height: height !== null && height !== void 0 ? height : sizeMap, "data-testid": testId, viewBox: "0 0 40 25", fill: "none", className: "iconCompLibrary_master-card-icon_svg", id: "iconCompLibrary_master-card-icon_svg_id", children: [jsx("path", { d: "M25.0161 3.32812H14.3867V22.1969H25.0161V3.32812Z", fill: "#FF5F00" }), jsx("path", { d: "M15.0621 12.7656C15.0604 10.9484 15.4773 9.15465 16.2811 7.52012C17.085 5.8856 18.2547 4.45315 19.7019 3.33123C17.9098 1.93977 15.7576 1.07445 13.4912 0.83416C11.2248 0.59387 8.93571 0.988299 6.88553 1.97238C4.83535 2.95647 3.10681 4.4905 1.89749 6.39912C0.688176 8.30775 0.046875 10.514 0.046875 12.7656C0.046875 15.0172 0.688176 17.2235 1.89749 19.1321C3.10681 21.0407 4.83535 22.5747 6.88553 23.5588C8.93571 24.5429 11.2248 24.9373 13.4912 24.6971C15.7576 24.4568 17.9098 23.5914 19.7019 22.2C18.2547 21.0781 17.085 19.6456 16.2811 18.0111C15.4773 16.3766 15.0604 14.5828 15.0621 12.7656Z", fill: "#EB001B" }), jsx("path", { d: "M39.3575 12.7656C39.3576 15.0172 38.7164 17.2234 37.5071 19.132C36.2979 21.0407 34.5694 22.5747 32.5193 23.5588C30.4691 24.5429 28.18 24.9373 25.9137 24.697C23.6473 24.4568 21.4951 23.5914 19.7031 22.2C21.149 21.0769 22.3178 19.6442 23.1216 18.01C23.9253 16.3757 24.3429 14.5825 24.3429 12.7656C24.3429 10.9487 23.9253 9.1555 23.1216 7.52123C22.3178 5.88696 21.149 4.45428 19.7031 3.33122C21.4951 1.93977 23.6473 1.07444 25.9137 0.834157C28.18 0.59387 30.4691 0.988316 32.5193 1.97241C34.5694 2.9565 36.2979 4.49053 37.5071 6.39916C38.7164 8.30779 39.3576 10.514 39.3575 12.7656Z", fill: "#F79E1B" }), jsx("path", { d: "M38.197 20.2001V19.8138H38.3547V19.7351H37.9531V19.8138H38.1109V20.2001H38.197ZM38.9767 20.2001V19.7344H38.8536L38.712 20.0547L38.5704 19.7344H38.4472V20.2001H38.5341V19.8488L38.6669 20.1517H38.7571L38.8898 19.848V20.2001H38.9767Z", fill: "#F79E1B" })] }));
}

function FadeIn({ children, config = { tension: 200, friction: 25 }, delay, duration, direction = "center", endStyle, isVisible, maxHeight = "200px", overflow = "hidden", startStyle, easing, onStart, onRest, }) {
    const transformDirectionMap = {
        left: "translate(-100%, 0)",
        right: "translate(100%, 0)",
        top: "translate(0, -100%)",
        bottom: "translate(0, 100%)",
        center: "translate(0, 0)",
    };
    const getDirectionTransform = () => {
        return transformDirectionMap[direction] || transformDirectionMap.center;
    };
    const getTransform = () => {
        return isVisible ? "translate(0, 0)" : getDirectionTransform();
    };
    const animationStyles = useSpring({
        opacity: isVisible ? 1 : 0,
        maxHeight: isVisible ? maxHeight : "0px",
        transform: getTransform(),
        overflow,
        config: Object.assign(Object.assign({}, config), { duration, delay, easing }),
        onStart,
        onRest,
    });
    return (jsx(animated.div, { style: Object.assign(Object.assign(Object.assign({}, animationStyles), startStyle), endStyle), children: children }));
}

function FadeInTranslateX({ children, isAnimationStart = false, 
// duration = 800,
translateFrom = "100px", onReset, config = { tension: 120, friction: 16, mass: 1 }, reverseAnimation = false, }) {
    const [opacity, setOpacity] = useState(0);
    useEffect(() => {
        if (isAnimationStart)
            setOpacity(1);
    }, [isAnimationStart]);
    const translateFromValue = reverseAnimation
        ? `-${translateFrom}`
        : translateFrom;
    const animateProps = useSpring({
        from: { opacity: 0, transform: `translateX(${translateFromValue})` },
        to: [
            {
                opacity,
                transform: opacity === 1
                    ? "translateX(0px)"
                    : `translateX(${translateFromValue})`,
            },
            {
                opacity,
                transform: `translateX(0px)`,
            },
        ],
        config: Object.assign({}, config),
        onRest: () => {
            if (onReset)
                onReset();
        },
    });
    return jsx(animated.div, { style: animateProps, children: children });
}

export { Dropdown as ACODropdown, DropdownItem as ACODropdownItem, AlertTriangleFilledIcon, BreadcrumbItem, Breadcrumbs, Button$1 as Button, ButtonTab, CalendarIcon, CheckCircleFilledIcon, CheckCircleIcon, CheckIcon, CheckBox as Checkbox, ChevronDownIcon, ChevronLeftIcon, ChevronRightIcon, ChevronUpIcon, DateInput, DateRangePicke as DateRangerPicker, Dialog, Divider, DocumentIcon, Dropdown$1 as Dropdown, DropdownItem$1 as DropdownItem, FacebookIcon, FadeIn, FadeInTranslateX, HeartHandshakeIcon, HeartIcon, HelpButton, HomeIcon, InfoIcon, InlineInfoBox, InstagramIcon, LeftArrowIcon, LinkedinIcon as LinkedInIcon, MailIcon, MasterCardIcon as MasterCard, MessageIcon, Modal, NotificationCard, OptionSelection, PaymentFailedIcon, PhoneIcon, PlusCircleIcon, PlusIcon, ProgressBar, RightArrowIcon, Searchbox as SearchBox, SearchListDropdown, SearchListItem, ShieldCardIcon, ShieldCheckIcon, SupportDrawer as SideDrawer, SingleDatePicker, SingleDayPicker, SpinnerDotIcon, TagSearchField, TelephoneTextField, TextField$1 as TextField, TextField as TextFieldSts, ToggleButton, Tooltip, TrustpilotMini, TwitterIcon, UsersIcon, VisaCardIcon as VisaCard, XCircleFilledIcon, XCircleIcon, XIcon, TextField as textFieldSts };
